export default {
  "pages.delivery.v2.flowMode": "New Workflow Mode",
  "pages.delivery.v2.environmentSwitchFailed": "Environment switch failed. Please retry.",
  "pages.delivery.v2.overviewLoadFailed": "Release overview could not be loaded. Please refresh.",
  "pages.delivery.v2.releaseWorkbench": "Release Workbench",
  "pages.delivery.v2.releaseWindow": "Release Window",
  "pages.delivery.v2.notConfigured": "Not configured",
  "pages.delivery.v2.startRelease": "Start Release",
  "pages.delivery.v2.classicListMode": "Classic List Mode",
  "pages.delivery.v2.releaseOrderList": "Release Orders",
  "pages.delivery.v2.onlyMine": "Only Mine",
  "pages.delivery.v2.searchReleaseOrder": "Search release orders",
  "pages.delivery.v2.currentlyOpen": "Currently Open",
  "pages.delivery.v2.noReleaseOrders": "No release orders",
  "pages.delivery.v2.totalItems": "{count} items",
  "pages.delivery.v2.selectOrStartRelease": "Select a release order or start a new release",
  "pages.delivery.v2.releaseOrder": "Release Order",
  "pages.delivery.v2.normalRelease": "Normal Release",
  "pages.delivery.v2.emergencyRelease": "Emergency Release",
  "pages.delivery.v2.approvalDetails": "Approval Details",
  "pages.delivery.v2.refresh": "Refresh",
  "pages.delivery.v2.system": "System",
  "pages.delivery.v2.releaseOrderType": "Release Order Type",
  "pages.delivery.v2.creator": "Creator",
  "pages.delivery.v2.collaborators": "Collaborators",
  "pages.delivery.v2.scheduledReleaseTime": "Scheduled Release Time",
  "pages.delivery.v2.actualReleaseTime": "Actual Release Time",
  "pages.delivery.v2.taskCount": "Tasks",
  "pages.delivery.v2.viewTasks": "Click to view tasks",
  "pages.delivery.v2.updatedAt": "Updated At",
  "pages.delivery.v2.emergencyReason": "Emergency Release Reason",
  "pages.delivery.v2.currentNextStep": "Next Step",
  "pages.delivery.v2.nextStepDescription": "Available actions are based on the release status and your permissions.",
  "pages.delivery.v2.releaseScopeAndBranches": "Release Scope and Branches",
  "pages.delivery.v2.serviceCount": "{count} services",
  "pages.delivery.v2.noReleasableServices": "This release has no releasable services in the current environment. Check the environment and deployment capabilities.",
  "pages.delivery.v2.relatedWorkItems": "Related Work Items ({count})",
  "pages.delivery.v2.approvalAndPreparation": "Approval and Release Preparation",
  "pages.delivery.v2.approvalCreatedDescription": "An approval request has been created and can be handled in the drawer on this page.",
  "pages.delivery.v2.noApprovalDescription": "This release has no approval request and will continue under the current environment and release-window rules.",
  "pages.delivery.v2.viewApproval": "View Approval",
  "pages.delivery.v2.emergencyFlowDescription": "This is an emergency release and follows its emergency release flow.",
  "pages.delivery.v2.normalFlowDescription": "This is a normal release and follows its normal release flow.",
  "pages.delivery.v2.viewCheckDetails": "View Full Check Details",
  "pages.delivery.v2.checkProgress": "{checked}/{total} checks passed. You can confirm the results here.",
  "pages.delivery.v2.noCheckItems": "No checks for this release order",
  "pages.delivery.v2.executionAndProgress": "Release Execution and Recent Service Deployments",
  "pages.delivery.v2.autoRefreshDescription": "Refreshes recent deployments and container status for related services in this environment every 3 seconds. Records are not scoped to this release order or execution batch and may belong to another release.",
  "pages.delivery.v2.jenkinsPipelineStages": "Jenkins Pipeline Stages",
  "pages.delivery.v2.containerRuntimeStatus": "Container Runtime Status",
  "pages.delivery.v2.waitingOneClickRelease": "Waiting for One-click Release",
  "pages.delivery.v2.noRunningPipelines": "No service pipelines are currently running",
  "pages.delivery.v2.releaseProgressDescription": "These are recent service deployments in the current environment, not confirmed results for this release order. Check release history and logs for details.",
  "pages.delivery.v2.completed": "Completed",
  "pages.delivery.v2.currentTodo": "Current Task",
  "pages.delivery.v2.waitingPreviousSteps": "Waiting for previous steps",
  "pages.delivery.v2.nextConfirmMaterials": "Next: Confirm Release Materials",
  "pages.delivery.v2.createReleaseDescription": "Start from a requirement, iteration, or online issue. Existing materials, branches, checks, and release-window rules apply in the next step.",
  "pages.delivery.v2.selectSystem": "Select a system",
  "pages.delivery.v2.startFrom": "Start From",
  "pages.delivery.v2.carrierRequired": "Link one {type}",
  "pages.delivery.v2.issueSelectionHint": "Only requirements you can release and whose status is Pending Release are shown.",
  "pages.delivery.v2.planSelectionHint": "Only iterations containing at least one releasable requirement are shown.",
  "pages.delivery.v2.onlineBugSelectionHint": "Only resolved online issues eligible for a release order are shown.",
  "pages.delivery.v2.selectOrSearchCarrier": "Select or search {type}",
  "pages.delivery.v2.noEligibleIssues": "No eligible pending-release requirements",
  "pages.delivery.v2.noAvailableCarrier": "No available {type}",
  "pages.delivery.v2.hotFixCreated": "Hot Fix request created",
  "pages.delivery.v2.confirmReleaseTitle": "Confirm one-click release?",
  "pages.delivery.v2.confirmReleaseContent": "After a successful release, the order moves to Pending Regression. Confirm the services, branches, and execution order.",
  "pages.delivery.v2.releaseCreated": "One-click release flow created",
  "pages.delivery.v2.regressionCompleted": "Regression completed",
  "pages.delivery.v2.confirmAcceptanceTitle": "Accept [{name}]?",
  "pages.delivery.v2.confirmAcceptanceContent": "The release order will be accepted and related requirements will be closed. This cannot be undone.",
  "pages.delivery.v2.acceptanceCompleted": "Acceptance completed",
  "pages.delivery.v2.sqlCheckConfirm": "The following SQL tickets did not pass. Ignore them?",
  "pages.delivery.v2.checkUpdated": "Check updated",
  "pages.delivery.v2.checkUpdateFailed": "Failed to update check",
  "pages.delivery.v2.developmentEnvironment": "Development Environments",
  "pages.delivery.v2.productionEnvironment": "Production Environments",
  "pages.delivery.v2.currentEnvironment": "Current Environment",
  "pages.delivery.v2.selectEnvironment": "Select an environment",
  "pages.delivery.v2.createSuccessTitle": "Release Order Created",
  "pages.delivery.v2.createSuccessContent": "Go to Release Workbench to continue approval, checks, and release?",
  "pages.delivery.v2.goToWorkbench": "Go to Release Workbench",
  "pages.delivery.v2.stayOnCurrentPage": "Stay on This Page",
  "pages.delivery.v2.stage.approval": "Request and Approval",
  "pages.delivery.v2.stage.check": "Release Checks",
  "pages.delivery.v2.stage.release": "One-click Release",
  "pages.delivery.v2.stage.regression": "Regression Testing",
  "pages.delivery.v2.stage.acceptance": "Business Acceptance",
  "pages.delivery.v2.carrier.issue": "Requirement",
  "pages.delivery.v2.carrier.plan": "Iteration",
  "pages.delivery.v2.carrier.onlineBug": "Online Issue",
  "pages.delivery.v2.carrier.regressionBug": "Regression Defect",
  "pages.delivery.v2.status.success": "Success",
  "pages.delivery.v2.status.failure": "Failed",
  "pages.delivery.v2.status.aborted": "Cancelled",
  "pages.delivery.v2.status.waiting": "Queued",
  "pages.delivery.v2.status.releasing": "Releasing",
  "pages.delivery.v2.k8s.notApplicable": "Non-container Service",
  "pages.delivery.v2.k8s.deploymentNotFound": "No Deployment found in this environment",
  "pages.delivery.v2.k8s.notAssociated": "No Container Association",
  "pages.delivery.v2.k8s.ready": "{ready}/{desired} instances ready",
  "pages.delivery.v2.k8s.updating": "Updating · {ready}/{desired} instances ready",
  "pages.delivery.v2.k8s.updatingWithPending": "Updating · {ready}/{desired} instances ready · {pending} pending",
  "pages.delivery.v2.k8s.viewRollingUpdate": "View rolling update in K8s",
  "pages.delivery.v2.action.reviewApproval": "View and Handle Approval",
  "pages.delivery.v2.action.waitingApproval": "Waiting for Approval",
  "pages.delivery.v2.action.handleChecks": "Handle Checks",
  "pages.delivery.v2.action.completeRegression": "Complete Regression Testing",
  "pages.delivery.v2.action.confirmAcceptance": "Confirm Business Acceptance",
  "pages.delivery.v2.action.viewApprovalFeedback": "View Approval Feedback",
  "pages.delivery.v2.action.handleRejection": "Handle Rejection",
  "pages.delivery.v2.action.viewFailureRollback": "View Failure and Rollback",
  "pages.delivery.v2.action.flowCompleted": "Release Flow Completed",
  "pages.delivery.v2.action.noPendingAction": "No pending action for your account. You can continue monitoring progress here.",
  "pages.delivery.v2.action.completeRegressionShort": "Complete Regression",
  "pages.delivery.v2.action.confirmAcceptanceShort": "Confirm Acceptance",
  "pages.delivery.v2.table.service": "Service",
  "pages.delivery.v2.table.serviceType": "Service Type",
  "pages.delivery.v2.table.serviceNature": "Service Attribute",
  "pages.delivery.v2.table.currentEnvironment": "Current Environment",
  "pages.delivery.v2.table.releaseBranch": "Release Branch",
  "pages.delivery.v2.table.branchStatus": "Branch Status",
  "pages.delivery.v2.table.behindMaster": "Behind Master",
  "pages.delivery.v2.table.aheadMaster": "Ahead of Master",
  "pages.delivery.v2.table.status": "Status",
  "pages.delivery.v2.table.released": "Released",
  "pages.delivery.v2.table.pending": "Pending Release",
  "pages.delivery.v2.table.branch": "Branch",
  "pages.delivery.v2.table.startTime": "Start Time",
  "pages.delivery.v2.table.duration": "Duration",
  "pages.delivery.v2.table.executionStatus": "Execution Status",
  "pages.delivery.v2.table.containerReadiness": "Container Readiness",
  "pages.delivery.v2.filter.createdAt": "Created At",
  "pages.delivery.v2.filter.carrierType": "Release Order Type",
  "pages.delivery.v2.filter.allTypes": "All Types",
  "pages.delivery.v2.filter.status": "Release Status",
  "pages.delivery.v2.filter.allStatuses": "All Statuses",
  "pages.delivery.v2.filter.creator": "Creator",
  "pages.delivery.v2.filter.allCreators": "All Creators",
  "pages.delivery.v2.filter.releaseMode": "Release Mode",
  "pages.delivery.v2.filter.allReleaseModes": "All Release Modes",
  "pages.delivery.v2.filter.apply": "Apply",
  "pages.delivery.v2.filter.reset": "Reset",
  "pages.delivery.v2.filter.button": "Filters",
  "pages.workplace.v2.pending": "Pending",
  "pages.workplace.v2.exceptions": "Exceptions",
  "pages.workplace.v2.description": "Work, risks, and personal data views related to you",
  "pages.workplace.v2.myInfo": "My Information",
  "pages.workplace.v2.attendanceDetails": "Attendance Details",
  "pages.workplace.v2.customWorkspace": "Custom Workspace",
  "pages.workplace.v2.currentDashboard": "Current Dashboard",
  "pages.workplace.v2.noDashboardCards": "No cards on the current dashboard",
  "pages.workplace.v2.noExceptions": "No exceptions",
  "pages.workplace.v2.noPendingItems": "No pending items",
  "pages.workplace.v2.kudoReceived": "Kudos received from colleagues",
  "pages.workplace.v2.kudoEmpty": "You have not received any kudos yet",
  "pages.workplace.v2.viewKudoCards": "View Kudos",
  "pages.workplace.v2.quickEntries": "Quick Links",
  "pages.workplace.v2.attendanceNormal": "Normal",
  "pages.workplace.v2.attendanceStatus": "Attendance status: {status}",
  "审批同意成功": "Approval granted successfully",
  "请填写拒绝原因": "Please enter a rejection reason",
  "审批拒绝成功": "Approval rejected successfully",
  "审批拒绝失败": "Failed to reject approval",
  "审批拒绝失败:": "Failed to reject approval:",
  "审批撤销成功": "Approval withdrawn successfully",
  "审批撤销失败": "Failed to withdraw approval",
  "审批撤销失败:": "Failed to withdraw approval:",
  "重新发起操作": "Submit Again",
  "审批单链接已复制到剪贴板": "Approval request link copied to clipboard",
  "复制链接失败": "Failed to copy link",
  "复制链接失败:": "Failed to copy link:",
  "请选择新的审批人": "Please select a new Approver",
  "审批人更新成功": "Approver updated successfully",
  "审批单详情": "Approval Request Details",
  "审批人无法审批？要变更审批人？可联系审批管理员": "Can't approve? Change the Approver? Could contact the Approver",
  "修改审批人": "Change Approver",
  "项目详情链接：": "Project details link:",
  "查看项目详情": "View Project Details",
  "复制链接": "Copy Link",
  "链接已复制到剪贴板": "Link copied to clipboard",
  "浏览器不支持复制功能": "Browser does not support copying",
  "审批单号": "Approval Request No.",
  "审批标题": "Approval Title",
  "审批进度": "Approval Progress",
  "审批类型": "Approval Type",
  "发起原因": "Request Reason",
  "发起时间": "Initiated At",
  "拒绝": "Reject",
  "更多": "More",
  "请输入审批单号/审批标题": "Please enter the approval request number/approved title",
  "发起时间:": "Launch date:",
  "查询类型:": "Query type:",
  "我发起的": "Initiated by Me",
  "我审批的": "Approved by Me",
  "审批类型:": "Type of approval:",
  "请选择审批类型": "Select the type of approval",
  "审批进度:": "Progress in approval:",
  "请选择审批进度": "Please select the approval progress",
  "拒绝审批": "Reject Approval",
  "确认拒绝": "Confirm Rejection",
  "请填写拒绝原因：": "Please fill out the reasons for refusal:",
  "请输入拒绝原因...": "Please enter the reason for the rejection...",
  "已选择": "Selected",
  "点击进入": "Click to Enter",
  "暂无可用审批类型": "No type of approval available",
  "审批统计": "Approval Statistics",
  "我的审批单": "My Approval Requests",
  "撤销": "Withdraw",
  "同意": "Approve",
  "审批流程": "Approval Workflow",
  "流程发起": "Workflow Initiated",
  "发起人：": "Sponsor:",
  "时间：": "Time:",
  "审批节点": "Approval Node",
  "分组审批：每个小组都需通过，每个小组审批通过规则为": "Sub-group approval: each group is required to pass and each group approves the adoption rules as follows:",
  "小组": "Group",
  "该分组暂无审批人信息": "No approval information for this group",
  "暂无审批人信息": "No approver information",
  "暂无审批流程信息": "No approval workflow information",
  "审批流程已完成": "Approval workflow completed",
  "编辑审批人": "Edit Approver",
  "需上一节点审批通过后开放...": "Once approved in the previous section...",
  "等待审批中...": "Awaiting approval...",
  "不需要审批了": "Approval is no longer required",
  "当前状态": "Current Status",
  "涉及系统": "System-related",
  "其他信息": "Other information",
  "获取事件详情失败:": "Failed to load event details:",
  "获取事件详情失败": "Failed to get event details",
  "Goc事件明细": "Goc Incident Details",
  "确认撤销": "Confirm withdrawal.",
  "您确定要撤销此审批单吗？撤销后将无法恢复。": "Are you sure you want to cancel this approval? It will not be possible to recover.",
  "将": "Will",
  "替换为：": "there shall be substituted:",
  "分支名称": "Branch Name",
  "我的审批": "My Approvals",
  "所有审批": "All Approvals",
  "ECS筛选": "ECS Filter",
  "实例名称": "Instance Name",
  "请输入实例名称": "Please enter an instance name",
  "实例状态": "Example Status",
  "请选择实例状态": "Please select instance status",
  "CPU核数": "CPU Number",
  "请输入CPU核数": "Enter the CPU number.",
  "内存大小(GB)": "Memory Size (GB)",
  "请输入内存大小(GB)": "Enter memory size (GB)",
  "操作系统类型": "Type of operating system",
  "请选择操作系统类型": "Select the type of operating system",
  "网络类型": "Network type",
  "请选择网络类型": "Select the network type",
  "网络计费类型": "Network billing type",
  "请选择网络计费类型": "Select the type of network billing",
  "实例计费类型": "Case billing type",
  "请选择实例计费类型": "Select the type of instance billing",
  "实例是否不可用": "Examples not available",
  "不可用": "Not Available",
  "运行中": "Running",
  "已停止": "Stopped",
  "启动中": "Starting",
  "停止中": "Stopping",
  "等待中": "Waiting",
  "经典网络": "Classic Network",
  "专有网络": "proprietary network",
  "按固定带宽": "Press fixed bandwidth",
  "按使用流量": "By usage",
  "包年包月": "Package months",
  "按量付费": "Pay at volume.",
  "抢占式实例": "Examples of looting",
  "实例ID": "Example ID",
  "可用区": "Available areas",
  "实例规格": "Examples",
  "规格族": "Organisation",
  "CPU/内存": "CPU/RAM",
  "系统类型": "System Type",
  "镜像ID": "Mirror ID",
  "主机名": "Hostname",
  "交换机ID": "Switch ID",
  "私网IP": "Internet IP",
  "公网IP": "Internet IP",
  "弹性公网IP": "Resilient Public Network IP",
  "安全组": "Security team.",
  "搜索关键词": "Search keywords",
  "请输入搜索关键词": "Please enter the search keyword",
  "监控项单位": "Monitoring Item Units",
  "请输入单位，多个用逗号分隔或直接选择": "Enter units, multiple commas separated or directly selected",
  "命名空间": "Namespace",
  "监控项描述": "Monitor Item Description",
  "统计周期": "Statistical cycle",
  "维度": "Dimensions",
  "单位": "Units",
  "统计方法": "Statistical methodology",
  "PolarDB筛选": "PolarDB Filter",
  "数据库类型": "Database Type",
  "请选择数据库类型": "Select Database Type",
  "数据库版本": "Database Version",
  "请输入数据库版本，多个用逗号分隔": "Please enter a database version, separate by commas",
  "存储付费类型": "Type of storage fee",
  "请选择存储付费类型": "Select the type of storage fee",
  "付费类型": "Type of payment",
  "请选择付费类型": "Select the type of fee to pay",
  "集群状态": "Cluster Status",
  "请选择集群状态": "Please select the cluster status",
  "集群系列": "Cluster series",
  "请选择集群系列": "Select the cluster series",
  "存储类型": "Storage Type",
  "请选择存储类型": "Please select the storage type",
  "强一致性": "Strong coherence",
  "请选择强一致性": "Please choose strong consistency.",
  "删除保护": "Delete Protection",
  "锁定": "Lock",
  "是否过期": "Expiry",
  "锁定模式": "Lock Mode",
  "请选择锁定模式": "Please select lock mode",
  "热备集群": "Hot cluster.",
  "请选择热备集群": "Please select the hot cluster.",
  "创建中": "Creating",
  "删除中": "Deleting",
  "重启中": "Restarting",
  "变配中": "Transforming",
  "标准版": "Standard version",
  "高性能": "High Performance",
  "未锁定": "Unlocked",
  "手动锁定": "Manual Lock",
  "因过期而锁定": "Locked due to expiry",
  "因恢复而锁定": "Locked for recovery",
  "因磁盘配额超限而锁定": "Locked due to disk quota excess",
  "SE标准版": "SE Standard",
  "开启": "Open",
  "集群描述": "Cluster Description",
  "数据库引擎": "Database engine",
  "集群类型": "Cluster type",
  "节点规格": "Node Specification",
  "节点数量": "Number of Nodes",
  "存储空间(GB)": "Storage space (GB)",
  "已用存储(GB)": "Used storage (GB)",
  "计费类型": "Type of charge",
  "存储计费类型": "Storage billing type",
  "子系列": "Subseries",
  "数据库节点": "Database Nodes",
  "资源组ID": "Resource group ID",
  "集群创建时间": "Cluster creation time",
  "集群过期时间": "Cluster expiration time",
  "云产品描述": "Cloud Product Description",
  "RDS筛选": "RDS Filter",
  "实例描述": "Example Description",
  "请输入实例描述": "Please enter an instance description",
  "请选择数据库引擎": "Select Database Engine",
  "实例类型": "Type of instance",
  "请选择实例类型": "Please select the type of instance",
  "请选择计费类型": "Select the billing type",
  "迁移中": "Moving",
  "升级中": "Upgrading",
  "创建只读实例中": "Creating read-only cases",
  "恢复中": "Restoring",
  "导入中": "Importing",
  "从其他实例导入中": "Importing from other instances",
  "网络类型变更中": "Network type changes under way",
  "容灾切换中": "Consistency is changing.",
  "克隆中": "Cloning",
  "克隆只读实例中": "Only reading examples of cloning",
  "内核版本升级中": "kernel version upgrading",
  "创建临时实例中": "Creating temporary examples",
  "SSL配置修改中": "SSL configuration changes under way",
  "SSL启用中": "SSL enabled",
  "SSL禁用中": "Disabled by SSL",
  "已删除": "Deleted",
  "内存(GB)": "Memory (GB)",
  "网络连接类型": "Network Connection Type",
  "连接地址": "Connection Address",
  "连接模式": "Connection Mode",
  "VPC云实例ID": "VPC Cloud Example ID",
  "锁定原因": "Lock Reason",
  "只读实例ID": "Only read instance ID",
  "实例创建时间": "instance creation time",
  "实例过期时间": "Expiry of instance",
  "提示级别": "Tip Level",
  "地域ID": "Geographical ID",
  "地域名称": "Geographical names",
  "地域端点": "Geographical Peers",
  "添加网关域名": "Add gateway domain name",
  "域名": "Domain Name",
  "请输入域名": "Please enter a domain name",
  "网关": "Gateway",
  "请选择网关": "Please select the gateway",
  "协议": "Agreements",
  "请选择协议": "Please select the protocol.",
  "证书": "Certificate",
  "请选择证书": "Please select a certificate",
  "证书名称": "Certificate Name",
  "证书ID": "Certificate ID",
  "绑定域名": "Bind Domain Name",
  "过期时间": "Expiry Time",
  "主机记录": "Host Record",
  "指域名前缀，例如：www": "Domain prefix, e.g.: www.",
  "记录类型": "Record type",
  "指解析记录的用途，例如：网站、邮箱": "Refers to the purpose for which the records are to be analysed, e.g. website, mailbox",
  "解析请求来源(isp)": "Parsing Request Source (isp)",
  "指解析请求的来源，例如：电信、联通": "Refers to the source of the request, e.g. telecommunications, connectivity",
  "记录值": "Record value",
  "一般是填写服务器的IP地址": "Usually fill out the server's IP address.",
  "指解析结果在Local DNS中的缓存时间": "Indicating Cache Time in Local DNS",
  "解析记录在云解析DNS中的启用情况": "Parsing log usage in cloud resolution DNS",
  "启用": "Enable",
  "暂停": "Pause",
  "已绑定网关": "_Other Organiser",
  "最近同步时间": "Recent Sync Time",
  "请输入主机记录": "Please enter the host log",
  "请输入记录值": "Enter the log value",
  "所有状态": "All Statuss",
  "常用域名": "Common domain name",
  "未标为常用域名": "Not marked as common domain",
  "记录数": "Number of records",
  "DNS服务器地址": "DNS Server Address",
  "付费版本": "Pay Version",
  "免费版": "Free version",
  "企业标准版": "Enterprise standard version",
  "企业旗舰版": "Enterprise flagship",
  "请选择行业线": "Select an industry line",
  "未设置开始结束时间": "No start end time set",
  "实际工作时间": "Actual working hours",
  "近30天": "Almost 30 days.",
  "近三月": "Last March",
  "开始结束时间": "Start End Time",
  "任务类型": "Task Type",
  "请到开始结束时间处设置预估人天（左侧蓝色分级线可拖动）": "Set an estimate of human days at the end of the period (left blue line to drag)",
  "需求甘特图": "requirement Gantt",
  "任务列表": "Chile",
  "任务甘特图": "Mission Gantt",
  "需求信息": "Information about needs",
  "任务状态": "Task Status",
  "未知用户": "Unknown User",
  "的": "Yes.",
  "甘特图视图": "Gantt Image View",
  "一键收起": "One key.",
  "一键展开": "Expand by one key",
  "任务状态筛选：": "_Other Organiser",
  "请选择任务状态": "Select Task Status",
  "任务时间筛选：": "_Other Organiser",
  "新建目录": "New Directory",
  "编辑目录": "Edit Directory",
  "目录名称": "Directory Name",
  "请输入目录名称": "Please enter a directory name",
  "请至少选择一个组织、系统或其他人员": "Please select at least one organization, system or other person",
  "组织": "Organizations",
  "添加该组织下的所有人员,支持多选": "Add all members of the organization to support multiple selection",
  "请选择组织": "Select Organisation",
  "组织人员": "Organizational staff",
  "已添加组织人员": "Organisation",
  "添加该系统下的所有人员,支持多选": "Add all personnel under the system to support multiple selection",
  "系统人员": "System personnel",
  "已添加系统人员": "Added System Personnel",
  "其他人员": "Other personnel",
  "请选择其他人员": "Please choose someone else.",
  "支持多选": "Support multiple selections",
  "创建面板": "Create Panel",
  "查看目录详情": "View directory details",
  "删除目录": "Remove Directory",
  "创建目录": "Create Directory",
  "人员名称": "Name of person",
  "部门": "Sector",
  "任务预估工时": "Task estimated working hours",
  "任务实际工时": "Actual working hours",
  "缺陷工时": "Shortfall hours",
  "线上问题工时": "production issue hours",
  "考勤工时": "Working hours",
  "加班工时": "Overtime",
  "缺陷时效": "Limitation period for defects",
  "研发为缺陷解决时效相加（解决时效=解决时间-创建时间）": "R & D is time-barred (resolved = time of resolution - creation)",
  "测试为缺陷关闭时效相加（关闭时效=关闭时间-解决时间）": "Tests added for defects (closure = closure time - resolution time)",
  "线上问题时效": "production issue prescription",
  "研发为线上问题解决时效相加（解决时效=解决时间-创建时间）": "R & D is on-line (resolution time = resolution time - creation time)",
  "测试为线上问题关闭时效相加（关闭时效=关闭时间-解决时间）": "Tests add a time limit for closing on-line problems (Closure time = closure time - resolution time)",
  "缺陷平均时效": "Average limitation period for defects",
  "缺陷平均时效 = 缺陷时效 / 缺陷数量": "Average limitation time for defects = number of limitations for defects / defects",
  "线上问题平均时效": "Average time limit for production issues",
  "线上问题平均时效 = 线上问题时效 / 线上问题数量": "Average limit for production issues = time limit for production issues / number of production issues",
  "缺陷工时占比": "Percentage of working hours with defects",
  "缺陷工时占比 = 缺陷实际工时 / 考勤工时": "Impairment rate = defective actual / time worked",
  "线上问题工时占比": "Proportion of working hours with production issues",
  "线上问题工时占比 = 线上问题工时 / 考勤工时": "Proportion of working hours with production issues = working hours with production issues / time on duty",
  "缺陷重开次数": "Number of reopens of defects",
  "缺陷重开率": "Deficiencies restart rate",
  "缺陷重开率 = 缺陷重开次数 / 缺陷数量": "Defectivity = number of reruns/ defects",
  "缺陷（平均值）": "Deficiencies (average)",
  "线上问题（平均值）": "production issues (average)",
  "平均产品评审驳回率": "Average product evaluation rejection rate",
  "平均代码提交规范率": "Average code submission norm rate",
  "平均紧急发布率": "Average emergency distribution rate",
  "代码与发布质量监测": "Code and release quality monitoring",
  "研发缺陷与线上缺陷综合指标": "Integrated indicators of R&D deficiencies and on-line deficiencies",
  "产品需求各阶段平均耗时": "Average time taken at all stages of product requirement",
  "人员数据详情": "Personnel data details",
  "姓名": "Name",
  "员工编码": "Employees Encoding",
  "等待阶段平均时间": "Average waiting period",
  "产品方案平均时间": "Average time of product programme",
  "研发平均开发时间": "Average R & D development time",
  "测试平均等待时间": "Test average waiting time",
  "缺陷平均解决耗时": "Average time taken to resolve defects",
  "缺陷平均关闭时长": "Average duration of closure of defects",
  "缺陷平均重开率": "Average restart rate for defects",
  "线上问题需求设计缺陷率": "Impairment rate for production issue design",
  "线上问题平均解决耗时": "Average time to solve production issues",
  "线上问题平均关闭时长": "production issue average time off",
  "线上问题平均重开率": "Average restart rate for production issues",
  "任务实际工时需满足以下条件：": "The actual working hours of the mission shall be as follows:",
  "工时开始时间大于等于任务开始时间。": "The starting time of working hours is greater than or equal to the start of the mission.",
  "工时结束时间小于等于任务结束时间。": "The working hours are less than the equivalent of the end of the mission.",
  "缺陷实际工时": "Defective actual working hours",
  "缺陷实际工时需满足以下条件：": "The following conditions are required for the actual working hours of the defect:",
  "工时开始时间大于等于缺陷创建时间。": "The starting time of working hours is greater than or equal to the creation time for defects.",
  "工时结束时间小于等于缺陷解决时间。": "The end of working hours is less than the equivalent of a deficiency resolution period.",
  "线上问题实际工时": "Actual working hours for production issues",
  "线上问题实际工时需满足以下条件：": "The following conditions are required for the actual working hours of the production issue:",
  "工时开始时间大于等于线上问题创建时间。": "The starting time of working hours is greater than the creation time of the production issue.",
  "工时结束时间小于等于线上问题解决时间。": "The end of working hours is less than equal to the time of resolving problems online.",
  "偏离值": "Deviation value",
  "实际工时 = 任务实际工时 + 缺陷实际工时 + 线上问题实际工时": "Actual working hours = the actual working hours of the task + the actual working hours of the defective + the actual working hours of the problem online",
  "偏离值=考勤工时 − 实际工时": "Deviation = time worked - actual hours worked",
  "如果偏离值为正，表示考勤工时超过了任务工时，可能意味着员工加班或工作效率低下。 如果偏离值为负，表示考勤工时低于任务工时，可能意味着员工未能完成预定的工作量。": "If the deviation is positive, indicating that the time worked exceeds the time worked on the assignment, it may mean that the staff member worked overtime or worked efficiently. If the deviation is negative, indicating that the time worked is lower than the time worked on the assignment, it may mean that the staff member has not completed the scheduled workload.",
  "偏差百分比": "Percentage deviation",
  "偏离率的计算公式通常为：偏离率=(考勤工时−实际工时)/实际工时*100%": "The formula used to calculate the deviation rate is usually 100 per cent (hours of attendance - actual hours)/actual hours of work*",
  "正偏离率：表示考勤工时高于实际工时，可能意味着员工在工作中投入了更多时间，或者任务预估时间不足。": "(b) Permissible deviation: an indication that the time worked was higher than the actual time worked may mean that the staff member invested more time in his or her work or that the task was not projected to be sufficient.",
  "负偏离率：表示考勤工时低于实际工时，可能意味着员工未能完成预定的工作量，或者考勤记录存在问题。": "Negative deviation rate: An indication that the time worked was lower than the actual time worked may mean that the staff member did not complete the scheduled workload or that there were problems with attendance records.",
  "查看全员甘特图": "Check the Gantt chart.",
  "单位：": "Unit:",
  "名称和链接已复制到剪贴板": "Names and links copied to clipboard",
  "点击这里展开左侧菜单": "Click here to expand the left menu",
  "请选择左侧菜单项进行操作": "Select the left menu entry for the operation",
  "点击这里展开左侧菜单以查看更多选项": "Click here to expand the left menu to see more options",
  "任务责任人看板": "Mission responsibility board.",
  "任务状态占比": "Mission status as a percentage",
  "预估工时（单位: 天）": "Estimated working hours (days)",
  "各时间段内个人任务的预估工时总和，数据为0表示存在任务尚未排期": "Total of estimated working hours for individual assignments over time, with 0 indicating that the existence of the task is not scheduled",
  "研发任务与考勤数据对比": "Comparison of R&D tasks with attendance data",
  "工时、缺陷、任务数据": "Hours of work, defects, task data",
  "查看教程": "View the tutorial",
  "新建值班表": "New Watch",
  "编辑值班表": "Edit watch",
  "值班表名称": "Watch",
  "请输入值班表名称": "Please enter a watch name",
  "值班时间段": "Time on duty",
  "请选择值班时间段": "Select a time frame for duty",
  "不参与组长轮转的业务领域": "Non-participating in team leader rotation business areas",
  "可选，默认全部参与": "Optional, default all participants",
  "只影响值班组长候选人，不影响业务领域自身的值班安排": "It affects only duty team leaders and does not affect the field's own duty schedule.",
  "创建值班表": "Create watch",
  "配置日常值班表模板": "Configure daily watch templates",
  "领域负责人": "Area manager",
  "值班日期": "Watch Date",
  "值班组长": "Officer on duty.",
  "日常值班表模版": "Model daily watch",
  "已选人员固定值班；业务岗位按关联部门成员轮转，组长按未排除的值班业务领域负责人轮转": "Selected personnel on fixed duty; business functions rotated by members of the related department, and team leaders rotated by heads of line areas not excluded",
  "按启用的业务领域重置模板岗位": "Reset template positions by active field",
  "确认重置模板岗位？": "Confirming template positions?",
  "确认重置": "Confirm Reset",
  "模板岗位已重置": "Template Post Resetd",
  "重置模板岗位": "Reset Template Posts",
  "假": "False",
  "班": "Ben.",
  "按最新模板重新排班": "Reschedule according to the latest template",
  "请先完成值班模板调整": "Please finish the duty template adjustment first.",
  "业务岗位只重排所选业务领域；值班组长按整张值班表的负责人候选范围独立重排。生效日期之前的排班不会修改。": "Operational positions are re-scheduled only for the selected areas of operation; the duty manager is re-scheduled independently on the basis of the pool of candidates for the head of the full duty schedule. The scheduling before the effective date will not be modified.",
  "生效日期": "Effective date",
  "请选择生效日期": "Please choose the effective date",
  "重排内容": "Reorder content",
  "请至少选择一项重排内容": "Please select at least one reset",
  "重排业务岗位": "Relocation of operational positions",
  "重排值班组长": "Reschedule the shift leader.",
  "需重排的业务领域": "Business areas to be reorganized",
  "请选择本次需要重排的业务领域": "Select the business areas that need to be reordered.",
  "今天": "Today",
  "可联系方式": "Contacts",
  "值班表名称和链接已复制到剪贴板": "Duty sheet names and links copied to clipboard",
  "从生效日期起，可选择重排业务岗位、值班组长或两者同时重排": "With effect from the effective date, the option is to reschedule the operational position, the duty leader or both",
  "重新排值班表": "Reschedule.",
  "自动排班": "Automatic scheduling",
  "只补全空缺岗位，不覆盖已手工填写的人员": "Filling vacant posts only and not covering manually filled posts",
  "按关联部门自动填充": "Autofill by Related Department",
  "业务需求明细": "Detailed operational requirements",
  "请至少选择一种专业线": "Please select at least one professional line",
  "请输入仪表盘名称": "Please enter the dashboard name",
  "仪表盘名称不能超过100个字符": "The dashboard name cannot exceed 100 characters",
  "专业线类型": "Professional Line Type",
  "自定义专业线": "Custom Professional Lines",
  "请选择自定义专业线": "Select a custom line",
  "配置专业线": "Configure professional lines",
  "可查看人员": "Available personnel",
  "描述不能超过500个字符": "Description cannot exceed 500 characters",
  "新建专业线": "New Professional Line",
  "编辑专业线": "Edit Professional Lines",
  "查看专业线": "View professional lines",
  "专业线名称": "Professional Line Name",
  "请输入专业线名称": "Please enter a professional line name",
  "专业线名称不能超过100个字符": "Professional line names cannot exceed 100 characters",
  "请选择成员": "Please select a member.",
  "删除确认": "Delete Confirmation",
  "暂停至": "Pause To",
  "产品需求明细": "Product requirement breakdown",
  "管理自定义专业线": "Manage custom professional lines",
  "折叠全部": "Collapse All",
  "展开全部": "Expand All",
  "退出全屏": "Exit Full Screen",
  "图表全屏": "Chart Full Screen",
  "整体交付周数统计（产品需求维度）": "Overall delivery week statistics (product requirement dimension)",
  "选择专业线": "Select Professional Line",
  "选择产品经理": "Selection of product manager",
  "年度交付周数（整体）": "Annual delivery weeks (total)",
  "专业线交付周数统计（产品需求维度）": "Specialized line delivery week statistics (product requirement dimension)",
  "整体交付周数统计（业务需求维度）": "Overall delivery week statistics (business needs dimension)",
  "专业线交付周数统计（业务需求维度）": "Professional line delivery week statistics (business requirement dimension)",
  "近两周需求进展环比": "We've got two weeks of progress.",
  "超期需求": "Overdue requirements",
  "超2周": "Over 2 weeks",
  "超3周": "Over three weeks.",
  "超1个月": "Over a month.",
  "超期未介入产品需求": "Uninvolved product requirement",
  "超期未介入业务需求": "Uninvolved operational requirements for extended periods",
  "超期方案未完成产品需求": "Unfinished product requirement for extended programmes",
  "评审完成超期未排期产品需求": "Review completion of unscheduled product requirement",
  "周新增/上线需求（数量）": "New/online requirements per week (number)",
  "完成方案/评审-上线（周需时）": "Programme completed/reviewed - online (when needed)",
  "专业线需求数量": "Number of professional lines of requirement",
  "您还没有仪表盘哦，请先点击下方按钮创建一个仪表盘吧": "You don't have a dashboard. Please click the bottom button to create a dashboard.",
  "只能上传图片文件": "Only upload pictures files",
  "图片大小不能超过 5MB": "Picture size cannot exceed 5MB",
  "图片上传成功": "Image upload successful",
  "上传失败:": "Upload failed:",
  "卡片信息缺失，无法赠送": "Card information is missing and cannot be given",
  "请选择接收人": "Select recipient",
  "赠送成功": "Presented successfully",
  "请选择卡片进行预览": "Please select a card for preview",
  "确认赠送": "Confirmed",
  "接收人": "Recipient",
  "请选择需要赠送的同事": "Please choose a colleague who needs a gift.",
  "赠送说明": "Notes",
  "请输入赠送说明": "Please enter a gift note.",
  "选择装饰": "Select Decoration",
  "自定义": "Custom",
  "实时预览": "Real time preview",
  "送你": "Here.",
  "选择点赞卡组：": "Select Zancard group:",
  "请选择组": "Select Group",
  "研发过程缺陷质量指标": "Quality indicators for R&D process deficiencies",
  "研发过程缺陷解决时效": "Deficiencies in the R & D process to address time limits",
  "质量度量指标": "Quality measures",
  "子项目质量度量指标对比": "Comparison of sub-project quality measures",
  "缺陷逃逸率=线上Bug数/（线上Bug数+研发过程Bug数）×100%": "Deficiencies escape rate = number of Bugs on line/(line of Bugs + Bugs in R & D) x 100%",
  "缺陷漏检率=线上Bug数/研发过程Bug数×100%": "Deficiencies detection rate = 100 per cent of the number of Bugs on line/R & D",
  "缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "The average time taken to resolve the defects = thallium (resolution time - creation time)/n.",
  "缺陷平均关闭耗时": "Average time spent closing defects",
  "缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "The average time taken to close the defect = ∑ (closure time - resolution time)/n.",
  "缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "Re-opening of defects = number of defects reopened/total number of deficiencies closed x 100%",
  "需求设计缺陷率=需求设计缺陷数/缺陷总数×100%": "requirement Design Impairment Rate = Total Number of Needs Design Impairments/Defections x 100%",
  "研发过程缺陷质量指标（子项目）": "Quality indicators for R&D process deficiencies (sub-project)",
  "研发过程缺陷解决时效（子项目）": "Deficiencies in the R & D process are addressed (sub-project)",
  "测试阶段平均时间": "Average duration of test phase",
  "验收阶段平均时间": "Average time at the acceptance and inspection stage",
  "需求平均前置时间": "Average lead time required",
  "产品需求各阶段平均耗时横向对比": "Average time-consuming horizontal comparison of product requirement stages",
  "等待阶段": "Waiting phase",
  "产品方案": "Product programme",
  "研发阶段": "R&D phase",
  "测试阶段": "Test phase",
  "验收阶段": "Acceptance phase",
  "需求前置时间": "Require preset time",
  "从需求提出，到完成开发、测试、上线的时间周期价值，反映了业务和产研团队对客户问题或业务机会的交付（响应）速度，依赖整个组织各职能部门的协调一致和紧密协作。": "The time-cycle value from requirement generation to completion of development, testing and go-live reflects the speed at which business and research teams deliver (responding) to client issues or business opportunities, relying on coherence and close collaboration across functions across the organization.",
  "注: 各阶段时间均已四舍五入至两位小数，总时间与各阶段直接相加可能存在微小差异。": "Note: All stages have been rounded to two decimal places, and there may be minor differences between the total time and the stage directly.",
  "回滚率": "Rollback Rate",
  "产品评审驳回率=评审驳回数/（评审驳回回数+评审通过数）×100%": "Product evaluation rejection rate = 100 per cent of evaluation rejections/(evaluation rejections + evaluation passed) x",
  "代码提交规范率=代码提交关联需求或者缺陷数/提交总数×100%": "Code submission standard ratio = code submission of associated needs or defects/total submission x 100%",
  "紧急发布率=紧急发布次数/发布总次数 ×100%": "Emergency launch rate = number of emergency issuances/total number of issuances x 100 per cent",
  "发布成功率=发布成功数/发布总数 ×100%": "Publication success = number of success stories/total number of releases x 100%",
  "发布回滚率=回滚数/发布总数 ×100%": "Release rollback = rollback/total number of releases x 100%",
  "线上缺陷质量指标": "Quality indicators for online defects",
  "线上缺陷解决时效": "Online defect resolution time limit",
  "线上缺陷质量指标（子项目）": "Quality indicators for online defects (sub-project)",
  "线上缺陷解决时效（子项目）": "Online deficiency resolution prescription (sub-project)",
  "子项目代码与发布质量监测对比": "Sub-project code versus release quality monitoring",
  "子系统产品需求各阶段平均耗时更新对比": "Average time-consuming update of sub-system product requirements",
  "需求总交付": "Total requirement delivery",
  "需求耗时分布（均值）": "Time-consuming distribution of requirement (average)",
  "需求平均等待时间": "Average waiting time for needs",
  "需求平均开发周期": "Average requirement development cycle",
  "需求平均测试周期": "requirement average test cycle",
  "需求平均验收周期": "Average requirement acceptance cycle",
  "发布回滚率": "Release Rollback Rate",
  "产品需求设计缺陷率": "Product requirement design deficiency rate",
  "产品需求设计缺陷率=产品需求设计缺陷数/研发过程缺陷总数×100%": "Product requirement Design Deficit Rate = Product requirement Design Deficiencies/total R & D process defects x 100%",
  "研发过程缺陷平均解决耗时（单位：天）": "Average time (in days) to address deficiencies in the R & D process",
  "研发过程缺陷平均解决耗时": "Average time-consuming resolution of R&D process deficiencies",
  "研发过程缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "The average time taken to address the deficiencies in the R & D process = ∑ (resolution time - creation time)/n.",
  "研发过程缺陷平均关闭耗时（单位：天）": "Average time taken to close a R&D process defect (in days)",
  "研发过程缺陷平均关闭耗时": "Average time taken to shut down the R & D process",
  "研发过程缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "The average time taken to shut down the R & D process = ∑ (closure time - resolution time)/n.",
  "研发过程缺陷重开率": "Re-opening rate of R&D process deficiencies",
  "研发过程缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "Re-opening rate for R & D defects = number of defects reopened/total number of deficiencies closed x 100%",
  "线上缺陷产品需求设计缺陷率": "Design defects rate for online defective products",
  "线上缺陷产品需求设计缺陷率=线上缺陷产品需求设计缺陷数/线上缺陷总数×100%": "Impairment rate = Design deficiency rate = total number of defects = defects = 100 per cent",
  "线上缺陷平均解决耗时（单位：天）": "Average time taken to resolve online defects (days)",
  "线上缺陷平均解决耗时": "The average time taken to resolve the defects on the line",
  "线上缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "Online defects are resolved on average = zirconium (resolution time - creation time)/n.",
  "线上缺陷平均关闭耗时（单位：天）": "Average time taken to close on-line defects (days)",
  "线上缺陷平均关闭耗时": "Online defects average time-consuming",
  "线上缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "Online defects take an average time = ∑ (closure time - resolution time)/n.",
  "线上缺陷重开率": "Reopen rate for online defects",
  "线上缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "Reopening rate for online defects = number of defects reopened/total number of defects closed x 100 per cent",
  "改进看板": "Improve the panel",
  "效率指标": "Efficiency indicators",
  "执行人类型": "Executor type",
  "质量指标": "Quality indicators",
  "财务分析": "Financial analysis",
  "请选择团队": "Please select a team.",
  "选择年份": "Select Year",
  "排名": "Rank",
  "年": "Year",
  "总计:": "Total:",
  "人员/年份": "Personnel/year",
  "排序方式": "Sort by",
  "按": "Press",
  "计划上线时间": "Plan time on line",
  "操作人员": "Operator",
  "服务状态": "Service Status",
  "其他": "Other",
  "影响周期": "Impact cycle",
  "有效解决时间": "Effective resolution time",
  "责任组长": "Head of Mission",
  "直接原因": "Direct causes",
  "根本原因": "The root causes",
  "关联项名称": "Associated Item Name",
  "驳回原因": "Reason for rejection",
  "提交不规范": "Commit irregularly",
  "提交人邮箱": "The author's mailbox",
  "请求次数": "Number of requests",
  "平均响应时间 (ms)": "Average response time (ms)",
  "错误数": "Errors",
  "慢查询": "Slow Query",
  "异常数": "Unusual",
  "慢接口": "Slow Interface",
  "等待时间": "Wait Time",
  "非规范提交记录": "Irregular submission record",
  "发布失败记录": "Organisation",
  "未覆盖需求记录": "Uncovered needs record",
  "技术债务详情": "Technical debt details",
  "总计：": "Total:",
  "执行次数": "Number implemented",
  "已解决": "Solved",
  "慢SQL模版详情": "Slow SQL template details",
  "慢SQL日志记录": "Slow SQL Log Log",
  "近三年": "Almost three years.",
  "近二年": "Almost two years.",
  "近一年": "About a year ago.",
  "筛选指标": "Filter indicators",
  "上月": "Last Month",
  "过往整周期": "Past whole cycle",
  "昨天": "Yesterday.",
  "上周": "Last week.",
  "上个月": "Last month.",
  "上两月": "Last February",
  "上三月": "Last March",
  "上一自然半年": "The last natural six months.",
  "去年": "Last year.",
  "最近": "Recent",
  "近7天": "Almost seven days.",
  "近60天": "Almost 60 days.",
  "近90天": "Almost 90 days.",
  "近180天": "Almost 180 days.",
  "近365天": "Almost 365 days",
  "近1月": "Last January",
  "近3月": "Last March",
  "近6月": "June",
  "近12月": "Almost December",
  "当前整周期": "Current whole cycle",
  "当前自然半年": "Current natural six months",
  "今年": "This year",
  "至今": "To date",
  "本周至今": "Since this week",
  "本月至今": "This month to date",
  "本年至今": "Year to date",
  "我的任务": "My mission.",
  "任务负责人看板": "Watchlist for mandate-holders",
  "气泡大小:": "Bubble size:",
  "（值越大，气泡越大）；": "(The greater the value, the greater the bubble);",
  "气泡颜色:": "Bubble colour:",
  "（值越大，颜色越深）": "(The larger the value, the deeper the color)",
  "排序:": "Sorting:",
  "您没有权限查看该角色数据": "You do not have access to the character data",
  "选择角色": "Organisation",
  "人员对比": "Comparison of personnel",
  "专业线对比": "Professional line comparison",
  "年度对比": "Annual comparison",
  "选择业务领域": "Selection of business areas",
  "选择人员(可多选)": "Selection (multi-optional)",
  "选择业务领域(可多选)": "Selection of areas of operation (multi-optional)",
  "选择年份(可多选)": "Select Year (multi-optional)",
  "请选择角色": "Please select the character.",
  "角色：": "Role:",
  "您没有权限查看该用户数据": "You do not have access to the user data",
  "指标": "Indicators",
  "(单位:": "(Unit:",
  "均值/总数": "Average/total",
  "个人对比": "Personal comparison",
  "全年": "All year",
  "上半年": "First half of the year",
  "下半年": "Second half",
  "上班": "Work.",
  "打卡时间": "Play time.",
  "下班": "Off duty.",
  "卡片唯一标志编码，前、后端需要根据该标志编码进行功能开发": "The card unique sign code, the front, back end of which requires functional development",
  "（创建公共卡片需要代码开发，请确认卡片功能上线后再创建卡片）": "(Code development is required to create a public card. Please confirm that the card will go online before creating the card.)",
  "新建卡片如需代码开发，请提前告知开发卡片编码": "If you need code development for a new card, please notify them in advance.",
  "创建卡片": "Create card",
  "请输入卡片名称或描述或编码": "Please enter a card name or description or code",
  "确定要删除 【": "Make sure to delete [%1]",
  "】 卡片吗？": "A card?",
  "我的仪表盘": "My dashboard.",
  "】 仪表盘吗？": "The dashboard?",
  "请选择或输入成员名称": "Please select or enter the name of the member",
  "（可通过拖拽调整卡片展示顺序）": "(The display order of cards can be adjusted by drag)",
  "显示在当前仪表盘": "Show the current dashboard",
  "可添加的卡片": "Addable Cards",
  "异常事项": "Unusual matters",
  "点击查看详情": "Click to see details",
  "我的考勤详情": "My attendance details.",
  "只能选择单条进行操作！": "Only single lines can be selected for operation!",
  "缺陷名称和链接已剪贴板": "Disable name and link clipboard",
  "催办成功": "It's working.",
  "线上问题明细": "On-line details.",
  "缺陷明细": "Discrepancies",
  "该任务相关联的服务的服务类型": "Type of service associated with the mandate",
  "指派给我的": "It was assigned to me.",
  "抄送给我的": "A copy to me.",
  "我反馈的": "I did.",
  "需求明细": "Detailed Requirements",
  "我负责的需求": "I'm responsible for the needs.",
  "我开发的需求": "I need to develop.",
  "我关注的需求": "I'm concerned about needs.",
  "我相关的需求": "My needs.",
  "已催促全部未确认人！": "All unidentified persons have been pressed!",
  "该评审相关信息已复制到剪贴板": "The evaluation information was copied to the clipboard",
  "评审明细": "Details of the evaluation",
  "确定要完成": "Make sure it's done.",
  "确定要取消": "Make sure it's cancelled.",
  "评审的会议吗？": "The jury meeting?",
  "我参与的评审": "I was involved in the review.",
  "我发起的评审": "I initiated the review.",
  "质量门禁": "Quality Gate Ban",
  "可靠性评级": "Reliability rating",
  "可维修性评级": "Maintenance rating",
  "漏洞数量": "Number of loopholes",
  "安全评级": "Security rating",
  "热点已审查(%)": "Hotspots reviewed (%)",
  "审查评级": "Review ratings",
  "覆盖率(%)": "Coverage (%)",
  "重复率(%)": "Repetition rate (%)",
  "代码行数": "Number of code lines",
  "扫描时间": "Scan Time",
  "详细报告": "Detailed report",
  "漏洞总数": "Total loopholes",
  "严重漏洞": "Serious loopholes",
  "高危漏洞": "High-risk loopholes",
  "中危漏洞": "Risk gap",
  "低危漏洞": "Low risk loophole",
  "组件总数": "Total number of components",
  "严重组件": "Severe Component",
  "高危组件": "High-risk components",
  "中危组件": "Medium-risk component",
  "低危组件": "Low-risk components",
  "慢SQL模板": "Slow SQL Template",
  "「协同」": "\"Synergy.\"",
  "我负责的迭代": "I'm responsible for it.",
  "预估人天（天）": "Estimated human days (days)",
  "实际工时（时）": "Actual working hours (hours)",
  "任务明细": "Task detail",
  "我负责的任务": "My mission.",
  "我参与的任务": "I'm on a mission.",
  "点击维护团队成员后可查看成员工作状况": "Click on the maintenance team member to see how members work",
  "维护成员": "Maintenance members",
  "请选择或输入成员名称查询": "Select or enter a member name to search",
  "用例类型": "Example type",
  "运行结果": "Run Results",
  "用例状态": "Case Status",
  "用例内容": "Examples",
  "我创建的测试用例": "I created a test example.",
  "请选择截止时间": "Please select a deadline",
  "今天到期": "Due today",
  "本周到期": "Due this week",
  "请先编辑并排期": "Please edit and schedule first",
  "待排期任务": "Tasks to schedule",
  "待评审测试用例": "Example to be evaluated",
  "未知": "Unknown",
  "测试环境": "Test Environment",
  "生产环境": "Production environment",
  "UAT环境": "UAT Environment",
  "查看全部": "View All",
  "研发缺陷": "R&D deficiencies",
  "线上缺陷": "Online defects",
  "未完成事项": "Not completed",
  "项目数据透视": "Project data perspective",
  "考勤状态：": "Attendance status:",
  "考勤状态：普通": "Attendance status: Normal",
  "欢迎来到研发效能工作台": "Welcome to the R&D effectiveness desk.",
  "研发效能工作台，聚合了研发效能平台与你相关的工作内容，帮助你更轻松、高效的处理工作，": "The R & D effectiveness platform brings together the work of the R & D effectiveness platform that is relevant to you and helps you to handle it more easily and efficiently.",
  "自定义卡片等功能帮助你高效触达工作场景。": "Customized cards and so on help you reach the work scene efficiently.",
  "请选择工作台角色": "Select the role of the desk",
  "开始工作": "Get to work.",
  "请选择仪表盘": "Select the dashboard",
  "新的仪表盘": "New dashboard",
  "配置仪表盘": "Configure dashboard",
  "编辑卡片": "Edit Card",
  "配置卡片": "Configure Cards",
  "分组字段:": "Group fields:",
  "分组层级最多支持4级，请重新选择": "Group level supports up to level 4. Select",
  "选择分组字段（最多4级）": "Select Group Fields (up to Level 4)",
  "⚠️ 已达到最大分组层级限制（4级），可删除现有分组后继续选择": "• The maximum group level limit (level 4) has been reached, allowing for the deletion of existing groups and the continuation of selection",
  "📋 基础信息": "Basic information",
  "🏢 归属信息": "Information on attribution",
  "👥 团队人员": "Team",
  "⚡ 操作人员": "Operator",
  "当前分组 (": "Current Grouping",
  "统计图表": "Statistical charts",
  "清理资源中...": "Clearing resource...",
  "切换中...": "Switching...",
  "获取图表选择数据失败:": "Failed to fetch chart selection data:",
  "展开控制面板": "Expand Control Panel",
  "收起控制面板": "Collapse Control Panel",
  "刷新数据": "Refresh Data",
  "添加图表": "Add Chart",
  "调整图表顺序": "Reorder Charts",
  "展示图表：": "Show charts:",
  "选择图表": "Select Chart",
  "需求创建时间:": "_Other Organiser",
  "请先选择需求池来查看数据": "Please select the requirement pool to check the data.",
  "您还没有自定义需求池哦，请先点击下方按钮创建一个需求池吧": "You don't have a custom requirement pool. Please click the bottom button to create a requirement pool.",
  "创建需求池": "Create requirement Pool",
  "请先选择左侧的需求池来查看数据": "Please select the requirement pool on the left for data first.",
  "展开控制面板(视图切换 · Tab切换 · 操作区)": "Expand control panel (view switch. Tab switch. operating area)",
  "收起控制面板(视图切换 · Tab切换 · 操作区)": "Collapse control panel (view switch. Tab switch. operating area)",
  "拖拽调整列宽": "Drag to adjust column width",
  "需求名称/序列号": "Required name/serial number",
  "请输入名称或序列号": "Please enter a name or serial number",
  "请选择需求类型": "Please select the type of requirement",
  "系统培训": "System training",
  "需要": "Yes.",
  "不需要": "No need.",
  "影响国家": "Impact on countries",
  "期待完成日期": "Expected completion date",
  "发布完成日期": "Issue completion date",
  "状态筛选": "Status Filter",
  "人员筛选": "Personnel screening",
  "筛选条件已重置": "Filter condition reset",
  "拆分时，该角色下每个人员独立一个分组；不拆分时，该角色下所有人员合并为一个分组": "When split, each member of the role is separated into a separate subgroup; if not divided, all members of the role are merged into one subgroup",
  "拆分": "Split",
  "字段管理 (": "Field Management (",
  "字段管理": "Field Management",
  "搜索字段名称...": "Search Field Name...",
  "个字段": "Fields",
  "全选": "Select All",
  "固定字段": "Fixed Fields",
  "已启用字段": "Enabled fields",
  "未启用字段": "No field enabled",
  "没有找到匹配的字段": "No matching fields found",
  "新建图表": "New Chart",
  "编辑图表": "Edit Chart",
  "查看图表": "View Charts",
  "请输入图表名称": "Please enter a chart name",
  "横轴（类别）": "Crossaxis (Category)",
  "请选择横轴类别": "Select a cross-axis category",
  "过滤条件": "Filter Conditions",
  "设置过滤条件": "Set filter conditions",
  "未设置": "Not set",
  "请选择迭代": "Please select an iterative",
  "请选择国家线": "Please select a national line",
  "请选择测试": "Please select the test",
  "实际完成日期": "Actual completion date",
  "获取图表数据失败:": "Failed to load chart data:",
  "图表顺序调整成功": "Diagram Ordered Successful",
  "拖拽卡片调整图表显示顺序，调整完成后点击确定保存": "Drag the card to reorder the chart display and click to save after completion",
  "拖拽调整顺序": "Drag to reorder order",
  "图表删除成功": "Chart deleted successfully",
  "请先配置图表": "Please configure the chart first.",
  "删除图表确认": "Delete Chart Confirmation",
  "确定要删除图表": "Confirm to delete chart",
  "需求池名称": "requirement pool name",
  "请输入需求池名称": "Please enter the name of the requirement pool",
  "需求池名称不能超过100个字符": "requirement pool name cannot exceed 100 characters",
  "负责人：": "Responsible:",
  "确认添加人员": "Confirm additional personnel",
  "确认添加": "Confirm Add",
  "选中的系统：": "System selected:",
  "选中的标签：": "_Other Organiser",
  "将要添加的人员": "Persons to be added",
  "点击人员标签的 ✕ 可移除该人员": "Click on the person label to remove the person",
  "所选系统的人员已全部存在，无需添加新人员。": "All personnel of the selected system already exist and no new personnel are required.",
  "其他可查看人员": "Other viewable persons",
  "快速添加系统人员/标签人员": "Quick Add System Personnel / Labels",
  "选择系统来快速添加人员": "Select the system to quickly add people",
  "选择标签来快速添加属于该标签的需求的人员": "Select a label to quickly add the person that needs it",
  "中文名": "Chinese",
  "英文名": "English Name",
  "关闭状态创建的标签为研发效能内部标签，开启状态为研发效能内部标签+需求看板外部展示标签。": "The label created for the closed state is the internal label for R & D effectiveness, which is activated by the external display of the internal label for R & D effectiveness + the requirement panel.",
  "添加标签": "Add Tab",
  "标签需求": "Tab Needs",
  "请先选择系统": "Select the system first.",
  "所选系统的人员已全部存在，无需添加": "All the selected systems already exist, no need to add",
  "请先选择标签": "Please select the label first",
  "所选标签的人员已全部存在，无需添加": "All selected labels already exist without adding",
  "人员已添加成功": "People added successfully",
  "添加失败": "Add Failed",
  "暂无有效的甘特图数据": "No valid Gantt data available",
  "个分组，": "Groups,",
  "条记录": "Notes",
  "全部折叠": "Collapse All",
  "需求:": "Needs:",
  "任务名称:": "_Other Organiser",
  "负责人:": "Responsible:",
  "任务类型:": "_Other Organiser",
  "开始时间:": "_Other Organiser",
  "结束时间:": "_Other Organiser",
  "所属迭代": "Organisation",
  "暂停至日期": "Pause to Date",
  "提测时间": "Time of survey",
  "后端任务时间": "Backend Task Time",
  "前端任务时间": "Front-end task time",
  "测试任务时间": "Test Task Time",
  "UI任务时间": "UI Task Time",
  "需求标题": "Needs Title",
  "UI设计师": "UI Designer",
  "筛选中...": "Filtering...",
  "数据更新中...": "Data updating...",
  "所有需求池": "All requirement pool",
  "产品需求池": "Product requirement Pool",
  "业务方需求池": "Operations needs pool",
  "开发需求池": "Development of requirement pool",
  "测试需求池": "Test requirement Pool",
  "前端需求池": "Front-end requirement pool",
  "后端需求池": "Backend requirement Pool",
  "UI设计需求池": "UI Design requirement Pool",
  "技术支持需求池": "Technical support needs pool",
  "已完成需求池": "Needs pool completed",
  "已复制": "Copyed",
  "性别:": "Gender:",
  "男": "Men",
  "女": "Women",
  "入职时间:": "Onboarding:",
  "所属国家:": "Country of nationality:",
  "Base地:": "Base:",
  "部门:": "Sector:",
  "手机号:": "Cell phone number:",
  "邮箱:": "Mailbox:",
  "所属系统:": "System in which:",
  "备注:": "Remarks:",
  "参与项目数 :": "Number of participating items:",
  "总人数:": "Total:",
  "逻辑图 (向右)": "Logic Chart (Right)",
  "思维导图": "Mindchart",
  "性别": "Gender",
  "入职时间": "Induction time",
  "所属国家": "Country of nationality",
  "所在部门": "Department",
  "手机号": "Cell phone number",
  "请选择所属系统": "Select your system",
  "请输入备注": "Please enter a comment",
  "点赞说明": "It's a compliment.",
  "缺陷的新增数量会有所波动。小幅度的波动是正常的，不必过于关注。需要关注的是大幅度的波动或连续的上升趋势会带来需求交付的延期风险。": "The number of new deficiencies will fluctuate. Small-scale fluctuations were normal and did not require too much attention. It is important to note that large fluctuations or successive upward trends can lead to the risk of delayed requirement delivery.",
  "是指单位时间内未解决的缺陷数量的趋势，反映出团队处理缺陷的能力及软件质量的状态。以下是一些查看存量缺陷趋势指标时的提示：": "This refers to the trend in the number of deficiencies not resolved in unit time, reflecting the ability of the team to address the deficiencies and the state of software quality. The following are some of the hints for the stock deficiency trend indicators:",
  "长期趋势：如果长期存量缺陷数量持续增长，可能说明存在质量问题或团队处理缺陷的效率低下。": "Long-term trend: If the number of long-term stock defects continues to grow, it may be indicative of quality problems or inefficiencies in team handling deficiencies.",
  "处理速度：存量缺陷如果长期不降只升，表示团队处理缺陷的速度赶不上新增缺陷的速度，可能需要调整优先级，分配更多的资源来处理旧的缺陷。": "Processing speed: The stock deficiency, if it does not rise for a long period of time, means that the team has not been able to address the deficiencies at the rate of new deficiencies and may need to reprioritize and allocate more resources to address old deficiencies.",
  "缺陷趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "Shortcoming trends are an important tool in a healthy software development life cycle, which, in addition to being used to track the pace of requirement, can serve as an important reference for improving work processes and improving product quality.",
  "该图表会显示每天新增的缺陷数量、修复的缺陷数量以及仍然活跃的或未解决的缺陷数量（通常称为\"缺陷存量\"）。": "The chart shows the number of new defects added daily, the number of deficiencies repaired and the number of deficiencies that remain active or unresolved (usually referred to as \"defect stock\").",
  "通常指的是在一天缺陷数量的变化。包括新增的缺陷，已经关闭的缺陷，解决中的缺陷等。": "Usually, it refers to a change in the number of defects in one day. Includes new deficiencies, deficiencies that have been closed, deficiencies in resolution, etc.",
  "效率衡量： 如果你的团队今天解决了很多缺陷，但同时又产生了许多新的缺陷，那缺陷数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "Efficiency measures: If your team solves many deficiencies today, but at the same time creates many new ones, the indicator of change in the number of days of impairments will reflect this well as an indicator of the effectiveness of the team.",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果缺陷的数量持续减少，那说明正在向好的方向发展。": "Progress tracking: This indicator can help R&D track progress in requirement. If the number of deficiencies continued to decrease, it would indicate a positive development.",
  "所选时间段内未关闭缺陷各状态占比": "Percentage of states with unclosed defects within the selected time period",
  "所选时间段内未关闭缺陷各优先级占比": "Percentage of priority for unclosed defects in the selected time period",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决缺陷数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "Helping to detect potential problems: This helps us to identify those who may need more support or whether their workload is excessive. If the number of unresolved deficiencies is much higher among one team member than others, this may indicate that the areas they are dealing with are particularly complex or may require additional resources and attention.",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的缺陷数量大致平均。这个指标并不意味着缺陷多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "Balancing the load: this indicator can also help us balance the load, and by adjusting the distribution of tasks we can roughly equalize the number of deficiencies for which each team member is responsible. This indicator does not mean that many team members with deficiencies are inefficient or have poor technical capacity, but may rather be because they are dealing with more complex issues that require more expertise. It is therefore necessary to take into account the actual situation and to understand the possible factors behind it, rather than simply quantifying them.",
  "是指单位时间内未解决的线上问题数量的趋势，反映出团队处理线上问题的能力及软件质量的状态。以下是一些查看存量线上问题趋势指标时的提示：": "This refers to the trend in the number of on-line problems that remain unresolved within unit time, reflecting the ability of the team to handle on-line problems and the state of software quality. The following are some of the tips for looking at trend indicators of problems on the stockline:",
  "长期趋势：如果长期存量线上问题数量持续增长，可能说明存在质量问题或团队处理线上问题的效率低下。": "Long-term trend: If the number of problems on the long-term stock line continues to grow, it may be indicative of quality problems or inefficient team handling of problems on the line.",
  "处理速度：存量线上问题如果长期不降只升，表示团队处理线上问题的速度赶不上新增线上问题的速度，可能需要调整优先级，分配更多的资源来处理旧的线上问题。": "Processing speed: If the stock line problem does not rise for a long time, it means that the team does not manage the line problem as fast as the new line problem, and may need to reprioritize and allocate more resources to address the old line problem.",
  "线上问题趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "On-line problem trends are an important tool in a healthy software development life cycle, which, in addition to being used to track requirement progress, can serve as an important reference for improving workflows and improving product quality.",
  "该图表会显示每天新增的线上问题数量、修复的线上问题数量以及仍然活跃的或未解决的线上问题数量（通常称为\"线上问题存量\"）。": "The chart shows the number of new problems on the line per day, the number of problems on the line that have been repaired and the number of problems on the line that are still active or unresolved (often referred to as \"the stock of problems on the line\".",
  "通常指的是在一天线上问题数量的变化。包括新增的线上问题，已经关闭的线上问题，解决中的线上问题等。": "Usually, it refers to changes in the number of problems on the day line. Includes new production issues, already closed production issues, resolving production issues, etc.",
  "效率衡量： 如果你的团队今天解决了很多线上问题，但同时又产生了许多新的线上问题，那线上问题数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "Efficiency measurement: If your team solves a lot of production issues today, but at the same time creates a lot of new production issues, the indicator of change in the number of questions (days) on the line can well reflect this situation as an indicator of team efficiency.",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果线上问题的数量持续减少，那说明正在向好的方向发展。": "Progress tracking: This indicator can help R&D track progress in requirement. If the number of problems on the line continued to decrease, that would indicate a positive development.",
  "所选时间段内未关闭线上问题各状态占比": "Proportion of problems on the line that have not been closed within the selected time period",
  "所选时间段内未关闭线上问题各优先级占比": "Percentage of priority issues on the line that have not been closed within the selected time period",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决线上问题数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "Helping to detect potential problems: This helps us to identify those who may need more support or whether their workload is excessive. If the number of unresolved online issues is much higher among one team member than others, this may indicate that the areas they are addressing are particularly complex or may require additional resources and attention.",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的线上问题数量大致平均。这个指标并不意味着线上问题多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "Balancing the load: this indicator can also help us balance the load, and by adjusting the distribution of tasks, we can roughly equalize the number of problems on the line for each team member. This indicator does not mean that team members with many problems online are inefficient or have poor technical capacity, but may be because they are dealing with more complex issues that require more expertise. It is therefore necessary to take into account the actual situation and to understand the possible factors behind it, rather than simply quantifying them.",
  "有": "Yeah.",
  "没有": "Nothing.",
  "配置模板": "Configure Templates",
  "自动推送": "Automatically Send",
  "抄送人&负责人": "Copy to person/head",
  "编辑模板": "Edit Template",
  "管理部门周报细分模板": "Management weekly breakdown template",
  "确认要删除该部门周报模板吗？": "Are you sure you want to delete the department weekly template?",
  "删除部门周报模板": "Remove Department Weekly Reporting Template",
  "配置部门周报": "Configure Department Weekly Report",
  "部门列表": "Sector List",
  "已配置模板列表": "Configured Template List",
  "配置部门周报模板": "Configure Department Weekly Reporting Templates",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xxx部门2034年第17周周报】；通配符说明：%N【部门名称】、%Y【当前年份】、%W【当年第几周】": "If no custom requirement is needed, use the default wildcard template without modification. For example, [%N_%Y Week %W Weekly Report] becomes [xxx Department 2034 Week 17 Weekly Report]. Wildcards: %N [Department Name], %Y [Current Year], %W [Week of Year].",
  "点击上方复制按钮获取原始模板或者自定义带有%Y与%W的模板": "Click the copy button above to get the original template, or customize a template containing %Y and %W.",
  "点击获取原始标题模板": "Click to get the original title template",
  "原始标题模板已复制到剪贴板": "Original title template copied to clipboard",
  "选择你的周报收件人": "Select your weekly recipients.",
  "周报包含成员": "Weekly newspaper includes members",
  "已添加周报模板项": "A weekly template item added",
  "(可拖拽调整顺序)": "(with drag to adjust order)",
  "未添加周报模板项": "No weekly template entries added",
  "已有模板": "Template already exists",
  "确认删除该项目周报模板吗？": "Confirm the deletion of the weekly reporting template for the project?",
  "未获取到模板ID，无法删除": "Template ID is unavailable. Unable to delete.",
  "删除模板": "Remove Template",
  "配置项目周报": "Configure Project Weekly Report",
  "我负责且进行中的项目": "I'm in charge of ongoing projects.",
  "发送成功": "Sent successfully",
  "汇报对象为邮件收件人，并且会自动拉取项目相关人员作为邮件抄送人": "Reporting object is the recipient of the mail and automatically removes the project person as the sender",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xx项目_2024年第17周周报】；通配符说明：%N【项目名称】、%Y【当前年份】、%W【当年第几周】": "If no custom requirement is needed, use the default wildcard template without modification. For example, [%N_%Y Week %W Weekly Report] becomes [xx Project_2024 Week 17 Weekly Report]. Wildcards: %N [Project Name], %Y [Current Year], %W [Week of Year].",
  "选择周报收件人": "Select recipients of weekly newspapers",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【产品经理_2024年第17周周报】；通配符说明：%N【角色名称】、%Y【当前年份】、%W【当年第几周】": "If no custom requirement is needed, use the default wildcard template without modification. For example, [%N_%Y Week %W Weekly Report] becomes [Product Manager_2024 Week 17 Weekly Report]. Wildcards: %N [Role Name], %Y [Current Year], %W [Week of Year].",
  "选择周报成员": "Selection of weekly newspaper members",
  "请选择周报成员": "Please choose the weekly members.",
  "周报人员状况": "Status of personnel reported weekly",
  "模板包含成员": "Template contains members",
  "确认要克隆该部门小组周报模板吗？": "Are you sure you want to clone the weekly report template for the unit?",
  "一键克隆模板": "One-click clone template",
  "确认要删除该部门小组周报模板吗？": "Are you sure you want to delete the weekly template for this unit?",
  "删除部门小组周报模板": "Remove the weekly template of the sector group",
  "创建部门小组周报模板": "Create a weekly template for sector groups",
  "配置个人周报模板": "Configure personal weekly reporting templates",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W_%B%P周报】 会自动转译为 【Luke李黎明_2024年第17周_研发效能（Development Engineer）周报】；通配符说明：%N【发送人姓名】、%Y【当前年份】、%W【当年第几周】、%B【业务领域】、%P【岗位】": "If no custom requirement is needed, use the default wildcard template without modification. For example, [%N_%Y Week %W_%B %P Weekly Report] becomes [Luke_2024 Week 17_R&D Efficiency (Development Engineer) Weekly Report]. Wildcards: %N [Sender Name], %Y [Current Year], %W [Week of Year], %B [Business Area], %P [Position].",
  "如果开启则在每周日15:00自动推送": "If it's open, it's automatically delivered at 1500 on a Sunday.",
  "已生成分享内容至剪切板": "Shared content to clipboard generated",
  "删除评论": "Delete Comments",
  "确认删除这条评论吗?": "Are you sure you want to delete this comment?",
  "汇报给：": "Reporting to:",
  "抄送：": "Copy:",
  "上一条": "Previous",
  "下一条": "Next",
  "已读数：": "Read:",
  "已读人：": "Reader:",
  "点赞人：": "Acclaimed:",
  "点赞": "Yes.",
  "评论区：": "Comment area:",
  "已保存为本周草稿内容": "Saved as this week 's draft",
  "保存后，本周写周报会携带上草稿内容，下周自动失效（草稿只对本周工作小结、下周工作计划、感想&问题&建议、自由内容模板有效）": "Once saved, this week's weekly paper will carry the draft, which will automatically expire next week. (The draft will only be valid for this week's working summary, next week's work programme, perception & questions & suggestions, free content template)",
  "保存本周草稿": "Can not open message",
  "确定现在推送工作周报吗？": "Are you sure you're pushing the workweek now?",
  "周报已在推送中，请勿重复提交": "The weekly report is being delivered. Please do not repeat.",
  "已创建周报推送任务，请稍等": "Created Weekly Report to Send Job, please wait",
  "确认后将会直接生成【当周周报】！": "When confirmed, it will be produced directly.",
  "保存后，本周写周报会携带上草稿内容，下周自动失效": "After saving, this week's weekly paper will carry the draft and automatically expire next week.",
  "以下数据由系统生成：": "The following data are generated by the system:",
  "点击查看git提交详情": "Click to see Git for details",
  "点击查看代码提交规范": "Click to see code submission specifications",
  "确认后将会直接生成【当周周报】并通过邮件推送给汇报对象！": "When confirmed, it will be generated directly.",
  "用例类别": "Example category",
  "标记": "Tag",
  "开始日期": "Start date",
  "风险程度": "Level of risk",
  "风险应对方法": "Risk response",
  "已处理": "Processed",
  "未处理": "Not processed",
  "总用例数量": "Total number of cases used",
  "新增功能用例数量": "Number of new functional examples",
  "已完成功能用例数量": "Number of functional examples completed",
  "未完成功能用例数量": "Number of functional examples not completed",
  "新增自动化用例数量": "Number of new examples of automation",
  "已完成自动化用例数量": "Number of cases of automation completed",
  "未完成自动化用例数量": "Number of cases where automation was not completed",
  "该URL已失效，请重新复制新的分享链接在打开详情！": "The URL is invalid, please copy the new shared link to open details!",
  "点赞数": "Nice point.",
  "确认要删除该周报吗？": "Are you sure you want to delete the weekly?",
  "删除周报": "Delete Weekly",
  "欢迎使用每周三省吾身": "Welcome to the three provinces.",
  "每周三省吾身，支持配置周报模板，根据您本周的工作内容一键生成周报，并且支持定时推送，": "We support the configuration of the weekly report template in three provinces a week, generate a weekly report based on your work this week and support regular delivery.",
  "让您更轻松的填写周报。": "Make it easier for you to fill out the weekly paper.",
  "创建周报模板": "Create weekly newspaper template",
  "写部门周报": "Write department weekly.",
  "配置角色模板": "Configure Role Templates",
  "写项目周报": "Write Project Weekly",
  "配置项目周报模板": "Configure project weekly reporting templates",
  "请输入标题名称": "Please enter the title name",
  "选择成员": "Selection of members",
  "获取该组织下的所有人员，支持多选": "Get all the people under the organization and support the multiple selection.",
  "组织人员与岗位": "Organizational staff and posts",
  "产品人员": "Product personnel",
  "红色代表大于本周平均值，需关注。": "Red represents more than the average for this week and requires attention.",
  "平均值计算规则：总缺陷数 / 总人数": "Rule for calculation of average: total defects/total number",
  "汇总": "Summary",
  "1）淡黄色代表此产品经理评审数量在周平均值以下，如果持续较低需关注其工作内容。 平均值计算规则：总评审数 / 总人数": "1) Light yellow represents the number of evaluations conducted by the product manager below the weekly average, with attention to its work content if it continues to be low. Average rules: total number of evaluations/total number",
  "2）红色代表未评审需求。": "2) Red represents no assessment of needs.",
  "平均值": "Average",
  "1）红色代表工作时长高于47.5小时(每天9.5H), 需关注。": "1) Red represents working longer than 47.5 hours (9.5 H per day) and requires attention.",
  "2） 绿色代表工作时长低于42.5小时(每天8.5H)。": "2) Green delegates work less than 42.5 hours (8.5 H per day).",
  "周报推送时间": "Weektime",
  "每周日下午六点": "Six o'clock a week.",
  "确认要删除该周报模板吗？": "Are you sure you want to delete the weekly template?",
  "删除周报模板": "Remove Weekly Report Template",
  "配置角色模块": "Configure Role Modules",
  "新增周报模块": "New Weekly Report Module",
  "总工作时长": "Total working hours",
  "待介入需求平均已等待时长(天)": "The needs for intervention have been on average long (days)",
  "处理中需求": "Needs under processing",
  "已暂停需求": "Paused needs",
  "本周新增需求": "New requirement this week",
  "本周评审需求": "Review of needs this week",
  "本周产品缺陷": "Product defects this week",
  "颜色说明": "Colour Description",
  ": 黄色代表需要关注，红色代表需要重点关注。": ": Yellow delegates need attention, red delegates need focus.",
  "数据统计时间范围": "Time frame for data statistics",
  ": 上周一 00:00 到上周日 23:59:59。": "From 1:00 to Sunday 23:59.",
  "总工作时长参考": "Total working hours reference",
  "- 红色: 工作时长高于 47.5 小时 (每天 9.5 小时)，需关注。": "- Red: Working longer than 47.5 hours (9.5 hours per day) requiring attention.",
  "- 绿色: 工作时长低于 42.5 小时 (每天 8.5 小时)。": "- Green: works less than 42.5 hours (8.5 hours per day).",
  ": 待介入业务需求 + 待介入产品需求的总数。": ": Operational needs to be involved + total product needs to be involved.",
  "待介入需求平均已等待时长 (天)": "(days)",
  "计算规则为 (当前时间 - 待介入需求的创建时间) / 待介入需求数量。": "Calculates the rule (current time - creation time for needs to be involved) / the number of needs to be involved.",
  ": 需求状态为 “业务已确认” 或 “产品方案中” 的需求数量。": ": The requirement status is the number of “business confirmed” or “product programmes”.",
  "统计该产品经理的已暂停需求，“()”中统计的是平均暂停时长，与待介入需求平均已等待时长逻辑一致。": "Statistics on the suspended needs of the product manager, the average duration of which is measured in “()”, is consistent with the logic of the average length of time that the needs for intervention have been waiting for.",
  "- 淡黄色: 此产品经理评审数量在周平均值以下，需关注其工作内容。": "- Light yellow: The number of evaluations conducted by the manager of the product is below the weekly average and requires attention to the content of the work.",
  "- 红色: 未评审需求。": "- Red: Unevaluated needs.",
  ": 测试问题中类别为 “需求缺陷” 的问题数。": ": Number of questions with a “requirement deficiency” category in test questions.",
  "- 红色: 大于本周平均值。": "- Red: greater than the average for the week.",
  "汇总/平均": "Summary/average",
  "审核中": "Audited",
  "工作项名称": "Task Name",
  "发布类型": "Release Type",
  "关联分支": "Associated branch",
  "关联缺陷": "Link defects",
  "预约日期": "Date of appointment",
  "预约人": "Appointments",
  "预约时间": "Appointments",
  "发布状态": "Organisation",
  "发布描述": "Release Description",
  "审核备注": "Audit of comments",
  "确认要取消预约吗？": "Make sure you cancel your appointment?",
  "预约记录": "Record of appointment",
  "服务分支详情": "Details of service branches",
  "填写原因": "Enter Reason",
  "原因不能为空": "The reason cannot be empty.",
  "请输入原因": "Please enter the reason",
  "关联缺陷详情": "Details of the associated defects",
  "请选择发布分支": "Select a branch to publish",
  "编辑预约": "Edit Appointments",
  "不存在预约发布服务分支": "No appointment distribution branch exists",
  "预约发布类型": "Organisation",
  "请选择预约发布类型": "Select the type of appointment to publish",
  "请选择工作项": "Select Task",
  "请选择预约日期": "Please select an appointment date",
  "重新拉取服务分支": "Restart Service Branch",
  "星期日": "Sunday",
  "星期一": "Monday",
  "星期二": "Tuesday",
  "星期三": "Wednesday",
  "星期四": "Thursday",
  "星期五": "Friday",
  "星期六": "Saturday",
  "预约详情": "Details of your appointment",
  "预约状态": "Organisation",
  "已预约": "Scheduled",
  "未预约": "Unscheduled",
  "假期": "Leave",
  "查看需求详情": "View Needs Details",
  "查看迭代详情": "View iterative details",
  "预约": "Appointments",
  "下个月": "Next month",
  "确认回滚": "Confirm roll-back.",
  "版本": "Version",
  "镜像": "Mirror",
  "处理中": "Processing",
  "历史版本": "History Version",
  "提交申请": "Submission of applications",
  "请输入回滚原因": "Please enter a reason to roll back",
  "申请调试": "Application debugging",
  "审批人": "Approver",
  "调试时长": "Debug Length",
  "请输入调试时长": "Please enter a debug period",
  "请输入数字": "Please enter the number.",
  "请输入1-120分钟": "Please enter 1-120 minutes.",
  "申请原因": "Reason for application",
  "申请记录": "Record of applications",
  "审批中": "Under approval",
  "已通过": "Passed.",
  "已拒绝": "Rejected",
  "申请人": "Applicant",
  "申请时间": "Time of application",
  "审批成功": "Successful approval",
  "审批时间": "Time frame for approval",
  "就绪：": "Ready:",
  "个，可用：": "One, available:",
  "个，期望：": "One, expect:",
  "滚动更新中": "Scroll updating",
  "容器名称": "Name of container",
  "当前镜像": "Current Mirror",
  "启动时间": "Start Time",
  "内存": "Memory",
  "调试记录": "Debug Record",
  "实时日志": "Real Time Log",
  "健康检测": "Health testing",
  "运行时长": "Run-time",
  "实例 IP": "Example IP",
  "节点信息": "Node Information",
  "基本操作": "Basic Operations",
  "查看 Yaml": "View Yamal",
  "同步当前服务": "Sync Current Service",
  "WebSocket 连接错误:": "WebSocket connection error:",
  "停止连接": "Stop Connection",
  "重新连接": "Reconnect",
  "Pod 名称:": "Pod name:",
  "容器名称:": "Name of container:",
  "YAML 已复制到剪贴板！": "Yaml has been copied to the clipboard!",
  "复制失败！": "Copy failed!",
  "Yaml 配置": "Yaml Configuration",
  "Pod数据同步成功": "Pod data sync successfully",
  "容器数据同步成功": "Packaging data synchronized successfully",
  "数据同步中，请耐心等待": "Please wait patiently.",
  "当前服务同步成功": "Current service sync successfully",
  "获取容器调试权限失败，请重试": "Failed to obtain container debugging permission. Please try again.",
  "副本数量": "Number of copies",
  "调整": "Adjustment",
  "实例IP": "Example IP",
  "服务实例": "Examples of services",
  "列表视图": "List View",
  "卡片视图": "Card View",
  "实例信息": "Example Information",
  "K8s 集群": "K8s Cluster",
  "区域": "Regional",
  "K8s 命名空间": "Namespace for K8s",
  "镜像仓库": "Mirror repository",
  "加密成功": "Encryption succeeded",
  "加密生成器": "Encryption Generator",
  "复制生成结果": "Copy Generating Results",
  "加密": "Encryption",
  "副本数数据异常，请刷新页面后重试": "Copy number data abnormal. Please try again after refreshing the page",
  "伸缩": "Scalp",
  "服务：": "Services:",
  "当前期望副本数：": "Current expected copies:",
  "目标副本数：": "Number of copies of target:",
  "可连续点击 +1/-1 选择最终目标值，然后一次提交。": "You can click on +1/-1 continuously to select the final target value and then submit it once.",
  "申请将副本数从": "Application for number of copies from",
  "修改为": "Modify to",
  "容器组数量": "Number of container groups",
  "可用副本数/期望副本数": "Number of copies available/expected",
  "请输入服务名称": "Please enter the service name",
  "服务总数": "Total services",
  "地域/集群/命名空间": "Geographical/cluster/naming space",
  "命名空间：": "Namespace:",
  "请选择命名空间": "Select Namespace",
  "请先选择地域": "Please choose your territory first.",
  "应用同步成功": "Apply Synchronization Success",
  "泳道组": "Swimway team.",
  "编辑泳道组": "Edit Swimway Group",
  "入口类型:": "Type of entry:",
  "泳道组流量入口:": "Swimming team traffic entrance:",
  "泳道组涉及的应用": "Applications involved in swimming lanes",
  "暂无匹配的应用": "No matching applications",
  "暂无应用数据": "Application data not available",
  "请不要重复提交": "Please do not repeat",
  "提交错误:": "_Other Organiser",
  "创建泳道组": "Create Swimway Group",
  "更新": "Update",
  "创建泳道组后：": "After creating the swimming lane team:",
  "1.若未创建灰度泳道，网关的所有流量默认会路由至后端服务的基线节点。": "1. In the absence of the creation of the grey-scale swimming lane, all traffic through the gateway will be by default route to the baseline node of the back end service.",
  "2.若已创建灰度泳道，网关会将不匹配灰度规则的流量路由至基线节点。": "2. If grey-scale swimming lanes are created, the gateway will route traffic that does not match the grey-scale rule to the baseline node.",
  "因此，需确保网关所指向的后端服务包含基线节点，否则请求会报错。": "Therefore, it is necessary to ensure that back-end services to which the gateway refers include baseline nodes, otherwise requests are misreported.",
  "基线节点指的是未接入服务治理的节点，或接入过程中未添加 alicloud.service.tag 标签的节点。": "Baseline nodes refer to nodes that are not connected to the governance of the service, or nodes that are not added to the alicloud.service.tag label during access.",
  "泳道组名称": "Swimway Group Name",
  "请输入泳道组名称": "Please enter the name of the swimming lane group",
  "泳道组名称不能超过64个字符": "Swimway Group names cannot exceed 64 characters",
  "支持大小写字母、数字、\".\"和\"-\"、长度不超过64个字符": "Supports case letters, numbers, \"...\" and \"-\" with a length of no more than 64 characters",
  "入口类型": "Enter Type",
  "请选择入口类型": "Please select the type of entry",
  "入口网关": "Entry gateway",
  "请选择入口网关": "Please select the entrance gateway.",
  "泳道组涉及应用": "The swimway team involved applications.",
  "选择泳道组涉及应用": "Selecting the swimming lane group involves applications",
  "请选择泳道组涉及的应用": "Select the applications involved in swimming lanes.",
  "应用数据同步成功": "Application data sync successfully",
  "请先选择命名空间": "Please select a namespace first",
  "请先选择泳道组": "Please choose the swimming lanes first.",
  "命名空间同步成功": "Namespace Synchronization Successful",
  "刷新成功": "Refresh succeeded",
  "泳道组同步成功": "Swimway Synchronization Success",
  "同步命名空间": "Sync Namespace",
  "刷新泳道组": "Refresh the swimming lanes.",
  "同步泳道组": "Synchronization Swimway Group",
  "当前命名空间下暂无泳道组": "No swimming lanes in the current namespace",
  "请创建第一个泳道组来开始流量管理": "Please create the first swimming lane team to start traffic management.",
  "按内容模式必须设置至少一条灰度条件": "You must set at least one greyscale condition by content mode",
  "请完善所有灰度条件的参数": "Please complete the parameters for all greyscale conditions",
  "按内容模式至少需要一条灰度条件": "At least one greyscale condition by content mode",
  "参数类型": "Parameter Type",
  "参数": "Parameters",
  "条件": "Conditions",
  "前缀匹配": "Prefix Match",
  "正则匹配": "The right match.",
  "百分比": "Percentage",
  "hash(get(key)) % 100 < value 成立时满足条件": "Hash(get(key)) %100 < value met",
  "值": "Value",
  "输入值后按回车添加": "After entering values, press back to add",
  "输入值后按回车添加多个条件": "Add multiple conditions after entering values",
  "hash(get(key)) % 100 &lt; value 成立时满足条件": "Hash(get(key) %100 & lt; value met",
  "按内容模式至少需要一条条件": "It takes at least one condition in content mode.",
  "删除条件": "Delete Condition",
  "编辑泳道": "Edit Swimway",
  "创建泳道": "Create swimming lanes",
  "泳道名称": "Swimway Name",
  "请输入一个便于理解和识别的泳道名称": "Please enter an understandable and identifiable swimway name.",
  "请输入泳道名称": "Please enter the name of the swimming lane.",
  "泳道名称不能超过64个字符": "Swimway names cannot exceed 64 characters",
  "泳道标签": "Swimway Tags",
  "请选择泳道标签": "Select a swimming track label",
  "编辑模式下不能修改泳道标签": "Could not modify swimway tags in edit mode",
  "泳道标签需要用来给应用打标，当匹配条件命中时，会将打上此处定义的标识。": "Swimway labels need to be used to mark applications and will be marked as defined here when the match hits.",
  "确认匹配关系": "Confirm matching",
  "请确认泳道标签与打标节点之间的匹配关系。如果不合预期，请根据实际情况调整泳道或节点的标签。请注意，下列匹配关系是系统当前的实时状态，后续可能会随着系统的变更而发生改变。": "Please confirm the match between the swimming track label and the marked node. If this is not expected, adjust the label of the swimming lane or node to the actual situation. Note that the following matching relationships are in the current real-time state of the system and may change as the system changes.",
  "应用名称": "Apply Name",
  "匹配节点数/全部节点数": "Match Nodes/All Nodes",
  "泳道状态": "Swimway status",
  "灰度模式": "Greyscale Mode",
  "灰度模式在整个泳道组内需保持一致，一旦第一条泳道成功创建，后续泳道就不可以再对其进行更改": "The greyscale pattern needs to be consistent across the entire swimming lane, and once the first one is successfully created, the subsequent course can no longer be changed.",
  "按内容匹配度": "Matchability by Content",
  "当请求内容可以用于灰度识别时，建议采用此种灰度模式。倘若不可以，也强烈建议您通过系统改造增加此类灰度标识，以便获得更好的灰度效果。比如，可以保持灰度请求前后的一致性。": "When the request could be used for greyscale recognition, it was suggested that the greyscale model should be used. If not, it is also strongly recommended that you add such greyscale markings to the system adaptation so as to achieve better greyscale effects. For example, consistency between greyscale requests could be maintained.",
  "按比例匹配度": "Proportional Matchability",
  "当请求内容无法用于灰度识别且遗留系统也无法进行改造时，可以采用此种退化的灰度模式。该模式有一定弊端，可能导致同一来源的请求进入不同泳道，而造成灰度请求前后行为的不一致。": "This degraded canary model may be used when the request cannot be used for greyscale recognition and the legacy system cannot be modified. The model has certain disadvantages, which may lead to requests from the same source entering different swimming lanes, resulting in inconsistent behaviour before and after greyscale requests.",
  "流量比例": "Proportion of traffic",
  "为所选路由或Path设置流量比例，在默认情况下，泳道内的所有路由或Path都将使用统一的流量比例。": "Set the flow ratio for the selected route or path, and by default, all routes within the swimming lane or path will use a uniform flow ratio.",
  "• 单个泳道流量比例不能超过": "• The proportion of individual swimming lane traffic cannot be exceeded",
  "• 泳道组内所有泳道流量比例之和不能超过": "• The sum of the proportion of all swimming lane traffic within the swimming lane group cannot be exceeded",
  "• 当前泳道组已使用": "• Current swimming lanes are already in use",
  "%，最多还可分配": "%, maximum available",
  "请输入流量比例": "Please enter the flow ratio",
  "灰度条件": "canary condition",
  "灰度条件指定了请求内容的灰度匹配方式。当请求内容满足下列条件时，会被打上前面指定的泳道标签。": "The greyscale condition specifies the greyscale matching of the requested content. When the request fulfils the following conditions, it is marked with the previously specified swimming lane label.",
  "条件关系": "Conditional relations",
  "按内容模式必须设置至少一条灰度条件，且所有条件参数都必须填写完整。": "The content pattern must set at least one greyscale condition and all condition parameters must be completed.",
  "以下条件同时满足": "The following conditions are met simultaneously:",
  "以下条件任意满足": "The following conditions are met arbitrarily:",
  "请添加灰度条件": "Please add the greyscale condition",
  "添加灰度条件": "Add Greyscale Condition",
  "条件:": "Conditions:",
  "泳道同步成功": "Swimway Synchronization Success",
  "泳道应用列表": "Swimway Application List",
  "流量分配条件规则": "Rules on conditions for distribution of flows",
  "灰度比例": "Greyscale Scale",
  "已启用": "Enabled",
  "已关闭": "Closed",
  "流量分配": "Flow distribution",
  "刷新泳道": "Refresh the swimming lane.",
  "同步泳道": "Synchronization of swimming lanes",
  "搜索泳道名称": "Search for swimming lane names",
  "发布中": "Publishing",
  "编辑中": "Editing",
  "下线中": "Downline",
  "强制HTTPS": "Force HTTPS",
  "已开启": "Enabled",
  "来源": "Source",
  "插件名称": "Plugin Name",
  "未启用": "Not enabled",
  "当前版本": "Current Version",
  "最高版本": "Top Version",
  "确认生效?": "Validation?",
  "生效成功!": "It's working!",
  "生效": "Entry into force",
  "灰度配置": "Greyscale Configuration",
  "保存(无权限)": "Save (without permission)",
  "保存成功!": "Saved!",
  "灰度版本": "Greyscale Version",
  "请选择!": "Please choose!",
  "灰度方式": "Greyscale Method",
  "灰度值": "canary value",
  "最多只能设置4000个灰度值": "A maximum of 4,000 greyscale values",
  "请至少选择或输入一个灰度值": "Please select or enter at least one greyscale value",
  "选择国家": "Selection of countries",
  "选择用户": "Select User",
  "用户ID": "User ID",
  "每行一个用户ID，或用逗号分隔 例如: user1 user2,user3 user4": "One user ID per line, or separated by comma for example: user1 user2, user3 user4",
  "请输入要添加的用户ID": "Please enter the user ID to add",
  "没有有效的用户ID可添加": "No valid user ID to add",
  "预览": "Preview",
  "生效中": "In force",
  "服务类別": "Service category",
  "秒": "sec",
  "责任描述": "Description of liability",
  "查看错误日志": "View Error Log",
  "请勾选要复制的数据": "Check data to copy",
  "已复制发布记录到剪贴板": "Copyed release record to clipboard",
  "复制选中数据": "Copy Selected Data",
  "请选择或输入服务名称": "Please select or enter a service name",
  "关联发布单": "Association Releaser",
  "选择系统": "Select System",
  "编辑回滚责任人": "Edit Rollback Responsibility",
  "申请Hot Fix": "Application Hot Fix",
  "申请服务的服务类型": "Type of service requested",
  "服务类型不能为空": "Service type cannot be empty",
  "服务不能为空": "Service cannot be empty.",
  "申请的服务": "Services requested",
  "分支不能为空": "Branches cannot be empty.",
  "申请的分支": "Branch of application",
  "请输入发布原因，不超过30个字符": "Please enter the reason for the release, not exceeding 30 characters",
  "发布原因不能为空": "Reason for release cannot be empty",
  "获取服务列表失败:": "Failed to load the service list:",
  "获取分支列表失败:": "Failed to load the branch list:",
  "获取服务属性失败:": "Failed to access service attribute:",
  "获取服务列表失败": "Failed to get list of services",
  "获取服务信息失败": "Failed to access service information",
  "请先选择发布单类型和对应的载体": "Select the type of release sheet and the corresponding carrier first",
  "获取已发布服务分支失败": "Failed to access published branch",
  "分支领先Master": "Branch leads Master.",
  "分支落后Master": "Branch is behind Master.",
  "新加坡生产环境发布": "Singapore Production Environment Release",
  "（提交后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单，请先确保新加披uat已验证通过）": "(Application to create a Singapore production environment release, release the approval process, and automatically create a release form to ensure that the new capuat is validated)",
  "（提交后会按服务顺序直接发布，并会根据发布单类型创建或关联一个发布单）": "(Submittal will be issued directly in order of service, and a release form will be created or linked according to the type of issuance)",
  "默认查60天git提交记录": "Default check for 60 daysgit submission records",
  "分支检查失败": "Branch check failed",
  "分支落后检查": "Branch Back check",
  "已关联发布单服务分支清单": "List of associated individual service branches issued",
  "请选择发布单类型": "Select the type of issuer",
  "请选择或输入需求名称": "Please select or enter the desired name",
  "本次发布关联的产品需求": "Associated product requirement this time",
  "请选择或输入迭代名称": "Please select or enter an iterative name",
  "本次发布关联的Sprint": "Sprint Related to This Release",
  "请选择或输入线上问题名称": "Please select or enter a problem name on the line",
  "本次发布关联的线上问题": "Online issues for this release",
  "如果拉取，则会将该载体下所有commit记录的服务分支拉取出来并填充": "If pulled, all service branches recorded in the carrier will be pulled out and filled.",
  "添加服务分支": "Add Service Branch",
  "非常重要！！！服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "Very important! The service will be published in the current table order, the default order will be the back-end base, back-end core, back-end other, front-end foundation, front-end core, front-end other, and you can drag to change the release order.",
  "待发布": "To be issued",
  "发布检查": "Organisation",
  "分支检查结果": "branch check results",
  "未发布发布单": "No release form issued",
  "发布单": "Release List",
  "已取消": "Canceled",
  "排队中": "Line up.",
  "暂无流水线明细": "There's no line.",
  "原发布流水线": "Original release line",
  "服务 / 分支": "Service / Branch",
  "分支：": "Branch:",
  "环境：": "Environment:",
  "当前发布状态": "Current Status",
  "耗时：": "Time consuming:",
  "部署实际状态": "Actual status of deployment",
  "前往 K8s 查看": "Go to K8s to see",
  "发布历史 / 日志": "Publish History/ Log",
  "保留原发布信息和流水线明细；展开服务可查看流水线。K8s 实际运行情况请点击对应入口，页面每 3 秒自动刷新。": "Retain the original release information and flow line details; extend services to view flow lines. K8s is actually running by clicking on the corresponding entry, and the page is automatically refreshed every 3 seconds.",
  "查看 K8s 服务详情": "View K8s service details",
  "K8s 详情": "K8s Details",
  "【新加坡生产环境】发布需要走审批流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "The release of ‘Singapore Production Environment’ requires a process of approval. (tips: services selected in tables can be submitted directly to the form)",
  "【非生产环境】可以不走正常发布流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "[Non-production environments] may not follow normal distribution processes. (tips: services selected in tables can be submitted directly to the form)",
  "申请发布": "Application for publication",
  "创建发布": "Create Release",
  "【Hot Fix】可在这提交申请。（tips：1、若【二次发布】提交的服务为首次发布，则发布单发布次数不会加1）2、在表格中勾选的服务可被直接代入提交表单": "[Hot Fix] can submit an application here. (tips 1: if the service submitted [two times] is first published, the number of times the issue sheet is issued will not add 1)2 and the services selected in the form can be submitted directly to the form",
  "确定要回滚": "Make sure you roll back.",
  "确定要中断部署": "Make sure you interrupt your deployment.",
  "点击查看服务部署流水线，（": "Click to view the service deployment line.",
  "）个服务正在部署流程中": ") Services in deployment process",
  "（发布成功后发布单将变为【待回归】状态，需要测试回归需求）": "(The release of a successful release will be made [to be returned] and return requirements will need to be tested)",
  "服务代码分支": "Service code branch",
  "存在以下SQL工单未通过，请确定是否忽略？": "If the following SQLs are not passed, please make sure they are ignored?",
  "请输入发布单名称": "Please enter the release form name",
  "确定一键发布?": "Are you sure about the release?",
  "一键发布流程创建成功": "One release process successfully created",
  "】 发布单吗？": "Is that a release?",
  "】 发布单是否已经完成发布？": "Is the release form complete?",
  "确定后该发布单未发布服务分支将会被删除，状态将会变为【待回归】状态！": "The unpublished branch of the release will be deleted and the status will be [to be returned]!",
  "确定要验收 【": "Make sure it's accepted.",
  "】 发布单中的所有需求吗？": "All the requirements in the release list?",
  "操作后发布单状态将更新为【已验收】、需求状态更新为【已关闭】且无法回退": "The release form status will be updated to [received], the requirement status updated to [closed] and cannot be returned",
  "确定要拒绝验收 【": "Make sure you reject it.",
  "】发布单中的所有需求吗？": ") to publish all the requirements in the list?",
  "操作后发布单状态将变为【验收失败】": "Once operational, release form status will be [receipt failed]",
  "已将发布单分享链接至剪切板": "Release sheet shared link to clipboard",
  "可以将发布单状态手动设置为【待回归】状态": "You can set the release single status manually to [to be returned]",
  "手动完成发布": "Manually complete release",
  "查看审批详情": "View approval details",
  "回归": "Return",
  "验收": "Receiving and Inspection",
  "检查项详情": "Check Item Details",
  "操作失败": "Operation failed",
  "暂无操作日志": "Operating log not available",
  "（操作后发布单状态将更新为【待验收】、需求状态更新为【已发布】且无法回退）": "(Preliminary release order status updated to [to be accepted], requirement updated to [issued] and unable to reverse)",
  "需求已经发布成功，请及时进行线上验收并进行结果确认": "Requirement has been issued successfully and please perform on-line acceptance and confirmation of results in a timely manner",
  "查看所有": "View All",
  "请确认检查项内容": "Please confirm the contents.",
  "暂无内容": "Not yet.",
  "更多（+": "More (+)",
  "关联发布单操作（无需操作可直接关闭）": "Association Releaser Operation (without operation to close directly)",
  "发布单吗？": "Is that a release?",
  "确定要验收": "Make sure it's accepted.",
  "发布单中的所有需求吗？": "All the requirements in the release list?",
  "是否紧急发布": "Is this urgent?",
  "预期发布日期": "Expected date of issuance",
  "实际发布日期": "Actual publication date",
  "点击查看任务": "Click to see jobs",
  "服务分支": "Services Branch",
  "关联工作项": "Associated work items",
  "删除发布单": "Delete Release",
  "已生产发布单分享链接至剪切板": "Produced release sheet sharing link to clipboard",
  "（下面为任务中未发布的服务分支，提交后将直接发起发布）": "(The following are the branches of services not issued in the mission, which will be directly launched after submission)",
  "已指定责任人": "Designated duty-bearers",
  "已指定": "Assigned",
  "今日部署：": "Deployment today:",
  "今日部署服务数量（与昨日环比情况）": "Number of services deployed today (as compared to yesterday)",
  "部署成功率：": "Deployment success rate:",
  "今日部署成功的服务数量 / 今日部署服务数量": "Number of services deployed successfully today / Number of services deployed today",
  "待部署：": "To be deployed:",
  "今日创建的发布单中还未部署的服务数量": "Number of services created today that have not been deployed",
  "紧急发布：": "Urgently issued:",
  "今日紧急发布发布单中的服务总数": "Total number of services in emergency release form today",
  "今日申请Hot fix的服务数量": "Number of services requested today for Hotfix",
  "预计明日：": "Tomorrow is expected:",
  "预计发布时间为明日且未发布的服务数量": "Number of services expected to be released tomorrow and not issued",
  "已回归": "Returned",
  "今日创建的发布单中已回归状态的发布单数量": "Number of releases returned to status in today 's created release list",
  "待回归": "To be returned",
  "今日创建的发布单中待回归状态的发布单数量": "Number of release orders to be returned from today 's created release list",
  "已验收": "Accepted",
  "今日创建的发布单中已验收状态的发布单数量": "Number of accepted and accepted forms in today 's created release list",
  "今日创建的发布单中待发布状态的发布单数量": "Number of release orders to be published in issue list created today",
  "上线失败：": "Deployment failed:",
  "今日创建的发布单中上线失败状态的发布单数量": "Number of release orders created today for distribution list failed to go online",
  "发布窗口期内无需审批即可创建发布单": "Create a release form without approval during the release window",
  "今日部署": "Deployment today",
  "部署成功率": "Deployment success rate",
  "待部署": "To be deployed",
  "预计明日": "Projected tomorrow",
  "待验收": "Pending acceptance",
  "上线失败": "Failed to go online",
  "已复制到剪贴板": "Copyed to clipboard",
  "问题数": "Questions",
  "最新提交问题统计": "Statistical update on submission issues",
  "规则": "Rule",
  "文件路径": "File Path",
  "发现": "Found",
  "个问题": "A question.",
  "代码提交详情": "Code Submission Details",
  "文件代码详情": "File code details",
  "跳转至GitLab": "Go to GitLab",
  "复制Commit ID": "Copy Comm ID",
  "复制文件路径": "Copy File Path",
  "搜索服务": "Search services",
  "提交人：": "Submitted by:",
  "提交信息：": "Submission of information:",
  "提交时间：": "Date of submission:",
  "请输入...": "Please enter...",
  "严重性": "Severity",
  "输入文件路径": "Enter File Path",
  "问题行号": "Problem Line Number",
  "错误信息": "Error message",
  "早到之星": "Early star.",
  "披星戴月": "The moon with the cape star.",
  "迟到最多": "Most late.",
  "迟到": "Late.",
  "各部门平均工时": "Average hours worked by sector",
  "最近七天": "The last seven days.",
  "排名Top 20": "Top 20",
  "各部门平均工时排名": "Average hours worked by sector",
  "各岗位平均工时": "Average hours worked per post",
  "各Base地平均工时": "Average working hours per Base site",
  "各人员平均工时": "Average hours worked per person",
  "人员月度排名Top 20": "Top 20 for monthly staff",
  "个人加班工时": "Individual overtime hours",
  "部门加班工时": "Departmental overtime hours",
  "Base地加班工时": "Base-based overtime hours",
  "新增/交付需求": "New/delivery requirements",
  "近12月内新增需求数、已交付（取值以需求关闭时间）需求数量；": "Number of additional requirements, delivered (value taken for closure time) within nearly 12 months;",
  "线上问题解决时效与数量趋势（横向）": "production issue-solving trends (horizontal)",
  "线上问题修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "On-line problem recovery timescale indicator: Average problem recovery time reflects the quality of the R & D process, and the indicator reflects the efficiency of testing deficiency restoration.",
  "1、平均响应耗时=∑（确认时间-指派时间）/n，该耗时越长研发需要改进。": "Average response time = ∑ (confirmation time - assignment time)/n, the longer the time is required for R&D.",
  "2、平均修复耗时=∑（解决时间-确认时间）/n，该耗时越长研发需要改进。": "Average repair time = thallium (resolution time - confirmation time)/n, which requires improvement in R&D.",
  "3、平均关闭耗时=∑（关闭时间-解决时间）/n，该耗时越长缺陷提交人需要改进。": "3. The average time taken to close = zirconium (closure time - resolution time)/n, the longer the time taken, the deficiency needs improvement.",
  "4、平均修复总耗时=∑（关闭时间-首次指派时间）/n，该耗时越长缺陷提交人需要改进。": "The average total time taken to repair = ∑ (closure time - first assignment time)/n, the longer the time is spent, the further the defects need improvement.",
  "5、全局平均修复耗时：∑（T1+T2+...+Tn）/ n（缺陷个数），单位时间区间内各系统，业务领域，研发整体测试缺陷解决耗时的平均基线，高于该基线的团队需要改进。": "5. Average global repair time: T1+T2+... +Tn)/n (number of deficiencies), systems within unit time horizons, business areas, average baseline for development of overall test deficiencies to address time-consuming problems, higher than that of teams that need improvement.",
  "缺陷解决时效与数量趋势（横向）": "Deficiencies in time and volume trends (horizontal)",
  "测试缺陷修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "Time indicator for test deficiency repair: Average problem recovery time reflects the quality of the R & D process and the efficiency of test deficiency repair.",
  "线上问题解决时效与数量趋势（时间）": "production issue-solving trends (time)",
  "缺陷解决时效与数量趋势（时间）": "Deficiencies resolution of prescription and quantitative trends (time)",
  "线上问题新增趋势": "New trends in production issues",
  "新增缺陷趋势": "New deficiency trend",
  "趋势": "Trends",
  "占比(状态)": "Percentage (state)",
  "占比(优先级)": "Percentage (priority)",
  "所选时间段内未关闭缺陷优先级占比": "Prioritization of defects not closed during the selected period",
  "按成员排名": "By Member",
  "按项目/业务领域排名": "Ranked by project/practice area",
  "\"存量缺陷按系统/领域排名\"这一指标，对全局存量缺陷进行比较，并依据数量进行排名，以观测各研发团队的质量情况。": "The indicator \"System/area ranking of stock defects\" compares global stock defects and ranks them on a quantitative basis to observe the quality of R&D teams.",
  "这个指标的主要价值和意义在于：": "The main values and significance of this indicator are:",
  "排名靠前（即存量缺陷多）的团队可能需要进行更深入的代码审查或质量改进。": "The team that ranks ahead (i.e., with multiple stock deficiencies) may require more in-depth code review or quality improvement.",
  "风险识别：如果某团队存量缺陷持续较多，那么可能代表该组织需求交付存在一定的风险，研发管理者需要引起注意，进行风险控制。": "Risk identification: If a team ' s stock deficit continues to be high, there may be a risk of delivery on behalf of the organization ' s needs, and R & D managers need attention and risk control.",
  "进展情况：通过查看各团队的存量缺陷排名，存量缺陷多可能说明团队进度较慢，存量缺陷少则可能说明团队进度较快。": "Progress: By looking at the ranking of stock defects among teams, the high level of stock defects may indicate that the team is slower, while the low level of stock defects may indicate that the team is faster.",
  "持续改进：此指标可以作为团队质量持续改进的一种工具，比如用来制定缺陷减少的目标，或者在各个研发组织之间推广成功的优秀实践等。": "Continuous improvement: This indicator can serve as a tool for continuous improvement in team quality, for example, to set targets for reducing deficiencies or to replicate successful good practices among R & D organizations.",
  "每人创建的Bug数": "Number of Bugs created per person",
  "每人解决的Bug数": "Number of Bugs settled per person",
  "每人关闭的Bug数": "Number of Bugs closed per person",
  "按Bug严重程度统计": "By the severity of bug",
  "按Bug解决方案统计": "By bug Solution",
  "按Bug类型统计": "By bug Type",
  "缺陷关闭数": "Deficiencies closed",
  "缺陷新增数": "Add defects",
  "历史缺陷存量": "Inventory of historical defects",
  "截至前一天21时未关闭的缺陷数量": "Number of defects not closed as at 21st day",
  "截至七天前21时未关闭的缺陷数量": "Number of defects not closed at 2100 hours 7 days ago",
  "日清率(%)": "Daily rate (%)",
  "日清率(含存量)=（今日内缺陷关闭数/（今日新增缺陷数+至今日之前的缺陷存量））*100%": "Day clearance rate (including stock) = 100 per cent (Closure of defects today/(Additional defects today + stock of defects prior to date)*",
  "周清率(%)": "Weekly clearance rate (%)",
  "周清率(含存量)=（近7天缺陷关闭数/(近7天新增缺陷数+至7天前的缺陷存量））*100%": "Weekly clearance rate (including stock) = 100 per cent (nearly 7 days of defects closure/(nearly 7 days of additional defects + until 7 days)*",
  "截至十四天前21时未关闭的缺陷数量": "Number of deficiencies not closed as at 2100 14 days ago",
  "日清率(含存量)=（昨日缺陷关闭数/（昨日缺陷新增数+至昨日之前的缺陷存量））*100%": "DSS (including stock) = 100 per cent (explosive closure of yesterday/(addition of defects of yesterday + stock of defects up to yesterday)*",
  "周清率(含存量)=（近7~14天内缺陷关闭数/（近7~14天内缺陷新增数+至14天前的缺陷存量））*100%": "Weekly clearance rate (including stock) = 100 per cent (defect closings within close to 7-14 days/(additions to defects within close to 7-14 days + stock of defects up to 14 days)*",
  "实时缺陷数据统计": "Statistics of real-time defects",
  "日清率": "Daily rate",
  "周清率": "Week clearance rate",
  "历史列表": "History List",
  "返回实时数据": "Returns real-time data",
  "总共": "Total",
  "展示条数": "Show the number of bars",
  "代码提交规范率趋势": "Trends in code submission norm rate",
  "代码提交规范率排行": "Code Submission Normalization Line",
  "点击查看CR详情": "Click to see CR details",
  "关闭搜索": "Close Search",
  "展开搜索": "Expand Search",
  "导出数据": "Export Data",
  "下载文件失败：": "Failed to download file:",
  "总体需求数量（自然年）": "Total requirement (natural year)",
  "年度累计交付需求总量": "Total cumulative annual delivery needs",
  "年度累计交付需求需满足以下条件：": "The cumulative annual delivery needs are subject to the following conditions:",
  "1）需求状态为：已发布、已关闭；": "1) needs state: published, closed;",
  "2）需求发布时间在本年1月1日至今天之间；": "2) The time of request release is between 1 January and today;",
  "3）不包括技术需求。": "3) does not include technology needs.",
  "年度累计新增需求总量": "Total cumulative annual additional needs",
  "年度累计新增需求需满足以下条件：": "The cumulative additional annual needs are subject to the following conditions:",
  "1）需求创建时间在本年1月1日至今天之间；": "1) The needs were created between 1 January and today;",
  "2）不包括技术需求。": "2) does not include technology needs.",
  "当前需求存量": "Current requirement stock",
  "当前需求存量需满足以下条件：": "Current requirement stocks are subject to the following conditions:",
  "1）需求状态不包括：已发布、已关闭；": "1) The requirement status does not include: published, closed;",
  "当周需求数量（自然周）": "Number of needs per week (natural week)",
  "当周交付需求数": "Number of delivery needs per week",
  "当周交付需求需满足以下条件：": "The delivery requirements during the week are subject to the following conditions:",
  "2）需求发布时间晚于上周日；": "2) needs to be published later than last Sunday;",
  "当周新增需求数": "New requirements per week",
  "当周新增需求需满足以下条件：": "The additional requirements for the week require the following:",
  "1）需求发布时间在本周一至今天之间；": "1) The time of request release is between Monday and today;",
  "需求准入数量": "Number of requests for access",
  "超1个月未准入需求数": "Number of unattended needs over 1 month",
  "超1个月未准入需求需满足以下条件：": "Non-access requirements for more than one month require the following:",
  "1）需求状态为：待介入；": "1) state of need: pending intervention;",
  "2）需求创建时间早于近1月（相对于今天）的最后一天；": "2) The requirement was created earlier than the last day of almost January (as opposed to today);",
  "近1周准入通过需求数": "Access through requirements for nearly 1 week",
  "近1周准入通过需求需满足以下条件：": "Access in the last one week requires the following requirements:",
  "1）需求状态从待介入（产品需求以产品方案中等状态代替）更新为其他状态（不包含已取消）；": "1) the state of requirement is updated from intervention (product requirement is replaced by medium product option) to other status (not including cancelled);",
  "进入研发需求数量": "Number of R & D requirements entered",
  "超1个月待排期需求数": "Over 1 month to be scheduled",
  "超1个月待排期需求需满足以下条件：": "The needs to be scheduled for more than one month require the following:",
  "1）需求状态不包括已取消及已排期之前的需求状态；": "1) the state of requirement does not include the state of requirement that has been cancelled and pre-scheduled;",
  "近1周排期需求数": "requirement scheduled for nearly 1 week",
  "近1周排期需求需满足以下条件：": "The requirements of the last one-week schedule require the following:",
  "1）已排期状态更新时间为：近1周（相对于今天的上1周时间范围）；": "1) The scheduled status update is: nearly one week (as opposed to the last week of today);",
  "实时需求数据统计": "Real-time requirement statistics",
  "如果选择了多个业务领域或系统，那预估结果为所选": "If multiple business areas or systems are selected, the estimate is selected",
  "与": "and",
  "的聚合结果": "The result of the convergence",
  "获取预估结果失败": "Failed to obtain estimate result",
  "请至少选择一个筛选条件": "Please select at least one filter condition",
  "已设为默认筛选条件": "Set as Default Filter Condition",
  "操作区": "Operational area",
  "新需求交付时间预估": "Estimated delivery time for new requirements",
  "产品需求概览": "Product requirement overview",
  "产品需求看板": "Product requirement board",
  "预估完成时间": "Estimated completion time",
  "未来8周整体资源使用情况": "Overall resource performance for the next eight weeks",
  "资源利用率计算说明": "Explanation of resource utilization",
  "📊 计算公式": "📊 Formula",
  "(角色人员任务排期已覆盖的工作日数 /": "(Number of workdays covered by the role person ' s assignment schedule/",
  "(当周工作日数 × 角色人员数量)) × 100%": "(number of working days per week x number of players)",
  "💡 示例说明": "💡 Example description",
  "• 当前系统下有": "• Under the current system",
  "2 个前端": "2 Frontends",
  "• 本周有": "• This week",
  "5 个工作日": "5 working days",
  "，总人天为": "It's always the same.",
  "• 任务排期分别覆盖了": "• Mandates are covered separately",
  "和": "and",
  "个工作日": "Working days",
  "➜ 前端投入人天为 5，资源利用率为": "Front-end input person-days of 5 and resource utilization of",
  "研发角色资源明细": "Detailed R & D role resources",
  "未来第几周忙不忙？": "Are you busy in the next few weeks?",
  "📋 产品经理角色": "The role of product manager",
  "1. 计算该产品经理最近 90 天的业务需求介入速率": "1. Calculation of the latest 90-day business needs intervention rate of the product manager",
  "例如：3 天/个": "For example: 3 days/s",
  "2. 计算预估介入完成时间": "2. Calculation of estimated intervention completion time",
  "未介入业务需求数 × 介入速率": "Number of uninvolved business requirements x Rate of engagement",
  "3. 判断：当前时间 &gt; 预估完成时间 → 不忙": "3. Judgement: Current & gt; estimated completion time",
  "💻 研发与测试角色": "R&D and testing roles",
  "指定周工作日内任务排期时间未排满 → 不忙": "Unscheduled schedule of tasks within a week 's working day",
  "指定周工作日内任务排期时间已排满 → 忙": "The schedule of tasks within the given week's working day is full.",
  "任务数：": "Number of tasks:",
  "业务需求数：": "Operational requirements:",
  "数量：": "Number:",
  "职位:": "Position:",
  "暂无角色资源数据": "No role resource data available",
  "未来第几周:": "The next few weeks:",
  "繁忙人员": "Busy people",
  "空闲人员": "Free personnel",
  "繁忙率": "Busyness",
  "繁忙人员:": "Busy person:",
  "空闲人员:": "Free:",
  "健康度雷达图": "Health radar map",
  "获取系统列表失败:": "Failed to load the system list:",
  "重置筛选": "Reset Filter",
  "业务领域不能为空": "Business areas cannot be empty",
  "业务满意度(0-4)": "Operational satisfaction (0-4)",
  "删除原因": "Delete Reason",
  "已创建": "Created",
  "预估工时（人天）": "Estimated working hours (person-days)",
  "部分任务类型默认不展示": "Some task types are not shown by default",
  "实际工时（人天）": "Actual hours worked (person-days)",
  "成本分析": "Cost analysis",
  "成本月对比": "Monthly comparison of costs",
  "成本分布": "Cost distribution",
  "提交失败，请检查必填项": "Submission failed. Check the required fields.",
  "请选择要添加的指标": "Please select the indicator to add",
  "所选指标已全部存在，请选择其他指标": "All selected indicators exist, please select others",
  "指标描述：": "Description of indicators:",
  "暂无描述": "No description.",
  "指标极性：": "Indicator polarity:",
  "正向指标": "Positive indicator",
  "负向指标": "Negative indicator",
  "权重值": "Weight Value",
  "请输入权重值": "Please enter a weight",
  "权重值不能小于0": "Weight not less than 0",
  "权重值不能大于100": "Weights cannot be greater than 100",
  "满分线": "Full Line",
  "请输入满分线": "Please enter a full line",
  "满分线不能小于0": "A full line cannot be less than zero.",
  "零分线": "Zero.",
  "请输入零分线": "Please enter a zero line.",
  "零分线不能小于0": "Zero can't be less than zero.",
  "指标顺序已更新": "The order of indicators has been updated",
  "新建模型": "New Model",
  "编辑模型": "Edit Model",
  "查看模型详情": "View Model Details",
  "模型基础信息": "Model basic information",
  "模型名称": "Model Name",
  "请输入模型名称": "Please enter the model name",
  "模型名称不能超过100个字符": "Model name cannot exceed 100 characters",
  "基础分": "Base Score",
  "请输入基础分": "Please enter base points",
  "基础分不能小于0": "The base cannot be less than zero.",
  "基础分不能大于100": "The base score cannot be greater than 100.",
  "请选择关联的业务领域（支持多选）": "Select the relevant business area (support multiple selection)",
  "请选择关联业务领域": "Select the relevant business area.",
  "模型指标配置": "Model indicator configuration",
  "请为以下指标配置权重值、满分线和零分线": "Please configure weights, full lines and zero lines for the following indicators",
  "请选择要添加的指标（支持多选）": "Select the indicator to add (support multiple selection)",
  "批量添加指标 (": "Batch Add Indicator (",
  "个指标，点击按钮批量添加": "indicator, click on button to load",
  "获取团队汇总数据失败": "Failed to get team aggregate data",
  "获取团队汇总数据失败:": "Failed to load team summary data:",
  "🏢 业务领域": "Operational areas",
  "📅 年月": "Year",
  "实际值": "Actual",
  "实际分": "Actual",
  "加权得分": "Weighted score",
  "⚠️ 事故扣分": "⚠️ Accident deduction points",
  "📊 总加权得分": "Total weighted score",
  "📈 同比变化": "Year-to-year change",
  "正在加载团队汇总数据...": "Loading team summary data...",
  "📊 数据概览": "Data overview",
  "🎯 当前平均分": "Current average score",
  "📈 环比变化": "Change in ring comparison",
  "📊 去年同期": "The same time last year",
  "📊 同比变化": "Year-to-year change",
  "🏆 得分排名": "🏆 Score ranking",
  "汇总平均": "Summary average",
  "📡 效能指标雷达图": "• Radar maps of performance indicators",
  "🏢 选择业务领域:": "Selection of areas of operation:",
  "当前指标得分（加权得分）": "Current indicator score (weighted)",
  "同比指标对比（加权得分）": "Comparison with indicator (weighted score)",
  "暂无雷达图数据，请先选择一个业务领域查看指标对比": "No radar chart data available, please select an area of operation to see the indicator comparison",
  "创建效能评分模型": "Create a performance rating model",
  "获取团队详情数据失败": "Failed to fetch team details data",
  "获取团队详情数据失败:": "Failed to load team details:",
  "正在加载团队数据...": "Loading team data...",
  "请先选择业务领域": "Please select the business area first.",
  "在筛选条件中选择一个业务领域以查看团队详情数据": "Select a business area in the filter conditions to view the team details data",
  "📊 年度数据概览": "Overview of annual data",
  "月": "Month",
  "平均分": "Average score",
  "📈 年度提升": "Annual upgrade",
  "🏆 最高月份（": "• Maximum month (%)",
  "⚠️ 最低月份（": "• Minimum month (",
  "📈 月度得分趋势": "• Trends in monthly scores",
  "📅 月度得分详情": "Monthly score details",
  "📅 选择月份（多选，不选则显示所有月份）:": "📅 Select the month (multiple, unselect all months):",
  "请选择月份，不选则显示所有月份数据": "Please select the month, and if not, show all month data",
  "年度平均指标对比（加权得分）": "Yearly average indicator comparison (weighted score)",
  "暂无雷达图数据": "Radar chart data not available",
  "暂无选中月份的雷达图数据，请选择其他月份或清空选择查看所有月份数据": "No radar chart data is available for the selected month. Select another month or clear the selection to view all months.",
  "您不是业务领域负责人，无法查看": "You're not in charge of the business area. You can't see it.",
  "您不是业务领域负责人，无法查询团队视图": "You are not in charge of the business area and cannot query the team view",
  "查询已触发": "Query triggered",
  "全局视图数据已刷新": "Global view data refreshed",
  "团队视图数据已刷新": "Team View Data Refreshed",
  "请选择时间范围": "Select the time frame",
  "团队视图": "Team View",
  "全局视图": "Global View",
  "还没有效能评分模型哦": "There's no performance rating model.",
  "立即创建": "Create Now",
  "💯 满分部门（100%）": "Full subsector (100%)",
  "👍 优秀部门（≥90%）": "• Excellent sector (90 per cent)",
  "💔 待改进部门（＜90%）": "Sector to be improved (<90%)",
  "指标/部门": "Indicator/sector",
  "确认关闭": "Confirm Close",
  "请至少选择一个邮件接收人": "Please select at least one mail recipient",
  "邮件发送成功": "Mail sent successfully",
  "提交失败，请重试": "Failed to submit, try again",
  "选择邮件收件人": "Select Mail Recipient",
  "是否发送水印图表": "Whether to send watermark charts",
  "水印图表异步发送，存在失败的情况，且发送时间较长，请谨慎发送": "Watermark graphs and graphs are sent in a different step, with failure and longer dispatch times, with caution",
  "请输入有效的邮箱地址": "Please enter a valid mailbox address",
  "需求吞吐量趋势（业务领域）": "Trends in requirement throughput (practice areas)",
  "统计口径：当月已发布/当月新增*100%": "Statistical calibration: 100 per cent new/issued/month*",
  "交付需求数（个）": "Number of delivery requirements (persons)",
  "创建需求数（个）": "Number of needs created (%)",
  "未完成需求数（个）": "Unfinished requirements (per cent)",
  "吞吐率平均值（%）": "Average throughput rate (%)",
  "高于平均吞吐率的业务领域 (共": "Operational areas above average throughput (total)",
  "个, 上期": "Last period",
  "个 )": "States)",
  "连续2个月高于平均值的业务领域": "Operational areas above average for 2 consecutive months",
  "技术需求占比": "Proportion of technology requirement",
  "统计口径：当月发布技术需求/当月发布总需求*100%": "Statistical calibration: 100 per cent of total requirement for technology issued in the month/month*",
  "技术需求交付占比平均值(%)": "Average share of technology requirement delivery (%)",
  "技术需求占比最多": "Technology requirement highest",
  "技术需求占比最少": "The least requirement for technology",
  "开发交付周期": "Development delivery cycle",
  "统计口径：已发布时间-产品阶段结束时间": "Statistical calibration: time issued -- end of product phase",
  "所有类型需求平均交付周期(天)": "Average delivery cycle for all types of requirement (days)",
  "产品需求平均交付周期(天)": "Average product requirement delivery cycle (days)",
  "技术需求平均交付周期(天)": "Average delivery cycle for technology needs (days)",
  "产品需求开发交付周期最长": "Product requirement development delivery cycle highest",
  "技术需求开发交付周期最长": "Maximum technology requirement development delivery cycle",
  "产品需求开发交付周期最短": "Shortest product requirement development delivery cycle",
  "技术需求开发交付周期最短": "Shortest technology needs development delivery cycle",
  "交付需求的创建时间分布": "Creation time distribution of delivery needs",
  "bug关闭与新增情况": "bug closure and additions",
  "统计口径：bug关闭占比=当月bug关闭数/新增数": "Statistical caliber: bug closure ratio = bug closure/increase in current month",
  "关闭总数(个)": "Total number of closed",
  "新增总数(个)": "Total number of new",
  "各领域关闭占比平均值(%)": "Area closure as a percentage of average (%)",
  "关闭bug创建时间分布": "Close bug creation time distribution",
  "bug类型及业务领域占比": "bug type and area of operations as a percentage",
  "线上bug逃逸率（按照逃逸率降序排序）": "Offline bug escape rate (in descending order)",
  "统计口径：线上bug关闭数/(过程bug关闭数+线上bug关闭数)*100%": "Statistical caliber: 100 per cent on-line bug closure/(process bug closure + line bug closure)*",
  "bug逃逸率平均值(%)": "bug escape rate average (%)",
  "逃逸率最高": "The highest escape rate.",
  "逃逸率最低": "The lowest escape rate.",
  "bug关闭时效": "bug close time",
  "平均响应耗时=∑(确认时间-指派时间)/bug关闭数 该耗时越长研发需要改进": "Average response time = thallium (confirmation time - assignment time)/bug closure The longer the response time requires improvement",
  "平均修复耗时=∑(解决时间-确认时间)/bug关闭数 该耗时越长研发需要改进": "Average repair time = zirconium (resolution time-confirmation time)/bug closure",
  "平均关闭耗时=∑(关闭时间-解决时间)/bug关闭数 该耗时越长缺陷提交人需要改进": "Average closure time = thallium (closure time - resolution time)/bug closure number The longer the duration of the failure the author needs improvement",
  "指标统计说明": "Statistical description of indicators",
  "所有bug平均关闭时效(天)": "Average closure time for all bugs (days)",
  "有效线上bug平均关闭时效(天)": "Average on-line bug closure time (days)",
  "平均关闭时效最长": "Maximum time limit on average",
  "平均关闭时效最短": "Minimum time limit for average closure",
  "关闭bug总数(个)": "Total number of closed bugs",
  "关闭量占比(%)": "% Closed",
  "有效bug关闭数(个)": "Number of effective bug closures (one)",
  "生产事故概况": "Overview of production accidents",
  "事故总数(个)": "Total number of accidents",
  "事故归属业务领域": "Accidents attributed to operational areas",
  "事故级别分布": "Distribution of accident levels",
  "原因类型分布": "Source type distribution",
  "月度事故分布": "Monthly accident distribution",
  "生产事故改进情况": "Improvements in production accidents",
  "措施总数": "Total number of measures",
  "超期未完成": "Overdue",
  "改进措施分布情况": "Improved distribution of measures",
  "事故负责人改进状态分布图": "Improved status map for accident managers",
  "需求分析": "Needs analysis",
  "需求吞吐量趋势": "Trends in requirement throughput",
  "过程缺陷分析": "Process gap analysis",
  "线上bug分析": "Online bug analysis",
  "线上bug关闭与新增情况": "Online bug closure and additions",
  "线上bug创建时间分布": "Online bug creation time distribution",
  "线上bug类型及业务领域占比": "On-line bug type and area of operation",
  "线上bug关闭时效": "Online bug shut down.",
  "线上bug逃逸率": "Online bug escape rate",
  "生产事故落地进展": "Progress in the landing of production accidents",
  "研发数据分析": "Analysis of R&D data",
  "需求吞吐量": "Need to swallow",
  "交付需求的创建时间分布 (按当月发布需求总数降序排列)": "Creation time distribution of delivery needs (in descending order of total requirement issued for the month)",
  "bug关闭与新增情况（按照bug关闭占比降序排序）": "bug closures and additions (ordered in terms of the percentage decrease of bug closures)",
  "关闭bug创建时间分布（按照关闭bug数降序排序）": "Close bug creation time distribution (in descending order of number of closed bugs)",
  "bug类型占比": "% of bug type",
  "bug业务领域占比": "% of bug fields of operation",
  "bug关闭时效（按照总体关闭时间降序排序）": "bug closure time limits (in descending order of total closure time)",
  "线上bug关闭与新增情况（按照bug关闭占比降序排序）": "Online bug closures and additions (ordered according to bug closure percentage down)",
  "线上bug创建时间分布（按照线上bug数降序排序）": "Online bug creation time distribution (sorted in descending order of the number of online bugs)",
  "线上bug执行方案占比": "Percentage of online bug implementation programmes",
  "线上bug有效占比": "On-line bug effective ratio",
  "线上bug类型占比": "Online bug type ratio",
  "线上bug业务领域占比": "Percentage of online bug fields of operation",
  "线上bug关闭时效（按照关闭时间降序排序）": "Online bug closure time (in descending order)",
  "研发管理荣誉榜": "R&D management honours list",
  "代码提交规范率部门排行": "Line the code submission standard rate sector",
  "上期": "Prior period",
  "超平均": "Super average",
  "交付需求数": "Delivery requirements",
  "吞吐率": "Swallow Rate",
  "关闭bug数": "Close bug count",
  "关闭占比（关闭数/新增数）": "Closure share (Closed/New)",
  "关闭量": "Closed",
  "关闭量占比": "% Closed",
  "新增bug数": "Add bug number",
  "交付需求数量TOP3": "Quantity of delivery needs TOP3",
  "关闭bug总数TOP3": "Close bug total TOP3",
  "占比最多TOP3": "Top ratio TOP3",
  "占比最少TOP3": "Minimum TOP3 ratio",
  "新增bug总数TOP3": "Add bug to total TOP3",
  "正在生成邮件报告（请勿关闭页面），请稍后...": "Generating mail report (do not close page), please later...",
  "月报已生成,请选择发送邮件人": "Monthly report generated, please select sender",
  "处理失败:": "Cannot initialise Evolution's mail component.",
  "分享链接已复制到剪贴板": "Share links copied to clipboard",
  "发送邮件": "Send Mail",
  "业务指标看板": "Operational indicators board",
  "仅主管指标": "Competent indicators only",
  "业务领域（可多选）": "Operational areas (multi-optional)",
  "系统（可多选）": "System (multi-optional)",
  "指标（可多选）": "Indicators (multi-optional)",
  "刷新当前视图": "Refresh Current View",
  "展示业务指标当前值，并提供往年同比（%）对照（": "Show current values for operational indicators and provide a comparison with previous years (%)",
  "当前范围暂无可展示指标": "There are no indicators for the current scope",
  "同比": "Ratio",
  "环比": "Ring",
  "当期平均": "Average current period",
  "往年同期": "Period of prior year",
  "小贴士：点击卡片可查看业务指标趋势的明细数据": "Petty: Click on a card to see detailed data on trends in operational indicators",
  "数据更新于": "Data update on",
  "个人指标看板": "Personal indicator panels",
  "角色（可多选）": "Role (optional)",
  "展示个人指标当前值，并提供往年同比（%）对照（": "Show current values for personal indicators and provide a comparison with previous years (%)",
  "小贴士：点击卡片可查看指标趋势的明细数据": "Petty: Click on the card to see the breakdown of indicators trends",
  "业务领域名称": "Name of operational area",
  "当前范围暂无可展示数据": "Current range is not available",
  "岗位名": "Job Name",
  "业务汇总": "Summary of operations",
  "人员汇总": "Summary of personnel",
  "导出 Excel": "Export Excel",
  "展示汇总统计表格数据，支持业务汇总与人员汇总视图切换": "Display summary statistical table data to support business summary and personnel summary view switching",
  "岗位（可多选）": "Posts (multi-optional)",
  "人员（可多选）": "Personnel (optional options)",
  "均值": "Mean",
  "点击角色卡片可筛选下方表格，再次点击当前角色可恢复全部": "Click on the character card to filter the bottom table and click again on the current role to restore all",
  "配置成员": "Configure Members",
  "配置团队成员": "Configure Team Members",
  "团队名称": "Team Name",
  "给团队起个名字": "Give the team a name.",
  "保存团队": "Save Team",
  "请先填写团队名称": "Please fill out the name of the team.",
  "团队配置已保存": "Team Configuration Saved",
  "团队配置保存失败，请稍后重试": "Team Configuration Save failed. Please try again later",
  "团队指标看板": "Team indicator board",
  "暂未配置团队名称": "Team name not configured",
  "导出所有角色人员指标明细": "Export all role indicators",
  "导出": "Export",
  "团队整体视图": "Group View",
  "人员明细视图": "Personnel Detailed View",
  "第一步：点击这里配置团队": "Step 1: Click here to configure the team",
  "请先配置团队成员": "Please configure the team members first.",
  "先补齐产品、研发、测试成员，再查看团队指标。": "First, the products are completed, R&D are developed, members are tested, and then team indicators are viewed.",
  "配置团队": "Configure Teams",
  "团队": "Team",
  "小贴士：先配置团队角色成员，再查看团队维度指标趋势与变化": "Petty: Configure team role members and then look at team dimensions indicators trends and changes",
  "里程碑记录": "Milestone record",
  "需求记录": "Record of requirements",
  "缺陷记录": "Record of defects",
  "事故记录": "Incident records",
  "技术债务记录": "Technical debt record",
  "指标详情": "Details of indicators",
  "暂无指标详情": "No indicator details available",
  "提示：点击柱子可查看记录明细": "Hint: Click on the column to see the details of the record",
  "当前区间暂无趋势数据": "Current trend data not available",
  "选择部门": "Select Sector",
  "请选择本部门线中的部门": "Select the sector in the sector line.",
  "单独选人": "Alone.",
  "可单独选择人员，与部门选择取并集": "Individually selected and selected with department",
  "选择人员": "Selection of personnel",
  "已自动选择人员，可继续调整": "People are automatically selected and can continue to be adjusted",
  "请先选择部门或单独选人": "Please choose the department or individual.",
  "已选": "Selected",
  "紧急发布 & HotFix趋势": "Emergency release of & HotFix trend",
  "总次数": "Total number",
  "窗口期发布次数": "Number of window period releases",
  "成功次数": "Successes",
  "成功率（%）": "Success rate (%)",
  "研发平均交付周期（Day）": "Average R & D delivery cycle (Day)",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从研发开始到结束所经历的时间；（不包含技术类需求）": "Average of the length of the stay at each stage, which refers to the period from the beginning to the end of the R & D period before the requirement is delivered; (excluding technical category requirements)",
  "需求数量排名": "Number of needs ranking",
  "平均交付周期（Day）": "Average delivery cycle (Day)",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从开始到结束所经历的时间；（不包含技术类需求）": "Average of the length of the required stay at each stage, which refers to the period from the beginning to the end of the requirement before delivery; (excluding technical category requirements)",
  "需求分布图": "requirement distribution",
  "按日": "By day",
  "按周": "By Week",
  "按月": "Monthly",
  "执行人类型：": "_Other Organiser",
  "选择执行人类型": "Select Executor Type",
  "执行人：": "By:",
  "选择执行人": "Select Executor",
  "复杂度：": "Complexity:",
  "选择复杂度": "Select Complexity",
  "优先级：": "Priority:",
  "选择优先级": "Select Priority",
  "需求延期交付数": "Delayed delivery of requirements",
  "需求延期交付数：": "Delayed delivery of requirements:",
  "1、需求交付月度指标，预计到期日为当月的需求（需求已发布时间-预计到期日&lt;0的数量累计，即为延期交付数量。": "1 The monthly target for requirement delivery, with the expected maturity date being the current month ' s needs (the requirement has been issued - the expected maturity date &lt; the cumulative amount of 0 is the quantity of delayed delivery).",
  "2、平均需求延期交付时间，根据系统或者领域，或者全局选择，需求延期交付时间的平均值。": "2. Average requirement delay delivery time, averaged by system or area or global selection.",
  "新增需求趋势": "Trends in new requirement",
  "新增需求趋势：": "Trends in new requirement:",
  "本指标反映各团队的新增需求数量的变化趋势，期待新增需求持续输入且数量相对稳定，若需求数量（story points）新增较多，需要考虑研发资源与交付时效是否可以按期完成。": "This indicator reflects the trend in the volume of additional requirement across teams, and expects that the volume of additional requirement will be continuously entered and relatively stable, and that if more requirement is added, consideration will need to be given to whether R&D resources and delivery deadlines will be met.",
  "存量需求趋势": "Trends in stock requirement",
  "存量需求趋势：": "Stock requirement trends:",
  "所选时间区间项目尚未完成需求的数量和，存量需求趋势 = （当前期的存量需求 - 前一期的存量需求） / 前一期的存量需求，其列成一个时间序列。如果存量需求呈现上升趋势，需要考虑研发资源分配和交付时效，反之亦然。": "Number and number of outstanding needs for selected time-zone projects, stock requirement trends = (in current period - prior period stock needs) / Stock needs for previous period, presented as a time series. If there is an upward trend in stock requirement, the allocation of R & D resources and delivery deadlines need to be considered, and vice versa.",
  "存量需求占比(状态)": "Stock requirement ratio (state)",
  "所选时间段内未关闭需求各状态占比": "Proportion of requirements not closed for the selected period",
  "存量需求占比(优先级)": "Share of stock requirement (priority)",
  "所选时间段内未关闭需求优先级占比": "Prioritization of unclosed needs in selected time periods",
  "需求交付时长分布": "Long-time distribution of requirement delivery",
  "需求交付时长分布：": "Long-term distribution of requirement delivery:",
  "所选时间区间内完成的需求，按完成日期排列，并分别统计每日完成需求从创建到完成的耗时时长分布。有助于团队了解需求交付的速度和效率，并从中找出可能存在的问题和瓶颈。": "The needs to be completed within the selected time horizon are arranged by the completion date and the distribution of the daily completion needs from creation to completion is measured separately. It helps teams to understand the speed and efficiency of requirement delivery and to identify potential problems and bottlenecks.",
  "需求趋势": "Trends in requirement",
  "需求趋势：": "Trends in requirement:",
  "需求趋势指标用于衡量在一段特定时间内需求的变化趋势。该图表会显示每天新增、发布需求数量以及仍然活跃的或未解决的需求数量（通常称为\"需求存量\"），故我们的需求颗粒度标准需要统一。": "requirement trend indicators are used to measure trends in requirement over a specific period of time. The chart shows the number of new needs added daily, the number of needs published and the number of needs that are still active or unsolved (often referred to as \"requirement stocks\" ), so we need to harmonize the standards of particle size.",
  "需求阶段数量累积": "Accumulation of requirement phase",
  "需求阶段累积（数量）：": "Cumulative needs phase (number):",
  "截止所选时间段内各个需求阶段的数量累积": "Cumulative number of phases of needs up to selected time periods",
  "需求阶段耗时累积": "Time-consuming accumulation of the requirement phase",
  "需求阶段累积（耗时）：": "Cumulative requirement phase (time-consuming):",
  "截止所选时间段内各个需求阶段的耗时累积": "Time-consuming accumulation of requirements at each stage by the selected time period",
  "选择来源": "Select Source",
  "平均时效": "Average limitation period",
  "平均时效:": "Average limitation period:",
  "已完成处理": "Processing completed",
  "待处理": "Pending",
  "获取点赞详情数据失败": "Failed to load like details",
  "获取点赞详情数据失败:": "Failed to load like details:",
  "正向": "Positive",
  "中性": "Neutral",
  "负面": "Negative",
  "显示所有类型的反馈": "Show all types of feedback",
  "等待处理的反馈": "Feedback pending processing",
  "已经处理完成的反馈": "Completed feedback processed",
  "当前用户提交的反馈": "Feedback from current users",
  "图标": "Icon",
  "Tab名称": "Tab name",
  "Tab代码": "Tab code.",
  "默认Tab": "Default Tab",
  "App Tab页配置": "App Tab Page Configuration",
  "管理移动端App中反馈页面的Tab标签配置": "Manage the Tab tab configuration of the feedback page in the mobile App",
  "搜索Tab名称或代码": "Search Tab name or code",
  "新增Tab": "Add Tab",
  "配置已删除": "Configuration deleted",
  "编辑功能待实现": "Edit function to be achieved",
  "配置详情": "Configure Details",
  "反馈来源:": "Source of feedback:",
  "反馈国家:": "Feedback countries:",
  "一级类型数量:": "Type I:",
  "二级类型数量:": "Number of secondary types:",
  "清空筛选": "Empty Filter",
  "中文内容为必填项，请填写中文内容": "In Chinese, please fill in the required entries",
  "英文内容为必填项，请填写英文内容": "Please fill in English as required",
  "规则中的反馈来源和默认负责人均为必填项": "The source of feedback in the rules and the default responsible person are required",
  "同一类型下不能配置相同来源的规则": "Rules that cannot be configured for the same source under the same type",
  "编辑反馈类型成功": "Edit feedback type successfully",
  "新增反馈类型成功": "New feedback type successfully",
  "请输入Code": "Please enter Code",
  "命名规则：全大写字母，单词之间使用下划线分隔": "Naming rules: full capital letters, underline between words",
  "请输入Code（例如：PRODUCT_ISSUE）": "Enter Code (e.g. PRODUCT_ISSUE)",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：PRODUCT_ISSUE": "Naming rules: Only uppercase letters can be included, using underlined separation between words, e.g. PRODUCT_ISSUE",
  "配置级别": "Configure Level",
  "请选择配置级别": "Please select the configuration level",
  "主配置": "Main Configuration",
  "次配置": "Subconfigure",
  "自定义规则配置": "Customise Rule Configuration",
  "多语言内容": "Multilingual content",
  "内容（必填）": "Content (mandatory)",
  "内容": "Contents",
  "描述（选填）": "Description (optional)",
  "排序号": "Sort Number",
  "默认负责人": "Default Responsible",
  "关注人": "Attention.",
  "已配置规则的来源": "Source of configured rules",
  "语言内容包": "Language Package",
  "个语言": "Languages",
  "属性删除成功": "Properties deleted successfully",
  "获取属性列表失败:": "Failed to fetch attribute list:",
  "获取属性列表失败": "Failed to fetch attribute list",
  "批量添加属性失败:": "Batch addition attribute failed:",
  "批量添加属性失败": "Batch addition properties failed",
  "删除属性失败:": "Failed to delete attribute:",
  "删除属性失败": "Failed to remove attribute",
  "添加子节点": "Add subpoint",
  "请选择要添加的属性": "Select the properties to add",
  "批量添加": "Batch Add",
  "父节点：": "Parent node:",
  "搜索属性名称...": "Search Attribute Name...",
  "项，已选择": "entry, selected",
  "项": "Item",
  "清除成功": "Clear successfully",
  "清除失败:": "Clearing failed:",
  "清除失败": "Clearing failed",
  "不能复制到自己": "You can't copy to yourself.",
  "💡 提示：已配置的单元格可以拖拽复制到其他单元格，未配置的单元格可以作为拖拽目标": "💡 Tip: Configured cells can drag and copy to another cell, and unconfigured cells can be used as drag and drag targets",
  "正在复制:": "Copying:",
  "一级:": "Level I:",
  "二级:": "Level 2:",
  "总数:": "Total:",
  "未配置": "Not configured",
  "编辑配置": "Edit Configuration",
  "确定要一键复制该来源配置到所有空白配置的国家与来源吗？": "Are you sure you want to copy the country and source where the source is configured to all blank configurations?",
  "一键复制": "Copy one.",
  "确定要清除此配置吗？": "Are you sure you want to clear this configuration?",
  "清除配置": "Clear Configuration",
  "添加配置": "Add Profile",
  "获取FAQ详情失败:": "Failed to load FAQ details:",
  "删除FAQ配置失败:": "Failed to delete FAQ configuration:",
  "该FAQ暂无语言包配置": "The FAQ has no language package configuration",
  "问题内容": "Questions",
  "答案内容": "Answer Contents",
  "语言包数量": "Number of language packages",
  "确定要删除这条FAQ配置吗？": "Are you sure you want to delete this FAQ configuration?",
  "FAQ管理": "FAQ Management",
  "请输入问题标题、内容或答案": "Please enter the title, content or answer to the question",
  "新增FAQ": "Add FAQ",
  "反馈来源": "Source of feedback",
  "请选择反馈来源": "Select the source of feedback",
  "请选择默认负责人": "Please select the default responsible person",
  "请选择关注人": "Please choose the person you care about.",
  "默认无需处理": "Default does not need to process",
  "是否默认无需处理": "Whether default is not required",
  "添加规则": "Add Rules",
  "语言内容详情": "Language Details",
  "暂无语言内容": "Language content not available",
  "新增成功": "Add success",
  "编辑功能": "Edit Functions",
  "新增功能": "Add function",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：FUNCTION_SWITCH": "Naming rules: Only uppercase letters can be included, using underlined separation between words, e.g. FUNCTION_SWITCH",
  "请输入Code（例如：FUNCTION_SWITCH）": "Enter Code (e.g. FUNCTION_SWITCH)",
  "删除配置成功": "Successfully removed configuration",
  "删除配置失败": "Failed to remove configuration",
  "配置类型": "Configure Type",
  "消息群ID": "Organisation",
  "确定要删除这条配置吗？": "Are you sure you want to delete this configuration?",
  "基础数据配置": "Basic data configuration",
  "如国家、来源、站点等基础配置信息": "Basic configuration information such as country, source, site, etc.",
  "请输入展示内容或配置值": "Please enter a presentation or configuration value",
  "配置类型:": "Configuration type:",
  "请选择配置类型": "Please select the configuration type",
  "新增配置": "Add Configuration",
  "编辑配置成功": "Edit Configuration Successful",
  "新增配置成功": "Add configuration successfully",
  "请输入消息群ID": "_Other Organiser",
  "获取FAQ详情失败": "Failed to get FAQ details",
  "删除FAQ配置成功": "Successfully removed FAQ configuration",
  "删除FAQ配置失败": "Failed to remove FAQ configuration",
  "FAQ配置": "FAQ Configuration",
  "管理常见问题解答，支持多语言配置": "Manage frequently asked questions and support multilingual configuration",
  "中文问题和答案为必填项，请填写中文内容": "Questions and answers in Chinese are required. Please fill in the Chinese text",
  "英文问题和答案为必填项，请填写英文内容": "Questions and answers in English are required, please fill in English",
  "编辑FAQ成功": "Edit FAQ successfully",
  "新增FAQ成功": "New FAQ succeeded",
  "编辑FAQ": "Edit FAQ",
  "问题内容（必填）": "Problem content (mandatory)",
  "答案内容（必填）": "Answers (mandatory)",
  "请选择语言类型": "Select Language Type",
  "请输入敏感词": "Please enter sensitive words",
  "请输入有效的敏感词": "Please enter a valid sensitive word",
  "批量添加敏感词失败": "Batch addition of sensitive words failed",
  "批量添加敏感词": "Batch Add Sensitive Words",
  "语言类型": "Language type",
  "敏感词列表": "Sensitive Word List",
  "请输入敏感词，支持以下格式：&#10;1. 每行一个敏感词&#10;2. 用逗号分隔：敏感词1,敏感词2,敏感词3&#10;3. 用分号分隔：敏感词1;敏感词2;敏感词3&#10;4. 混合使用：敏感词1,敏感词2&#10;敏感词3;敏感词4": "Enter sensitive words to support the following formats: & #10; 1. A sensitive word & #10 per row; 2. Comma-separated: sensitive word 1, sensitive word 2, sensitive word 3 & 10; 3. semi-separated: sensitive word 1, sensitive word 2, sensitive word 3 & 10; 4. Mixed use: sensitive word 1, sensitive word 2 & # 10; sensitive words 3; sensitive words 4",
  "预览敏感词 (": "Preview sensitive words (",
  "个)：": "Numbers:",
  "使用说明：": "Description of use:",
  "• 支持多种分隔符：逗号(,)、分号(;)、换行符": "• Support for multiple separators: commas (), semi-colons (;), line breaks",
  "• 系统会自动去除空白字符和重复项": "• The system automatically removes blank characters and duplicate items",
  "• 建议每批添加不超过100个敏感词": "• It is recommended that no more than 100 sensitive words be added to each batch",
  "• 添加前请确认语言类型选择正确": "• Please confirm that language type selection is correct before adding",
  "语言名称": "Language name",
  "敏感词": "Sensitive words",
  "敏感词配置": "Sensitive Word Configuration",
  "配置各语言的敏感词，包括政治、色情、暴力、赌博、毒品、恐怖主义、宗教、种族歧视等敏感词": "Combining sensitive words in various languages, including politics, pornography, violence, gambling, drugs, terrorism, religion, racial discrimination",
  "语言类型:": "Language type:",
  "请选择语言": "Select Language",
  "新增敏感词": "Add Sensitive Words",
  "编辑敏感词成功": "Edit sensitive words successfully",
  "新增敏感词成功": "New Sensitive Word Successful",
  "编辑敏感词": "Edit Sensitive Words",
  "反馈类型配置": "Feedback type configuration",
  "功能配置": "Function Configuration",
  "暂无类型数据": "No type data available",
  "暂无次类型数据": "No secondary type data available",
  "反馈类型筛选": "Feedback type filter",
  "主类型": "Main type",
  "次类型": "Subtype",
  "反馈类型": "Type of feedback",
  "个已选": "Selected",
  "聊天消息": "Chat Message",
  "暂无可翻译的原文内容": "Original text not available for translation",
  "缺少反馈ID": "Lack of feedback ID",
  "翻译成功": "Translation success",
  "翻译失败": "Translation failed",
  "请输入回复内容或上传附件": "Please enter a response or upload attachment",
  "回复成功": "Reply Successful",
  "回复失败": "Reply Failed",
  "暂无可翻译内容": "No translation at this time.",
  "反馈信息": "Feedback",
  "翻译后": "After translation",
  "手动翻译": "Manual Translation",
  "处理与回复": "Processing and response",
  "翻译中": "Translation",
  "翻译": "Translation",
  "暂无处理与回复记录": "Pending processing and response records",
  "回复后您会被添加到关注人": "You will be added to the person concerned after reply",
  "发送": "Send",
  "反馈记录不存在了": "The feedback's gone.",
  "操作日志": "Operation Log",
  "评分": "Rating",
  "来源渠道": "Source channel",
  "问题解决类型": "Problem resolution type",
  "是否弹幕": "Whether to play screen",
  "关联标签": "Association Tabs",
  "反馈主类型": "Feedback master type",
  "反馈次类型": "Type of feedback",
  "站点": "Site",
  "用户删除": "User Delete",
  "聊天记录": "Chat Record",
  "原文：": "Original language:",
  "翻译：": "Translation:",
  "反馈人ID": "Feedback ID",
  "被指派人": "Appointed",
  "关联BUG": "Associated bug",
  "暂无状态记录": "No status record.",
  "状态变更失败": "State change failed",
  "介入时间": "Intervention Time",
  "下架": "Down!",
  "上架": "Up!",
  "请选择反馈主类型": "Please select the main type of feedback",
  "保存失败:": "Save failed:",
  "请先选择主类型": "Please select the main type first",
  "该主类型下暂无次类型": "No subtype for this main type",
  "选择反馈类型": "Select Type of Feedback",
  "（可选）": "(optional)",
  "关联业务需求": "Related business requirements",
  "确定要删除这个关联需求吗？": "Are you sure you want to delete this associated requirement?",
  "请选择要添加的需求": "Please select the needs to add",
  "关联需求详情": "Details of associated needs",
  "添加需求：": "_Other Organiser",
  "请输入备注内容": "Please enter a comment",
  "备注添加成功": "Comments added successfully",
  "备注添加失败": "Comments added failed",
  "暂无数据可导出": "Data not available for export",
  "导出成功": "Export succeeded",
  "请先选择需要分享的反馈": "Please select the feedback that needs to be shared.",
  "批量分享内容已复制": "Batch sharing content copied",
  "批量分享失败": "Batch sharing failed",
  "翻译失败:": "Translation failed:",
  "用户是否删除": "_Other Organiser",
  "批量分享": "Batch sharing",
  "反馈类型负责人": "Head of feedback type",
  "人员类型": "Type of personnel",
  "请选择人员类型（可选）": "Select the type of person (optional)",
  "取消关联成功": "Can not open message",
  "取消关联失败": "Unconnect failed",
  "请选择要关联的线上问题": "Select the production issue to be associated",
  "确定要取消关联吗？": "Are you sure you want to cancel the connection?",
  "添加线上问题：": "Add a problem online:",
  "请选择线上问题": "Please select a problem on line",
  "关联成功": "Association succeeded",
  "关联失败": "Association failed",
  "请选择要关联的业务需求": "Please select the business needs to be associated",
  "请选择业务需求": "Please select business needs",
  "无需处理后，反馈状态将自动更新为已关闭": "The feedback status will automatically be updated as closed without processing",
  "翻译中...": "Translation...",
  "反馈翻译": "Feedback translation",
  "反馈原文": "_Other Organiser",
  "处理状态": "Process Status",
  "添加关联业务需求": "Add Associated Business Needs",
  "添加关联BUG": "Add Associated bug",
  "最新回复内容": "Latest replies",
  "最新回复内容翻译": "Translation of responses",
  "反馈人名称": "Feedback name",
  "设备型号": "Device Model",
  "系统版本": "System Version",
  "app版本": "App Version",
  "反馈提交时间": "Time of submission of feedback",
  "变更处理人": "Change Processor",
  "变更关注人": "Change focus",
  "转业务需求": "Transition requirements",
  "转线上问题": "It's a switch.",
  "编辑关联标签": "Edit Association Tabs",
  "编辑备注": "Edit Remarks",
  "查看图片": "View Pictures",
  "查看消息": "View Message",
  "查看操作记录": "View Operations Records",
  "暂无可分享的反馈信息": "Feedback not yet shared",
  "分享内容已复制": "Shared content copied",
  "分享失败": "Sharing Failed",
  "暂不转换": "Do Not Convert",
  "备注保存成功": "Remarks saved successfully",
  "备注保存失败": "Remarks Save Failed",
  "修改失败": "Modify failed",
  "业务需求创建失败": "Business requirement creation failed",
  "全部类型": "All types",
  "事件类型": "Event type",
  "事件详情": "Event Details",
  "工单ID:": "Worksheet ID:",
  "工单名称": "Worksheet Name",
  "工程师": "Engineer",
  "所属组": "Group of which",
  "是否备份": "Whether to backup",
  "已备份": "Backup",
  "未备份": "_Other Organiser",
  "完成时间": "Completion time",
  "SQL内容": "SQL content",
  "审核结果": "Audit findings",
  "影响行数:": "Impact rows:",
  "应用ID": "Apply ID",
  "发布标题": "Issue Title",
  "集群": "Cluster",
  "配置变更详情": "Configure Change Details",
  "原值:": "Original value:",
  "新值:": "New value:",
  "运行ID:": "Run ID:",
  "发布ID:": "Publishe ID:",
  "服务基本信息": "Service Basic Information",
  "服务类别": "Service category",
  "运行信息": "Run Information",
  "操作人信息": "Organisation",
  "电话": "Telephone",
  "错误日志对象:": "Error log object:",
  "加载详情中...": "Loading details...",
  "暂无详情数据": "Detailed data not available",
  "事件名": "Event Name",
  "• 数据库变更：为数据库名": "• Database change: name of database",
  "• 配置变更：为应用ID": "• Configuration change: for application of ID",
  "• 服务发布：为服务名": "• Service announcements: service name",
  "个事件": "Event",
  "暂无事件数据": "Event data not available",
  "时间轴视图": "Time axis view",
  "网格视图": "Grid View",
  "获取事件数据失败:": "Failed to get event data:",
  "获取事件数据失败": "Failed to get event data",
  "获取字典数据失败:": "Failed to load dictionary data:",
  "获取事件类型数据失败": "Failed to get event type data",
  "时间范围不能超过180天": "The time frame cannot exceed 180 days.",
  "时间范围不能超过180天，请重新选择": "The time frame cannot exceed 180 days. Please re-select.",
  "发起审计成功": "Successfully initiated audit",
  "发起审计失败": "Failed to initiate audit",
  "发起审计失败:": "Failed to launch audit:",
  "GOC统一事件看板": "GOC unified event panel",
  "总事件": "Total Events",
  "时间范围：": "Time frame:",
  "业务领域：": "Operational areas:",
  "请选择环境": "Select Environment",
  "发起审计": "Initiate audit",
  "请输入审批标题": "Please enter the approval title.",
  "指派工单": "Assign worksheets",
  "必须选择一个工单": "You have to choose a worksheet.",
  "指派成功": "Assign success",
  "指派失败": "Assigning failed",
  "请选择被指派人员": "Please select the person to be appointed.",
  "获取运维人员失败:": "Failed to load operations personnel:",
  "获取可处理人员失败，将继续提交工单": "Failure to obtain handlers and continued submission of work orders",
  "创建工单成功！": "Create worksheet succeeded!",
  "表单验证失败:": "Form validation failed:",
  "创建工单": "Create worksheet",
  "紧急程度": "Level of urgency",
  "请选择紧急程度": "Please choose the emergency level.",
  "问题分类": "Problem classification",
  "请选择问题分类": "Select the problem group",
  "问题描述": "Problem description",
  "请输入问题描述": "Please enter a question description",
  "缺少工单ID": "Missing worksheet ID",
  "请选择评价分数": "Select the evaluation score",
  "评价成功": "Evaluation success",
  "评价失败": "Evaluation failures",
  "评价工单失败:": "Evaluation of worksheets failed:",
  "评价工单": "Evaluation of worksheets",
  "评价分数：": "Evaluation scores:",
  "评价内容：": "Evaluation content:",
  "请输入评价内容（可选）": "Please enter the evaluation content (optional)",
  "获取聊天记录失败:": "Failed to load chat history:",
  "回复失败:": "Reply failed:",
  "工单信息": "Worksheet Information",
  "创建时间：": "Created:",
  "（可处理人：": "(Able to process:",
  "请输入回复内容": "Please enter the response.",
  "工单详情": "Details of worksheets",
  "1分": "1 minute",
  "2分": "Two minutes.",
  "3分": "Three minutes.",
  "4分": "Four minutes.",
  "5分": "Five minutes.",
  "工单筛选": "Sheet Filter",
  "指派人员": "Designated personnel",
  "请选择指派人员": "Please select an assigned person.",
  "评价分数": "Evaluation scores",
  "获取工单详情失败:": "Failed to load ticket details:",
  "工单已完成": "Worksheet completed",
  "完成工单失败": "Completed worksheet failed",
  "请至少选择一个可指派的工单": "Please select at least one of the assigned worksheets",
  "工单编号": "Worksheet Number",
  "可处理人员": "Personnel at disposal",
  "被指派人员": "Designated persons",
  "实际处理人员": "Actual processors",
  "分数范围为1~5分": "The fraction range is 1-5 minutes.",
  "评价内容": "Evaluation content",
  "处理完成": "Processing completed",
  "服务评价": "Service evaluation",
  "确定要删除此工单吗？": "Are you sure you want to delete this worksheet?",
  "删除工单失败:": "Failed to delete the ticket:",
  "批量指派": "Batch Assign",
  "确认完成工单": "Confirm completed work orders.",
  "确定要完成此工单吗？": "Are you sure you want to finish this?",
  "请等待文件上传完成": "Please wait until file upload is complete",
  "点击或拖拽文件到此区域上传": "Click or drag files to upload to this area",
  "支持多文件上传，单个文件不超过10MB": "Support the uploading of multiple files, not exceeding 10MB for single files",
  "已读完成": "Read completed",
  "去填写": "Fill it out.",
  "已读": "Read",
  "未读": "Unread",
  "系统通知": "System Notifications",
  "全部已读": "Read All",
  "全部设为已读": "Set all as read",
  "加载里程碑失败": "Failed to load milestone",
  "请先选择一个里程碑": "Please select a milestone first.",
  "关联迭代": "Correlation",
  "下一步": "Next",
  "项目：": "Projects:",
  "请选择一个里程碑：": "Please select a milestone:",
  "请选择里程碑": "Select the milestones",
  "项目ID不能为空": "Project ID cannot be empty",
  "预算已更新": "Budget updated",
  "编辑预算": "Edit Budget",
  "预估人天不能为空": "I don't expect people to be empty.",
  "须大于 0": "must be greater than 0",
  "机器预算（人民币）": "Machine budget (RMB)",
  "其他预算（人民币）": "Other budgets (RMB)",
  "预期收益（人民币）": "Expected proceeds (RMB)",
  "预期收益不能为空": "Expected gains cannot be empty",
  "项目编码：": "Item code:",
  "空间 / 业务领域未配置": "Space/ fields of operation not configured",
  "空间": "Space",
  "年份:": "Year:",
  "周期:": "Period:",
  "规模": "Size",
  "时间进度": "Time progress",
  "进度根据时间流逝计算占比：(当前日期 - 开始日期) / (结束日期 - 开始日期) × 100%": "Progress calculated according to the passage of time: (Current date - Start date) / (End date - Start date) x 100%",
  "点击查看迭代明细": "Click to see the column",
  "完成数/总数": "Number of completed/total",
  "点击查看需求明细": "Click to see requirement details",
  "点击查看任务明细": "Click to see Task Details",
  "质量评分:": "Quality rating:",
  "未评分": "Not rated",
  "未完成不可评分": "Not completed non-scoring",
  "项目团队": "Project team",
  "立项后技术接口人仅可变更主开发、主测试、其他干系人；如需变更其他人员，请联系Zola周华变更。": "The technical interface may be changed only for the main development, primary testing, and other liners; contact Zola Chowhua for any other change.",
  "暂无": "Not yet.",
  "暂无项目": "Items not available",
  "点击\"新建项目\"开始创建": "Click \"New Item\" to start creating",
  "项目完成": "Project completion",
  "确认完成项目": "Confirmation of completion of project",
  "实际人天": "Real days.",
  "请填写实际人天": "Please fill out actual person-days.",
  "请输入实际人天，可保留两位小数": "Enter actual person-days to keep two decimal places",
  "人力成本约为": "The human cost is about",
  "（实际人天 × 平均工资 ¥": "(actual days x average wage)",
  "/人天）": "/ Man days)",
  "机器成本（元）": "Machine cost ($)",
  "请填写机器成本": "Please fill out the machine costs.",
  "请输入机器成本": "Please enter the machine cost.",
  "其他成本（元）": "Other costs ($)",
  "请填写其他成本": "Please fill out other costs.",
  "请输入其他成本": "Please enter other costs",
  "实际收益（元）": "Actual proceeds ($)",
  "请填写实际收益": "Please fill in the actual proceeds.",
  "请输入实际收益": "Please enter the actual proceeds.",
  "暂无验收标准": "No acceptance standards at this time",
  "添加验收标准": "Add acceptance standard",
  "关键结果": "Key findings",
  "权重": "Weights",
  "验收时间": "Time of receipt and inspection",
  "请选择日期": "Select Date",
  "验收人": "Receiving and Inspection",
  "验收标准": "Acceptance and inspection standards",
  "确定要删除此验收标准吗？": "Are you sure you want to delete this acceptance criterion?",
  "项目不存在，无法保存里程碑": "Project does not exist and cannot save milestones",
  "请输入里程碑名称": "Please enter the name of the milestone",
  "请输入完成目标": "Please enter the target.",
  "请选择截止日期": "Please select the deadline",
  "编辑里程碑": "Edit milestones",
  "新增里程碑": "New Milestone",
  "如：立项启动、各系统改动点确认": "e.g., start-up of projects, confirmation of changes in systems",
  "开始日期 / 截止日期": "Start Date / Deadline",
  "请选择开始日期和截止日期": "Select the starting date and the deadline",
  "项目不存在，无法保存风险": "The project does not exist and the risk cannot be saved",
  "编辑风险": "Edit Risk",
  "新增风险": "Additional risks",
  "请输入风险类型": "Please enter the risk type",
  "风险描述": "Risk description",
  "请输入风险描述": "Please enter a risk description.",
  "请输入风险原因": "Please enter the reason for the risk.",
  "风险等级": "Risk level",
  "请选择风险等级": "Please select the risk level.",
  "应对措施": "Response",
  "请输入应对措施": "Please enter a response.",
  "替换": "Replace",
  "暂无人员": "Not available",
  "项目背景": "Project background",
  "项目目标": "Project objectives",
  "带此图标的字段可在详情中快速编辑。立项通过后需要变更项目基础与预算信息，可联系Zola周华": "Fields with this icon can be quickly edited in detail. Once the project has been established, changes in project base and budget information will be required to contact Zola Chowhua",
  "项目编码": "Item code",
  "所属空间": "Space",
  "项目状态": "Project Status",
  "请选择年份": "Please choose the year",
  "项目背景与目标": "Project background and objectives",
  "请编辑项目背景（支持富文本格式）": "Please edit the background of the item (substance rich text format)",
  "请编辑项目目标（支持富文本格式）": "Please edit the project objectives (support rich text formats)",
  "项目预算与资源": "Project budget and resources",
  "人力预算": "Human budget",
  "人力成本": "Human cost",
  "机器预算": "Machine Budget",
  "机器成本": "Machine cost",
  "其他预算": "Other budgets",
  "其他成本": "Other costs",
  "预期收益": "Expected income",
  "实际收益": "Actual proceeds",
  "预期ROI": "Expected ROI",
  "实际ROI": "Actual ROI",
  "当前进度:": "Current progress:",
  "预算进度": "Budget progress",
  "预算进度 = 当前已用预算 ÷ 总预算 × 100%": "Budget progress = total budget currently used x 100%",
  "请选择时间或预估人天": "Please choose the time or estimated day.",
  "编辑任务时间": "Edit Task Time",
  "开始结束:": "_Other Organiser",
  "预估人天:": "Estimated days:",
  "请至少选择一项": "Please choose at least one.",
  "完成关联": "Finish Association",
  "多少天之内的创建的迭代": "Create an iterative number of days",
  "多少天之内的创建的需求": "Creation needs within days",
  "最近7天": "The last seven days.",
  "最近30天": "The last 30 days.",
  "最近180天": "Last 180 days.",
  "最近360天": "Last 360 days.",
  "选择要关联的迭代": "Select the iterative to be associated",
  "选择要关联的需求": "Select the needs to be associated",
  "没有迭代？": "No overlap?",
  "没有产品需求？": "No product requirement?",
  "去创建": "To create",
  "仅支持删除任务类型工作项": "Only support the deletion of task type jobs",
  "确定要删除该工作项吗？": "Are you sure you want to delete the task item?",
  "确定要将该工作项移出项目吗？": "Are you sure you want to move this item out of the project?",
  "项目或工作项信息异常": "Malformed information on project or work item",
  "当前工作项类型不支持移出项目": "The current work item type cannot be removed from the project",
  "解绑成功": "Untied.",
  "暂无关联链接": "_Other Organiser",
  "创建能力待接入": "Create capability to access",
  "知道了": "Okay.",
  "添加备注成功": "Add Remarks Successful",
  "迭代详情": "Organisation",
  "任务详情": "Task Details",
  "展示内容：": "Presentation:",
  "里程碑时间轴": "Milestone Axis",
  "工作项明细": "Details",
  "已完成 / 总数": "Completed/ Total",
  "暂无里程碑数据": "Milestone data not available",
  "只看未完成": "Only incomplete",
  "暂无工作项数据": "_Other Organiser",
  "暂无迭代数据": "Data not available",
  "迭代名称": "Organisation",
  "周期": "Cycle",
  "未完成": "Not completed",
  "暂无明细记录": "No details.",
  "暂无需求数据": "No requirement data available",
  "暂无任务数据": "_Other Organiser",
  "实际工时(h)": "Actual working hours (h)",
  "任务不支持直接关联项目：请先在关联需求，然后在需求下创建任务，任务会通过需求自动关联到该项目": "The mission does not support the directly related project: please start with the associated needs and then create the task with the needs, which will automatically link the project to the needs",
  "仅项目技术接口人可编辑周报模板并写周报": "Only project technical interfaces can edit weekly report templates and write weekly reports",
  "编辑周报模板": "Edit weekly report templates",
  "新增周报模板": "New weekly reporting template",
  "当前无权限编辑该角色成员": "Currently no permission to edit the role member",
  "确定要移除此人员吗？": "Are you sure you want to remove this person?",
  "暂无活动记录": "No activity recorded",
  "总数": "Total",
  "查看": "View",
  "请先完成所有内容": "Please finish everything.",
  "验收完成": "Acceptance complete.",
  "完成验收失败": "Failed to complete acceptance",
  "工作项完成情况": "Completion of work items",
  "工作项完成情况检查": "Project completion check",
  "暂无完成明细": "It's not finished yet.",
  "存在未完成工作项，无法完成验收，请先完成所有内容。": "If you have an uncompleted item, you cannot complete the receipt and inspection.",
  "迭代明细": "Descending",
  "业务接口人（BPM）": "Business interface (BPM)",
  "技术接口人（产品经理）": "Technical interface (product manager)",
  "业务负责人": "Chief of Operations",
  "验收负责人": "Head of Receiving and Inspection",
  "主开发": "Main development",
  "主测试": "Main Test",
  "系统落地负责人": "System landing manager",
  "系统培训负责人": "Head of System Training",
  "其他干系人": "Other practitioners",
  "该角色至少保留一名人员，无法全部移除": "This role retains at least one person and cannot be removed",
  "已移除": "Removed",
  "项目名称不能为空": "Item name cannot be empty",
  "项目编号不能为空": "Item number cannot be empty",
  "项目编号不能超过20个字符": "Item numbers cannot exceed 20 characters",
  "项目编号仅支持字母、数字、中划线、下划线": "Item numbers only support letters, numbers, underlineds, underlineds",
  "项目背景不能为空": "Project background cannot be empty",
  "项目目标不能为空": "Project objectives cannot be empty",
  "时间进度总览": "Time progress overview",
  "周报": "Weekly",
  "活动时间线": "Active Timeline",
  "查看审批单": "View approvals",
  "开始项目": "Start Project",
  "重新发起审批": "Re-launch approval",
  "发起立项审批": "Start project approval",
  "质量打分": "Quality score",
  "完整编辑": "Full Edit",
  "项目信息不存在": "Project information does not exist",
  "未指定": "Not specified",
  "验收评价": "Acceptance and inspection evaluation",
  "暂无评价": "Evaluation not available",
  "明细": "Details",
  "完成里程碑": "Completion milestones",
  "完成": "Completed",
  "里程碑已完成": "Milestone completed",
  "验收分数须为 1～5 分": "The acceptance score must be 1 to 5 minutes.",
  "验收已保存": "Receiving and Inspection Saved",
  "验收保存失败": "Receiving and Inspection Save Failed",
  "里程碑验收": "Milestone acceptance and acceptance",
  "完成评分（满分 5 分）：": "Score completed (Five:",
  "完成评价：": "Evaluation completed:",
  "请填写对该里程碑完成情况的评价（选填）": "Please complete the evaluation of the milestone completion (selection)",
  "加载项目风险失败": "Failed to load project risk",
  "风险已标记为已处理": "Risk marked as processed",
  "删除风险": "Remove Risk",
  "解决风险": "Addressing risks",
  "检索值": "Retrieving value",
  "请输入项目名称、编码或描述": "Enter the name, code or description of the item",
  "项目类型": "Type of project",
  "请选择类型": "Select Type",
  "加载更多": "Load More",
  "保存草稿": "Save Draft",
  "起草完成": "Drafting completed",
  "提交并进入技术起草": "Submission and entry into technical drafting",
  "开始日期、预计完成日期": "Start date, expected completion date",
  "所属年份": "Year",
  "项目规模": "Project size",
  "业务接口人": "Business interface",
  "技术接口人": "Technical interface",
  "至少填写一条里程碑": "At least one milestone.",
  "风险为选填，若添加则每条须填写完整": "Risk is optional, and if added, each entry must be completed",
  "一、项目基本信息": "Basic information on the project",
  "二、项目背景与目标": "II. Project background and objectives",
  "三、项目团队": "Project team",
  "四、项目预算与资源": "IV. Project budgets and resources",
  "五、项目关键里程碑": "V. Key milestones of the project",
  "六、项目风险": "Project risk",
  "业务起草已提交，项目已流转至技术起草": "Operational drafting has been submitted and the project has been transferred to technical drafting",
  "草稿已保存": "Draft saved",
  "起草完成，可发起立项审批": "Drafting completed and project approval initiated",
  "编写说明": "Preparation of notes",
  "请按顺序填写下列区域，点击区域名称可快速定位到对应表单。绿色勾表示该区域已填写完整。": "Please fill in the following areas in order, and click on the area name to quickly position the corresponding form. Green tick indicates that the region has been completed.",
  "仅业务接口人和技术接口人可编写项目信息。": "Only business and technical interfaces can prepare project information.",
  "整体预览": "Overall Preview",
  "待填": "To be filled",
  "选填": "Select Fill",
  "待填写": "To be completed",
  "提示：点击上方步骤标题可快速跳转到对应区域。": "Tip: Click on the top step title to jump quickly to the corresponding area.",
  "请输入项目背景": "Please enter the project background",
  "请描述项目的背景、现状和需要解决的问题": "Please describe the background, current status of the project and the issues to be addressed.",
  "请输入项目目标": "Please enter the project target.",
  "请描述项目的预期目标、关键成果和成功标准": "Please describe the expected objectives, key results and success criteria of the project",
  "请输入项目名称": "Please enter the project name",
  "项目名称不能超过100个字符": "Item name cannot exceed 100 characters",
  "请选择所属年份": "Select the year to which you belong",
  "项目的计划开始和结束时间": "Planned start and end of project",
  "请选择项目周期": "Select the project cycle",
  "请选择所属空间": "Select your space",
  "请选择项目类型": "Select the project type",
  "请选择项目规模": "Select the project size",
  "人力预算：--（请先填写预估人天）": "Human resources budget: -- (please fill in an estimated number of days)",
  "人力预算：": "Human budget:",
  "万（人民币）": "Thousand yuan",
  "计算方式：预估人天 ×": "Calculation: Estimated human days x",
  "元/人天（人民币）": "dollar/man/man/person",
  "预期ROI：--": "Expected ROI: -",
  "计算公式：预期ROI = （预期收益 - 总投资） ÷ 总投资 × 100%，其中总投资 = 人力预算（预估人天 × 3000） + 机器预算 + 其他预算": "Formula: Expected ROI = (expected return - total investment) Total investment x 100 per cent, of which total investment = human budget (estimated human day x 3000) + machine budget + other budget",
  "大于0，支持两位小数": "> 0, support two decimals",
  "请输入预估人天": "Please enter an estimate.",
  "须大于0，且可保留两位小数": "Be greater than 0 and can retain two decimal places",
  "请输入金额（元）": "Please enter the amount (dollars)",
  "请输入预期收益": "Please enter the expected return.",
  "五、项目关键里程碑（业务与技术协作编写）": "V. Key milestones of the project (business and technical collaboration preparation)",
  "请至少填写一条里程碑，每条里程碑的「里程碑名称」「完成目标」「开始日期」「预计完成日期」「负责人」均必填。": "Please fill in at least one milestone, and for each milestone, the name \"Significant of the milestone\" \"Performance of the target\" \"Start of the target\" \"Performance of the target\" \"Performance of the completion date\" \"Performance of the target\".",
  "六、项目风险（选填）": "Project risk (selection)",
  "风险为选填，若添加则每条须填写完整（风险类型、描述、风险原因、风险程度、风险应对方法）。": "The risk is optional and, if added, each entry must be complete (type of risk, description, cause of risk, degree of risk, risk response).",
  "请选择业务接口人（可多选）": "Select the business interface (multi-optional)",
  "请选择业务接口人": "Select Business Interface",
  "请选择技术接口人（可多选）": "Please select a technology interface (multi-optional)",
  "请选择技术接口人": "Please select a technology interface",
  "请选择业务负责人（可多选）": "Please select the chief of operations (multi-optional)",
  "请选择业务负责人": "Please select the head of business.",
  "请选择验收负责人（可多选）": "Select the head(s) to accept and accept (multiple options)",
  "请选择验收负责人": "Please select the recipient.",
  "请选择主开发（可多选）": "Select main development (multi-optional)",
  "请选择主测试（可多选）": "Select main test (multi-optional)",
  "请选择系统落地负责人（可多选）": "Select the system landing manager (multi-optional)",
  "请选择系统落地负责人": "Please select the system implementation owner",
  "请选择系统培训负责人（可多选）": "Please select the system training manager (multi-optional)",
  "请选择系统培训负责人": "Please select a system training officer.",
  "请选择其他干系人（可多选）": "Please select another line of work.",
  "请选择开始日期和预计完成时间": "Select the start date and expected completion date",
  "添加里程碑": "Add milestones",
  "低": "Low",
  "高": "High",
  "请选择风险程度": "Please select the risk level.",
  "请输入风险应对方法": "Please enter a risk response.",
  "添加风险": "Add Risk",
  "结项": "Conclusion",
  "确定要删除这个项目吗？": "Are you sure you want to delete this item?",
  "质量评分": "Quality rating",
  "待评分": "Outstanding",
  "完成数/总数，点击查看迭代明细": "Number of completeds/totals, click to see diaries",
  "完成数/总数，点击查看需求明细": "Number of completeds/totals, click to see details of needs",
  "完成数/总数，点击查看任务明细": "Number of completed/total, click to see task details",
  "发起审批": "Initiate approval",
  "重发审批": "Reissued for approval",
  "打分": "Score",
  "个项目": "Projects",
  "新建项目": "New Item",
  "隐藏筛选": "Hide Filter",
  "显示筛选": "Show Filter",
  "卡片": "Card",
  "表格": "Table",
  "看板": "Watch.",
  "点击选择 1-5 星": "Click to select 1-5 stars",
  "所有的": "All of it.",
  "获取项目详情失败": "Failed to fetch project details",
  "加载项目详情...": "Load Details...",
  "项目ID为空，无法写周报": "Project ID is empty, unable to write a weekly report",
  "正在提交评分...": "Submit Ratings...",
  "评分成功": "Rating successful",
  "正在删除项目...": "Removing items...",
  "项目已删除": "Item deleted",
  "正在开始项目...": "Starting Project...",
  "项目已开始": "Project commenced",
  "正在发起立项审批...": "Starting project approval...",
  "已发起立项审批": "Project approval initiated",
  "暂无审批单信息": "No approval request information available",
  "正在完成项目...": "Finishing Project...",
  "项目已完成": "Project completed",
  "没有找到符合条件的项目": "No eligible items found",
  "暂无项目数据": "No project data available",
  "清除筛选条件": "Clear Filter Conditions",
  "创建项目": "Create Item",
  "项目需求明细": "Detailed project requirements",
  "项目任务明细": "Detailed project tasks",
  "项目迭代明细": "Details of projects",
  "编辑空间": "Edit Space",
  "确定要删除这个空间吗？": "Are you sure you want to delete this space?",
  "删除后空间下的所有项目将无法访问": "All items in the deleted space will not be accessible",
  "删除空间": "Remove Space",
  "成员（": "Members",
  "暂无成员": "Not available",
  "创建于": "Created on",
  "暂无空间": "No room.",
  "点击\"新建空间\"开始创建": "Click \"New Space\" to start creating",
  "空间名称": "Space name",
  "项目数": "Number of projects",
  "最后更新人": "Last updateer",
  "最后更新时间": "Last update time",
  "成员管理": "Member management",
  "其他成员": "Other members",
  "暂无其他成员": "No other members",
  "空间详情": "Space Details",
  "在此空间下创建项目": "Create projects in this space",
  "空间信息不存在": "Space information does not exist",
  "活跃空间": "Active Space",
  "新建空间": "New Space",
  "请输入空间名称": "Please enter a space name",
  "空间名称不能超过50个字符": "Space name cannot exceed 50 characters",
  "空间负责人": "Spacemaster",
  "请选择空间负责人": "Please choose the space manager.",
  "空间描述": "Spatial Description",
  "请输入空间描述（可选）": "Please enter a spatial description (optional)",
  "空间成员": "Space members",
  "请选择成员（可多选）": "Please select members (multi-optional)",
  "个空间": "Space",
  "空间名称或描述": "Space name or description",
  "没有找到符合条件的空间": "No eligible space found",
  "暂无空间数据": "No spatial data available",
  "创建空间": "Create Space",
  "产品需求原型或需求文档": "Product requirement Prototype or requirement Document",
  "产品经理响应速度": "Product manager response speed",
  "产品经理对业务方需求的理解度": "Knowledge of product managers on business side needs",
  "与产品经理沟通过程": "Communication process with product managers",
  "研发开发和交付效率": "R & D and delivery efficiency",
  "产品功能交付质量": "Quality of product functional delivery",
  "提交成功": "Successful submission",
  "产品需求交付验收单": "Receipt and inspection of product requirement",
  "尊敬的业务方：": "Distinguished operator:",
  "您好！": "Hello!",
  "非常感谢您对我们工作的支持！为了不断改进我们的服务质量，我们诚邀您填写此份简短的问卷，以便我们了解您对我们产品需求交付的满意度以及任何改进建议。您的反馈对我们非常重要！": "Thank you very much for your support for our work! In order to continuously improve the quality of our services, we kindly invite you to complete this short questionnaire so that we can understand your satisfaction with the delivery of our product needs and any suggestions for improvement. Your feedback is very important to us!",
  "产品需求基本信息": "Basic information on product needs",
  "需求相关时间和时长": "Time and duration of requirement",
  "需求创建时间": "Require creation time",
  "需求交付时间": "requirement delivery time",
  "研发投入时间": "R&D investment time",
  "前端：": "Frontend:",
  "(小时)": "(hours)",
  "后端：": "Backend:",
  "测试：": "Test:",
  "产品阶段耗时": "Product stage time-consuming",
  "研发阶段耗时": "Time-consuming R & D",
  "测试阶段耗时": "Time-consuming test phase",
  "是否与您确认期待完成时间": "Whether to confirm with you the expected completion time",
  "需求验收意见": "Request and acceptance comments",
  "请选择验收结果": "Please select the acceptance result.",
  "请填写不通过原因": "Please fill out the reasons for non-adoption.",
  "改进建议或意见": "Suggested improvements or observations",
  "请填写改进建议或意见": "Please fill in any suggestions or suggestions for improvement.",
  "满意度评价": "Evaluation of satisfaction",
  "请您对以下方面进行满意度评价,并在相应选项后打分。": "Please provide an assessment of your satisfaction with regard to the following, and rate the corresponding options.",
  "请根据实际情况进行评价，评价结果将作为需求交付质量的重要参考。": "Evaluations should be undertaken on a case-by-case basis and should serve as an important reference for the quality of requirement delivery.",
  "总体评价": "Overall evaluation",
  "对本次需求交付的整体满意度": "Overall satisfaction with the delivery of this requirement",
  "提交问卷": "Submission of questionnaires",
  "需求背景描述": "Needs background description",
  "问题清晰度": "Problem clarity",
  "原型或者需求设计": "Prototype or requirement design",
  "产品需求评审质量评价": "Product needs assessment quality evaluation",
  "尊敬的需求评审参与人员：": "Honorable Needs Review Participants:",
  "非常感谢您参与此次产品需求评审，为了了解此次需求评审质量情况，我们诚邀您匿名填写此份简短的问卷，感谢您的支持！": "Thank you very much for participating in this product needs assessment, and in order to understand the quality of this needs assessment, we kindly invite you to fill out this short questionnaire anonymously and thank you for your support!",
  "需求评审后是否有修改？": "Has the needs assessment been modified?",
  "亲, 您已填写过该问卷哦, 感谢您的参与!": "Honey, you've filled out the questionnaire, thanks for your participation!",
  "感谢您的反馈, 我们将努力做得更好!": "Thanks for your feedback, we'll try to do better!",
  "(未填写详细内容)": "(no details provided)",
  "导出失败": "Export Failed",
  "导出Word": "Export Word",
  "变更记录": "Change records",
  "事故名称和链接已剪贴板": "Incident name and link clipboard",
  "事故名称": "Name of incident",
  "影响范围": "Scope of impact",
  "分类": "Classification",
  "影响值": "Impact value",
  "暂无影响范围数据": "No impact range data available",
  "备注说明": "Remarks",
  "时间节点": "Time nodes",
  "恢复时间": "Recovery Time",
  "影响开始时间": "Impact Start Time",
  "影响结束时间": "Impact end time",
  "定级依据": "Classification basis",
  "暂无定级依据": "No basis for rating",
  "责任人与团队": "Responsible persons and teams",
  "事故处理责任组长": "Chief, Accident Management Unit",
  "暂无服务数据": "Service data not available",
  "事件时间线": "Event Timeline",
  "暂无时间线数据": "Timeline data",
  "事故原因": "Causes of accidents",
  "改进措施和计划": "Improvement measures and plans",
  "措施内容": "Content of measures",
  "计划完成时间": "Planned completion time",
  "永久": "Permanent",
  "跟踪备注": "Track Remarks",
  "查看添加": "View Add",
  "暂无改进措施": "No improvement measures available",
  "暂无附件": "Not attached",
  "选择责任人": "Selection of responsible persons",
  "事故序列号": "Incident serial number",
  "请输入事故名称或序列号": "Please enter an accident name or serial number",
  "进行中并且截止日期在3天内的措施发企微消息提醒": "Measures in progress and within three days of the deadline to send micromessage reminders",
  "发送失败": "Sending failed",
  "进行中临期提醒": "Organisation",
  "到达开始时间但未开始和超过完成时间的措施给责任人发送企微消息提醒": "Send micro-message alerts to duty-bearers on measures that arrive at the beginning but do not start and exceed the completion time",
  "未开始逾期提醒": "Overdue reminder not started",
  "热力图": "Hot try.",
  "事故等级分布": "Distribution of accident levels",
  "事故序列分布": "Incident sequence distribution",
  "月度事故趋势": "Trends in monthly accidents",
  "改进措施状态概览": "Overview of the status of improvement measures",
  "改进措施改进状态分布图": "Improved status map of measures",
  "改进措施负责人超期未完成": "Overdue by the head of the improvement measures",
  "前置过程（背景）": "Pre-process (background)",
  "事故发生": "Accident",
  "事件发现/处置": "Event detection/disposal",
  "善后处理": "Aftercare.",
  "暂存报告时，事故名称不能为空": "The name of the incident cannot be empty at the time of the temporary report",
  "有附件正在上传中，请稍后再试！": "There's an attachment uploading. Please try again later!",
  "操作失败：": "Operation failed:",
  "文件上传失败:": "File upload failed:",
  "暂存": "Pending",
  "1. 事故概况": "1. Overview of the accident",
  "请输入事故名称": "Please enter the name of the accident",
  "2. 影响范围": "2. Scope of impact",
  "数值": "Value",
  "请输入有效数字": "Please enter a valid number",
  "3. 责任分析": "3. Analysis of responsibility",
  "已存在群": "Existing group",
  "拉群人数小于3人": "The number of pullers is less than 3",
  "是否拉群": "Whether to pull",
  "4. 关联服务": "4. Associated services",
  "请选择服务类型": "Select the type of service",
  "请选择服务": "Select Service",
  "选择服务": "Select Service",
  "添加服务": "Add Service",
  "5. 事件时间线": "5. Incident timeline",
  "添加时间节点": "Add Time Node",
  "请选择时间": "Please choose the time",
  "文字颜色": "Text Colour",
  "字体加粗": "Hard",
  "加粗": "Harder",
  "6. 原因分析": "6. Reason analysis",
  "7. 改进措施和计划": "7. Improvement measures and plans",
  "改进措施": "Improvement measures",
  "设为永久": "Set as Permanent",
  "8. 附件": "Annex",
  "未暂存的更改将在关闭后清空，是否继续？": "Unsustained changes will be emptied after closure, and will they continue?",
  "推送邮件": "Send Mail",
  "确定删除吗？": "Are you sure about that?",
  "新建事故报告": "New Accident Report",
  "配置影响范围": "Configure Impact Ranges",
  "选择影响指标": "Selection of impact indicators",
  "请选择影响范围": "Select the impact range",
  "指标名称(单位)": "Indicator name (unit)",
  "是否加粗": "Is it thicker?",
  "组名": "Group Name",
  "项)": "item)",
  "显示顺序": "Show Order",
  "新建指标": "New indicator",
  "批量编辑": "Batch Edit",
  "批量删除": "Batch Delete",
  "批量操作": "Batch Operations",
  "必选": "Selected",
  "选择分类": "Select Category",
  "最长20字": "Up to 20 words.",
  "例如：包裹量": "For example: volume of parcels",
  "最长50字": "Up to 50 words.",
  "例如：件": "Examples:",
  "添加指标": "Add indicator",
  "确定要删除这些指标吗？此操作不可逆！": "Are you sure you want to delete these indicators? This operation is irreversible!",
  "刷新措施详情失败:": "Failed to refresh action details:",
  "添加备注失败": "Failed to add comment",
  "添加备注错误:": "Cannot initialise Evolution's mail component.",
  "备注删除成功": "Comments deleted successfully",
  "删除备注失败": "Failed to delete comment",
  "删除备注错误:": "Cannot initialise Evolution's mail component.",
  "确认删除这条备注？": "Confirm to delete this note?",
  "措施跟踪备注": "Measures Tracking Remarks",
  "措施信息": "Information on measures",
  "备注记录": "Remarks",
  "暂无备注": "No comment at this time",
  "不能超过1000字符": "Could not exceed 1,000 characters",
  "请输入备注内容...": "Please enter a comment...",
  "下载失败，请手动右键另存为": "Download failed. Right-click and select Save As.",
  "该格式文件不支持预览，已自动触发下载": "The format file does not support preview, automatically triggers download",
  "若未下载成功，请": "If not downloaded, please",
  "点击此处": "click here.",
  "文件预览": "File Preview",
  "推送有点慢，但我没放弃——": "It was a little slow, but I didn't give up--",
  "用户列表加载失败": "Failed to load user list",
  "必须选择一个收件人": "One recipient must be selected",
  "发射成功～邮件正在路上！": "We're on our way!",
  "发射失败…请稍后再试": "The launch failed. Please try again later.",
  "确认发送事故邮件？": "Confirm an accident e-mail?",
  "收件人：": "Recipient:",
  "标题：": "Title:",
  "标题：默认标题": "Title: Default Title",
  "确认发送": "Confirm Send",
  "再检查一下": "Check again.",
  "发送事故邮件": "Send Accident Mail",
  "默认已填充事故相关人员邮箱，可自行删减/追加；支持按姓名或邮箱搜索。": "Default filled accident-related personnel mailboxes can be deleted/added; search by name or mailbox is supported.",
  "邮件标题": "Mail Title",
  "留空将使用默认标题（事故名称-事故报告）": "Leave empty will use the default title (incident name - accident report)",
  "收件人": "To",
  "按姓名/邮箱搜索，支持多选": "Search by name/mail to support multiple selections",
  "抄送人员": "Copying personnel",
  "可选：按姓名/邮箱搜索抄送人员": "Optional: Search for copying persons by name/mail",
  "抄送组织": "Copy to Organisation",
  "团队邮箱": "Team Mailbox",
  "可选：选择团队邮箱": "Optional: Select Team Mailbox",
  "事故报告": "Accident report",
  "草稿箱": "Draft box",
  "数据看板": "Data Viewer",
  "需求编号": "Requirement Number",
  "需求文档": "Required Document",
  "是否与您沟通确认": "Are you communicating with me?",
  "请选择是否与您沟通确认": "Please choose whether to communicate with you for confirmation.",
  "(对本次需求交付的整体满意度)": "(General satisfaction with the delivery of the present request)",
  "请对总体情况进行评分": "Please rate the overall situation.",
  "需求业务方": "requirement side",
  "评价状态": "Evaluation status",
  "已评价": "Evaluated",
  "未评价": "Not evaluated",
  "验收意见": "Receiving and inspection observations",
  "不通过验收的原因": "Reasons for non-acceptance",
  "评价状态：": "State of evaluation:",
  "请选择评价情况": "Please select the evaluation.",
  "所有": "All",
  "COE 等级分布": "COE grade distribution",
  "根因类型分布": "Root type distribution",
  "责任人 COE 分布": "Responsible person COE distribution",
  "COE编号": "COE number",
  "等级": "Level",
  "发生时间": "Time of occurrence",
  "发现耗时": "Time-consuming discovery",
  "恢复耗时": "Recovery time-consuming",
  "故障责任人": "Liability for failure",
  "直接资损": "Direct financial losses",
  "间接资损": "Indirect damages",
  "Todo 内容": "Todo content",
  "交付时间": "Time of delivery",
  "延期情况": "Extensions",
  "延期": "Extension",
  "COE 明细": "COE Details",
  "COE Todo 明细": "COE Todo Details",
  "月度 COE 趋势": "Monthly COE trend",
  "COE 总数": "Total COE",
  "高等级 COE": "High Level COE",
  "故障等级为 P0 或 P1 的 COE 数量": "Number of COEs with failure level P0 or P1",
  "平均发现时长": "Average duration of discovery",
  "当前筛选范围内，从故障发生到发现的平均耗时；缺少有效时间对时不参与计算": "Average time between failure and discovery in the current screening range; absence of valid time to calculate",
  "平均恢复时长": "Average length of recovery",
  "当前筛选范围内，从故障发现到恢复的平均耗时；缺少有效时间对时不参与计算": "In the current screening range, the average time taken from failure detection to recovery; absence of effective time to participate in calculations",
  "累计资损": "Cumulative loss",
  "直接损失 + 间接损失": "Direct loss + indirect loss",
  "延期 Todo": "Postponement Todo",
  "Todo 完成率": "Todo completion rate",
  "已完成 Todo ÷ Todo 总数 × 100%": "Completed Todo ÷ Todo Total x 100%",
  "COE Todo 状态概览": "COE Todo Status Overview",
  "Todo 总数": "Total Todo",
  "逾期未完成": "Overdue",
  "COE Todo 状态分布": "COE Todo Status Distribution",
  "完成率": "Completion rate",
  "负责人 COE Todo 状态分布": "COE Todo Status Distribution",
  "负责人逾期 COE Todo": "COE Todo",
  "COE 全局数据看板": "COE Global Data Viewer",
  "全部打开": "Open All",
  "部分看板数据加载失败，请点击刷新重试": "Partial panel data loaded failed. Click to refresh and retry",
  "加载 COE 评论失败": "Failed to load COE comment",
  "评论已删除": "Comments deleted",
  "删除 COE 评论失败": "Failed to delete COE comment",
  "保存 COE 评论失败": "Failed to save COE comment",
  "评论已更新": "Comments updated",
  "输入评论，使用 @ 提醒相关人员": "Enter comments, use @to alert the person concerned",
  "添加图片": "Add Picture",
  "Enter 发送，Shift + Enter 换行": "Enter Send, Shift + Enter",
  "修改评论，使用 @ 提醒相关人员": "Modify comments, use @to alert the person concerned",
  "回复当前讨论，使用 @ 提醒相关人员": "Reply to the current discussion, use @to alert the person concerned",
  "Enter 保存，Shift + Enter 换行": "Enter Save, Shift + Enter",
  "收起评论": "Gather comments",
  "展开评论": "Commence comments",
  "原文位置已变更，暂无法定位": "Original position changed, no location available",
  "编辑评论": "Edit Comments",
  "删除这条评论？": "Delete this comment?",
  "编辑回复": "Edit Response",
  "删除这条回复？": "Delete this reply?",
  "暂无评论": "No comment at present",
  "原文已修改，评论仅作备案，无法定位": "The original text has been modified, comments are only filed and cannot be located",
  "暂无原文已修改评论": "Comments modified without original text",
  "变更记录加载失败": "Failed to load change record",
  "重新加载": "Reload",
  "暂无变更记录": "No change in record",
  "图片": "Picture",
  "详情加载失败": "Loading details failed",
  "故障级别": "Fault Level",
  "持续时长": "Duration",
  "归属系统": "Attribution system",
  "1-故障基础信息": "1. Basic information on failure",
  "故障责任组长": "Head of the trouble management team.",
  "内外因素": "Internal and external factors",
  "归属部门": "Department",
  "复盘组织者": "Repeat Organizer",
  "复盘参与人": "Reassembly participants",
  "2-故障现象": "2-Mechanisms",
  "3-故障影响": "3. Impact of malfunctions",
  "关联系统影响": "Associated system impacts",
  "异常数据量": "Unusual Data Volume",
  "资损能否追回": "Recovery of damages",
  "客户投诉量": "Client complaints",
  "故障发现人": "Fault detected.",
  "影响时长": "Impact duration",
  "客诉渠道": "Access to justice",
  "故障上报人": "We're reporting a malfunction.",
  "用户/客户通知人": "User/client notifier",
  "4-故障处理时间线": "Timeline for trouble management",
  "操作人员：": "Operator:",
  "暂无处理时间线": "Timeline not processed",
  "5-5 Why 根因分析": "5-5 Why root cause analysis",
  "暂无该阶段分析": "This stage of analysis is not available",
  "问题": "Problem",
  "答案": "Answer",
  "6-综合根因总结": "6- Synthesis of the root causes",
  "暂无根因总结": "There is no cause to summarize",
  "根因类型": "Root Type",
  "7-改进措施": "7 - Improvement measures",
  "暂无该类改进措施": "No such improvements are available",
  "措施": "Measures",
  "关联5Why": "Link 5Wy",
  "8-Todo 列表": "8-Todo List",
  "暂无Todo": "There is no Todo.",
  "任务内容": "Task content",
  "故障现象": "Fault phenomena",
  "故障影响": "Impact of malfunctions",
  "处理时间线": "Process Timelines",
  "根因总结": "Genesis Summary",
  "请先填写发生时间和恢复时间": "Please fill in the time of occurrence and recovery.",
  "当前持续时长已是计算结果": "Current duration has been calculated",
  "覆盖持续时长？": "Cover duration?",
  "确认覆盖": "Confirm Overwrite",
  "请填写问题": "Please fill in the questions.",
  "请填写措施": "Please complete the measures.",
  "发现本机未同步的编辑内容": "Unsynced Edit content found",
  "恢复内容": "Restore Content",
  "放弃缓存": "Drop Cache",
  "最新内容尚未保存，且本机缓存失败，请先点击暂存后再关闭": "The latest content has not been saved and this machine cache failed. Click to save before closing",
  "内容已更新，请确认后重新保存": "Update, save after confirmation",
  "请先填写故障名称后再暂存": "Please fill out the name of the malfunction before saving.",
  "保存成功，但本机备份清理失败，已保留当前页面内容，请稍后重试": "Save successfully, but the backup failed, the current page is saved, please try again later",
  "动作": "Actions",
  "图片/附件": "Pictures/Annexes",
  "请填写根因总结": "Please fill out the root cause summary.",
  "如：5.1-Why1": "For example: 5.1-Why1",
  "搜索并选择需求（可多选）": "Search and select needs (multi-optional)",
  "暂无需求": "Not required",
  "请选择故障级别": "Please select the default level.",
  "请输入持续时长": "Please enter the duration",
  "恢复时间减去发生时间，不足 1 分钟向下取整；点击后回填到持续时长": "Recovery time minus occurrence time less than 1 minute to pick down; back to duration after clicking",
  "计算": "Calculate",
  "请选择归属系统": "Please select the attribution system.",
  "请选择内外因素": "Please select internal and external factors.",
  "外部原因无需选择归属部门": "External reasons do not have to choose to belong to the department.",
  "请选择归属部门（可多选）": "Please select the sector to which you belong (multiple options)",
  "搜索并选择迭代（可多选）": "Search and select an iterative (multi-optional)",
  "暂无迭代": "For now.",
  "请输入故障现象": "Please enter a malfunction",
  "请输入直接资损金额": "Please enter the amount of direct damages.",
  "请输入间接资损金额": "Please enter the amount of indirect damages.",
  "8-Todo列表": "List of 8-Todo",
  "编辑COE复盘记录": "Edit COE Duplicate Record",
  "新建COE复盘记录": "New COE Duplicate Record",
  "复盘目录": "Rewind Directory",
  "时间线": "Timeline",
  "根因": "Gene.",
  "COE复盘名称和链接已复制到剪贴板": "COE Duplicate name and link copied to clipboard",
  "刷新详情和评论": "Update details and comments",
  "Todo 状态更新失败": "Todo status update failed",
  "Todo 状态已更新": "Todo status updated",
  "Todo 至少需要保留一名执行人": "Todo needs at least one enforcer.",
  "Todo 更新失败": "Todo Update failed",
  "Todo 已更新": "Todo updated",
  "请选择执行人": "Select Executor",
  "搜索关联需求": "_Other Organiser",
  "延期提醒发送成功": "Postponed alarm sent successfully",
  "延期提醒发送失败": "Organisation",
  "COE编号、故障名称或任务内容": "COE number, malfunction name or mission content",
  "确认发送延期提醒？": "Confirming extension alarms?",
  "将向已延期且未完成 Todo 的执行人发送飞书汇总提醒。": "A flyer 's summary alarm will be sent to the extended and incomplete Todo 's implementer.",
  "延期提醒": "Organisation",
  "已复制COE编号": "Copyed COE number",
  "Todo列表": "Todo List",
  "请输入故障名称": "Please enter the name of the malfunction.",
  "5.1-5Why根因分析-1故障原因（为什么会发生）": "5.1-5 Whygen for analysis-1 (why)",
  "5.2-5Why根因分析-2故障感知（为什么没有及时发现）": "5.2-5 Whygen for analysis-2 failure perception (why was it not discovered in time)",
  "5.3-5Why根因分析-3故障止损（为什么没快速阻止损失扩大）": "5.3-5 Whygen stoppage due to breakdown 3 (why has the loss not been stopped quickly)",
  "5.4-5Why根因分析-4故障定位（为什么排查耗时长）": "5.4-5 Whygen for analysis-4 failure positioning (why time-consuming check-ups)",
  "技术架构根因": "Root causes of technology architecture",
  "研发质量根因": "Quality factors in R & D",
  "监控观测根因": "Monitor the root causes.",
  "应急处置根因": "Reasons for emergency disposal",
  "流程制度根因": "Causes of the process system",
  "7.1-改进措施-故障预防": "7.1 - Improvement measures - trouble prevention",
  "7.2-改进措施-故障感知": "7.2 - Improvement Measures - Fault Awareness",
  "7.3-改进措施-故障止损": "7.3 - Improvement measures - Loss and loss",
  "7.4-改进措施-故障定位": "7.4 - Improvement Measures - Fault Positioning",
  "告警类型": "Type of alarm",
  "值班人员": "Staff on duty",
  "告警详情": "Police details",
  "该群已被解散": "The group has been disbanded.",
  "进群成功": "Group success",
  "确认要解散该群吗？": "Are you sure you want to disband the group?",
  "解散后，该群将无法使用。": "Once disbanded, the group will not be usable.",
  "解散成功": "Dismissed.",
  "仅该群创建者可以解散": "Only the founders can be disbanded.",
  "解散": "Dismissed.",
  "今日告警记录": "Today's police report.",
  "系统崩溃": "System crash",
  "数据错误": "Data Error",
  "运营受阻": "The operation is blocked.",
  "确认覆盖内容": "Confirm Overwrite",
  "确认清空": "Confirm empty.",
  "拨打告警电话": "Call the alarm.",
  "告警记录": "Police records",
  "该业务领域今日没有值班人员": "There are no duty officers in this field today.",
  "一键告警": "One-inch alarm.",
  "新增自定义告警电话": "Add a custom alarm number",
  "（非必须，默认拨打值班人员电话）": "(Do not have to, default call on duty)",
  "将相关值班人员加入应急响应群。": "The relevant duty officers were added to the emergency response cluster.",
  "仅拉群": "Draw only",
  "拉群成功": "We've got it.",
  "拉群人数不足": "We don't have enough people.",
  "给相关值班人员以及自定义电话拨打告警电话。": "Call the alarm number for the person on duty and for the custom phone.",
  "仅拨打告警电话": "Just call the alarm.",
  "将相关值班人员加入应急响应群，并给相关值班人员以及自定义电话拨打告警电话。": "Relevant duty personnel are added to the emergency response response group and call the alarm number to the relevant duty officer and to the custom phone.",
  "拉群+拨打告警电话": "Pull + call the alarm.",
  "请输入有效的中国手机号码": "Please enter a valid Chinese phone number.",
  "请输入电话": "Please enter the phone.",
  "输入或选择电话号码": "Enter or select a telephone number",
  "添加电话": "Add Phone",
  "报警详情": "Call the police for details.",
  "选择模板可快速填充内容": "Select template to fill quickly",
  "选择模板": "Select Template",
  "专属号码模式：": "Organisation",
  "使用专属号码(0571-23677999)呼叫": "Call with an exclusive number (0571-23677999)",
  "公共模式：": "Public mode:",
  "使用系统分配的公共号码呼叫": "Call with the system assigned public number",
  "（推荐优先使用专属号码保证通话质量）": "(Recommends preferential use of exclusive numbers to ensure quality of calls)",
  "是否使用专属号码呼叫": "Whether to use an exclusive number to call",
  "请输入报警详情": "Please enter the alarm details.",
  "报警详情不能超过200个字": "You can't call the police more than 200 words.",
  "请输入或选择模板编辑...": "Please enter or select a template editor...",
  "呼叫成功": "Call Success",
  "_验收报告": "_Receipt and inspection reports",
  "开发人员": "Developer",
  "发送人员": "Sender",
  "需求匹配度": "requirement Matches",
  "功能完备性": "Functional adequacy",
  "功能流畅性": "Flowability of function",
  "设计满意度": "Design satisfaction",
  "总体意见": "General observations",
  "需求细项": "Requirements item",
  "验收人员": "Receiving and inspection staff",
  "验收结果": "Results of acceptances",
  "补充意见": "Additional comments",
  "备注不能为空": "Remarks cannot be empty",
  "备注成功": "Remarks Successful",
  "提交备注": "Submission of Remarks",
  "流转": "Flow",
  "发布列表": "Publish List",
  "仅被指派人可操作": "Only assignable",
  "实际任务不能超过120个小时": "Actual tasks cannot exceed 120 hours",
  "最多保留两位小数，总位数不超过四位": "Up to two decimal places with a total of no more than four digits",
  "单个任务不能超过3天，请拆解任务": "No more than three days for a single assignment. Please dismantle the task.",
  "文件或视频上传失败，请重试！": "File or video upload failed, please try again!",
  "上传文件不能超过500MB": "Upload file cannot exceed 500MB",
  "重现步骤(双击开始编辑)": "Recurrence step (double click to start editing)",
  "视频 & 附件": "Video & Attachment",
  "点击或者将\"视频\"拖动到区域上传": "Click or drag Video to the area for upload",
  "点击或者将\"文件\"拖动到区域上传": "Click or drag file into area upload",
  "名称和链接已剪贴板": "Name and Link Clipboard",
  "进群失败": "Group failure",
  "指派给产品经理": "To the product manager.",
  "已读取暂存需求": "Read suspense needs",
  "简要说明": "Brief description",
  "具体举例说明": "Specific examples",
  "系统、服务、重要组件、停止或者无法正常运行，严重影响或阻碍测试执行": "Systems, services, critical components, stoppage or inability to function, seriously affecting or obstructing test implementation",
  "1、系统崩渍或者挂起": "1. System collapse or hanging",
  "2、服务挂掉": "Service hangs up.",
  "3、中间件等重要组件无法正常使用": "Important components, such as intermediate, are not functional",
  "4、核心功能的严重错误": "4. Serious errors in core functions",
  "1、程序无法执行、应用模块无法启动或异常退出": "1. Programs cannot be executed, application modules cannot start or abnormal exit",
  "2、系统崩渍、死锁、内存泄露、导致严重问题或致命错误": "2. System crashes, dead locks, memory leaks, causing serious problems or fatal errors",
  "3、存在主流程核心功能的严重功能错误、逻辑错误、严重影响或阻碍测试执行": "3. There is a serious functional error, logical error, serious influence or impediment to test implementation of the core function of the main process",
  "4、 APP 闪退": "4. APP Back",
  "主流程严重的功能性缺陷,影响测试执行": "Serious functional deficiencies in the main process, impact test execution",
  "1、影响主流程的严重错误": "1. Serious errors affecting the main process",
  "2、主流程功能不符合要求或未完成": "2. Main process functionality not compliant or not completed",
  "1、存在影响结果和使用的主流程功能的重大功能错误、逻辑错误、影响测试执行": "1. Significant functional error, logical error, impact test execution where impact results and mainstream process functionality are used",
  "2、不符合或未完成的主流程器求和交互": "2. Non-compliant or incomplete mainstream process requests and interactions",
  "3、内存泄露": "3. Memory leakage",
  "4、严重的数值计算错误": "4. Serious numerical error",
  "主流程功能性缺陷,不影响测试执行": "Main process functional deficiencies, not affecting test execution",
  "1、影响主流程的错误": "1. Errors affecting the main process",
  "2、严重影响用户体验和使用的缺陷": "2. Disparities that seriously affect user experience and use",
  "1、存在影响结果和使用的主流程功能的较大功能错误、逻辑错误、不影响测试执行": "1. Larger functional errors, logical errors, not affecting the execution of tests, that affect the outcome and use of mainstream processes",
  "2、严重影响用户体验和使用的 UI 问题，如严重兼容性适配问题": "2. UI issues that seriously affect user experience and use, such as critical compatibility adaptation",
  "3、影咱系统性能的问题": "Three. It's a systemic problem.",
  "4、不符合大部分用户操作习惯": "4. Non-compliance with most user practices",
  "一般功能性缺陷，主流程功能无异常": "General functionality deficiencies, main process function not abnormal",
  "1、不影响主流程的错误": "Errors that do not affect the main process",
  "2、直接影响用户体验和使用的缺陷": "2. Deficiencies that directly affect user experience and use",
  "3、主流程功能不符合需求或未完成": "3. Main process functionality does not match needs or is not completed",
  "1、存在不影响结果和使用的非主流程小的功能错误，逻辑错误": "1. There is a small functional error that does not affect the outcome and use of a non-main process, a logical error",
  "2、不符合或未完成的非主流程需求和交互": "2. Non-compliant or incomplete non-main process needs and interactions",
  "3、直接影响用户体验和使用的 UI 问题，如兼容性适配问题，界面截断、折行、溢出等": "3. UI issues that directly affect user experience and use, such as compatibility adaptation, interface cut-off, break-ups, spills, etc.",
  "4、提示信息错误，有歧义，或者未给出提示信息而直接影响用户体验": "4. Indication of information error, ambiguity, or direct impact on user experience without giving indicative information",
  "5、操作界面不友好，不符合部分用户习惯": "5. The interface is not friendly and does not conform to some user habits",
  "保存中...": "Saving...",
  "已保存到云端": "Saved to Cloud",
  "重现步骤（粘贴链接后输入空格变为超链接）": "Recurring steps (to enter spaces into hyperlinks after pasting)",
  "上传视频": "Upload video",
  "视频文件不能超过50MB,仅支持.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm,.3gp,.mpeg,.asf格式": "Video files cannot exceed 50MB and only support.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm, 3gp,.mpeg,.asf",
  "附件不能超过10MB": "Attachments cannot exceed 10MB",
  "请选择严重程度": "Please choose the severity.",
  "研发": "R&D",
  "请输入指派给": "Please enter the assignment to",
  "Bug页面地址(一个地址一行)": "bug page address (one address line)",
  "不支持在ALL系统下拖动，请切换具体系统后操作！": "Drags under the ALL system are not supported, please switch to the specific system after operation!",
  "添加子模块": "Add submodule",
  "重命名": "Rename",
  "取消编辑": "Cancel Edit",
  "新建模块": "New Module",
  "不支持在ALL系统下创建模块，请切换具体系统后操作！": "The creation of modules under the All system is not supported, please switch to the specific system after operation!",
  "一次仅支持创建一个模块，请保存后在新建！": "Only support the creation of a module at a time, save and then create a new module!",
  "所有模块": "All Modules",
  "出现bug的页面": "Show bug page",
  "添加链接：": "_Other Organiser",
  "链接不能为空": "Link cannot be empty",
  "按创建时间最早": "By early creation",
  "按创建时间最晚": "_Other Organiser",
  "按更新时间最早": "As early as the update time",
  "按更新时间最晚": "Press update at the latest",
  "按截止时间最早": "As early as the deadline.",
  "按截止时间最晚": "At the latest.",
  "保存为默认排序": "Save as Default Sorting",
  "在\"只看我\"下，不能选择人物相关": "You can't choose a character under \"Look at me.\"",
  "请选择反馈人": "Please select a feedback person",
  "请选择责任人": "Please choose those responsible.",
  "请选择被指派人": "Please select the assigned person",
  "解决人": "Solve People",
  "已复制全页内容到剪贴板": "Copyed full page contents to clipboard",
  "全页复制": "Copy All Pages",
  "展示与自己相关的": "Show yourself",
  "缺陷确认时间": "Disorder recognition time",
  "缺陷解决时间": "Gap resolution time",
  "缺陷关闭时间": "Deficiencies close time",
  "记录不存在了": "Records don't exist.",
  "进行中": "Ongoing",
  "概览": "Overview",
  "在途需求": "Needs in transit",
  "在途异常需求": "Unusual needs in transit",
  "我提的业务需求": "My business needs.",
  "关联我的产品需求": "Linking my product needs",
  "在\"只看我\"下，不能选择产品对接人": "Under \"Look at me\" you can't choose a match.",
  "请选择产品对接人": "Please select the product match.",
  "请选择提出人": "Please select the proposer.",
  "在\"只看我\"下，不能选择创建人": "Under \"Look at me\" you can't choose the founder.",
  "我提出": "I propose.",
  "交接成功": "Handover successful.",
  "当前产品对接": "Current product docking",
  "交接产品": "Handover products",
  "请选择交接产品": "Please select the handover product.",
  "请先选择交接产品": "Please choose the delivery product.",
  "已批量填充空白交接产品": "Bulk filled blank hand-over products",
  "请先选择需要清空的业务需求": "Please select the business needs to be cleared.",
  "已清空所选业务需求的交接产品": "Handover products cleared of selected business requirements",
  "请先选择需要交接的业务需求": "Please select the business needs to be handed over.",
  "业务需求交接": "Operational requirements handover",
  "交接的业务需求（": "Handover of operational requirements",
  "，可操作": "actionable",
  "交接产品：": "Handover products:",
  "统一选择交接产品": "Harmonization of the selection of hand-over products",
  "批量填充空值": "Batch Fill Empty",
  "清空交接": "Clear the bridge.",
  "隐藏无法操作的需求": "Hide inoperable needs",
  "驳回时间": "Date rejected",
  "驳回人": "Overruled.",
  "交付时长分布": "Long distribution of deliveries",
  "4周内交付率：": "Delivery rate within 4 weeks:",
  "认领": "Recognition",
  "驳回": "Rejected.",
  "拒绝验收": "Deny acceptance",
  "是否删除需求": "Delete requirement",
  "确认要删除需求吗？": "Confirm to delete requirement?",
  "添加产品对接人": "Add product match",
  "驳回业务需求": "Dismissed business needs",
  "请输入任务名称": "_Other Organiser",
  "在“只看我”下，不能选择产品对接人": "Under \"Look at me alone,\" you can't choose a product match.",
  "期待开始": "Looking forward to starting.",
  "期待结束": "Looking forward to the end.",
  "在“只看我”下，不能选择创建人": "Under \"Look at me alone,\" you can't choose the creator.",
  "展示产品经理、业务方、创建人为自己的记录": "Show the product manager, the operator, the creator's record.",
  "产品需求名称": "Product requirement Name",
  "产品需求创建时间": "Product requirement creation time",
  "产品介入时间": "Product Intervention Time",
  "产品评审完成时间": "Completion of product review",
  "预计开发投入时间": "Estimated development input time",
  "预计开发完成时间": "Expected development completion time",
  "实际开发完成时间": "Actual development completion time",
  "预计测试投入时间": "Estimated time spent on testing",
  "预计测试完成时间": "Estimated test completion time",
  "实际测试完成时间": "Actual test completion time",
  "实际验收完成时间": "Actual acceptance completion time",
  "期望上线时间": "Looking forward to getting online.",
  "实际上线时间": "It's actually line time.",
  "请勾选要复制的需求": "Check the requirements for copying",
  "已复制需求内容到剪贴板": "Copyed requested contents to clipboard",
  "业务需求，记录的业务需求描述，产品经理可以认领**需求并创建产品需求进入研发任务。": "Business needs, documented business needs description, product managers can identify ** needs and create product needs for R & D.",
  "导出Excel": "Export Excel",
  "请先勾选需要交接的业务需求": "Please check the business needs to be handed over.",
  "业务交接": "Operational handover",
  "使用人": "User",
  "介入人": "Participants",
  "发布人": "Publisher",
  "需求描述(双击开始编辑)": "requirement description (two click to start editing)",
  "点击或者将文件拖动到区域上传": "Click or drag files into the area for upload",
  "变更需求描述模版": "Change requirement description template",
  "当前产品经理设置了专属需求模板，切换会覆盖现有内容(当前需求描述内容将被复制到剪贴板)。": "The current product manager has set up an exclusive requirement template, and the switch will cover the existing content (the current requirement description will be copied to the clipboard).",
  "确定要执行此操作吗？": "Are you sure you want to do this?",
  "原先需求描述内容已复制到剪贴板": "Original requirement description copied to clipboard",
  "该需求功能提出的具体人，或者具体使用用户": "Specific person proposed by the requirement function, or specific user",
  "系统使用人": "System User",
  "简单 - 小于5个工作日": "Simple - less than 5 working days",
  "中等 - 5~10个工作日": "Medium - 5-10 working days",
  "复杂 - 大于10个工作日": "Complex - greater than 10 working days",
  "业务方提出的需求功能或者目标为了服务该国家，不适用于全球通用业务场景": "The requirement function or objective proposed by the operator is to serve the country and does not apply to the global business landscape",
  "业务方提出的需求功能或者目标为了服务该垂直行业线，适用于全球通用业务场景": "The requirement function or objective proposed by the operator is to serve the vertical industry line and applies to the global business landscape",
  "需求描述": "Needs description",
  "编辑需求主要归属": "Primary attribution of editorial needs",
  "业务需求名称": "Business requirements name",
  "业务需求创建时间": "Business needs creation time",
  "业务需求期望上线时间": "Operational requirements expect to go online",
  "业务需求实际上线时间": "Operational requirements, actual line time",
  "请选择待关联需求": "Select the needs to be associated",
  "综合数据看板🔥": "Integrated Data Viewer",
  "预测数据看板🔥": "Projection data viewer",
  "我的数据看板📊": "I'm looking at the data.",
  "只能上传.xmind文件!": "Only upload. xmind files!",
  "上传测试用例": "Upload test examples",
  "参与总人数 * 工时（天）": "Total number of participants*",
  "成本预估=人/天*3000，可直观告知业务方预估花费成本，需对方考虑ROI是否合理。": "Cost estimate = person/day * 3000, with a visual message to the operator that the estimated cost is reasonable.",
  "以及后期如果成本过高，需要上升到不同维度进行决策。": "And if costs are too high, they need to rise to different dimensions for decision-making.",
  "任务参与相关人员": "Relevant mission participants",
  "展开更多录入项": "Expand More Entry",
  "该任务相关联的服务": "Services associated with the mandate",
  "服务相关联的分支": "Service-related branches",
  "已经是用例了": "That's the example.",
  "导入用例": "Import Examples",
  "模块": "Module",
  "请选择模块": "Select Module",
  "请切换到具体项目在创建": "Please switch to specific item creating",
  "暂时还不支持保存": "Save not supported for the moment",
  "脑图渲染慢，请耐心等待": "Please wait.",
  "暂无数据，请点击左侧模块": "Data not available, click the left module",
  "模块视图需要切换到具体项目下查看": "The module view needs to be switched to a specific item",
  "模块视图": "Module View",
  "提测记录": "Test records",
  "请输入规划名称": "Please enter a plan name",
  "绑定成功": "Tie successful",
  "业务需求名称已复制到剪贴板": "Business needs name copied to clipboard",
  "业务需求描述": "Description of business needs",
  "暂无关联业务需求": "Operational requirements not related",
  "暂无业务需求": "Operational requirements not available",
  "请填写所有验收人员": "Please fill in all receiving and inspection personnel.",
  "请填写所有验收结果": "Please complete all acceptances.",
  "提交过程中出错:": "Error during submission:",
  "人员信息": "Personnel information",
  "验收结论": "Conclusion of acceptance",
  "：通过": "_: adopted",
  "：不通过": ": Not adopted",
  "必填项：1-5分制，满分20分。原则上，总分12分以下不通过。": "To fill in a score of 1 to 5, with a full score of 20. In principle, the total score is less than 12 points.",
  "应用": "Apply",
  "操作类型": "Operation Type",
  "旧值": "Old value",
  "新值": "New value",
  "变更类型": "Change Type",
  "配置Key": "Configure Key",
  "变更Key": "Change Key",
  "无变更": "No change",
  "变更数量": "Number of changes",
  "发布备注": "Issue Remarks",
  "操作者": "Operator",
  "Apollo配置工单列表": "List of Apollo Lists",
  "确定（已选": "Yes (selected)",
  "项）": "item)",
  "选择环境": "Select Environment",
  "应用ID：": "Apply ID:",
  "选择应用ID": "Select Apply ID",
  "收起变更明细": "Close Change Details",
  "展开查看变更明细": "Expand View Changes",
  "工单状态": "Worksheet Status",
  "备份": "Backup",
  "组": "Group",
  "SQL工单列表": "List of SQL sheets",
  "隐藏": "Hide",
  "待办需求池": "To-do needs pool",
  "只有方案中需求才可以在发起业务评审！": "Only programme needs can initiate a business review!",
  "发起业务评审": "Launching of the business review",
  "请输入删除原因": "Please enter the reason for the deletion",
  "是否解绑Sprint": "Untie Sprint",
  "确认要解绑Sprint吗？": "Are you sure you want to untie Sprint?",
  "解绑Sprint": "UntieSprint",
  "绑定Sprint": "StapleSprint",
  "添加任务": "Add Task",
  "草稿不支持查看详情，请保存为正常需求后操作！": "The draft does not support looking for details, save for normal needs after operation!",
  "计划需求评审日期": "Date of plan needs review",
  "计划技术方案评审日期": "Date of review of planned technical programmes",
  "计划测试用例评审日期": "Date of evaluation of case for planned tests",
  "计划提测日期": "Planned date of survey",
  "计划业务验收日期": "Date of receipt and inspection of planned operations",
  "点击查看后端任务详情": "Click to see backend details",
  "点击查看前端任务详情": "Click to see frontend job details",
  "点击查看测试任务详情": "Click to see test job details",
  "点击查看UI任务详情": "Click to see UI job details",
  "产品阶段截止时间": "Product phase deadline",
  "研发阶段截止时间": "Deadline for R & D",
  "测试阶段截止时间": "Deadline for testing phase",
  "阶段耗时明细": "Phase time-consuming and detailed",
  "确定取消暂停吗？": "Are you sure about the pause?",
  "取消暂停后状态将会恢复到": "After the pause is lifted, the state will be restored.",
  "最后一次": "Last time.",
  "操作状态": "Operation Status",
  "取消暂停成功": "Cancel pause successful",
  "取消暂停": "Cancel Pause",
  "克隆成功": "Cloning succeeded.",
  "复制名称和链接": "Copy name and link",
  "仅复制链接": "Only copy links",
  "请先勾选需要复制的行": "Please check the lines that need to be copied.",
  "已复制选中行的内容到剪贴板": "Copyed selected line contents to clipboard",
  "创建Sprint": "Create Sprint",
  "所勾选需求中存在不可验收需求": "Unreceivable requirement in the selected requirement",
  "批量验收": "Batch acceptance",
  "所选需求必须都有发布权限且属于同一业务领域": "The selected needs must be subject to the same terms of reference and the same area of business",
  "批量发布": "Batch Release",
  "产品交接": "Product handover",
  "查看需求阶段耗时": "Time-consuming to view requirement phase",
  "查看需求状态数量统计": "View number of needs",
  "在研发过程中，增量代码缺陷率的高低直接影响软件质量和团队效率。这个数值越高，说明研发质量越低。": "In the development process, the high and low rate of incremental code defects directly affects software quality and team efficiency. The higher the value, the lower the quality of R&D.",
  "增量代码缺陷率:": "Incremental code deficiency rate:",
  "通常指在特定代码变更中发现的缺陷数量与该变更所涉及的代码行数的比率。较低的缺陷率通常意味着代码质量较高，反之则可能表明存在较多问题。": "Usually refers to the ratio of the number of defects identified in a particular code change to the number of code lines involved in the change. Lower deficiency rates usually mean higher code quality, and vice versa may indicate more problems.",
  "高质量代码:": "High-quality code:",
  "低的增量代码缺陷率通常表明代码质量较高，开发团队在编码时遵循了良好的实践和标准。": "Low incremental code deficiency rates usually indicate higher code quality, and the development team followed good practices and standards in coding.",
  "高缺陷率的潜在问题:": "Potential problem with high deficiency rate:",
  "质量控制不足: 高的增量代码缺陷率可能表明在开发过程中存在质量控制不足的问题，可能是测试覆盖率不够或开发人员对需求理解不清。": "Inadequate quality control: A high rate of incremental code defects may indicate a lack of quality control in the development process, possibly due to insufficient test coverage or lack of understanding of needs by developers.",
  "千行代码缺陷率（Bug Rate）": "1,000 Line Code Impairment Rate (bug Late)",
  "是软件开发中常用的质量指标，用于衡量每千行代码中存在的缺陷数量。这个指标在评估软件质量和开发团队绩效时具有重要意义。以下是关于千行代码缺陷率考核指标的详细说明：": "It is a quality indicator commonly used in software development to measure the number of deficiencies per 1,000 lines of code. This indicator is important in assessing software quality and development team performance. The following is a detailed description of indicators for the assessment of the 1,000-line code deficiency rate:",
  "千行代码bug率=bug数/ (代码行数/1000)": "1,000-line code bug rate = bug number/ (code line number/1000)",
  "例如，如果一个项目有 2000 行代码，发现了 4 个缺陷，则千行代码缺陷率为： 千行代码bug率=4/（2000/1000）=2‰": "For example, if a project with a 2000 line code found four deficiencies, the 1,000 line code deficiency rate was: 1,000-line code bug rate = 4/(2000/1000) = 2 per 1,000",
  "CMMI 级别与千行代码缺陷率": "CMMI Level & 1000 Line Code Impairment Rate",
  "CMMI（能力成熟度模型集成）为不同成熟度级别的组织设定了千行代码缺陷率的标准：": "CMMI (Capacity maturity model integration) sets standards for thousands of line code defects for organizations at different levels of maturity:",
  "CMMI 1 级:": "CMMI Level 1:",
  "CMMI 2 级:": "CMMI Level 2:",
  "CMMI 3 级:": "CMMI Level 3:",
  "CMMI 4 级:": "CCMI level 4:",
  "CMMI 5 级:": "CCMI level 5:",
  "缺少需求名称！": "We don't need a name!",
  "确认提交": "Confirmed",
  "已存在相同类型和名称的任务，如下：": "Tasks of the same type and name already exist, as follows:",
  "请选择操作：": "Please select operation:",
  "仍要全部创建": "Create All Still",
  "仅创建不存在的": "Only create non-existent",
  "（注：任务时间不能超过需求起始至交付时间段）": "(Note: Task time cannot exceed the period between start of requirement and delivery)",
  "时间跨度不能超过3天，请拆解": "It can't be more than three days. Please dismantle it.",
  "单个任务不能超过3天，请拆解": "You can't have more than three days on a single mission. Please dismantle it.",
  "请填入必填字段后在创建": "Please fill in the required fields and create them",
  "提测检查不通过，请确认itp平台用例冒烟是否通过~": "Check if you can't pass the check, please confirm if you can use smoke on the platform ~",
  "提测检查通过，可以申请提测": "Checking passes, so you can apply.",
  "填写提测申请": "Fill in the test request",
  "提测检查": "Testing",
  "CR报告：": "CR Report:",
  "服务名：": "Service name:",
  "分支名：": "Branch name:",
  "点击复制CommitId": "Click to CopyId",
  "CommitId已复制至剪贴板": "CommitId copied to clipboard",
  "必填项 (": "Required()",
  "此项为必填项": "This entry is required",
  "确定清空该选项及内容吗？": "Are you sure you want to empty this option and content?",
  "选择/重新选择配置": "Select/reselect Configuration",
  "请输入数据库相关内容": "Please enter the database contents",
  "请输入配置相关内容": "Please enter a profile",
  "请输入相关内容": "Please enter the contents.",
  "重新选择配置": "Reselect Configuration",
  "最近由": "Recent by",
  "于": "on",
  "非必填项 (": "Unnecessary entry()",
  "需求上线检查项": "Request for an online check item",
  "若检查项已被确认，请再次认真核对！": "If the inspection is confirmed, please check again!",
  "4周内达成率": "Rate of achievement within 4 weeks",
  "需求评审": "Needs assessment",
  "技术评审": "Technical review",
  "用例评审": "Case evaluation",
  "联调": "Convergence",
  "提测": "Test",
  "计划上线": "Plan to go online.",
  "产品截止": "Product cut-off",
  "研发截止": "R&D deadline",
  "测试截止": "Test deadline",
  "技术方案": "Technical programme",
  "注意：研发排队后不支持更改需求类型": "Note: R & D queues do not support changing requirement type",
  "迭代周期": "Period",
  "查看业务需求描述": "View Business Needs Description",
  "只读权限！": "Read-only!",
  "计划时间": "Planned time",
  "交付物": "Delivery",
  "提测详情": "Details of the survey",
  "是否创建任务(后端、前端、测试、UI)": "Whether to create a task (backend, frontend, test, UI)",
  "不创建": "Do Not Create",
  "点击创建将会给后端、前端、测试、UI创建对应的测试任务，如果已存在任务则不创建！": "Click to create a test job that will be created for backend, frontend, test, UI, or not if a job already exists!",
  "提测申请正在提交中，稍后会自动退出~": "The test application is in the process of being submitted and will be withdrawn automatically later?",
  "提测申请提交成功，已通知相关人员": "Successful submission of the test application and persons notified",
  "请输入需求名称": "Please enter the required name",
  "存为草稿": "Can not open message",
  "请输入需求描述": "Please enter a request description",
  "粘贴链接后输入空格变为超链接": "Enter spaces into hyperlinks after pasting links",
  "业务需求接口人": "Business needs interface",
  "如果经由技术支持或产品中转的需求，务必填写正确的需求提出人。": "In the case of a need for technical support or the transit of products, it is important that the correct person of requirement is completed.",
  "需求状态变更时会自动通知到关注人。以便关注人知晓此需求进展情况": "The person concerned is automatically notified of the change in requirement status. To inform people of the progress of this need",
  "如果业务有明确期望上线日期，则填写此数据即可。": "If the business has a clear expectation of going online, then it is sufficient to fill this in.",
  "期待时间": "Looking forward to time.",
  "需求状态变更时会自动通知到对应国家的技术支持。以便技术支持知晓此需求进展情况。": "Technical support is automatically communicated to the counterpart country when the requirement status changes. To inform technical support of progress in this need.",
  "产品需求可以归属于国家线或行业线，或同时具备两者的特性，但必须以其中一方为主。具体定义如下：": "Product requirement can be attributed to national or industrial lines, or both, but must be dominated by one of them. Specific definitions are as follows:",
  "国家线：业务方提出的需求功能或目标主要服务于特定国家的业务场景，不适用于全球通用业务场景。": "Country lines: The requirement functions or objectives identified by the business community primarily serve the country-specific business landscape and do not apply to the global business landscape.",
  "行业线：业务方提出的需求功能或目标主要服务于特定垂直行业的业务场景，适用于全球通用业务场景。": "Industry Lines: The requirement functions or objectives proposed by the business community primarily serve the business landscape of a particular vertical industry and are applicable to the global business landscape.",
  "默认选择当前需求影响国家下的技术支持。": "The default selection of current needs affects technical support in countries.",
  "是否给前端、后端、测试、UI创建对应的任务，一端已存在任务的负责人将不在创建": "Whether to create a corresponding task for front, back, test, UI, the person responsible for the existing task at one end will not create",
  "自动创建任务": "_Other Organiser",
  "不创建任务": "Do not create a task",
  "请选择是否自动创建任务": "Select whether to create a task automatically",
  "如果已明确后端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "If a back-end developer is identified, the counterpart may be pre-selected. The corresponding personnel will receive a preview of their needs in advance.",
  "如果已明确前端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "If a front-end developer is identified, the counterpart may be pre-selected. The corresponding personnel will receive a preview of their needs in advance.",
  "如果已明确测试人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "If a tester has been identified, the counterpart may be pre-selected. The corresponding personnel will receive a preview of their needs in advance.",
  "如果已明确UI设计人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "If the UI designer is identified, the counterpart may be pre-selected. The corresponding personnel will receive a preview of their needs in advance.",
  "该下拉列表展示的是研发效能内部标签。": "The bottom-down list shows internal labels of R & D performance.",
  "添加标��": "Add Mark",
  "UI设计交付物": "UI design delivery",
  "技术方案交付物": "Technical programme deliverables",
  "技术需求": "Technology needs",
  "如果需要使用系统培训，将会给系统培训师发消息": "If a system training is required, a message will be sent to the system trainers",
  "未保存的更改": "Unsaved Changes",
  "离开": "Leave",
  "请选择要编辑的需求": "Please select the requirements to edit",
  "编辑现有需求": "Edit Current Requirements",
  "是否是技术需求": "Technology needs",
  "需求描述（粘贴链接后输入空格变为超链接）": "Needs description (to enter spaces into hyperlinks after pasting)",
  "按期待完成时间最早": "The earliest possible completion time.",
  "按期待完成时间最晚": "The deadline for completion is as late as expected.",
  "按实际完成时间最早": "By the earliest actual completion time",
  "按实际完成时间最晚": "By actual time of completion",
  "按优先级最高": "Highest by Priority",
  "按优先级最低": "Minimum by Priority",
  "在“只看我”下，不能选择需求执行人": "Under \"Look at me\", you can't choose an executioner.",
  "请选择需求执行人类型": "Please select the type of person you want to execute",
  "请选择需求执行人": "Please select a requirement assignee",
  "请选择Sprint": "SelectSprint",
  "业务满意度": "Operational satisfaction",
  "0~1 代表 大于等于0 ，小于1": "0~1 is greater than 0 and less than 1",
  "1~2 代表 大于等于1 ，小于2": "1~2 is greater than 1 or less than 2",
  "2~3 代表 大于等于2 ，小于3": "2~3 is greater than 2 and less than 3",
  "3~4 代表 大于等于3 ，小于4": "3~4 is greater than 3 and less than 4",
  "4 代表 等于4": "4 Representative equals 4",
  "请选择业务满意度": "Please select business satisfaction.",
  "创建开始结束": "End of creation",
  "默认展示所有开发角色为自己的需求，并可与其他筛选条件“与”查询": "Default display of all development characters for their own needs and query with other filter conditions",
  "合并请求": "Consolidation request",
  "开发分支：": "Development branch:",
  "目标分支：": "Target branch:",
  "失败原因：": "Reason for failure:",
  "请输入删除原因：": "Please enter the reason for the deletion:",
  "请先选择需要清空的需求": "Please select what needs to be cleared.",
  "已清空所选需求的交接产品": "The selected transient product has been cleared",
  "请先选择需要交接的需求": "Please select the need for a handover.",
  "要交接的需求（": "requirement to be handed over",
  "关联Bug数": "Associated bug Number",
  "关联需求详情列表": "List of Association Needs Details",
  "创建人名称": "Creator Name",
  "关联测试用例（冒烟通过率：": "Examples of association tests (smoking pass rate:",
  "智能会议纪要数量": "Number of smart minutes",
  "需求关联评审": "Needs-related assessment",
  "会议时间": "Meeting time",
  "30分钟": "Thirty minutes.",
  "1小时": "1 hour",
  "1.5小时": "1.5 hours",
  "2小时": "Two hours.",
  "会议开始时提醒": "Reminders at the beginning of the meeting",
  "5分钟前提醒": "Five minutes ago.",
  "15分钟前提醒": "15 minutes ago.",
  "一小时前提醒": "An hour ago.",
  "一天前提醒": "A day ago.",
  "会议室": "Room",
  "请先选择会议时间！": "Please choose the meeting time first!",
  "请选择发布环境": "Please select the posting environment",
  "请输入预计发布时间": "Please enter the expected release time",
  "和这次发布相关的人": "The people involved in this release.",
  "请输入协同人": "Please enter a collaborator",
  "紧急发布原因": "Reason for emergency release",
  "请输入紧急发布原因": "Please enter the reason for the emergency release.",
  "请详细说明紧急发布的原因...": "Please specify the reasons for the emergency release...",
  "请输入发布描述信息...": "Please enter a description for release...",
  "是否拉取": "Whether to pull",
  "人员列表": "List of persons",
  "拉群人员列表": "List of persons",
  "取消全选": "Unselect All",
  "💡 勾选的人员将在创建发布单时自动加入发布群": "The selected person will automatically join the release group when creating the release form",
  "发布检查项": "Release Checkpoint",
  "已显示所有关联服务（包括同仓库服务）": "All associated services shown (including with warehouse services)",
  "已隐藏同仓库的服务": "Hidden with warehouse services",
  "选择分支": "Select Branch",
  "最新 Merged By": "The latest, Merged By",
  "请先选择服务": "Please choose the service first.",
  "加载全部分支失败": "Failed to load all branches",
  "选": "Select",
  "非常重要！": "Very important!",
  "服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "The service will be published in the current table order, the default order will be the back-end base, back-end core, back-end other, front-end foundation, front-end core, front-end other, and you can drag to change the release order.",
  "请按commit规范提交代码，规范为\"[需求或线上问题的序列号]你的提交描述\"，我们会直接从commit提交记录中拉取当前需求、迭代、回归缺陷、线上问题的服务分支。": "Please submit the code as the \"sequence number of the [requirement or production issue] your submission\" code. We will remove the current service branch of the file from the file file.",
  "默认不带出同仓库的服务分支，如果需要带出，请点击“显示所有关联服务”": "Default does not leave the service branch with the warehouse, click Show All Associated Services if necessary",
  "点击隐藏同仓库的服务": "Click to hide services from the warehouse",
  "点击显示所有关联服务": "Click to show all associated services",
  "（服务：": "(services:",
  "请选择一个分支": "Please select a branch",
  "从全部分支中选择": "Select From All Branches",
  "发布项名称": "Organisation",
  "关联发布单数量": "Number of associated release orders",
  "是否能创建发布单": "Can you create a release?",
  "发布项明细": "Release Item Details",
  "请至少添加一个服务分支": "Please add at least one service branch",
  "请完善所有服务分支的服务名称和分支信息": "Please improve service name and branch information for all service branches",
  "确认提交?": "Confirmed?",
  "限制：": "Limits:",
  "个/工作项": "Individual/Work Item",
  "⚠️ 已达创建上限": "⚠️ has reached the creation limit",
  "需要先预约发布才能创建发布单，": "This post is part of our special coverage Global Voices 2011.",
  "去预约": "Make an appointment.",
  "平均耗时(天)": "Average time (days)",
  "需求状态": "Request Status",
  "产品阶段耗时(天)": "Product stage time (days)",
  "大于3天显示红色，小于等于3天显示绿色": "Red for more than 3 days and green for less than 3 days",
  "研发阶段耗时(天)": "R & D phase time (days)",
  "测试阶段耗时(天)": "Test phase time (days)",
  "验收阶段耗时(天)": "Time-consuming acceptance phase (days)",
  "总耗时(天)": "Total time (days)",
  "小于等于15天显示绿色，15-30天显示橙色，大于30天显示红色": "Less than 15 days green, 15-30 days orange, more than 30 days red",
  "产品等待阶段开始": "Product waiting phase begins",
  "产品等待阶段结束": "End of product waiting period",
  "产品方案阶段开始": "Beginning of product programme phase",
  "产品方案阶段结束": "End of product programme phase",
  "产品评审阶段开始": "Beginning of product evaluation phase",
  "产品评审阶段结束": "End of product evaluation phase",
  "需求阶段耗时": "requirement phase time-consuming",
  "基础模式": "Base Mode",
  "详细模式": "Detailed Mode",
  "数据加载中...": "Loading data...",
  "正在加载更多数据 (": "Loading more data (%1)",
  "请填写检查项，红色为必填项": "Please fill in the check box. Red is mandatory.",
  "当前需求类型为【": "Current requirement type is [%]",
  "当前状态流转之后就无法更改需求类型了，请确认是否继续？如果不确定，请与需求相关人员确认后再做决定！": "The type of requirement cannot be changed after the current state flow, please confirm whether it continues? If not, please confirm before making a decision!",
  "提测申请正在暂存中！": "The test application is in the interim!",
  "提测申请已暂存！": "The test application is pending!",
  "不是": "Nope.",
  "提测主题": "The subject of the survey",
  "请输入提测主题": "Please enter the survey theme",
  "研发人员": "R&D staff",
  "请选择研发人员": "Please select a researcher.",
  "请选择测试人员": "Please select a tester.",
  "提测环境": "Survey environment",
  "请选择提测环境": "Select the environment.",
  "预计上线日期": "Estimated date on line",
  "本地测试结果": "Local Test Results",
  "请选择本地测试结果": "Please select local test results",
  "是否有P0测试用例": "Examples of P0 tests available",
  "请选择是否有测试用例": "Choose if there are test examples.",
  "是否新增模块": "Whether to add a new module",
  "请选择是否新增模块": "Select whether to add a new module",
  "没有P0测试用例的原因": "Reason for not having a P0 test example",
  "请填写没有测试用例的原因": "Please fill out the reasons why there are no test examples.",
  "新增模块说明": "Add module description",
  "请填写新增模块说明": "Please complete the description of the new module.",
  "提测内容": "Test",
  "重点测试点": "Focus Test Point",
  "联调结果": "Joint Results",
  "检查项加载中...": "Checking entry loading...",
  "检查项信息": "Check Item Information",
  "全部选择\"是\"": "All \"yes.\"",
  "全部选择\"否\"": "Select No for All",
  "一键选择": "One-click selection",
  "请选择是否": "Please choose whether or not",
  "确定要清空该选项及内容吗？": "Are you sure you want to clear this option and its content?",
  "请输入分支名称": "Please enter the branch name",
  "分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "Branch names can only include numbers, letters, decimal points, short lines and underlined and slash separator",
  "创建分支失败:": "Creating branch failed:",
  "创建分支": "Create Branch",
  "服务名称：": "Name of service:",
  "分支名称：": "Name of branch:",
  "* 分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "* Branch names can only include numbers, letters, decimal points, short lines and underlined and slash separator",
  "加载分支列表失败": "Failed to load branch list",
  "加载分支列表失败:": "Failed to load branch list:",
  "请选择开发分支！": "Please select the development branch!",
  "代码合并成功": "Code merge successfully",
  "代码合并失败": "Code merge failed",
  "合并分支": "Merge branch",
  "请选择开发分支": "Select Development Branch",
  "选择要合并到提测分支的开发分支": "Select the development branch to merge into the tabulation branch",
  "由": "By",
  "提测分支（目标分支）": "Detection branch (target branch)",
  "开发分支将合并到此分支": "The development branch will be merged into this branch",
  "请先选择服务名称！": "Please choose the name of the service first!",
  "请先创建提测分支！": "Please create a branch of the survey first!",
  "分支创建成功": "Branch created successfully",
  "提测分支": "Survey branch",
  "请&nbsp;": "Please & nbsp;",
  "&nbsp;或&nbsp;": "&nbsp; or &nbsp;",
  "建": "Construction",
  "&nbsp;一个提测分支": "&nbsp; a survey branch",
  "删除行": "Delete Row",
  "删": "Delete",
  "是否被驳回": "Is it rejected?",
  "获取数据失败": "Failed to get data",
  "需求任务甘特图": "_Other Organiser",
  "任务状况：": "Status of the mandate:",
  "逾期": "Overdue",
  "未逾期": "Not overdue",
  "需求未设置任务或未设置任务时间": "_Other Organiser",
  "人员昵称": "Personnel nickname",
  "人员岗位": "Personnel positions",
  "负责人名称": "Name of person in charge",
  "负责人岗位": "Position of Director",
  "需求状态数量统计": "Number of needs statistics",
  "按系统分组": "Group by System",
  "按人员分组": "By personnel",
  "需求状态数量明细": "Number of requirements",
  "需求自定义阶段数量明细": "Detailed number of requirements for self-defined phases",
  "确认要删除任务吗？": "Confirm to delete the task?",
  "甘特图": "Gantt.",
  "开始人": "Starters",
  "结束人": "End",
  "需求角色阶段耗时明细": "requirement role phase timed and detailed",
  "0.0天": "0.0 days",
  "方案阶段": "Programme phase",
  "评审阶段": "Review phase",
  "研发等待": "R & D Waiting",
  "提测等待": "Test waiting.",
  "验收等待": "Receiving and Inspection Waiting",
  "暂无信息": "Can not open message",
  "测试用例缺失的原因：": "Reason for missing test examples:",
  "新增模块说明：": "Add module description:",
  "提测内容：": "Test:",
  "影响范围：": "Scope of impact:",
  "重点测试点：": "Focus testing points:",
  "联调结果：": "Coordinated results:",
  "环境配置：": "Environmental configuration:",
  "相关Sql：": "Related Sql:",
  "其他信息：": "Other information:",
  "数据看板🔥": "Data Viewer",
  "是否删除规划": "Delete Planning",
  "确认要删除该规划吗？": "Are you sure you want to delete the plan?",
  "删除成功！": "Delete successful!",
  "请选择视图": "Select View",
  "状态看板": "Status Watch",
  "规划看板": "Planboard",
  "新建规划": "New Planning",
  "正在创建中，请勿重复提交": "Creating, do not duplicate",
  "会议开始时间必须在当前时间之后": "The meeting must start after the current time",
  "正在创建中，请稍等": "Creating",
  "创建成功！": "Created successful!",
  "会议周期": "Conference cycle",
  "不重复": "Do Not Repeat",
  "每天重复": "Repeat every day",
  "每个工作日重复": "Repeated every working day",
  "每周重复": "Repeated weekly",
  "每月重复": "Monthly repeat",
  "请选择周期": "Select the cycle",
  "会议创建人将自动成为参与人，无需额外选择": "The founder of the Conference will automatically become a participant without any additional choice",
  "请选择会议参与人": "Please select a conference participant.",
  "请输入内容": "Please enter content",
  "当前会议时间段空闲的会议室列表": "List of vacant meeting rooms at current meeting time",
  "添加参与人": "Add participant",
  "克隆评审（会议）": "Cloning Review (meeting)",
  "该会议相关信息已复制到剪贴板": "Conference information copied to clipboard",
  "新建评审（会议）": "New Review (meetings)",
  "展示创建人为自己的记录": "Show the creator's record.",
  "评审": "Evaluation",
  "的会议吗？": "A meeting?",
  "克隆评审会议": "Cloning Review Conference",
  "创建评审会议": "Create Review Session",
  "编辑评审会议": "Editorial review session",
  "评审需求只能未关闭的需求": "Evaluation needs can only be kept open",
  "评审Sprint只能是进行中的Sprint": "Reviewing Sprint can only be an ongoing Sprint",
  "评审测试用例只能是未完成评审的用例": "Examples of evaluation tests may only be those where evaluation has not been completed",
  "评审（会议）周期": "Review (meeting) cycle",
  "评审（会议）创建人将自动成为参与人，无需额外选择": "Review (meeting) founders will automatically become participants without additional choice",
  "请选择评审（会议）参与人": "Selection of review participants",
  "如果选择预约，在提交表单时会直接预约一个会议": "If you choose an appointment, you make a direct appointment to a meeting when submitting a form.",
  "当前评审时间段空闲的会议室列表": "List of vacant meeting rooms for the current review period",
  "评审确认情况": "Evaluation confirmations",
  "AI智能会议纪要": "AI Smart Meeting Summary",
  "按章节": "By Chapter",
  "按主题": "By Theme",
  "按发言人": "By Spokesperson",
  "请选择当前评审时间段空闲的会议室": "Please select the vacant room for the current review period",
  "空闲": "Free",
  "最多只能选6个会议室": "A maximum of six conference rooms can be selected",
  "评审时间": "Time of review",
  "您不是会议参与人，没有权限查看该智能会议纪要": "You are not a conference participant. You have no access to the smart minutes.",
  "会议纪要(双击填写)": "Summary of meetings (two-click to fill in)",
  "双击填写": "Double click to fill",
  "会议纪要附件": "Annex to the summary of meetings",
  "会议录制文件标题": "Conference recorded document title",
  "开始录制时间": "Start recording time",
  "结束录制时间": "End recording time",
  "参会人": "Participants",
  "查看AI智能会议纪要": "View AI smart meeting minutes",
  "评审关联会议详情": "Review details of associated meetings",
  "会议室（时间不得超过14天）": "Conference room (not to exceed 14 days)",
  "周期性会议不支持选择会议室": "Periodic meetings do not support room selection",
  "请先选择时间！": "Please choose the time!",
  "请先选择评审时间！": "Please choose the time for the evaluation!",
  "评审关联详情": "Details of the evaluation link",
  "会议纪要": "Summary of meetings",
  "规划添加需求（默认展示自己创建的需求）": "Plan additional needs (default display of self-created needs)",
  "正在导出，请稍后...": "Exporting, please later...",
  "下载图片": "Download Pictures",
  "下载": "Download",
  "链接已失效": "Link corrupted",
  "需求详情列表": "_Other Organiser",
  "任务负责人": "Mandate-holders",
  "只允许任务负责人删除": "Mandate-holders are allowed to delete only",
  "迭代开始后移入": "Organisation",
  "迭代开始后移出": "Organisation",
  "个工作项尚未完成，请处理后再完成迭代": "The work item has not yet been completed. Please process it before it is done.",
  "确认起始时间完成迭代": "Confirm start time to finish the iterative",
  "确认起始时间": "Confirm start time",
  "把它们移除本迭代，移至未规划": "Remove them from their original and move them to unplanned",
  "把它们移至其他迭代": "Move them to another iterative",
  "度量指标": "Measurement indicators",
  "标准值": "Standard value",
  "千行代码缺陷率": "1,000-line code deficiency rate",
  "（缺陷总数/代码行数）* 1000": "(total number of defects/code lines)* 1000",
  "移动端：&lt;": "Move end: &lt;",
  "前端：&lt;": "Frontend: &lt;",
  "后端：&lt;": "Backend: &lt;",
  "查看任务详情": "View Task Details",
  "查看缺陷详情": "View defects for details",
  "计划暂停至日期": "Planned suspension to date",
  "更换Sprint": "Replace Sprint",
  "取消批量": "Cancel Batch",
  "批量选择": "Batch Selection",
  "数据明细": "Data Details",
  "迭代已完成归档，如需查看请切换到「已归档」下查看": "Organisation",
  "编辑迭代": "Edit Organisation",
  "解锁": "Unlock",
  "是否删除迭代吗": "Do you want to delete it?",
  "确认要删除迭代吗？": "Confirm to delete it?",
  "删除迭代": "Delete italic",
  "树形": "Tree",
  "阶段看板": "Stage Board",
  "缺陷列表": "List of defects",
  "产品经理：": "Product Manager:",
  "后端开发：": "Backend development:",
  "前端开发：": "Frontend development:",
  "测试开发：": "Test development:",
  "UI设计：": "UI Design:",
  "技术支持：": "Technical support:",
  "业务对接：": "Operational interface:",
  "关注人：": "Attention:",
  "相关人：": "Relevant person:",
  "功能使用：": "Function Usage:",
  "Sprint迭代": "Sprint",
  "未规划工作项（产品需求）": "Unplanned work items (product requirement)",
  "工作项": "Task",
  "迭代名称和链接已复制到剪贴板": "The iterative name and link were copied to the clipboard",
  "提醒成功": "Reminder sent successfully",
  "催开始": "Let's get started.",
  "催结束": "Let's get this over with.",
  "规划迭代": "Planning iterative",
  "开始迭代": "Start an iterative",
  "完成迭代": "Completed iterations",
  "发布迭代": "Organisation",
  "创建人：": "_Other Organiser",
  "迭代周期：": "Period:",
  "迭代进度：": "Organisation",
  "目标进度：": "Target progress:",
  "开始迭代：": "_Other Organiser",
  "完成迭代：": "_Other Organiser",
  "后端研发：": "Backend development:",
  "前端研发：": "Front-end development:",
  "当前状态：": "Current status:",
  "迭代目标：": "The iterative target:",
  "未规划项（拖动需要展开Sprint）": "Unplanned items (sprint to drag)",
  "锁定已锁定，不能规划迭代，请联系负责人解锁后再操作": "Lock is locked, it cannot be planned. Please contact the person responsible to unlock before operating.",
  "确认后，当前状态将被标记为该需求的迭代目标，操作完成！": "Upon confirmation, the current state will be marked as the iterative target for the requirement, and the operation is complete!",
  "迭代目标状态：": "Organisation",
  "暂无迭代目标": "There are no overlapping targets.",
  "迭代尚未开始": "It's not started yet.",
  "返回旧版": "Return old version",
  "新建Sprint": "NewSprint",
  "交接迭代": "Intersection",
  "当前没有可交接的迭代": "There are no overlaps at this time.",
  "人天": "Man",
  "迭代工时概览": "Overview of working hours",
  "（1人天 = 8小时）": "(1 person-days = 8 hours)",
  "开始": "Start",
  "请到Sprint（新版）右上角完成迭代": "Please go to the top right corner of the Spring.",
  "工作项变更": "Work Item Change",
  "工作项概览": "Overview of work",
  "查看任务列表": "_Other Organiser",
  "添加需求任务": "_Other Organiser",
  "目标(双击开始编辑)": "Target (two click to start editing)",
  "Sprint名称和链接已剪贴板": "Sprint name and link to clipboard",
  "请先选择交接负责人": "Please choose who's in charge.",
  "已批量填充空白交接负责人": "Batch filled blank handover owner",
  "请先勾选需要清空的迭代": "Please check out those words that need to be cleared.",
  "已清空选中迭代的交接负责人": "Cleared Handover Manager for Selected Terminator",
  "请先选择需要交接的迭代": "Please select the overlap that needs to be crossed.",
  "请选择交接负责人": "Please select the person in charge.",
  "迭代目标": "Inverted target",
  "时间周期": "Period",
  "当前负责人": "Current Responsible",
  "交接负责人": "Hand over to the chief.",
  "迭代交接": "Intersection",
  "要交接的迭代（": "_Other Organiser",
  "交接负责人：": "Handover person:",
  "统一选择交接负责人": "Unified selection of the person responsible for the handover",
  "隐藏无法操作的迭代": "Hide inoperable iteratives",
  "请输入Sprint名称": "Please enter a name for Spring",
  "Sprint名称不能包含中文字符": "Sprint name cannot contain Chinese characters",
  "该Sprint包含的需求，一个需求只能属于一个Sprint": "The needs contained in the Spring, one of which can only belong to one",
  "版本号只能以数字开头结尾并且用小数点连接（如 1.0.0），创建迭代会自动版本+1": "Version numbers can only end with numbers and connect with decimal points (e.g. 1.0.0), creating an iterative version +1",
  "格式不正确，(如 1.0.0)": "Incorrect format (e.g. 1.0)",
  "邮件抄送人": "Email copying",
  "请输入迭代目标": "Please enter an iterative target.",
  "在“只看我”下，不能选择负责人": "Under \"Just look at me,\" you can't choose the head.",
  "请至少选择一个状态": "Please select at least one status",
  "周期开始": "Start of cycle",
  "周期结束": "End of cycle",
  "正在添加": "Adding",
  "添加失败，请重试！": "Add failed, try again!",
  "更新中": "Updating",
  "更新成功！": "Update successful!",
  "更新失败，请重试！": "Update failed, try again!",
  "是否删除Sprint": "Delete Spring",
  "确认要删除Sprint吗？": "Confirm to delete Sprint?",
  "Sprint（新版）": "Sprint (new)",
  "大类筛选（可选，不选则显示全部）": "Large category filter (optional, not all)",
  "选择大类以缩小范围": "Select a large category to narrow the range",
  "输入要创建的分支名称或选择分支": "Enter the name or selection branch to create",
  "存在未创建的分支，请点击分支后的“ + ”创建后再保存任务": "There is an uncreated branch, click on the '+' created after the branch to save the task",
  "所属需求：": "Requirements",
  "服务类型、服务、分支不能为空！": "Service type, service, branch cannot be empty!",
  "需求 & 服务分支(双击开始编辑)": "requirement & Service Branch (two click to start editing)",
  "任务描述(双击开始编辑)": "Job Description (two click to start editing)",
  "任务名称和链接已剪贴板": "_Other Organiser",
  "系统与Sprint、需求下拉框会有联动效果": "The system will be linked to Sprint, the drop-down frame.",
  "筛选大类": "Filter large class",
  "Sprint下拉选择只有筛选需求的作用，任务只会与需求直接关联": "Sprint drop-down selection is only for filtering the requirement, the task is only directly related to the requirement",
  "该下拉列表展示的是“任务中心”标签。": "This drop-down list shows the task centre label.",
  "该任务相关联的服务(注:服务类型选择后，服务名称下拉框会自动加载服务名称)": "Service associated with the task (Note: service type selected will automatically load service name under the service name).",
  "输入分支“+”创建或选择分支": "Enter branch \"+\" to create or select branch",
  "数字、字母、小数点、短横线、下划线": "Numbers, letters, decimal points, short lines, underline",
  "创建远程分支": "Create Remote Branch",
  "删除当前行": "Delete the current row",
  "在“只看我”下，不能选择参与人": "Under \"Look at me\", no participant can be selected.",
  "请选择参与人": "Please select the participant.",
  "默认展示负责人、参与人、创建人为自己的记录，并可与其他筛选条件“与”查询": "Default display of responsible persons, participants, creators' own records, and access to other filter conditions",
  "相关任务": "Related tasks",
  "取消排序": "Un sort",
  "新建状态流转规则": "New Status Streaming Rule",
  "编辑状态流转规则": "Edit state flow rules",
  "当工作项从": "When Work Item From",
  "进入": "Enter",
  "时，需要满足：": ", shall meet:",
  "字段": "Fields",
  "必填，": "It will be filled.",
  "部分人": "Some people.",
  "操作，": "Operation,",
  "且": "and",
  "添加其它字段条件": "Add another field condition",
  "字段条件": "Field Conditions",
  "添加必填字段": "Add mandatory fields",
  "添加操作人员": "Add Operator",
  "执行人角色": "Executor Role",
  "具体人员": "Specific personnel",
  "添加状态": "Add Status",
  "状态阶段列表": "Status phase list",
  "新增阶段": "New phase",
  "请输入阶段名称或描述或编码": "Please enter a name or description or code for the phase",
  "】 状态阶段吗？": "State stage?",
  "状态名称（中文）": "Status name (Chinese)",
  "状态名称（英文）": "Status Name (English)",
  "状态描述": "Status Description",
  "状态阶段名称": "Status Phase Name",
  "状态阶段回显颜色": "State phase echo color",
  "状态列表": "Status List",
  "新增状态": "Add Status",
  "请输入状态名称或描述或编码": "Please enter a status name or description or code",
  "】 状态吗？": "What's your status?",
  "配置状态": "Configure Status",
  "配置状态阶段": "Configure Status Phase",
  "创建一个工作流": "Create a Workstream",
  "排序号：": "Sort number:",
  "编辑工作所属状态": "The status of the editing work",
  "编辑工作流基础信息": "Edit Workflow Basic Information",
  "克隆工作流": "Cloning workflow",
  "删除工作流": "Remove Work Stream",
  "点击转正草稿": "Click to cross draft",
  "点击关闭对外展示": "Click to close the external display",
  "对外展示": "Public Presentation",
  "点击开启对外展示": "Click to open the external display",
  "对外隐藏": "Hide External",
  "确定删除 【": "Confirm Delete [%1]",
  "】 工作流吗": "Workstream?",
  "确定克隆 【": "Confirm Cloning [P]",
  "确定转正 【": "Make sure it's positive.",
  "工作流草稿已成功转正": "Workstream draft successfully corrected",
  "】 工作流对外展示吗": "♪ Work-flowing show ♪",
  "配置 【": "Configure[s]",
  "】 工作流状态": "Workflow status",
  "配置工作流所属状态及状态流转": "Configure workflow status and state flow",
  "创建完成": "Create finished",
  "工作流已成功创建，请点击完成按钮完成创建并退出！": "Workstream successfully created, click the finish button to finish creation and exit!",
  "创建 【": "Create [%1]",
  "】 工作流": "Workstream",
  "上一步": "Previous",
  "请先点击保存按钮保存工作流基础信息": "Please click the Save button to save the working stream base information",
  "工作流已成功创建": "Workstream successfully created",
  "工作流名称": "Workstream Name",
  "工作流描述": "Workstream Description",
  "请输入排序号": "Please enter a sorting number",
  "工作流Logo": "Workstream Logo",
  "状态名称(中文)": "Status name (Chinese)",
  "状态名称(英文)": "Status Name (English)",
  "状态所属阶段": "Phase of status",
  "阶段名称(中文)": "Phase Name (Chinese)",
  "阶段名称(英文)": "Phase Name (English)",
  "阶段描述": "Phase description",
  "】 工作流基础信息": ") Workstream Basic Information",
  "鼠标左键按住拖动调整顺序": "Left mouse button to hold the drag adjustment order",
  "移除状态": "Remove Status",
  "确定移除": "Confirm Remove",
  "吗": "I'm sorry.",
  "移除成功": "Remove successfully",
  "的流转规则吗": "The rules of the flow?",
  "审批流程配置 -": "Approval process configuration -",
  "添加审批节点": "Add approval nodes",
  "编辑审批类型": "Edit approval type",
  "添加审批类型": "Add approval type",
  "请输入审批类型名称，如：请假审批、报销审批等": "Enter the name of the type of approval, e.g. leave, reimbursement, etc.",
  "请输入审批类型名称": "Please enter the name of the approval type",
  "Code是审批类型的唯一标识，用于在审批流程中引用，命名规则：全大写字母，用_分割，如：PROJECT_APPLY等": "Code is the only identifier for the type of approval to be cited in the approval process, naming rules: full capital letters divided by _, e.g. PROJECT_APPLY, etc.",
  "请输入审批类型Code，全大写字母，用_分割": "Enter the approval type Code, full capital letters, divided by _",
  "请输入审批类型Code": "Please enter approval type Code",
  "请详细描述这个审批类型的用途和流程，帮助用户更好地理解": "Please describe in detail the use and process of this type of approval to help users better understand",
  "管理人员": "Managers",
  "请选择审批类型管理人员": "Selection of approval type managers",
  "管理人员可修改已发起审批单的审批人": "Managers may modify the Approver for the initiating approval request",
  "解析审批者类别 ruleScope 失败:": "Failed to parse approver category ruleScope:",
  "节点配置 -": "Node Configuration -",
  "基础配置": "Basic Configuration",
  "是否合并审批": "Merger approval or not",
  "合并审批说明：": "Consolidated approval notes:",
  "合并": "Merge",
  "：将该规则节点的所有审批人员视为一个整体发起审批": ": All Approvers at this rule node are treated as a whole initiating approval",
  "独立": "Independence",
  "：按照业务领域或系统或服务作为审批小组独立发起审批": ": Independent initiation of approval by operational area or system or service as an approval team",
  "注意：合并模式适用于需要统一审批的场景，独立模式适用于按业务分组审批的场景": "Note: The consolidation model applies to scenarios that require uniform approval, and the stand-alone model to scenarios that are approved by business groups",
  "审批者类别": "Category of approving authority",
  "通过规则": "Adoption of rules",
  "审批人员": "Approver",
  "追加固定审批人": "Additional Fixed Approver",
  "请选择审批人员": "Please select the Approver.",
  "可选：追加固定审批人": "Optional: Additional fixed Approver",
  "作用域配置": "Field Configuration",
  "域范围": "Scope",
  "只用于": "Only for",
  "不用于": "Not used",
  "域类型": "Domain Type",
  "域值": "Domain Value",
  "删除节点": "Delete Node",
  "上移": "Move Up",
  "下移": "Move Down",
  "克隆节点": "Cloning Nodes",
  "在此节点后添加": "Add after this node",
  "没有配置人员": "No staffing",
  "自动获取 +": "Automatic Access +",
  "系统自动获取": "System AutoAcquire",
  "业务": "Operations",
  "放大": "Zoom In",
  "重置聚焦": "Reset Focus",
  "重置视图": "Reset View",
  "重置缩放": "Reset Scale",
  "暂无审批节点，点击\"添加审批节点\"开始设计流程": "No approval nodes, click Add approval nodes to start the design process",
  "结束": "End",
  "加载审批规则失败": "Failed to load approval rules",
  "节点克隆成功": "Node Cloning Success",
  "保存失败": "Save Failed",
  "禁用": "Disable",
  "编辑类型": "Edit Type",
  "删除类型": "Remove Type",
  "确定要删除这个审批类型吗？": "Are you sure you want to delete this type of approval?",
  "规则配置": "Rule Configuration",
  "搜索审批类型名称、Code或描述": "Search for approval type name, code or description",
  "状态更新失败，请重试！": "Status update failed. Try again!",
  "确认关闭该业务领域？": "Confirm the closure of this business area?",
  "关联部门": "Related sectors",
  "企微群ID": "Microgroup ID",
  "飞书群ID": "Flying Books ID",
  "飞书BUG群ID": "Flying Book bug Group ID",
  "业务群机器人url": "Business group roboturl",
  "新增业务领域": "New business areas",
  "请输入业务领域名称": "Please enter the name of the business area",
  "保存中": "Saving",
  "保存失败，请重试": "Save failed, try again",
  "研发接口人": "R&D interface",
  "飞书需求群聊ID": "Flying Books needs ID.",
  "新增系统": "Add System",
  "请输入系统名称或系统key": "Enter the name of the system or the systemkey",
  "关联数据库": "Associated Database",
  "机器人url": "Roboturl",
  "创建该系统的线上问题时，研发接口人将会被拉到线上问题群": "When creating production issues with the system, R & D interfaces will be drawn to production issue groups.",
  "行业线编码(唯一且不能修改)": "Industry line code (single and unmodified)",
  "行业线编码只能包含字母、数字、横划线和下划线": "The industry line code can only contain letters, numbers, lines and underlineds",
  "行业线名称": "Industry Line Name",
  "父级行业线": "Parent Industry Line",
  "激活": "Activate",
  "行业线编码": "Industry line encoding",
  "请输入行业线名称或编码": "Enter industry line name or code",
  "新增行业线": "Add Industry Line",
  "打标明细": "Plug in.",
  "确认要删除标签吗？": "Are you sure you want to delete the label?",
  "请输入标签名称": "Please enter a label name",
  "新增标签": "Add Tab",
  "属性信息配置（待实现）": "Properties Information Configuration (to be achieved)",
  "缺少组ID，无法保存": "Missing Group ID, Unable to Save",
  "基础信息保存成功": "Basic information saved successfully",
  "基础信息编辑": "Basic Information Edition",
  "组名称": "Group Name",
  "请输入组名称": "Please enter the name of the group",
  "组名称不能超过50个字符": "Group name cannot exceed 50 characters",
  "负责人可以管理该卡片组，并进行卡片分发与编辑(不包含删除权限,只有创建人才能删除卡片组) ps:卡片赠送消息会抄送负责人": "The person in charge can manage the card group and distribute and edit the card (without permission to delete the card group, only the creator can delete the card group) ps: the message will be copied to the person in charge",
  "关联TOP部门": "Linking TOP",
  "卡片将在这些top部门内部流转": "The cards will flow within these top departments.",
  "请选择关联TOP部门": "Please select a link to TOP",
  "请选择TOP部门": "Please select the TOP department.",
  "组描述": "Group Description",
  "请输入组描述（选填）": "Please enter group description (check-in)",
  "组描述不能超过200个字符": "Group description cannot exceed 200 characters",
  "活动名称": "Name of activity",
  "同人同卡最大赠送数": "Maximum number of same-person cards",
  "提醒周期": "Reminder Interval",
  "第几小时提醒": "Hourly Reminder",
  "确认手动触发未使用卡片提醒吗？": "Confirm that manually triggers unused card alarms?",
  "提醒": "Organisation",
  "确认删除该活动吗？": "Confirm deletion of the activity?",
  "请选择卡片组": "Select a card group",
  "请选择活动时间": "Please select active time",
  "活动更新成功": "Activity update successful",
  "活动创建成功": "Activity created successfully",
  "活动列表": "Activity List",
  "新建活动": "New Activity",
  "暂无活动": "Not active",
  "编辑活动": "Edit Activity",
  "请输入活动名称": "Please enter the activity name",
  "活动时间": "Activity Time",
  "同人同卡最大赠送数量": "Maximum number of same-person cards",
  "可选，默认不限": "Optional, default open",
  "设置后会给未使用卡片人员发送提醒通知": "Reminder sent to unused card after setting",
  "可选，选择后需配置提醒小时": "Optional, selected to configure alarm hours",
  "可选，范围 0~23": "Optional, range 0-23",
  "分发原因": "Reason for distribution",
  "单人发放数量": "Number of individual distributions",
  "发放人数": "Number of persons issued",
  "总发放数": "Total issued",
  "确认撤回该分发批次吗？": "Confirm the withdrawal of the distribution?",
  "撤回成功": "Withdrawal succeeded",
  "撤回": "Withdrawn",
  "分发批次记录": "Distribution of batch records",
  "请选择卡片组后查看分发批次记录": "Please select the card group and check the batch records.",
  "卡片名称": "Card Name",
  "持有人": "Holder",
  "生效时间": "Entry into force time",
  "失效时间": "Expiry time",
  "发放人": "Issuer",
  "发放时间": "Issue time",
  "持有人:": "Holder:",
  "请选择持有人": "Please select the holder",
  "卡片:": "Card:",
  "请选择卡片": "Select a card",
  "发放时间:": "Issuance time:",
  "分发记录": "Distribution of records",
  "请选择卡片组后查看分发记录": "Please select a card group to see distribution records",
  "赠送人": "Presenter",
  "接收人所属部门": "Department of recipient",
  "赠送装饰": "Decoration",
  "赠送时间": "Timing",
  "导出失败:": "Export failed:",
  "赠送人:": "Presenter:",
  "请选择赠送人": "Please choose the presenter.",
  "接收人:": "Recipient:",
  "赠送时间:": "Present time:",
  "赠送记录": "Records of gifts",
  "请选择卡片组后查看赠送记录": "Please select the card group to check the gift log",
  "请选择卡片组后再分发": "Please select the card group for distribution.",
  "模板信息异常，无法分发": "Template information is abnormal and cannot be distributed",
  "请至少选择一个部门": "Please select at least one department.",
  "所选部门暂无人员": "No personnel in selected departments",
  "请至少选择一位人员": "Please choose at least one person.",
  "分发成功": "Distribution succeeded",
  "有效期": "Valid period",
  "请选择有效期": "Select the validity period",
  "分发数量": "Number distributed",
  "请输入分发数量": "Please enter the number of distributions",
  "分发数量需大于0": "Distribution needs to be greater than 0",
  "请输入数量": "Please enter the number",
  "请填写分发原因": "Please fill out the distribution reasons.",
  "选人模式": "Selection Mode",
  "按部门": "By sector",
  "按人员": "By personnel",
  "指定部门": "Designated authorities",
  "指定人员": "Designated personnel",
  "请选择分发人员": "Please select a distributor.",
  "卡片赠送情况占比": "Share of card deliveries",
  "请选择卡片类型": "Select the card type",
  "卡片净收到数量排行": "Number of net cards received",
  "暂无卡片净收到数量排行数据": "No card received net count data",
  "赠送": "Present",
  "分发卡片": "Distribution of cards",
  "确定要删除这个卡片吗？": "Are you sure you want to delete this card?",
  "请输入卡片名称": "Please enter the name of the card",
  "请选择卡片适用范围": "Select the card application",
  "卡片模板更新成功": "Card template updated successfully",
  "卡片模板创建成功": "Card template successfully created",
  "暂无素材": "No material.",
  "无背景": "No Background",
  "卡片适用范围": "Scope of application of cards",
  "卡片使用规则": "Card usage rules",
  "请输入卡片使用规则": "Please enter the card usage rule",
  "背景素材库": "Background material library",
  "新增卡片": "Add Card",
  "模板信息异常，无法删除": "Template information is abnormal and cannot be deleted",
  "分发批次": "Distribution",
  "活动配置": "Activity Configuration",
  "请先新建一个活动哦": "Please start with a new event.",
  "创建活动后即可配置卡片。": "Creates the activity to configure the card.",
  "快速创建活动": "Quick Create Activity",
  "卡片类型配置保存成功": "Card type configuration successfully saved",
  "卡片类型配置": "Card Type Configuration",
  "卡片类型名称": "Card Type Name",
  "请输入卡片类型名称": "Please enter the name of the card type",
  "卡片类型编码": "Card type encoding",
  "只能包含大写字母和下划线": "Only uppercase letters and underlined",
  "请输入卡片类型编码": "Please enter a card type encoding",
  "卡片类型编码只能包含大写字母和下划线": "The card type code can only contain capital letters and underline",
  "请输入卡片类型编码（大写字母和下划线）": "Please enter a card type code (fast letter and underline)",
  "适用范围": "Scope of application",
  "请选择适用范围": "Select the scope of application",
  "确定要删除这条记录吗？": "Are you sure you want to delete this record?",
  "添加卡片类型": "Add Card Type",
  "表单未初始化": "Form not initialized",
  "请完善卡片类型信息": "Please complete the card type information",
  "请完善表单信息": "Please complete the form information",
  "创建失败": "Failed to create",
  "创建卡片组": "Create Card Group",
  "完成创建": "Finish Create",
  "卡片素材": "Card material",
  "组素材保存成功": "Package saved successfully",
  "组素材配置": "Group material configuration",
  "仅支持上传 PNG/JPG/SVG 图片": "Only uploading PNG/JPG/SVG pictures is supported",
  "背景素材": "Background material",
  "点击批量上传": "Click Batch Upload",
  "装饰素材": "Decorative material",
  "素材配置": "Material Configuration",
  "删除组": "Remove Group",
  "确定要删除这个组吗？": "Are you sure you want to delete this group?",
  "月份": "Month",
  "指标类型": "Indicator type",
  "指标单位": "Indicator units",
  "考核角色": "Test role.",
  "基线值": "Baseline value",
  "确定删除该基线吗？": "Are you sure that the baseline will be deleted?",
  "新增基线": "New baseline",
  "编辑基线": "Edit baseline",
  "请选择关联类型": "Select the association type",
  "年-月": "Year-month",
  "请选择年月": "Please choose a number of years",
  "（单位：": "(Unit:",
  "批量新增基线": "Bulk new baseline",
  "请至少选择一个年月": "Please select at least one year",
  "选择图标": "Select Icon",
  "请选择指标图标": "Please select an indicator icon",
  "提交失败，请检查表单": "Failed to file, check form",
  "新增指标": "Add new indicator",
  "编辑指标": "Edit Indicators",
  "更换图标": "Replace Icon",
  "请输入指标名称": "Please enter an indicator name",
  "指标编码": "Indicator encoding",
  "请输入指标编码": "Please enter an indicator code",
  "请选择指标类型": "Select the indicator type",
  "能否算分": "Can you score?",
  "请选择能否算分": "Please choose whether you can score.",
  "请选择考核角色": "Please select the exam role.",
  "指标极性": "Indicator polarity",
  "请选择指标极性": "Select the polarity of the indicator",
  "请选择指标单位": "Select the indicator unit",
  "指标级别": "Indicator level",
  "指标归属": "Attribution of indicators",
  "指标描述": "Description of indicators",
  "请输入指标描述": "Please enter an indicator description",
  "状态切换成功": "Status Switch Success",
  "查看基线详情": "View baseline details",
  "确定删除该指标吗？": "Are you sure that the indicator will be deleted?",
  "请输入指标名称/编码/描述": "Please enter the indicator name/coding/description",
  "单个新增": "Add individual",
  "批量新增": "Batch Add",
  "配置指标": "Configure Indicators",
  "交付": "Delivery",
  "效率": "Efficiency",
  "代码": "Code",
  "协作": "Collaboration",
  "工时": "Hours of work",
  "质量": "Quality",
  "增长": "Growth",
  "下降": "Down",
  "进展": "Progress",
  "分析": "Analysis",
  "报表": "Report",
  "总览": "Overview",
  "数据": "Data",
  "安全": "Clear.",
  "监控": "Monitor",
  "性能": "Performance",
  "热点": "Hot.",
  "雷达": "Radar",
  "漏斗": "Funnel",
  "节点类型": "Node Type",
  "节点": "Nodes",
  "节点描述不能为空": "Node description cannot be empty",
  "节点驳回描述（中文）": "Node Rejects Description (Chinese)",
  "节点驳回描述（英文）": "Node rejects description (English)",
  "回退节点；可不设置，不设置默认按操作记录回退为上一操作节点": "Back node; do not set, do not set the default operation log back to the previous operation node",
  "节点描述": "Node Description",
  "回退节点": "Back off.",
  "确认要删除驳回节点吗？": "Are you sure you want to delete the node?",
  "新增驳回节点": "Add rejected node",
  "请输入查询条件": "Please enter the conditions for the query",
  "无操作权限": "No permission to operate",
  "服务组": "Service Group",
  "git组": "Group guit",
  "git名称": "Name",
  "请输入git名称": "Please enter the Git name",
  "请输入有效的git名称，例如：https://git.imile.com/tech/athena.git": "Please enter a valid git name, e.g. https://git.imile.com/tech/athena.git",
  "服务描述": "Service Description",
  "已部署环境": "Deployed environment",
  "环境数量": "Number of environments",
  "开发": "Development",
  "添加环境": "Add Environment",
  "克隆后，请及时修改服务名": "After cloning, please modify the service name in time.",
  "克隆服务基础信息": "Basic information on cloning services",
  "删除后，【服务环境记录】与【服务jenkins配置】也会一并删除，确认要删除吗？": "When deleted, the [service environment record] and [service jenkins configuration] will also be deleted, confirming that they should be deleted?",
  "服务基础信息列表": "List of Service Basic Information",
  "新增服务": "Add Service",
  "请输入服务名或服务描述": "Please enter a service name or service description",
  "日志url": "Logurl",
  "副本数": "Number of copies",
  "镜像列表": "Mirror List",
  "是否灰度发布": "Whether to release greyscale",
  "域名配置": "Domain Name Configuration",
  "发布窗口开始时间": "Launch window start time",
  "发布窗口截止时间": "Release window deadline",
  "克隆环境": "Cloning environment",
  "服务关联环境列表": "List of Service Related Environments",
  "新增环境": "New Environment",
  "克隆环境配置": "Cloning Environment Configuration",
  "请选择目标环境": "Please select the target environment.",
  "目标环境": "Target environment",
  "新增环境配置": "Add Environment Configuration",
  "编辑环境配置": "Edit Environment Configuration",
  "发布窗口时间": "Release window time",
  "Apollo环境": "Apollo Environment",
  "数据库名": "Database Name",
  "域名对象": "Domain Name Object",
  "应用说明": "Description of application",
  "订阅后会在配置和数据库变更后推送企微消息，前端不支持订阅": "Subscriptions are sent after configuration and database changes, and subscriptions are not supported at the frontend",
  "配置服务": "Configure Services",
  "订阅人更新成功": "_Other Organiser",
  "更新失败": "Update failed",
  "编辑订阅人失败:": "_Other Organiser",
  "选择订阅人：": "_Other Organiser",
  "请选择订阅人": "Please select the subscriber",
  "新的状态组": "New Status Group",
  "状态中文名": "Chinese Status Name",
  "状态英文名": "Status English Name",
  "类型编码": "Type encoding",
  "类型名称": "Type Name",
  "正常": "Normal",
  "新增类型": "Add Type",
  "请输入编码或名称或描述": "Please enter a code or name or description",
  "请输入编码或中英文名称": "Please enter a code or a Chinese English name",
  "保存草稿失败:": "Failed to save the draft:",
  "表单提交失败:": "Form submission failed:",
  "新增版本": "Add Version",
  "如：v2.1.0": "For example: V2.1.0",
  "请输入版本号": "Please enter a version number",
  "版本号格式不正确，请输入如：v2.1.0 ，v1.0.0-beta格式（必须以v开头）": "Version number is incorrect, for example: V2.1.0, v1.0.0-beta (must start with V)",
  "请选择发布时间": "Please select the release time",
  "选择发布时间": "Organisation",
  "一句话描述本次发布内容（可选）": "A sentence describing the content of this release (optional)",
  "版本摘要": "Version Summary",
  "请输入版本摘要（可选）": "Please enter a version summary (optional)",
  "更新明细": "Update Details",
  "更新类型": "Update Type",
  "选择类型": "Select Type",
  "请选择更新类型": "Please select the type of update",
  "更新内容": "Update",
  "请输入更新内容": "Please enter an update",
  "最新版本": "Latest version",
  "📝 版本摘要": "• Summary of the version",
  "📋 更新内容": "Update",
  "项更新": "Item Update",
  "目录": "Contents",
  "查看所有功能更新和版本历史，了解最新系统改进": "View the history of all functionality updates and releases and the latest system improvements",
  "暂无草稿版本": "No draft version available",
  "暂无发布版本": "Release not available",
  "创建第一个版本": "Create First Version",
  "请填写完整的中文模板内容": "Please complete the full Chinese template",
  "中文模板": "Chinese Template",
  "请输入中文模板内容": "Please enter the Chinese template",
  "英文模板": "English Template",
  "是否启用": "Enable",
  "模版所有者": "Template Owner",
  "确认要删除模版吗？": "Are you sure you want to delete the template?",
  "新增模版": "Add Template",
  "搜索类型（名称）": "Search type (name)",
  "暂无订阅类型": "No type of subscription",
  "确认删除该订阅类型？": "Are you sure you want to delete this subscription type?",
  "删除类型后将无法在页面选择该类型。": "When you delete the type, you cannot select it on the page.",
  "新增订阅类型": "New Subscription Type",
  "编辑订阅类型": "Edit Subscription Type",
  "请输入类型名称": "Type Name",
  "例如：需求池订阅": "For example: requirement pool subscription",
  "类型 CODE": "Type CODE",
  "请输入类型 CODE": "Enter type CODE",
  "仅支持字母/数字/_/-": "Only letters/numbers/_/-",
  "例如：POOL_SUBSCRIBE": "For example: POOL_SUBCRIBE",
  "关联值类型": "Association Value Type",
  "请选择关联值类型": "Select the associated value type",
  "订阅值": "Subscriptions",
  "请选择一个订阅类型": "Please select a subscription type",
  "搜索订阅值（名称）": "Search for Subscriptions (name)",
  "产品需求状态": "Product requirement status",
  "订阅类型编码缺失，无法保存": "Subscription type code is missing. Unable to save.",
  "请至少选择一个订阅值": "Please select at least one subscription value",
  "订阅已保存": "Subscription saved",
  "保存订阅失败，请重试": "Can not open message",
  "无权限：仅 CTO 可新增订阅类型": "Unpermitted: CTO only can add new subscription type",
  "无权限：仅创建人可编辑该类型": "No permission: Only creators can edit this type",
  "已新增订阅类型": "New Subscription Type",
  "已更新订阅类型": "Subscription type updated",
  "无权限：仅创建人可删除该类型": "No permission: Only creators can delete this type",
  "已删除订阅类型": "Subscription type deleted",
  "订阅类型": "Subscription type",
  "已订阅": "Subscriptioned",
  "未保存": "Unsaved",
  "保存订阅": "Can not open message",
  "确认全部订阅？": "Can not open message",
  "全部订阅": "Subscriptions to All",
  "确认全部取消订阅？": "Unsubscribe from all?",
  "全部取消": "Cancel All",
  "已刷新": "Refreshed",
  "正在删除": "Deleting",
  "请输入模板id": "Please enter a templateid",
  "请输入模板关键字": "Please enter a template keyword",
  "已选择:": "Selected:",
  "确认绑定": "Confirm binding.",
  "请从下方表格中选择要绑定的SQL模板": "Please select the SQL template to bind from the bottom table",
  "债务总数": "Total liabilities",
  "新增债务": "Additional obligations",
  "高优先级": "High Priority",
  "降序 ↓": "Order reduction",
  "升序 ↑": "Upgrade",
  "事故详情": "Accident details",
  "业务需求详情": "Detailed operational requirements",
  "仅指派人可以操作": "Only assignable",
  "新建成功": "New Success",
  "编辑成功": "Edit Successful",
  "表单校验或提交失败:": "Form verification or submission failed:",
  "新建技术债务": "New technology debt",
  "编辑技术债务": "Edit technical obligations",
  "请选择关联系统": "Select the associated system",
  "请选择债务类型": "Please select the type of obligation",
  "绑定债务": "Bonded debt",
  "未绑定任何债务": "No obligations bound",
  "重新选择": "Reselect",
  "选择绑定": "Select binding",
  "请选择指派人": "Please select the appointing person",
  "债务描述": "Debt description",
  "重开次数": "Reopen Number",
  "关联债务": "Related liabilities",
  "暂无关联债务": "Obligations not related",
  "(双击开始编辑)": "(two clicks start editing)",
  "债务名称和链接已剪贴板": "Debt name and links are clipboarded",
  "切换到系统 All 下才能筛选业务领域": "Switch to system All to screen business areas",
  "优先级分布": "Priority distribution",
  "严重程度分布": "Distribution of severity",
  "月度债务趋势": "Trends in monthly debt",
  "债务重开": "Debt re-opening",
  "暂无文档内容": "No document contents",
  "点击\"编辑文档\"开始创建": "Click Edit Document to start creating",
  "请联系管理员创建文档": "Please contact the administrator to create the document",
  "编辑文档": "Edit Document",
  "获取应用配额记录失败:": "Failed to access application log:",
  "获取应用配额记录失败": "Failed to access application log",
  "可调用模型": "Callable Models",
  "无": "None",
  "应用配额使用情况": "Application of quotas",
  "用户配额使用情况": "User quota usage",
  "创建密钥明细": "Create Key Details",
  "加载应用中...": "Loading applications...",
  "应用视图": "Apply View",
  "选择您要使用的AI应用，点击卡片进入对应的应用页面": "Select the AI application you want to use, click the card on the corresponding application page",
  "暂无可用应用": "Application not available",
  "审批申请已提交，请等待审批结果": "Requests for approval have been submitted pending the outcome",
  "审批申请提交失败": "Failed to submit application for approval",
  "申请密钥": "Application Key",
  "重置密钥": "Reset Key",
  "请填写申请原因": "Please fill out the reasons for your application.",
  "请详细说明申请密钥的原因和用途": "Please provide details on the reasons for and purpose of applying for the key.",
  "• 申请后需要经过审批流程": "• Post-application approval process",
  "• 审批通过后将自动生成API密钥": "• Automatically generate API keys after approval",
  "• 您可以在审批进度中查看申请状态": "• You can see the status of applications in the approval process",
  "获取聊天记录失败": "Failed to fetch chat record",
  "已复制完整内容到剪贴板": "_Other Organiser",
  "复制完整内容": "Copy Full Contents",
  "请求模型": "Request Model",
  "请求内容": "Contents of request",
  "响应内容": "Response content",
  "请求参数": "Request parameters",
  "响应参数": "Response parameters",
  "输入Token": "Enter Token",
  "输出Token": "Output Token",
  "总Token": "General Token",
  "请求IP": "Request IP",
  "请求人": "Requester",
  "请求时间": "Request Time",
  "请求记录详情": "Request to record details",
  "API Key已复制到剪贴板": "API Key copied to clipboard",
  "您还没有": "You haven't.",
  "应用密钥": "Apply Keys",
  "申请一个": "Request one.",
  "应用密钥开始使用": "Apply key start",
  "查看审批进度": "View approval progress",
  "隐藏密钥": "Hide Keys",
  "显示密钥": "Show key",
  "复制完整密钥": "Copy Full Key",
  "Base Url已复制到剪贴板": "Base Url copied to clipboard",
  "应用日配额": "Apply day quota",
  "个人日配额": "Personal day quota",
  "可用模型": "Available Models",
  "配额使用趋势": "Trends in the use of quotas",
  "在指定时间范围内的配额使用量趋势，点击图表可查看详情": "Trends in the use of quotas within specified time frames, click on a chart to see details",
  "所选条件范围内暂无配额使用趋势数据": "Data on trends in the use of quotas within selected conditions",
  "查看接入文档": "View Access Document",
  "接入文档": "Access Document",
  "刷新页面": "Refresh Page",
  "应用配额": "Apply quota",
  "使用趋势": "Trends in use",
  "请求记录": "Recording of requests",
  "配额日使用情况（已用/总量）": "Quota days used (used/total)",
  "暂无应用密钥统计数据": "No application key statistics available",
  "应用类型": "Application Type",
  "请选择应用类型": "Select the application type",
  "加载应用类型中...": "Loading application type...",
  "请先确保有应用密钥统计数据": "Make sure you have applied key statistics.",
  "加载趋势数据中...": "Loading trend data...",
  "密钥申请趋势": "Key application trend",
  "所选时间范围内暂无应用密钥创建趋势数据": "No application key to create trend data for the selected time frame",
  "用户": "User",
  "请选择用户": "Select User",
  "加载数据中...": "Loading data...",
  "应用密钥统计": "Apply Key Statistics",
  "应用明细": "Apply Details",
  "OpenApi业务日志": "OpenApi Operations Log",
  "Java服务日志(here-info)": "Java Service Log (here-info)",
  "Java服务日志(error-logs)": "Java Service Log (error-logs)",
  "请输入节点ID": "Please enter node ID",
  "请输入客户端地址": "Please enter the client address",
  "数据库订阅": "Database subscriptions",
  "执行成功": "Implementation Success",
  "请先选择需要审批的工单": "Please select the work orders to be approved.",
  "只有待人工审核状态的工单可以审批": "Only manual clearance is allowed.",
  "未找到有效的工单ID，无法审批": "No valid worksheet ID found, not approved",
  "请填写审批备注": "Please complete the approval note.",
  "名称:": "Name:",
  "请输入工单名称": "Please enter the name of the worksheet.",
  "状态:": "Status:",
  "批量审批": "Batch approval",
  "SQL详情": "SQL Details",
  "审批备注": "Approval of notes",
  "终止流程": "Termination process",
  "审核通过": "Audited",
  "请输入审批备注": "Please enter an approval note.",
  "了解更多": "Get to know more.",
  "欢迎使用 Ant Design Pro": "Welcome to Ant Design Pro",
  "Ant Design Pro 是一个整合了 umi，Ant Design 和 ProComponents 的脚手架方案。致力于在设计规范和基础组件的基础上，继续向上构建，提炼出典型模板/业务组件/配套设计资源，进一步提升企业级中后台产品设计研发过程中的『用户』和『设计者』的体验。": "Ant Design Pro is a scaffolding scheme that integrates uni, Ant Design and ProCommponents. It is committed to building up on design specifications and basic components, refining typical templates/business components/system design resources, and further enhancing the experience of `user' and `designer' in the design and development of intermediate and backstage products at the enterprise level.",
  "了解 umi": "Got it.",
  "了解 ant design": "Roger that.",
  "了解 Pro Components": "Know Pro Components",
  "创建业务需求": "Create business needs",
  "创建任务": "Create Task",
  "创建评审": "Create Review",
  "创建回归缺陷": "Create Return Impairment",
  "创建线上问题": "Creating production issues",
  "按类型新建": "New by Type",
  "转换操作失败:": "Conversion operation failed:",
  "研发任务明细": "Detailed development tasks",
  "差": "Bad",
  "较差": "Poor",
  "一般": "General",
  "良好": "Good.",
  "优秀": "Excellent.",
  "较上周：": "More than last week:",
  "视频无法播放，已在新窗口打开": "The video could not be played, it was opened in a new window",
  "视频": "Video",
  "在新窗口播放": "Play in New Window",
  "点击下载": "Click to Download",
  "附件列表": "Attachment List",
  "有问题请请点击此处,开权限等": "If you have a problem, please click here.",
  "全局搜索": "Global Search",
  "点击设置计划联调日期": "Click to set scheduled date",
  "点击设置计划上线日期": "Click to set the scheduled go-live date",
  "点击设置暂停日期": "Click to set a pause date",
  "联调日期反馈": "Joint date feedback",
  "填写后将会自动通知至需求业务方及产品经理！": "Once completed, you will automatically notify the requirement operator and the product manager!",
  "计划上线日期反馈": "Planned uplink date feedback",
  "预估人天（研发、测试总人天）": "Estimated human days (RD, test total)",
  "变更原因": "Reason for change",
  "暂停反馈": "Pause feedback",
  "计划暂停至": "Plan suspended until",
  "提测申请记录已暂存！": "The records of the test applications are on hold!",
  "标签设置成功": "Tab Settings Successful",
  "请输入标签中文名称": "Please enter a Chinese name for the label",
  "请输入标签英文名称": "Please enter the name of the label in English",
  "标签创建成功": "Tab created successfully",
  "暂无标签": "Unlabeled",
  "选择标签": "Select Tab",
  "没有想要的？": "Nothing?",
  "手动添加": "Manual Add",
  "暂无操作记录": "Operational records are not available",
  "操作记录": "Operation records",
  "产品验收通知": "Product acceptance notification",
  "您有": "You have.",
  "个需求待验收": "Requirements pending acceptance",
  "关闭此通知后，您可以在通知中心查看": "After closing this notification, you can view the notification centre",
  "研发效能平台版本更新": "Development effectiveness platform update",
  "发布版本号：": "Release number:",
  "去查看": "Check it out.",
  "每一起严重事故的背后，必然有": "Behind every serious accident is certain.",
  "29次轻微事故": "29 minor accidents",
  "300起未遂先兆": "300 attempts.",
  "以及": "and",
  "1000起事故隐患": "1,000 accidents.",
  "📞 联系值班人员": "Contact the duty officer.",
  "很不满意": "I'm not satisfied.",
  "不满意": "Unsatisfactory",
  "满意": "Satisfied",
  "很满意": "I'm satisfied.",
  "添加备注失败:": "Failed to add remarks:",
  "添加备注失败，请重试": "Failed to add remarks. Please try again.",
  "查看当前工作项备注记录": "View current working item notes",
  "隐藏当前工作项备注记录": "Hide Comment Record for Current Task",
  "备注类型": "Remarks Type",
  "备注内容": "Remarks",
  "点击隐藏当前工作项备注记录": "Click to hide a comment on the current working item",
  "点击查看当前工作项备注记录": "Click to see the current working item note",
  "将按当前筛选条件导出，最多支持 5000 条。": "The current filter condition will be exported, with a maximum of 5,000 entries supported.",
  "导出已勾选数据（": "Export Checked Data",
  "条）": "(Articles)",
  "导出当前筛选结果（": "Export the current filter result",
  "数据超过 5000 条，请缩小筛选范围后再导出。": "If the data exceeds 5,000, please narrow the filter and then export it.",
  "获取责任人详情失败:": "Failed to load owner details:",
  "获取责任人详情失败，将使用默认值": "Failed to get responsible person details, default value used",
  "请至少选择一个责任人": "Please choose at least one responsible person.",
  "更新责任人成功": "Update of duty bearers successful",
  "更新责任人失败": "Failed to update responsible person",
  "编辑责任人失败:": "Edit duty:",
  "编辑责任人失败": "The editor responsible failed",
  "责任人员": "Responsible personnel",
  "责任原因": "Causes of responsibility",
  "请输入责任原因": "Please enter the cause of responsibility.",
  "调用 logout 接口失败:": "Failed to call logout interface:",
  "请选择或搜索系统": "Select or search system",
  "至少选择一个相关人": "Select at least one related person",
  "图表初始化失败:": "Failed to initialize chart:",
  "手动添加事件监听器失败:": "Failed to add the event listener manually:",
  "已同意": "Agreed",
  "未开放": "Not Available",
  "审批撤销": "Approval Withdrawn",
  "待审批": "Pending Approval",
  "后付费": "Pay-as-you-go",
  "预付费": "Subscription",
  "通用型": "Generic",
  "独享型": "Dedicated",
  "「技术类」": "“Technical”",
  "不能为空": "This field is required",
  "实际工时不能超过120h": "No more than 120h actual hours worked",
  "将按全部启用的业务领域重建模板，业务岗位和值班组长都会清除固定人员并恢复自动轮转；需要固定的人员请在重置后重新选择。已生成的值班数据不会立即改变。": "Templates will be re-established for all active business areas, and both operational positions and duty leaders will remove fixed personnel and resume automatic rotation; those who need them should be re-selected after replacement. The duty data generated will not change immediately.",
  "确认重排": "Confirm Reorder",
  "我创建的仪表盘": "I created the dashboard.",
  "共享我的仪表盘": "Share my dashboard",
  "-需求交付时长": "- Long requirement delivery.",
  "当前装饰": "Current Decoration",
  "自定义装饰": "Custom Decoration",
  "装饰": "Decoration",
  "研发bug数": "R&D Bugs",
  "生产bug数": "Production Bugs",
  "发布总次数": "Total number of releases",
  "次": "times",
  "发布回滚次数": "Release rollbacks",
  "研发需求设计缺陷数": "R&D Requirement Design Defects",
  "产品评审驳回数": "Product Review Rejections",
  "代码规范提交数": "Coding Standard Submissions",
  "研发bug重开数": "Reopened R&D Bugs",
  "生产bug重开数": "Reopened Production Bugs",
  "紧急发布数": "Number of emergency releases",
  "需求测试覆盖数": "Requirements Covered by Tests",
  "缺陷数": "Defects",
  "万次": "10,000 times",
  "技术债务个数": "Number of technical debts",
  "模版数量": "Number of templates",
  "致命事故": "Critical Incidents",
  "生产事故出现次数和严重程度：无P1级及以上生产事故，P2级及以下生产事故<=2": "Number and severity of production accidents: No P1 and above, P2 and below < = 2",
  "严重事故": "Major Incidents",
  "一般事故": "Moderate Incidents",
  "轻微事故": "Minor Incidents",
  "需求前置平均等待时间": "Average waiting time for pre-requirement",
  "提出需求到产品介入需求等待时长平均值": "Average number of lead times between requirement for product intervention",
  "所有已介入需求到需求评审完成的累计时长平均值": "Cumulative average of all intervention needs to completion of the needs assessment",
  "开始开发到转提测的累计时长平均值": "Cumulative average of the length of time to begin development to transfer to",
  "需求转提测至产品验收通过的累计时长平均值": "requirement transferred to aggregate average of time passed for product acceptance",
  "需求开始验收到已发布的累计时长平均值": "Needs start to verify receipt of cumulative average of time issued",
  "卡片名称(中文)": "Card name (Chinese)",
  "卡片名称(英文)": "Card name (English)",
  "只能上传jpg/png文件,且不大于10MB": "Only jpg/png files can be uploaded and not greater than 10MB",
  "填写评审纪要": "Fill out the review summary.",
  "警告": "Warning",
  "错误": "Error",
  "扫描中": "Scanning",
  "确定要删除任务「{name}」吗？": "Are you sure you want to delete task “{name}”?",
  "驳回项": "Rejected",
  "提交不规范项": "Submit an irregular entry",
  "紧急发布项": "Urgent release entry",
  "发布失败项": "Release Failed",
  "回滚项": "Roll Back",
  "我创建的需求池": "I created the requirement pool.",
  "共享我的需求池": "Share my needs pool.",
  "后端任务": "Backend Task",
  "前端任务": "Front-end Task",
  "测试任务": "Test Tasks",
  "UI任务": "UI Task",
  "产品任务": "Product Task",
  "运维任务": "Operations Task",
  "其他类任务": "Other Task Types",
  "其他任务": "Other tasks",
  "已完成或未逾期": "Completed or overdue",
  "进行中且已逾期": "Ongoing and overdue",
  "未开始且已逾期": "Not started and overdue",
  "配置【": "Configure[s]",
  "】模板": "_Other Organiser",
  "拆分【": "Split",
  "】部门周报": "Department Weekly",
  "本周新增": "Add this week",
  "本周完成": "Done this week.",
  "模板": "Templates",
  "分钟": "min",
  "已撤销": "Cancelled",
  "重新申请": "Reapply",
  "支持大小写字母、数字、'.'和'-'、长度不超过64个字符": "Support case letters, numbers, '.' and '-', not longer than 64 characters",
  "请输入有效的用户ID": "Enter a valid user ID",
  "添加一行服务分支": "Add a line of service branches",
  "拉取": "Pull",
  "不拉取": "Do Not Pull",
  "拉取载体分支": "Pull the carrier branch",
  "发布成功后发布单将变为【待回归】状态，需要测试回归需求": "After a successful release, the release request will move to “Pending Regression” and requires regression testing.",
  "确定【": "Sure.",
  "】吗？": "What?",
  "全局平均值": "Global average",
  "平均工时": "Average hours worked",
  "{value} 小时": "{value} hours",
  "基础柱状图-图形标签位置": "Basic column chart - graphic label position",
  "基础柱状图的图形标签位置可以指定为top-柱形上部，middle-柱形中心，bottom-柱形底部。": "The graphic label position of the base column chart can be assigned to the top of the toop-bar, middle-column centre, bottom-column bottom.",
  "时长": "Length",
  "{value} 天": "{value} days",
  "{value} 个": "{value}",
  "平均响应耗时": "Average response time",
  "平均解决耗时": "Average time to resolve",
  "平均关闭耗时": "Average time to close",
  "平均修复总耗时": "Average total repair time",
  "全局平均修复耗时": "Average global repair time",
  "未关闭缺陷数量": "Number of defects not closed",
  "已关闭缺陷数量": "Number of defects closed",
  "每天新增Bug数": "New Bugs per Day",
  "每天解决Bug数": "Resolved Bugs per Day",
  "每天关闭Bug数": "Closed Bugs per Day",
  "预计一个月内完成，进度良好": "It is expected to be completed within one month and progress is good",
  "预计3个月内完成，需要关注进度": "Expected to be completed within 3 months, requiring attention to progress",
  "预计超过3个月完成，风险较高": "Expected to be completed in more than three months, with higher risk",
  "展示各项健康度指标的分布情况": "Show the distribution of health indicators",
  "工时（人天）": "Hours worked (person-days)",
  "占比": "Percentage",
  "成本": "Cost",
  "您确定要关闭吗？": "Are you sure you want to close it?",
  "添加邮箱": "Add Mailbox",
  "数量（个）": "Number",
  "事故总数": "Total number of accidents",
  "bug总数": "Total Bugs",
  "关闭时效": "Close the time limit",
  "bug数": "Bugs",
  "效能度量总分": "Total Performance Score",
  "各指标分数": "Scores by indicator",
  "{value} 分": "{value} points",
  "总分": "Total",
  "产品": "Products",
  "{value} 次": "{value} times",
  "每月平均发布次数": "Average number of releases per month",
  "每月平均发布成功率": "Average monthly rate of success",
  "成功率": "Success rate",
  "耗时1周内": "One week.",
  "耗时1-2周": "1 - 2 weeks",
  "耗时2-4周": "2-4 weeks",
  "耗时4周以上": "More than 4 weeks",
  "延期交付数量": "Number of postponed deliveries",
  "平均延期交付时间": "Average delay in delivery",
  "天数": "Days",
  "累积次数（个）": "Cumulative number(s)",
  "累积耗时（天）": "Cumulative time (days)",
  "全部反馈": "All Feedback",
  "我的反馈": "My feedback.",
  "手打标签": "Manual Tag",
  "请输入搜索反馈名称": "Please enter a search feedback name",
  "确定要将此反馈转为业务需求吗？": "Are you sure this feedback will be translated into business needs?",
  "执行完成": "Implementation complete",
  "待人工审核": "Pending manual review",
  "定时任务": "Scheduled Task",
  "执行中": "In Progress",
  "自动审核失败": "Automatic Review Failed",
  "执行异常": "Execution exception",
  "数据库变更详情": "Database change details",
  "系统发布详情": "Send details on the system",
  "待审核": "Pending review",
  "数据库变更": "Database changes",
  "配置变更": "Configure Changes",
  "系统发布": "System Release",
  "故障/事件": "Incident/Event",
  "权限变更": "Permission Change",
  "流量变更": "Traffic Change",
  "系统优化": "System optimization",
  "德国生产环境": "German Production Environment",
  "新加坡生产环境": "Singapore ' s Production Environment",
  "新加坡预发环境": "Advance Environment for Singapore",
  "德国预发环境": "Germany Advance Environment",
  "本地测试环境": "Local Test Environment",
  "杭州测试环境": "Hangzhou Test Environment",
  "德国灰度环境": "Greyscale Environment in Germany",
  "香港测试环境": "Hong Kong Test Environment",
  "开发环境": "Development environment",
  "消息列表": "Message List",
  "验收报告": "Receiving and inspection reports",
  "问卷": "Questionnaire",
  "元": "Dollar",
  "删除后无法恢复，请谨慎操作。": "If you cannot recover with the deletion, be careful.",
  "移出后该工作项将不再属于当前项目，可从项目外重新关联。": "When removed, the work item would no longer be a current item and could be reconnected from outside the project.",
  "当前为演示效果，后续会接入真实的需求 / 迭代 / 任务新增能力。": "Currently, for demonstration effects, follow-up access real needs / iterative / tasks add capabilities.",
  "项目里程碑明细": "Detailed project milestones",
  "是否需要关联遗漏需求与迭代？": "Is there a need to link missing needs to overlap?",
  "确定要删除该条风险吗？": "Are you sure the risk of the article should be deleted?",
  "确认将该风险标记为已处理？": "Confirm that the risk is marked as treated?",
  "删除后项目数据将无法恢复": "Project data cannot be restored after deletion",
  "张三": "Zhang San",
  "李四": "Li Siu",
  "王五": "Wang Hu!",
  "赵六": "Zhao",
  "孙七": "Sun Qi",
  "周八": "On a Saturday.",
  "吴九": "Wu Chiu.",
  "郑十": "Zheng Xiao",
  "王潇武": "Wang Xianwu.",
  "常峻": "Always.",
  "古静杨": "Gu Jing Yang",
  "陈晓": "Chen Xiao.",
  "林薇": "Lindsey.",
  "黄杨": "Young",
  "刘言": "Liu.",
  "徐鑫": "Seo-ho!",
  "毛俊": "Mao Jun!",
  "高玲": "Gauling.",
  "路通": "Pass.",
  "产品需求原型或需求文档是否准确，是否符合业务预期": "Prototype of product requirement or accuracy of requirement documentation and compliance with business expectations",
  "产品经理响应是否及时，是否及时解决问题": "Timely response by product managers and timely resolution of problems",
  "产品经理是否准确理解业务诉求，并能转化为合适的产品方案": "Accurate understanding of business requirements by product managers and their translation into appropriate product programmes",
  "与产品经理沟通过程是否顺畅，是否及时解决问题": "Whether the communication process with product managers is smooth and timely",
  "研发开发和交付效率是否满足业务预期": "Whether R & D and delivery efficiency meets business expectations",
  "产品功能交付质量是否满足业务预期": "Quality of product functional delivery meeting business expectations",
  "需求背景描述是否清晰": "Whether the requirement background description is clear",
  "问题描述是否清晰": "Is the description clear?",
  "产品方案是否合理": "Reasonability of product programmes",
  "原型或者需求设计是否清晰": "Is the prototype or needs design clear?",
  "事故数量": "Number of accidents",
  "请选择有效日期": "Please select a valid date",
  "事故明细": "Accident breakdown",
  "责任人排名": "Rank of duty bearers",
  "COE 详情": "COE Details",
  "平均恢复时长(天)": "Average recovery time (days)",
  "恢复时长(天)": "Recovery duration (days)",
  "Todo 数量": "Todo Number",
  "COE评论": "COE comments",
  "查看原文已修改评论": "View original modified comments",
  "删除回复": "Delete Response",
  "综合根因内容": "Synthesis of root causes",
  "由表及里，导致故障现象的直接原因是什么？": "What is the direct cause of the malfunction from the table and inside?",
  "如：MQ推送了旧脏数据": "For example: MQ sent old dirty data",
  "为什么会推送旧数据？": "Why send old data?",
  "如：未复用内存数据，查询了从库": "e.g. unused memory data, queryed from library",
  "为什么从库有旧数据？": "Why do you have old data from the library?",
  "如：主从同步延迟": "For example: Main delay from sync",
  "为什么会读从库？": "Why read from the library?",
  "如：上传与推送拆分两个方法": "For example, upload and push to split",
  "为什么拆分方法未合并？": "Why is the split not merged?",
  "如：过渡期双链路遗留": "For example: legacy of the two-link transition",
  "为什么没有自动告警？": "Why didn't you report it?",
  "如：仅监控通道可用性": "e.g., monitor channel availability only",
  "为什么缺数据一致性监控？": "Why is there no data consistency monitoring?",
  "如：未列入监控需求": "For example, monitoring needs are not included",
  "为什么没有自动熔断？": "Why isn't it automatically melting?",
  "如：消息均发送成功，无异常触发": "e.g. message was sent successfully and no anomaly triggered",
  "为什么定位困难？": "Why is it difficult to locate?",
  "如：日志无异常、无数据对比": "e.g. logs without anomalies, no data comparisons",
  "是否恢复上次未成功保存的内容？选择放弃将清除这份本机缓存。": "Restore last unsuccessfully saved content? Select to give up will clear this machine cache.",
  "COE新建表单章节": "COE New Form Chapter",
  "COE复盘章节": "COE Duplicate Section",
  "只看延期": "Just the extension.",
  "系统出现崩溃情况，现象：影响范围：": "System collapse, phenomenon: impact:",
  "数据导出失败，错误信息：影响业务：": "Data export failed, error message: influence business:",
  "发现数据异常，问题描述：错误数据示例：": "Discover data anomalies, problem description: examples of incorrect data:",
  "运营流程受阻，受阻环节：影响程度：": "Obstruction of business processes: degree of impact:",
  "当前输入框已有内容，确定要用模板覆盖吗？": "The current input box is already available, are you sure you want to overwrite it with a template?",
  "当前输入框已有内容，确定要清空吗？": "The current input box is already available, are you sure you want to empty it?",
  "响应时间": "Response Time",
  "处理时间": "Processing time",
  "bug类型": "bug type",
  "bug页面URL数": "bug Page URLs",
  "请勿重复点击": "Do Not Repeat Click",
  "飞书": "Flying Book.",
  "反馈者": "Feedback",
  "抄送": "Copy",
  "时间不能小于今天": "It can't be less than today.",
  "再建一行": "One more line.",
  "期待日期": "Expected date",
  "请选择期待完成时间": "Please select the expected completion date",
  "用例等级": "Example level",
  "主负责人": "Main Officer",
  "过程": "Process",
  "判断": "Decision",
  "观点一": "View one.",
  "观点二": "View II",
  "观点三": "View III",
  "观点四": "View four.",
  "需求ID": "requirement ID",
  "需求是否符合业务预期，是否符合产品规划": "Requirements are in line with business expectations and product planning",
  "功能是否完备，是否满足业务预期": "Fully functional and meeting business expectations",
  "功能是否流畅，是否满足业务预期": "Flow of functionality and compliance with business expectations",
  "设计是否符合业务预期，是否符合产品规划": "Design compliance with business expectations and product planning",
  "时间不能小于当前时间": "Time cannot be less than current time",
  "分享链接": "Share Link",
  "一键创建": "Create first key",
  "添加一行": "Add a line",
  "不能超过3天": "Not more than three days.",
  "内容不能超过15000个字符": "Content cannot exceed 15,000 characters",
  "需要培训师": "Need for trainers",
  "评审参与人": "Evaluation of participants",
  "请确认要申请发布吗？": "Please confirm your request for release?",
  "数据加载失败": "Loading data failed",
  "请选择预计上线日期": "Please select the projected date on line",
  "评审名称": "Name of the review",
  "评审类型": "Type of evaluation",
  "评审需求": "Evaluation needs",
  "评审Sprint": "ReviewSprint",
  "评审测试用例": "Examples of evaluation tests",
  "不预约": "No appointment.",
  "评审描述": "Evaluation description",
  "12人以下": "Less than 12",
  "13~20人": "13-20",
  "20人以上": "More than 20 persons",
  "电视": "Television",
  "投影": "Projection",
  "白板": "Whiteboard",
  "（点击催读）": "( clicks on reminder )",
  "研发工时": "R&D hours",
  "期望": "Expectations",
  "迭代例会": "An iterative meeting",
  "{b} : {c} 人天 ({d}%)": "{b}: {c} person-days ({d}%)",
  "{b}: {c} 人天": "{b}: {c} person-days",
  "工作项总数": "Total number of work items",
  "工作项完成数": "Number of work items completed",
  "工作项未完成数": "Tasks not completed",
  "关联产品数": "Number of associated products",
  "上传失败！": "Upload failed!",
  "预估时间范围": "Estimated time frame",
  "删除Sprint": "DeleteSprint",
  "（选择服务分支必须选择需求）": "(Selection of service branches must select requirement)",
  "时间不能为空": "Time cannot be empty.",
  "预估人天不能小于0": "One can't predict less than zero.",
  "预估人天不能超过3天，请拆解": "It can't be expected to last more than three days.",
  "数字越小越靠前；排序号相同时，最新创建的工作流靠前": "The smaller the number, the closer it is; when the sorting number is the same, the newly created task stream is forward",
  "不可编辑（": "Non-editable",
  "移除流转": "Remove flow",
  "添加流转": "Add flow",
  "新增流转规则（": "Add flow rule",
  "编辑流转规则（": "Edit flow rules",
  "移除流转规则（": "Remove flow rules",
  "系统会自动获取": "The system will be accessed automatically.",
  "，并与下方固定人员合并": "and merged with fixed personnel below",
  "一人同意": "One agreed.",
  "关闭后，该业务领域下的所有系统也会全部关闭，是否继续？": "Once closed, all systems under this practice will also be closed, and will they continue?",
  "业务领域名称(中)": "Name of business area (C)",
  "业务领域名称(英)": "Name of business area (E)",
  "创建系统": "Create System",
  "编辑系统": "Edit System",
  "系统唯一Key（全大写字母，中划线拼接）": "System only Key (full capital letters, threading)",
  "删除标签": "Remove Tab",
  "正在导出数据...": "Exporting data...",
  "导出失败，请稍后重试": "Export failed, please try again later",
  "只能上传jpg/png文件,且单个文件不超过10MB": "Only jpg/png files can be uploaded and no more than 10MB single files",
  "是否克隆服务基础信息": "Basic information on cloning services",
  "是否删除服务基础信息": "Delete Service Basic Information",
  "停用": "Disable",
  "添加更新明细": "Add Update Details",
  "规则名称": "Rule name",
  "规则描述": "Rule Description",
  "请输入至少五个字符": "Please enter at least five characters",
  "配置规则属性": "Configure Rules Properties",
  "监控对象": "Monitor Object",
  "规则模板": "Rule Template",
  "规则类型": "Rule Type",
  "设定调度周期": "Set schedule cycle",
  "周": "Week",
  "万": "10,000",
  "债务数量": "Number of obligations",
  "您有未保存的更改，确定要关闭吗？": "Do you have any unsaved changes that are sure to close?",
  "技术债务明细": "Technical debt breakdown",
  "显示选定应用类型在指定时间范围内的密钥创建数量趋势": "Show the trend in the number of key creations for the selected application type within the specified time frame",
  "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。": "umi is a scalable front-end enterprise application framework that is route-based and supports configuration and agreed routers to ensure that routers are functionally adequate and functionally expanded.",
  "antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。": "Antd is the React UI repository based on the Ant Design System, which is used mainly for the development of intermediate and backstage products at the enterprise level.",
  "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。": "ProCommponents is a much more abstract template component based on Ant Design, with one component being a page to develop the idea of a better experience of middle backstage development.",
  "加载失败": "Loading failed",
  "点击预览": "Click Preview",
  "{value0}核/{value1}GB": "{value0} cores / {value1} GB",
  "{value0} 小时": "{value0} hours",
  "{value0} 分钟": "{value0} minutes",
  "{value0} 秒": "{value0} seconds",
  "第{value0}-{value1} 条共 {value2} 条": "{value0}–{value1} of {value2}",
  "{value0}任务甘特图": "{value0} Task Gantt Chart",
  "确定要删除 {value0} 目录吗？": "Are you sure you want to delete the {value0} directory?",
  "确定要删除 {value0} 吗？": "Are you sure you want to delete {value0}?",
  "第{value0}-{value1}条/总共 {value2} 条": "{value0}–{value1} of {value2}",
  "共 {value0} 条": "{value0} items in total",
  "重新排班成功，共更新 {value0} 条排班记录": "Schedule rebuilt successfully. {value0} records were updated.",
  "补齐今日到截止日期（{value0} ~ {value1}）缺失的排班，已有排班不会覆盖": "Fill missing shifts from today through the end date ({value0}–{value1}). Existing shifts will not be overwritten.",
  "已自动填充 {value0} 个空缺岗位": "Automatically filled {value0} vacant positions.",
  "{value0} 值班表": "{value0} Duty Roster",
  "4周内交付率：{value0}": "Delivery Rate Within 4 Weeks: {value0}",
  "年度交付周数（{value0}）": "Annual Delivery Weeks ({value0})",
  "4周内：{value0}": "Within 4 Weeks: {value0}",
  "赠送卡片{value0}": "Send Card {value0}",
  "{value0} 送你了 {value1}": "{value0} sent you {value1}",
  "{value0} 天": "{value0} days",
  "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            </div>": "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} days</div>\n            </div>",
  "{value0}年-{value1}": "{value0} - {value1}",
  "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}年)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}year)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ",
  "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  总计: {value7} {value8}\n                </div>\n              ": "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  Total: {value7} {value8}\n                </div>\n              ",
  "模板{value0}": "Template {value0}",
  "最新{value0}: {value1}{value2}": "Latest {value0}: {value1}{value2}",
  "累计{value0}: {value1}{value2}": "Cumulative {value0}: {value1}{value2}",
  "{value0} 万次": "{value0} × 10,000",
  "{value0} 次": "{value0} times",
  "{value0}年": "{value0}",
  "{value0}指标": "{value0} Metric",
  "{value0} 月": "{value0}",
  "{value0} 文件上传失败": "Failed to upload {value0}",
  "仅查看{value0}": "View {value0} Only",
  "请选择{value0}": "Select {value0}",
  " • 搜索到 {value0} 个结果": " • {value0} results found",
  "点击查看{value0}任务详情": "Click to view {value0} task details",
  "正在渲染... ({value0}/{value1})": "Rendering... ({value0}/{value1})",
  "配置项目周报模板{value0}": "Configure Project Weekly Report Template {value0}",
  "共{value0}条 ": "{value0} items in total",
  "{value0}预约详情": "{value0} Appointment Details",
  "已提交回滚到版本 {value0}": "Rollback to version {value0} submitted.",
  "确认回滚到版本 {value0}？": "Roll back to version {value0}?",
  "申请回滚到版本 {value0}": "Request Rollback to Version {value0}",
  "申请调试 (Pod: {value0} 容器: {value1})": "Request Debugging (Pod: {value0}, Container: {value1})",
  "容器信息 ({value0})": "Container Information ({value0})",
  "{value0}重启请求已提交": "{value0} restart request submitted.",
  "是否重启该{value0}": "Restart this {value0}?",
  "确认要重启该{value0}吗？": "Are you sure you want to restart this {value0}?",
  "{value0}重启申请已提交": "{value0} restart application submitted.",
  "重启{value0}": "Restart {value0}",
  "申请重启{value0}": "Request {value0} Restart",
  "副本数已修改为 {value0}": "Replica count changed to {value0}.",
  "执行{value0}": "Execute {value0}",
  "申请{value0}": "Request {value0}",
  "确定要删除泳道组 \"{value0}\" 吗？此操作不可恢复。": "Delete swimlane group “{value0}”? This action cannot be undone.",
  "流量比例不能超过 {value0}%": "Traffic percentage cannot exceed {value0}%.",
  "流量比例必须在0-{value0}%之间": "Traffic percentage must be between 0 and {value0}%.",
  "确定要删除泳道 \"{value0}\" 吗？此操作不可恢复。": "Delete swimlane “{value0}”? This action cannot be undone.",
  "[{value0}] 前缀匹配 [{value1}]": "[{value0}] Prefix Match [{value1}]",
  "[{value0}] 正则匹配 [{value1}]": "[{value0}] Regex Match [{value1}]",
  "[{value0}] 百分比 [{value1}]": "[{value0}] Percentage [{value1}]",
  "第 {value0}-{value1} 条/总共 {value2} 条": "{value0}–{value1} of {value2}",
  "{value0} 灰度配置": "{value0} Canary Configuration",
  "最多还能添加 {value0} 个用户ID，当前待添加{value1}个": "You can add up to {value0} more user IDs; {value1} are pending.",
  "成功添加 {value0} 个用户ID": "Added {value0} user IDs successfully.",
  "{value0}秒": "{value0} seconds",
  "共 {value0} 条记录": "{value0} records in total",
  "服务发布流水线（{value0}）": "Service Release Pipeline ({value0})",
  "复制{value0}": "Copy {value0}",
  "查看问题 \n              {value0}": "View Issue\n{value0}",
  "{value0}万": "{value0}0,000",
  "{value0}年{value1}月{value2}日": "{value0}-{value1}-{value2}",
  "{value0} - {value1}详情": "{value0} - {value1} Details",
  "未来第{value0}周": "Week {value0} Ahead",
  "查看更多 (+{value0})": "View More (+{value0})",
  "{value0} 人天": "{value0} person-days",
  "{value0}人天": "{value0} person-days",
  "{value0}<br/>\n                  实际工时: {value1} 人天<br/>\n                  占比（实际工时/总工时）: {value2}%": "{value0}<br/>\nActual Effort: {value1} person-days<br/>\nShare (Actual/Total Effort): {value2}%",
  "部分指标已存在，已跳过：{value0}": "Some metrics already exist and were skipped: {value0}",
  "成功添加 {value0} 个指标": "Added {value0} metrics successfully.",
  "{value0}全年平均分": "{value0} Full-Year Average Score",
  "{value0}下半年平均分": "{value0} Second-Half Average Score",
  "{value0}上半年平均分": "{value0} First-Half Average Score",
  "{value0}年12月平均分": "December {value0} Average Score",
  "{value0}年{value1}月平均分": "{value1} {value0} Average Score",
  "{value0}月": "{value0}",
  "{value0}月指标对比（加权得分）": "{value0} Metric Comparison (Weighted Score)",
  "\n            <div>超期未完成</div>\n            <div>{value0}: {value1}个</div>\n          ": "\n            <div>Overdue and Incomplete</div>\n            <div>{value0}: {value1}</div>\n          ",
  "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} 个\n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} \n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ",
  "{value0}(天)": "{value0} (days)",
  "操作失败: {value0}": "Operation failed: {value0}",
  "总分: {value0}": "Total Score: {value0}",
  "统计区间：{value0}    数据量：{value1} 条": "Period: {value0}    Records: {value1}",
  "{value0} - {value1}指标明细": "{value0} - {value1} Metric Details",
  "统计区间：{value0}    成员数：{value1} 人": "Period: {value0}    Members: {value1}",
  "{value0}-{value1}指标明细-{value2}.xls": "{value0}-{value1}-metric-details-{value2}.xls",
  "{value0}-全角色指标明细-{value1}.xls": "{value0}-all-role-metric-details-{value1}.xls",
  "暂未配置{value0}成员": "No {value0} members configured",
  "当前筛选未命中{value0}指标": "No {value0} metrics match the current filters",
  "展开剩余 {value0} 人": "Show {value0} More",
  "展示团队指标当前值，并提供往年同比（%）对照（{value0} ~ {value1}）": "Shows current team metrics with year-over-year (%) comparisons ({value0}–{value1}).",
  "按角色展示成员指标明细表格，不同角色展示各自独立指标（{value0} ~ {value1}）": "Shows member metric details by role, with role-specific metrics ({value0}–{value1}).",
  "选择{value0}成员": "Select {value0} Members",
  "已选择 {value0} 人，可在下方微调": "{value0} selected. You can fine-tune the selection below.",
  "工专路 {value0} 号店": "Gongzhuan Road Store {value0}",
  "正向反馈: {value0}个 ({value1}%)": "Positive Feedback: {value0} ({value1}%)",
  "中性反馈: {value0}个 ({value1}%)": "Neutral Feedback: {value0} ({value1}%)",
  "负面反馈: {value0}个 ({value1}%)": "Negative Feedback: {value0} ({value1}%)",
  "平均时效: {value0}": "Average Resolution Time: {value0}",
  "待处理 {value0} 个反馈": "{value0} feedback items pending",
  "第 {value0}-{value1} 条/共 {value2} 条": "{value0}–{value1} of {value2}",
  "{value0} - 反馈详情": "{value0} - Feedback Details",
  "{value0} - {value1}反馈详情": "{value0} - {value1} Feedback Details",
  "点赞排行 - {value0}": "Like Ranking - {value0}",
  "{value0}情绪反馈详情": "{value0} Sentiment Feedback Details",
  "编辑{value0}": "Edit {value0}",
  "新增{value0}": "Add {value0}",
  "成功添加 {value0} 个属性": "Added {value0} attributes successfully.",
  "确定要删除 \"{value0}\" 吗？": "Delete “{value0}”?",
  "确定要删除 \"{value0}\" 及其所有子节点吗？": "Delete “{value0}” and all of its child nodes?",
  "编辑配置 - {value0} × {value1}": "Edit Configuration - {value0} × {value1}",
  "正在复制 {value0} × {value1} 的配置...": "Copying configuration from {value0} × {value1}...",
  "拖拽复制: {value0} × {value1}": "Drag to Copy: {value0} × {value1}",
  "成功添加 {value0} 个敏感词": "Added {value0} sensitive words successfully.",
  "确定要变更为\"{value0}\"状态吗？": "Change the status to “{value0}”?",
  "变更{value0}": "Change {value0}",
  "当前{value0}": "Current {value0}",
  "选择{value0}": "Select {value0}",
  "{value0}变更成功": "{value0} changed successfully.",
  "{value0}变更失败": "Failed to change {value0}.",
  "反馈原文：{value0}\n反馈翻译：{value1}\n详情链接：{value2}": "Original Feedback: {value0}\nTranslated Feedback: {value1}\nDetails: {value2}",
  "{value0} 至 {value1}": "{value0} to {value1}",
  "草稿 · {value0}": "Draft · {value0}",
  "所属空间: {value0}": "Space: {value0}",
  "业务领域: {value0}": "Business Domain: {value0}",
  "类型: {value0}": "Type: {value0}",
  "规模: {value0}": "Size: {value0}",
  "风险: {value0}": "Risk: {value0}",
  "替换 - {value0}": "Replace - {value0}",
  "添加 - {value0}": "Add - {value0}",
  "请选择要关联的{value0}": "Select the {value0} to link",
  "确定要删除里程碑「{value0}」吗？": "Delete milestone “{value0}”?",
  "第{value0}条：{value1}未填": "Row {value0}: {value1} is missing",
  "{value0} 万": "{value0}0,000",
  "预期ROI：{value0}%": "Expected ROI: {value0}%",
  "已选择 {value0} 星": "{value0} stars selected",
  "项目数: {value0}": "Projects: {value0}",
  "成员数: {value0}": "Members: {value0}",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} days</div>\n            ",
  "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}年)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ": "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}year)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ",
  "{value0}-事故报告": "{value0} - Incident Report",
  "{value0}({value1}项)": "{value0} ({value1} items)",
  "添加备注失败: {value0}": "Failed to add note: {value0}",
  "删除备注失败: {value0}": "Failed to delete note: {value0}",
  "请对{value0}进行评分": "Please rate {value0}",
  "{value0} 小时 {value1} 分钟": "{value0} hours {value1} minutes",
  "{value0} COE 看板": "{value0} COE Dashboard",
  " · {value0} 行": " · Row {value0}",
  "移除图片 {value0}": "Remove image {value0}",
  "展开 {value0} 条评论": "Show {value0} comments",
  "查看 {value0} 条原文已修改评论": "View {value0} comments whose source text changed",
  "原文已修改评论 ({value0})": "Comments with Changed Source Text ({value0})",
  "时间线第 {value0} 行": "Timeline Row {value0}",
  "节点 {value0}": "Node {value0}",
  "Todo 第 {value0} 行{value1}": "Todo Row {value0}{value1}",
  "当前为 {value0} 分钟，按发生时间和恢复时间计算为 {value1} 分钟。": "Current value: {value0} minutes; calculated from occurrence and recovery times: {value1} minutes.",
  "删除 {value0}？": "Delete {value0}?",
  "有 {value0} 条改进措施关联了该 Why，确认后将同时清空这些关联。": "{value0} improvement actions are linked to this Why. Confirming will remove those links as well.",
  "已自动暂存 {value0}": "Autosaved at {value0}",
  "提交数据缺少：{value0}，已定位到第一处": "Missing submission data: {value0}. The first occurrence has been located.",
  "{value0}成功，保存期间还有新的修改，已保留在当前页面和本机备份中": "{value0} succeeded. New changes made during saving remain on this page and in the local backup.",
  "请完善必填项：{value0}，已为你定位": "Complete the required field: {value0}. It has been located for you.",
  "还有 {value0} 处必填或格式校验未通过，已定位到第一处：{value1}": "{value0} required or format validations still fail. The first has been located: {value1}",
  "已延期 {value0} 天": "Overdue by {value0} days",
  "{value0}分钟": "{value0} minutes",
  "{value0}小时": "{value0} hours",
  "{value0}小时{value1}分钟": "{value0} hours {value1} minutes",
  "COE复盘名称：{value0}\n详情链接：{value1}": "COE Review: {value0}\nDetails: {value1}",
  "{value0}_告警记录": "{value0}_alert-records",
  "{value0}，拉群成功": "{value0}: group created successfully",
  "{value0}，拉群人数不足": "{value0}: not enough participants to create a group",
  "{value0}等": "{value0}, etc.",
  "{value0} 不是一个视频文件": "{value0} is not a video file",
  "业务需求{value0}": "Business Requirement {value0}",
  "{value0}_验收报告": "{value0}_acceptance-report",
  "「{value0} 」已绑定Sprint，请解绑后后绑定新的Sprint": "“{value0}” is already linked to a sprint. Unlink it before linking a new sprint.",
  "{value0} - {value1} (负责人: {value2})": "{value0} - {value1} (Owner: {value2})",
  "请输入{value0}相关内容": "Enter content related to {value0}",
  "你有未保存的更改，确定要{value0}吗？": "You have unsaved changes. Are you sure you want to {value0}?",
  "{value0}关联Bug记录": "{value0} Linked Bug Records",
  "已加载 {value0} 条数据": "Loaded {value0} records",
  "已加载 {value0}/{value1} 条数据": "Loaded {value0} of {value1} records",
  "已加载全部 {value0} 条数据": "Loaded all {value0} records",
  "（{value0}结束）": "({value0} ends)",
  "已选择{value0}个会议室：{value1}": "{value0} meeting rooms selected: {value1}",
  "  \n            日期: {value0}<br/>  \n            存量: {value1}<br/>  \n            操作: {value2}<br/>  \n            期望: {value3}  \n          ": "  \n            Date: {value0}<br/>  \n            Backlog: {value1}<br/>  \n            Change: {value2}<br/>  \n            Expected: {value3}  \n          ",
  "  \n            日期: {value0}<br/>  \n            期望: {value1}  \n          ": "  \n            Date: {value0}<br/>  \n            Expected: {value1}  \n          ",
  " 共{value0}人": "{value0} people in total",
  "选择需求（{value0}）的目标状态": "Select the target status for requirement ({value0})",
  "已经超期{value0}天": "Overdue by {value0} days",
  "还有{value0}天到期": "{value0} days remaining",
  "规划工时 {value0} 天": "Planned Effort: {value0} days",
  "审批节点{value0}": "Approval Node {value0}",
  "{value0} 时": "At {value0}",
  "赠送记录_{value0}.csv": "gift-records_{value0}.csv",
  "分发卡片-{value0}": "Distribute Cards - {value0}",
  "前{value0}": "Top {value0}",
  "卡片配置-{value0}": "Card Configuration - {value0}",
  "{value0} 年": "{value0}",
  "编辑版本 - {value0}{value1}": "Edit Version - {value0}{value1}",
  "更新明细 {value0}": "Update Details {value0}",
  "编辑{value0}的模版": "Edit {value0} Template",
  "查看{value0}的模版": "View {value0} Template",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3} 个 ({value4}%)\n              </div>\n              {value5}\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3}  ({value4}%)\n              </div>\n              {value5}\n            ",
  "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                总计: {value0} 个\n              </div>\n              ": "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                Total: {value0} \n              </div>\n              ",
  "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>数量: {value2} 个</div>\n          ": "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>Count: {value2} </div>\n          ",
  "{value0}天": "{value0} days",
  "模型名称 {value0} 已复制到剪贴板": "Model name {value0} copied to the clipboard.",
  "显示选定应用类型{value0}在指定时间范围内的配额使用量趋势，点击图表可查看详情": "Shows the quota usage trend for application type {value0} over the selected period. Click the chart for details.",
  "操作人：{value0}": "Operator: {value0}",
  "已催办当前审批节点未审批人：": "Reminded pending approvers at the current approval step:",
  "催办失败": "Catalyst failed.",
  "同意中...": "Approving...",
  "待我审批": "Pending My Approval",
  "我发起且审批中": "My Requests in Progress",
  "我发起且今日通过": "My Requests Approved Today",
  "我发起且今日驳回": "My Requests Rejected Today",
  "我发起且今日撤销": "My Requests Withdrawn Today",
  "未知岗位": "Unknown post",
  "自动轮转（业务领域负责人）": "Automatic Rotation (Business Domain Owner)",
  "自动轮转": "Automatic Rotation",
  "获取可赠送人员失败": "Failed to obtain giftee",
  "图片上传失败，请稍后重试": "Image upload failed, please try again later",
  "赠送失败，请稍后重试": "The gift failed. Please try again later.",
  "请点击选择会议室": "Click to select a meeting room",
  "我是研发": "I Am an R&D Engineer",
  "获取标签人员失败": "Failed to fetch labeler",
  "未命名需求": "Unnamed needs",
  "周报标题预览效果：": "Weekly Report Title Preview:",
  "DevOps可直接执行，每次回滚都会记录操作日志。": "DevOps can execute this directly. Every rollback is recorded in the operation log.",
  "该审批在通过后24小时内可重复用于此版本，每次执行都会记录操作日志。": "This approval can be reused for this version within 24 hours after approval. Every execution is recorded in the operation log.",
  "回滚申请已提交，审批通过后请再次点击该版本执行回滚": "Rollback request submitted. After approval, click this version again to execute the rollback.",
  "调试申请已提交": "Application for debugging submitted",
  "调试": "Debug",
  "副本数变更申请已提交": "Request for change in number of copies submitted",
  "开始调试": "Start debugging",
  "禁用成功": "Disable successfully",
  "启用成功": "Enabled successfully",
  "暂无匹配的泳道": "There's no match for the swimming lane.",
  "暂无泳道数据": "No swimming track data available.",
  "是否申请新加坡生产环境发布?": "Are you applying for a Singapore production environment release?",
  "是否创建非生产环境发布?": "Are non-production environment releases created?",
  "确定后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单（请先确保新加披uat已验证通过）": "Once identified, a Singapore production environment release application will be created, an approval process will be issued, and a release form will be created automatically (please ensure that the new capuat is validated)",
  "确定后会按服务顺序直接发布，并会根据发布载体类型创建或关联一个发布单": "When identified, it is published directly in order of service and a release form is created or associated with the type of vehicle to be published",
  "昨日": "Yesterday",
  "近7~14天": "Last 7–14 Days",
  "总反馈详情": "Overall feedback details",
  "编辑反馈类型失败": "Failed to edit feedback type",
  "新增反馈类型失败": "New feedback type failed",
  "根节点": "Root",
  "编辑失败": "Edit failed",
  "新增失败": "New Failed",
  "编辑配置失败": "Edit Configuration Failed",
  "新增配置失败": "New configuration failed",
  "编辑FAQ失败": "Failed to edit FAQ",
  "新增FAQ失败": "Failed to add FAQ",
  "编辑敏感词失败": "Failed to edit sensitive words",
  "新增敏感词失败": "Failed to add sensitive words",
  "上架成功": "It's working.",
  "下架成功": "Down!",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈详情链接：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\"># Feedback details link:</span></strong></p><p></p>",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\"># Feedback:</span></strong></p><p></p>",
  "创建工单失败": "Failed to create worksheet",
  "该工单不支持指派": "The worksheet does not support assignment",
  "预算更新失败": "Budget update failed",
  "获取项目实际人天失败": "Failed daily to get actual project",
  "里程碑已更新": "Milestone updated",
  "里程碑已新增": "Milestone added",
  "更新里程碑失败": "Failed to update milestone",
  "新增里程碑失败": "New milestone failed",
  "风险已更新": "Risk updated",
  "风险已新增": "Risk added",
  "更新风险失败": "Update risk failed",
  "新增风险失败": "New risk failed",
  "管理需求": "Management needs",
  "移出项目": "Remove Item",
  "编辑时间": "Edit Time",
  "未命名里程碑": "Unnamed milestones",
  "加载项目里程碑失败": "Failed to load project milestones",
  "解决风险失败": "Failed to address risk",
  "请完善项目基本信息、项目背景和项目团队信息": "Please improve basic project information, project background and project team information",
  "草稿保存失败": "Can not open message",
  "请完善必填信息": "Please complete the required information.",
  "基础": "Foundation",
  "研发/周报": "R&D / Weekly Reports",
  "流程/其他": "Workflow / Other",
  "加载看板数据失败": "Failed to load panel data",
  "评分失败": "Rating failed",
  "删除项目失败": "Failed to delete item",
  "开始项目失败": "Starting Project Failed",
  "发起立项审批失败": "Failed to initiate project approval",
  "完成项目失败": "Failed to complete project",
  "已收藏": "Collected",
  "已取消收藏": "Canceled Collection",
  "收藏操作失败": "Collection operation failed",
  "请选择是否与您沟通确认期待完成时间": "Please choose whether to communicate with you and confirm the expected completion time.",
  "暂存成功": "Suspend Successful",
  "暂存失败": "Suspend Failed",
  "COE 复盘": "COE Duplicate",
  "更新 COE 评论失败": "Failed to update COE comment",
  "保存 COE 回复失败": "Failed to save COE reply",
  "持续时长计算失败": "Duration calculation failed",
  "未填写故障名称，内容仅保存在本机": "No malfunction name completed, content stored on this machine only",
  "正在自动暂存…": "Suspended automatically...",
  "自动暂存失败，已保存在本机，联网后重试": "Auto suspense failed, saved on this machine, retrying after networking",
  "自动暂存失败，本机缓存空间不足，请手动暂存": "Auto-suspension failed. We don't have enough cache space. Please save manually",
  "等待自动暂存…": "Waiting for automatic suspense...",
  "未保存修改已备份到本机": "Unsaved changes backed up to this machine",
  "本机缓存空间不足，请尽快保存": "We don't have enough cache space. Please save it as soon as possible.",
  "附件仍在上传，请等待上传完成后再关闭": "Attachments are still uploading, please wait until upload is complete",
  "存在上传失败的附件，请删除或重新上传后再关闭": "Some attachments failed to upload. Remove or re-upload them before closing.",
  "附件仍在上传，请等待上传完成后再保存": "Attachments are still uploading, please wait until upload is complete",
  "存在上传失败的附件，请删除或重新上传后再保存": "Some attachments failed to upload. Remove or re-upload them before saving.",
  "保存失败，内容仍保留在当前页面和本机缓存中": "Save failed, content is still in the current page and machine cache",
  "如：迭代上线": "e.g. on-line",
  "选择操作人员": "Select Operator",
  "请输入备注，支持换行": "Please enter a comment to support the line break",
  "请输入根因总结，支持换行": "Please enter the semen summary to support the line break.",
  "请输入说明，支持换行": "Please enter a description to support the line break.",
  "请填写任务内容": "Please fill in the tasks.",
  "请输入任务内容，支持换行": "Please enter the job content to support the line break",
  "请选择交付时间": "Please select the delivery time",
  "如：履约轨迹缺失": "For example: missing track of compliance",
  "请选择故障责任组长": "Please select the Fault Leader.",
  "请选择故障责任人": "Please select the person responsible for the malfunction.",
  "请选择复盘组织者": "Please select a repeat organizer",
  "请选择复盘参与人": "Please select the participant for the reset.",
  "如：影响XX国家/XX业务线": "For example: influence XX country/XX line of operations",
  "如：12单 / 3个客户": "For example: 12/ 3 clients",
  "如：约2小时 / 10:00-12:00": "Examples: approximately 2 hours / 10 - 12 noon",
  "如：工单/群反馈/客服": "For example: worksheets/group feedback/client service",
  "如：异常订单1200单，说明统计口径": "e.g.: 1200 unusual orders, indicating the statistical calibre",
  "如：可追回，预计7月15日前完成": "If recoverable, expected to be completed by 15 July",
  "如：下游账务系统对账延迟": "For example, delays in the reconciliation of downstream accounts",
  "请选择用户/客户通知人": "Select a user/client notifier",
  "主值班": "Main shift",
  "备值班": "Stand by for duty.",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 以下为线上问题引用内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\"># Here's a quote from the online question:</span></strong></p><p></p>",
  "交接失败": "Handover failed",
  "非需求对接人与已完成状态无法操作变更": "Non-need-to-recipient and completed status cannot be changed",
  "业务需求.xlsx": "Operational requirements",
  "产品需求.xlsx": "Product requirement. xlsx",
  "后端任务-": "Backend Task -",
  "前端任务-": "Frontend Task -",
  "测试任务-": "Test Task-",
  "设计任务-": "Design Tasks -",
  "（提测申请）": "(application for testing)",
  "你有未保存的更改，确定要离开吗？": "Do you have any unsaved changes to make sure you're leaving?",
  "非需求产品经理无法操作变更": "The non-requirement product manager cannot operate the change",
  "存在相同的服务，请自行Merge到一个分支后保存，服务分别是": "If you have the same service, please save it from one branch to another.",
  "申请创建紧急发布单": "Application to create emergency release form",
  "申请创建发布单": "Application to create a release",
  "产品阶段": "Product stage",
  "请选择评审类型": "Select the type of evaluation",
  "需求按缺陷数量排名（单位：个)": "requirement ranked by number of deficiencies (in units)",
  "迭代需求燃尽图": "It's a burning-out.",
  "tips：需求状态流转维度": "Tips: requirement state flow dimension",
  "代码缺陷率（增量）排名（单位：％)": "Code Impairment Rate (Incremental) Rank (in %)",
  "千行代码缺陷率（全量）排名（单位：‰)": "thousands of line code defects (full) ranking (per thousand)",
  "工时容量": "Hour capacity",
  "预估工时": "Estimated working hours",
  "预估工时排名（单位：人天)": "Estimated hourly ranking (in person-days)",
  "实际工时排名（单位：人天）": "Number of actual hours worked (in person days)",
  "停用成功": "Disable successfully",
  "操作失败，请稍后重试": "Operation failed. Please try again later",
  "活动列表加载失败": "Failed to load active list",
  "元数据加载失败，请稍后重试": "Failed to load metadata. Try again later.",
  "更新并发布成功": "Update and release successfully",
  "创建并发布成功": "Created and published successfully",
  "草稿保存成功": "Draft saved successfully",
  "创建草稿成功": "Created draft successfully",
  "API Key总数": "Total API Key",
  "日新增": "Add Day",
  "日请求数量": "Number of requests per day",
  "标签设置失败": "Tab Settings Failed",
  "标签创建失败": "Label creation failed",
  "阶段": "Stage",
  "实时日志已连接...": "Live log connected...",
  "欢迎使用 Pod 调试功能，通过模拟终端的方式，方便快速进入容器进行调试。(注意：默认连接的 Shell 为 Bash)": "Welcome to Pod debugging. Use the simulated terminal to quickly access and debug the container. (The default shell is Bash.)",
  "控制台": "Console",
  "平均工时(小时)": "Average Effort (Hours)",
  "销售量": "Sales Volume",
  "不满": "Dissatisfied",
  "开始日期不能早于项目开始日期": "The start date cannot be earlier than the project start date.",
  "截止日期不能晚于项目截止日期": "The due date cannot be later than the project due date.",
  "结束日期": "End Date",
  "请选择开始日期": "Select a start date",
  "请选择预计完成时间": "Select an estimated completion time",
  "如：合并双链路代码": "Example: merge dual-path code",
  "如：强制架构评审": "Example: require architecture review",
  "如：完善测试场景": "Example: improve test scenarios",
  "如：新增数据一致性校验告警": "Example: add data consistency validation alerts",
  "如：新增计税金额波动监控": "Example: monitor taxable-amount fluctuations",
  "如：建立客户侧数据日报": "Example: create a daily client-side data report",
  "如：消息推送异常自动熔断": "Example: automatically stop abnormal message delivery",
  "如：批量订正工具": "Example: bulk correction tool",
  "如：一键回滚机制": "Example: one-click rollback",
  "如：请求链路全量日志": "Example: full request-chain logging",
  "如：数据对比工具": "Example: data comparison tool",
  "请等待附件上传完成": "Wait for the attachments to finish uploading.",
  "请删除上传失败的附件后重试": "Remove failed attachments and try again.",
  "发现时间不能早于发生时间": "The discovery time cannot be earlier than the occurrence time.",
  "恢复时间不能早于发现时间": "The recovery time cannot be earlier than the discovery time.",
  "内部原因必须选择归属部门": "A department is required for internal causes.",
  "交付开始时间": "Delivery Start Time",
  "交付结束时间": "Delivery End Time",
  "极差": "Very Poor",
  "失望": "Disappointed",
  "惊喜": "Delighted",
  "无标题": "Untitled",
  "不限": "No Limit",
  "请选择提醒周期": "Select a reminder frequency",
  "请选择提醒小时": "Select a reminder hour",
  "催办失败，请稍后重试": "Failed to send the reminder. Try again later.",
  "任务信息": "Task Information",
  "名称：": "Name:",
  "链接：": "Link:",
  "人员已失效（自动轮转）": "User Inactive (Automatic Rotation)",
  "值班表名称：": "Duty Roster Name:",
  "值班表链接：": "Duty Roster Link:",
  "上传失败，未返回文件URL": "Upload failed: no file URL was returned.",
  "主播粉丝": "Creator Fans",
  "超跑礼物": "Supercar Gift",
  "模板存量": "Template Backlog",
  "模板已解决": "Resolved Templates",
  "无数据": "No Data",
  "01月": "January",
  "02月": "February",
  "03月": "March",
  "04月": "April",
  "05月": "May",
  "06月": "June",
  "07月": "July",
  "08月": "August",
  "09月": "September",
  "10月": "October",
  "11月": "November",
  "12月": "December",
  "缺陷名称：": "Bug Name:",
  "问题反馈人：": "Reporter:",
  "详情链接：": "Details:",
  "需求名称：": "Requirement Name:",
  "需求链接：": "Requirement Link:",
  "暂无会议": "No Meeting",
  "邀请你参加评审": "invited you to a review",
  "评审主题：": "Review Topic:",
  "评审详情链接：": "Review Details:",
  "评审类型：": "Review Type:",
  "评审时间：": "Review Time:",
  "评审地点：": "Review Location:",
  "会议链接：": "Meeting Link:",
  "评审资料：": "Review Materials:",
  "点击升序排列": "Click to sort ascending",
  "点击降序排列": "Click to sort descending",
  "点击取消排序": "Click to clear sorting",
  "未分组": "Ungrouped",
  "当前：按开始时间排序": "Current: Sorted by Start Time",
  "当前：按结束时间排序": "Current: Sorted by End Time",
  "始": "Start",
  "终": "End",
  "需求创建时间：": "Requirement Created At:",
  "_%Y%W周报": "_%Y%W-weekly-report",
  "%N_%Y%W周报": "%N_%Y%W-weekly-report",
  "已配置项目周报模板": "Project Weekly Report Template Configured",
  "%N_%Y%W_%B%P周报": "%N_%Y%W_%B%P-weekly-report",
  "周报标题：": "Weekly Report Title:",
  "未知职位": "Unknown position",
  "刚刚": "Just Now",
  "申请人同时为本节点审批人，系统已跳过": "The requester is also the approver for this step, so the system skipped it.",
  "当前操作无需审批，可以立即执行": "This operation does not require approval and can be executed immediately.",
  "你同时是审批人，命中的审批节点已自动跳过，可以立即执行操作": "You are also the approver. The matching approval steps were skipped automatically, so you can execute the operation now.",
  "你同时是审批人，命中的审批节点已自动跳过，其余节点继续审批": "You are also the approver. Matching approval steps were skipped automatically; the remaining steps will continue.",
  "审批已通过，可以立即执行操作": "Approval completed. You can execute the operation now.",
  "重复提交": "Repeat",
  "发布单名称：": "Release Request Name:",
  "发布单类型：": "Release Request Type:",
  "漏洞数": "Vulnerabilities",
  "Bug数": "Bugs",
  "在职": "Active",
  "离职": "Departed",
  "当前值": "Current Value",
  "Canvas转换失败": "Canvas conversion failed.",
  "获取图片URL失败": "Failed to get the image URL.",
  "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">指标释义</Data> </Cell>": "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">Definitions of indicators</Data> </Cell>",
  "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">团队均值</Data> </Cell>": "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">Group average</Data> </Cell>",
  "样本个数": "Samples",
  "里程碑个数": "Milestones",
  "需求个数": "Requirements",
  "缺陷个数": "Bugs",
  "事故个数": "Incidents",
  "债务个数": "Technical Debts",
  "指标值": "Metric Value",
  "指标达成率": "Metric Achievement Rate",
  "总计需求数": "Total Requirements",
  "可以配置各国、各反馈来源中的App Tab页，如：首页、产品页、用户页、设置页等": "App Tab pages for countries, feedback sources, e.g. home pages, product pages, user pages, settings, etc.",
  "可以配置各国、各反馈来源中的常见问题解答，支持多语言配置": "Common questions and answers from countries, feedback sources can be configured to support multilingual configurations",
  "可可以配置各国、各反馈来源中的功能，如：是否支持上传视频等": "The functions of each country, each source of feedback, e.g., whether or not to support uploading, etc., can be configured",
  "可以配置各国、各反馈来源中的反馈主次类型，如：产品问题、功能问题、性能问题、体验问题、其他问题等": "Countries can be configured, the main types of feedback in each source, such as product issues, functional issues, performance issues, experience issues, other issues, etc.",
  "App Tab页管理": "App Tab Management",
  "功能管理": "Functional management",
  "反馈类型管理": "Type of feedback management",
  "App Tab页": "App Tab Page",
  "新增Tab页": "Add Tab Page",
  "批量添加FAQ": "Batch Add FAQ",
  "批量添加反馈类型": "Batch Add Type of Feedback",
  "批量添加App Tab页": "Batch Add App Tab Page",
  "批量添加属性": "Batch Add Properties",
  "（已完成）": "(Completed)",
  "关键结果不能为空": "Key results cannot be empty.",
  "权重不能为空": "Weights cannot be empty.",
  "验收时间不能为空": "We can't take time off.",
  "验收人不能为空": "The receiver can't be empty.",
  "验收标准不能为空": "The acceptance standards cannot be empty.",
  "关联需求/迭代": "Associated needs/overlapping",
  "继续完成项目": "Continue project completion",
  "完成验收": "Acceptance completed",
  "如果里程碑已经开始，需要变更里程碑信息，可联系 Zola 周华": "Zola Zhouhua, if the milestone has already begun, you need to change the milestone information.",
  "请至少添加一条项目关键里程碑": "Please add at least one key project milestone",
  "业务起草": "Operational drafting",
  "创建项目 - 业务起草": "Create Project - Business Drafting",
  "技术起草": "Technical drafting",
  "编辑项目": "Edit Item",
  "平均解决时长(天)": "Average resolution time (days)",
  "处理时长(天)": "Length of processing (days)",
  "事故名称：": "Name of incident:",
  "新增事故报告": "New accident report",
  "编辑事故报告": "Edit incident report",
  "哪怕把CPU干冒烟、把内存条烧成灰、把我自己加载成地中海，也保证给您推送完！🚬🔥": "Even if we dry the CPU, burn the memory bars to ashes, and load myself into the Mediterranean Sea, we'll push you out! Zenium",
  "别急，页面正在和网速搏斗中🤼": "Don't worry. The page is fighting the Internet.",
  "哪怕把服务器薅秃、把网线搓出火花、把我自己加载到发际线后移三厘米，也一定把您的邮箱页面完整送到！💻🦲": "Even if the server is bald, if the wires are sparkled, if I load myself up to the hairline and move three centimeters, I'm sure I'll get your mailbox page to complete! Zenium",
  "您放心，今天哪怕加班到头发掉光、咖啡喝到洗胃、服务器被我哄到崩溃重启，我也一定把您的邮件页面怼出来！☕🦲": "Don't worry, I'll have your mail page posted today even after my hair has gone out, my coffee has gone to the stomach wash, my server has crashed and restarted! Zenium",
  "未定级": "No rating",
  "请选择统计时间范围": "Select the statistical time frame",
  "当前用户": "Current User",
  "未命名附件": "Unnamed Attachment",
  "表单字段": "Table Fields",
  "自动暂存失败": "Auto suspense failed",
  "编辑执行人": "Edit Executor",
  "编辑关联需求": "Edit Association Needs",
  "未延期": "Not extended",
  "恢复时间不能早于发生时间": "Recovery should not take place before",
  "反馈人：": "Feedback:",
  "指派给：": "Assigned to:",
  "需求提出人：": "Requester:",
  "必填项未填写": "Required entries not completed",
  "切换": "Switch",
  "邀请你参加例会/评审": "Invite you to regular meetings/reviews.",
  "例会/评审主题：": "Regular meetings/review themes:",
  "例会/评审详情链接：": "Links to regular meetings/review details:",
  "例会/评审类型：": "Type of regular meeting/evaluation:",
  "例会/评审时间：": "Regular meetings/evaluations:",
  "例会/评审地点：": "Place of regular meeting/review:",
  "例会/会议链接：": "Regular/meeting links:",
  "例会/评审资料：": "Regular meetings/evaluation of information:",
  "迭代名称：": "Organisation",
  "迭代负责人：": "Officer-in-Charge:",
  "Sprint名称：": "Sprint name:",
  "迭代数据不存在": "The iterative data does not exist",
  "只有状态为\"未开始\"或\"进行中\"的迭代才能操作": "Only if the state is \"not started\" or \"ongoing\" iterative.",
  "无法获取当前用户信息": "Unable to get the current user information.",
  "非迭代负责人无法操作": "The non-hierarchical head cannot operate",
  "任务名称：": "_Other Organiser",
  "无作用域": "No field",
  "接收人ID": "Recipient ID",
  "部门ID": "Sector ID",
  "时间未知": "Time unknown",
  "新建卡片": "New Card",
  "表一": "Table 1",
  "表二": "Table 2",
  "规则模板一": "Rule Template 1",
  "规则模板二": "Rule Template 2",
  "人员排名": "Rank",
  "债务名称：": "Name of obligation:",
  "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif": "Microsoft YaHei=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif",
  "苹果苹方=PingFang SC,Microsoft YaHei,sans-serif": "PingFang SC=PingFang SC,Microsoft YaHei,sans-serif",
  "宋体=simsun,serif": "SimSun=simsun,serif",
  "仿宋体=FangSong,serif": "FangSong=FangSong,serif",
  "黑体=SimHei,sans-serif": "SimHei=SimHei,sans-serif",
  "指标释义": "Metric Definition",
  "团队均值": "Team Average",
  "重开项": "Reopened Items",
  "需求设计缺陷项": "Requirement Design Defects",
  "按系统审批流配置": "Configured by System Approval Workflow",
  "需求统计.xlsx": "requirement-statistics.xlsx",
  "未设置时间": "Time Not Set",
  "项目创建": "Project Created",
  "添加成员：李四": "Added Member: Li Si",
  "开始第一个Sprint": "Started the First Sprint",
  "系统研发接口人": "System R&D Contact",
  "发布协同组": "Release Coordination Group",
  "确认人": "Confirmer",
  "关闭人": "Closer",
  "慢SQL模板记录.xlsx": "slow-sql-template-records.xlsx",
  "正在连接中": "Connecting",
  "已经连接并且可以通讯": "Connected",
  "连接正在关闭": "Closing Connection",
  "连接已关闭或者没有连接成功": "Disconnected or Connection Failed",
  "role.badge.product": "PM",
  "role.badge.developer": "Dev",
  "role.badge.tester": "QA",
  " ": " ",
  "pages.common.deleteConfirm": "Confirm Deletion",
  "pages.common.deleteConfirmDesc": "Are you sure you want to delete task “{name}”?",
  "pages.common.ok": "OK",
  "pages.common.cancel": "Cancel",
  "pages.common.deleteSuccess": "Deleted successfully",
  "please.select.release.order": "Select a release request",
  "pages.bug.responsiblePerson": "Owner",
  "pages.bug.joining": "Please do not click repeatedly",
  "任务数": "Tasks",
  "前端预计完成时间": "Estimated Frontend Completion Time",
  "后端预计完成时间": "Estimated Backend Completion Time",
  "测试预计完成时间": "Estimated Testing Completion Time",
  "pages.system.form.selectUiDesign": "Select a UI designer",
  "pages.system.form.systemName": "Enter a name!",
  "pages.searchTable.updateForm.ruleConfig": "Rule Configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Configuration",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules": "Enter a rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "Enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules": "Enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Rule Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title": "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Start Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "Select a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.titleCallNo": "Service Calls",
  "pages.searchTable.tenThousand": "10,000",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "Shut Down",
  "pages.searchTable.nameStatus.running": "Running",
  "pages.searchTable.nameStatus.online": "Online",
  "pages.searchTable.nameStatus.abnormal": "Abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled At",
  "pages.searchTable.exception": "Enter the reason for the exception!",
  "pages.searchTable.titleOption": "Actions",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to Alerts",
  "pages.searchTable.title": "Query Table",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "Selected",
  "pages.searchTable.item": "items",
  "pages.searchTable.totalServiceCalls": "Total Service Calls",
  "pages.searchTable.batchDeletion": "Batch Delete",
  "pages.searchTable.batchApproval": "Batch Approve",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.bug.feedbackUserCode": "Reporter",
  "pages.layouts.userLayout.title": "Ant Design is the most influential web design specification in Xihu district",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage": "Faster and stronger heavy-duty components have been released.",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage": "umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.common.createDate": "Create time",
  "pages.common.id": "ID",
  "pages.common.createUserName": "Created by",
  "pages.common.lastUpdDate": "Update time",
  "pages.common.lastUpdUserName": "Updated by",
  "pages.common.option": "Operation",
  "pages.common.create": "New",
  "pages.common.apply": "Apply",
  "pages.common.edit": "Edit",
  "pages.common.delete": "Delete",
  "pages.common.restore": "Restore",
  "pages.common.copy": "Clone",
  "pages.common.status": "Status",
  "pages.common.share": "Share",
  "pages.common.tag": "Tag",
  "pages.common.productManagerName": "Product Manager",
  "pages.common.uiDesignName": "UI Design",
  "pages.common.developName": "Backend Development",
  "pages.common.frontWebName": "Front-end Development",
  "pages.common.testEngineerName": "Test Development",
  "pages.common.testName": "Test",
  "pages.common.itSupportName": "Technical Support",
  "pages.common.businessCounterpartName": "Business counterpart",
  "pages.common.form.selectProduct": "Please select product manager",
  "pages.common.form.selectBusinessCounterpartName": "Please select business counterpart",
  "pages.common.form.selectUdDesign": "Please select UI design",
  "pages.common.form.selectDev": "Please select backend development",
  "pages.common.form.selectFont": "Please select front-end development",
  "pages.common.form.selectTest": "Please select test development",
  "pages.common.form.selectSupport": "Please select technical support",
  "pages.common.startTime": "Start time",
  "pages.common.endTime": "End time",
  "pages.common.colSetting": "Column settings",
  "pages.common.closed": "Archived",
  "pages.common.filter": "Filter",
  "pages.common.clear": "Clear",
  "pages.common.notarize": "Confirm",
  "pages.common.addRemark": "Add remark",
  "pages.common.assign": "Assign handler",
  "pages.common.cardUnit": "pcs",
  "pages.business.businessNameCn": "Business Area (CN)",
  "pages.business.businessNameEn": "Business Area (EN)",
  "pages.business.systemId": "Related System",
  "pages.business.title": "Business Area",
  "pages.system.updateForm.schedulingPeriod.timeLabel": "Start time",
  "pages.system.updateForm.schedulingPeriod.timeRules": "Please select a start time! ",
  "pages.system.status": "Enable Status",
  "pages.system.title": "System",
  "pages.system.name": "System Name",
  "pages.system.systemId": "System ID (associated with Jira SystemId)",
  "pages.system.systemKey": "System Key",
  "pages.system.ruleName": "System name is required",
  "pages.system.businessName": "Business Area",
  "pages.system.businessNameEn": "Business Area - English",
  "pages.system.leaderUserName": "System Leader",
  "pages.system.businessLeaderUserName": "Business Area Leader",
  "pages.system.businessUserCount": "Business Participants Count",
  "pages.system.systemDesc": "System Description",
  "pages.system.exception": "Please enter the reason for the exception! ",
  "pages.system.form.businessName": "Business Area",
  "pages.system.form.systemKey": "System Key (unique)",
  "pages.system.form.selectBusiness": "Please select a business area",
  "pages.system.form.selectSystemLeader": "Please select system leader",
  "pages.system.form.inputSystemName": "Please enter system name",
  "pages.system.form.inputSystemId": "Please enter associated Jira system ID",
  "pages.system.form.inputSystemKey": "Please enter system Key",
  "pages.system.form.robotId": "Robot ID",
  "pages.businessIssue.productManagerName": "Product Contact",
  "pages.businessIssue.productManagerName2": "Contact",
  "pages.businessIssue.businessSideInfo": "Proposer",
  "pages.businessIssue.businessRelatedInfo": "Related Person",
  "pages.businessIssue.pengingTime": "Waiting Duration (Days)",
  "pages.businessIssue.pengingTime2": "Waiting Duration",
  "pages.businessIssue.expectDate": "Expected Completion Time",
  "pages.businessIssue.relatedIssues": "Related Product Requirements",
  "pages.businessIssue.relatedIssuesCount": "Related Product Requirements Count",
  "pages.businessIssue.createProductIssue": "Create Product Requirement",
  "pages.issuePool.issueId": "Serial Number",
  "pages.issuePool.issueName": "Requirement Name",
  "pages.issuePool.system": "System",
  "pages.issuePool.relatedUser": "Related Person (CC)",
  "pages.issuePool.complexRate": "Complexity",
  "pages.issuePool.sourceDesc": "Requirement Source",
  "pages.issuePool.country": "Country",
  "pages.issuePool.label": "Label",
  "pages.issuePool.priorityLevel": "Priority",
  "pages.issuePool.sprint": "Sprint",
  "pages.issuePool.expectDate": "Expected Completion Time",
  "pages.issuePool.completeDate": "Actual Completion Time",
  "pages.issuePool.expectDate2": "Expected Completion",
  "pages.issuePool.completeDate2": "Actual Completion",
  "pages.issuePool.reviewDate": "Review (Meeting) Time",
  "pages.issuePool.allReviewDate": "Time",
  "pages.issuePool.relatedIssues": "Related Requirements",
  "pages.issuePool.follower": "Follow",
  "pages.issuePool.cancelFollower": "Unfollow",
  "pages.issuePool.transfer": "Transfer System",
  "pages.issuePool.planName": "Plan Name",
  "pages.issuePool.allIssues": "All Requirements",
  "pages.issuePool.currentSprint": "View Current Sprint",
  "pages.issuePool.taskCnt": "Task Count",
  "pages.issuePool.release": "Create Release Order",
  "pages.issuePool.isTechnical": "Technical Requirement",
  "pages.issuePool.isRequireTrainer": "Requires System Training",
  "pages.issuePool.addPlan": "Bind Requirement to Sprint (default shows Sprint of requirement system)",
  "pages.issuePool.follewUsers": "Followers",
  "pages.issuePool.taskTotalTime": "Total Task Time",
  "pages.issuePool.taskTime": "Task Time",
  "pages.issuePool.form.selectIssueName": "Please enter title",
  "pages.issuePool.form.selectExpectDate": "Please select expected date",
  "pages.issuePool.form.selectComplexRate": "Please select complexity",
  "pages.issuePool.form.selectPriorityLevel": "Please select priority",
  "pages.issuePool.form.estimatedPersonDay": "Estimated Person Days",
  "pages.issuePool.form.businessReviewName": "Business Review Name",
  "pages.issuePool.form.collaborativeIssue": "Collaborative Requirement",
  "pages.issuePool.form.relatedSprint": "Related Sprint",
  "pages.issuePool.form.country": "Requirement Impact Country",
  "pages.issuePool.form.isRequireTrainer": "Whether System Training is Required",
  "pages.release.collaboratorList": "Collaborators",
  "pages.release.Date": "Release Date",
  "pages.issueReview.name": "Review (Meeting) Name",
  "pages.issueReview.allName": "Name",
  "pages.issueReview.createUserName": "Initiator",
  "pages.issueReview.reviewUsers": "Review (Meeting) Participants",
  "pages.issueReview.status": "Review (Meeting) Status",
  "pages.issueReview.reviewType": "Review (Meeting) Type",
  "pages.issueReview.reviewReadCount": "Confirmation Status",
  "pages.issueReview.reviewTime": "Estimated Review Time",
  "pages.issueReview.relatedIssueCount": "Related Requirements Count",
  "pages.issueReview.meetingCount": "Meeting Count",
  "pages.issueReview.meetingCode": "Click to Copy Meeting Code",
  "pages.issueReview.createMeeting": "Initiate Meeting",
  "pages.issueReview.editMeeting": "Edit Meeting",
  "pages.issueReview.cancelMeeting": "Cancel Meeting",
  "pages.issueReview.cancelReview": "Delete Review",
  "pages.issueReview.ReviewAgain": "Review Again",
  "pages.issueReview.reviewDesc": "Review (Meeting) Description",
  "pages.issueReview.form.meetingName": "Review Meeting Name",
  "pages.issueReview.form.allMeetingName": "Meeting Name",
  "pages.issueReview.form.meetingTime": "Meeting Duration",
  "pages.issueReview.form.reviewMeetingDesc": "Review Meeting Description",
  "pages.issueReview.form.allReviewMeetingDesc": "Meeting Description",
  "pages.issueReview.form.plan": "Plan",
  "pages.issueReview.form.issues": "Requirement",
  "pages.issueReview.form.reviewMeetingContent": "Review Meeting Minutes",
  "pages.issueReview.issuePool.unReadCount": "Unread Count",
  "pages.issueReview.issuePool.unReadUser": "Unread Users",
  "pages.issueReview.issuePool.readCount": "Read Count",
  "pages.issueReview.issuePool.readUser": "Read Users",
  "pages.issueReview.meetingRemindBefores": "Remind Before Start",
  "pages.sprint.name": "Sprint Name",
  "pages.sprint.owner": "Owner",
  "pages.sprint.goal": "Sprint (Iteration) Goal",
  "pages.sprint.issueCnt": "Requirement Count",
  "pages.sprint.cycle": "Cycle (GMT+8)",
  "pages.sprint.budget": "Person Day Budget (Day)",
  "pages.sprint.isSynergy": "Collaborative Planning",
  "pages.sprint.plan": "Sprint Planning",
  "pages.sprint.version": "Version Number",
  "pages.sprint.createVersion": "Create Iteration",
  "pages.sprint.form.time": "Start - End",
  "pages.sprint.form.issues": "Requirement",
  "pages.sprint.add.issue": "Add Requirement",
  "pages.sprint.systemNames": "System",
  "pages.task.id": "Task ID",
  "pages.task.name": "Task Name",
  "pages.task.type": "Type",
  "pages.task.complexRate": "Complexity",
  "pages.task.priorityLevel": "Priority",
  "pages.task.status": "Status",
  "pages.task.owner": "Owner",
  "pages.task.taskParticipants": "Participants",
  "pages.task.task": "Task Detail List",
  "pages.task.estimatedPersonDay": "Estimated Person Days",
  "pages.task.issues": "Requirement",
  "pages.task.serviceType": "Service Type",
  "pages.task.service": "Service",
  "pages.task.branch": "Branch",
  "pages.task.overtime": "Overdue",
  "pages.task.form.time": "Start - End",
  "pages.task.sprint": "Iteration",
  "pages.test.caseName": "Case Name",
  "pages.test.systemName": "System",
  "pages.test.issueName": "Requirement",
  "pages.test.moduleName": "Module",
  "pages.test.caseLevel": "Case Level",
  "pages.test.reviewStatusDesc": "Review Status",
  "pages.test.fileName": "File Name",
  "pages.bug.title": "Title",
  "pages.bug.system": "System",
  "pages.bug.issue": "Requirement",
  "pages.bug.severityLevel": "Severity Level",
  "pages.bug.priorityLevel": "Priority",
  "pages.bug.implementationPlan": "Implementation Plan",
  "pages.bug.bugType": "Bug Type",
  "pages.bug.proposer": "Reporter",
  "pages.bug.assignedUser": "Assigned To",
  "pages.bug.assignedDate": "Assigned Time",
  "pages.bug.relatedIssueInfos": "Related Requirements",
  "pages.bug.deadline": "Deadline",
  "pages.bug.relatedIssuesCount": "Related Product Requirements Count",
  "pages.bug.bugPageUrlsCnt": "Bug Page URLs Count",
  "pages.bug.responseTime": "Response Time",
  "pages.bug.processingTime": "Processing Time",
  "pages.bug.waitingCloseTime": "Waiting to Close",
  "pages.bug.waitingTime": "Total Time",
  "pages.bug.carbonCopyUser": "CC",
  "pages.bug.operatingSystem": "Operating System",
  "pages.bug.resolvedUser": "Resolver",
  "pages.bug.confirmedDate": "Confirmed Time",
  "pages.bug.resolvedDate": "Resolved Time",
  "pages.bug.closedUser": "Closer",
  "pages.bug.closedDate": "Closed Time",
  "pages.bug.confirm": "Confirm",
  "pages.bug.resolve": "Resolve",
  "pages.bug.reopen": "Reopen",
  "pages.bug.closed": "Closed",
  "pages.bug.reminder": "Reminder",
  "pages.bug.clone": "Clone",
  "pages.bug.join": "Join Group",
  "pages.codeQuality.title": "Project/Service",
  "pages.codeQuality.type": "Category",
  "pages.codeQuality.lines": "Total Lines of Code",
  "pages.codeQuality.changeLines": "Code Lines Change",
  "pages.codeQuality.addLines": "Incremental Code Lines",
  "pages.codeQuality.allLines": "Total Lines of Code",
  "pages.codeQuality.bugs": "Defect Count",
  "pages.codeQuality.bugDensity": "Defect Rate per 1000 Lines (‰)",
  "pages.codeQuality.addBugDensity": "Incremental Code Defect Rate (%)",
  "pages.codeQuality.allBugDensity": "Total Defect Rate per 1000 Lines (‰)",
  "pages.efficiencyDashboard.title": "Requirement Delivery Overview",
  "pages.efficiencyDashboard.issueStatistics": "Requirement Stock Statistics",
  "pages.efficiencyDashboard.stockCount": "Total Stock",
  "pages.efficiencyDashboard.pendingInterventionsCount": "Pending Intervention",
  "pages.efficiencyDashboard.suspendedCount": "Suspended",
  "pages.efficiencyDashboard.underSolutionCount": "In Solution",
  "pages.efficiencyDashboard.toBeDevelopedCount": "To Be Developed",
  "pages.efficiencyDashboard.underDevelopmentCount": "Under Development",
  "pages.efficiencyDashboard.recentSevenDayDasboard": "Recent 7 Days Requirement Overview",
  "pages.efficiencyDashboard.newCount": "New",
  "pages.efficiencyDashboard.closeCount": "Closed",
  "pages.efficiencyDashboard.totalReleaseCount": "Total Releases",
  "pages.efficiencyDashboard.normalReleaseCount": "Normal Releases",
  "pages.efficiencyDashboard.emergencyReleaseCount": "Emergency Releases",
  "pages.efficiencyDashboard.delayedUnpublishedCount": "Delayed Unpublished",
  "pages.efficiencyDashboard.recentSevenDayQuality": "Recent 7 Days Requirement Quality",
  "pages.efficiencyDashboard.handledWaitTime": "Requirement Wait Time (Handled) Unit: hours",
  "pages.efficiencyDashboard.designTime": "Requirement Design Time (Handled) Unit: hours",
  "pages.efficiencyDashboard.recentSevenDayOption": "Recent 7 Days Operations",
  "pages.efficiencyDashboard.changeCount": "Status Change Count",
  "pages.polarDB.log.id": "ID",
  "pages.polarDB.log.environment": "Environment",
  "pages.polarDB.log.dbClusterId": "Cluster ID",
  "pages.polarDB.log.dbName": "Database",
  "pages.polarDB.log.dbNodeId": "Node ID",
  "pages.polarDB.log.executionStartTime": "SQL Execution Time (UTC)",
  "pages.polarDB.log.hostAddress": "Client Address",
  "pages.polarDB.log.lockTimes": "SQL Lock Duration (seconds)",
  "pages.polarDB.log.queryTimes": "SQL Execution Duration (seconds)",
  "pages.polarDB.log.parseRowCounts": "Parse Row Count",
  "pages.polarDB.log.returnRowCounts": "Return Row Count",
  "pages.polarDB.log.sqlText": "Query Statement",
  "pages.polarDB.log.dataTimestamp": "SQL Execution Timestamp",
  "pages.polarDB.log.sqlTemplateId": "SQL Template ID",
  "pages.polarDB.tempalte.id": "Template ID",
  "pages.polarDB.tempalte.environment": "Environment",
  "pages.polarDB.tempalte.dbClusterId": "Cluster ID",
  "pages.polarDB.tempalte.dbName": "Database",
  "pages.polarDB.tempalte.dbNodeId": "Node ID",
  "pages.polarDB.tempalte.hostAddress": "Client Address",
  "pages.polarDB.tempalte.sqlText": "SQL Template",
  "pages.polarDB.tempalte.createDate": "Pull Time",
  "pages.polarDB.tempalte.lastUpdDate": "Update Time",
  "pages.polarDB.tempalte.lastUpdUserName": "Updated By",
  "pages.polarDB.tempalte.overdueDays": "Overdue Days",
  "pages.polarDB.tempalte.handlerInfo": "Handler",
  "pages.polarDB.tempalte.status": "Processed",
  "pages.polarDB.tempalte.remark": "Remark",
  "pages.db.subscribe.dbId": "Database ID",
  "pages.db.subscribe.dbName": "Database",
  "pages.db.subscribe.dbLeader": "Leader",
  "is.subscribe": "Subscribed",
  "subscribers": "Subscribers",
  "pages.db.subscribe.explain": "Note: After subscribing to the database, starting from the next day, you will receive push notifications of slow SQL template data from yesterday for the subscribed database! (No push if there is no slow SQL)",
  "edit.subscribers": "Edit Subscribers",
  "pages.label.status": "Enable Status",
  "pages.label.type": "Label Type",
  "pages.label.nameCn": "Label Name (Chinese)",
  "pages.label.nameEn": "Label Name (English)",
  "pages.label.markingCnt": "Marking Count",
  "pages.label.lastUpdDate": "Update Time",
  "pages.label.lastUpdUserName": "Updated By",
  "pages.label.relationTypeName": "Marking Type",
  "pages.label.relationName": "Marking Name",
  "pages.label.createDate": "Marking Time",
  "pages.label.createUserName": "Marker",
  "pages.delivery.id": "ID",
  "pages.delivery.releaseCarrierId": "Release Order ID",
  "pages.delivery.releaseCarrierName": "Release Order Name",
  "pages.delivery.releaseCarrierType": "Release Order Type",
  "pages.delivery.collaboratorInfos": "Collaborators",
  "pages.delivery.otherInfo": "Other Information",
  "pages.delivery.isEmergency": "Emergency Release",
  "pages.delivery.progress": "Status",
  "pages.delivery.progressDesc": "Status",
  "pages.delivery.appointmentDate": "Expected Release Date",
  "pages.delivery.releaseDate": "Actual Release Date",
  "pages.delivery.checkTermList": "Check Items",
  "pages.delivery.issueSn": "Requirement Serial Number",
  "pages.delivery.taskCnt": "Task Count",
  "pages.delivery.issueUrl": "Requirement Details",
  "pages.delivery.serviceName": "Service Name",
  "pages.delivery.serviceType": "Service Type",
  "pages.delivery.serviceStatus": "Pipeline Status",
  "pages.delivery.devOwnerNames": "Dev Owner",
  "pages.delivery.developerNames": "Developers",
  "pages.delivery.businessName": "Business Area",
  "pages.delivery.serviceLevel": "Service Level",
  "pages.delivery.serviceNature": "Service Attribute",
  "pages.delivery.replicas": "Container Replicas",
  "pages.delivery.branch": "Development Branch",
  "pages.delivery.releaseNum": "Release Count",
  "pages.delivery.emergencyReleaseNum": "Emergency Count",
  "pages.delivery.updateBy": "Latest Operator",
  "pages.delivery.updateTime": "Latest Operation Time",
  "start.up.today": "Production Deployment Today",
  "delivery.today": "Delivery Today",
  "publish.window": "Release Window",
  "service.publishing": "Service Release",
  "release.reason": "Release Reason",
  "code.branch": "Code Branch",
  "oneClick.publishing": "One-Click Release",
  "secondary.release": "Secondary Release",
  "noLpt.publishing": "Non-Production Release",
  "regression.completion": "Regression Completed",
  "acceptance.pass": "Acceptance Passed",
  "release.note": "Release Notes",
  "requirement.acceptance.link": "Requirement Acceptance Link",
  "release.history": "Release History",
  "release.log": "Release Log",
  "service.log": "Service Log",
  "vulnerability.scanning": "Vulnerability Scanning",
  "publish": "Publish",
  "rollback": "Rollback",
  "run.id": "Run ID",
  "branch": "Branch",
  "commit.id": "Commit ID",
  "run.time": "Run Time",
  "opt.time": "Operation Time",
  "end.time": "End Time",
  "op.user": "Operator",
  "finish.desc": "Deployment Description",
  "please.select.a.branch": "Please select a branch",
  "commit.publish": "Commit Publish",
  "commit.scanner": "Commit Scanner",
  "error.log": "Error Log",
  "release.env": "Release Environment",
  "product.requirements": "Product Requirements",
  "pull.carrier.branch": "Pull Release Order Branch",
  "refresh.branch": "Refresh Branch",
  "related.items": "Related Items",
  "whether.to.schedule.a.meeting": "Whether to Schedule a Meeting",
  "review.issue": "Review (Meeting) Requirement",
  "review.sprint": "Review (Meeting) Sprint",
  "review.test.case": "Review (Meeting) Test Cases",
  "meeting.code": "Meeting Code",
  "edit.review": "Edit Review",
  "edit.allReview": "Edit",
  "complete.review": "Complete Review",
  "initiate.a.review.meeting": "Schedule Review Meeting",
  "initiate.a.allReview.meeting": "Schedule Meeting",
  "update.review.meeting": "Update Review Meeting",
  "update.review.allMeeting": "Update Meeting",
  "fill.in.the.review.minutes": "Fill in Meeting Minutes",
  "cancel.review.meeting": "Cancel Review Meeting",
  "delete.review": "Delete Review",
  "unconfirmed.person": "Unconfirmed Person",
  "confirmed.person": "Confirmed Person",
  "review.detail": "Review Details",
  "relation.name": "Related Name",
  "relation.type": "Related Type",
  "create.dashboard": "Create Dashboard",
  "pages.dashboard.kudoCard.description": "Light up a star. Give instant kudos",
  "pages.dashboard.kudoCard.summary": "Dear {nickname},you have received Starkudos from your colleague",
  "pages.dashboard.kudoCard.empty": "No colleagues have given you Star Kudos yet~",
  "pages.dashboard.kudoRank.rankingRule": "Ranking is calculated by total StarKudos collected.",
  "pages.dashboard.kudoRank.title": "Star Kudos Rank Top 20",
  "pages.dashboard.kudoRank.yourRank": "Your Rank",
  "pages.dashboard.kudoRank.rankTime": "Rank Time: ",
  "pages.dashboard.kudoRank.noData": "No ranking data",
  "pages.dashboard.kudoRank.selectGroup": "Please select a card group",
  "pages.dashboard.receivedCards.title": "Kudos Received",
  "pages.dashboard.receivedCards.description": "Received This Event",
  "pages.dashboard.receivedCards.colleague": "Colleague",
  "pages.dashboard.receivedCards.cardName": "Star Kudos",
  "pages.dashboard.receivedCards.filter": "Filter: ",
  "pages.dashboard.receivedCards.noCards": "No Star Kudos",
  "pages.dashboard.myCards.title": "StarKudos Inventory",
  "pages.dashboard.myCards.description": "Available This Event",
  "pages.dashboard.myCards.available": "Available",
  "pages.dashboard.myCards.status.pending": "Pending",
  "pages.dashboard.myCards.status.used": "Used",
  "pages.dashboard.myCards.filter": "Filter: ",
  "pages.dashboard.myCards.noCards": "No Cards",
  "instrument.name": "Dashboard Name",
  "card.logo": "Card Logo",
  "card.name.cn": "Card Name (Chinese)",
  "card.name.en": "Card Name (English)",
  "card.code": "Card Code",
  "card.desc.cn": "Card Description (Chinese)",
  "card.desc.en": "Card Description (English)",
  "card.type": "Card Type",
  "edit.personal.instrument.card": "Edit Personal Dashboard Card",
  "card.list": "Card List",
  "to.do.name": "Todo Name",
  "to.do.type": "Todo Type",
  "to.do.status": "Todo Status",
  "expected.end": "Expected Completion Time",
  "member.name": "Member Name",
  "edit.members": "Edit Members",
  "report.date": "Report (Year-Week)",
  "weekly.report.title": "Weekly Report Title",
  "weekly.report.type": "Weekly Report Type",
  "weekly.report.title.template": "Weekly Report Title Template",
  "weekly.report.content.template": "Weekly Report Content Template",
  "report.to": "Report To",
  "report.by": "Reporter",
  "report.cc": "CC",
  "role": "Role",
  "push.time": "Send Time",
  "is.automatic.sending.enabled": "Auto Send Enabled",
  "stage.name": "Stage Name",
  "quantity": "Quantity",
  "week.on.month.ratio": "Week-over-Week Ratio",
  "special.remark": "Remark (Enter to save)",
  "read.count": "Read Count",
  "add.comment": "Add Comment",
  "comment.content": "Comment Content",
  "chinese.name": "Chinese Name",
  "code": "Code",
  "status.type": "Status Type",
  "status.code": "Status Code",
  "english.name": "English Name",
  "status.group": "Status Group",
  "echo.color": "Display Color",
  "transferable.status": "Transferable Status",
  "sort": "Sort",
  "clone.to.other.status.group": "Clone to Other Status Group",
  "meeting.room.id": "Meeting Room ID",
  "meeting.room.name": "Meeting Room Name",
  "meeting.room.capacity": "Meeting Room Capacity",
  "city": "City",
  "building": "Building",
  "floor": "Floor",
  "meeting.room.equipment": "Meeting Room Equipment",
  "sn": "Serial Number",
  "标题": "Title",
  "状态": "Status",
  "负责人": "Owner",
  "起始时间": "Start Time",
  "截止时间": "End Time",
  "创建时间": "Create Time",
  "创建人": "Created By",
  "工作项类型": "Work Item Type",
  "更新时间": "Update Time",
  "更新人名称": "Updated By Name",
  "操作": "Operation",
  "优先级": "Priority",
  "截止日期": "Deadline",
  "所属项目": "Project",
  "任务名称": "Task Name",
  "项目名称": "Project Name",
  "团队空间": "Team Space",
  "项目负责人": "Project Owner",
  "项目干系人": "Project Stakeholders",
  "项目周期": "Project Cycle",
  "默认视图": "Default View",
  "团队空间名称": "Team Space Name",
  "团队空间成员": "Team Space Members",
  "团队空间描述": "Team Space Description",
  "里程碑周期": "Milestone Cycle",
  "删除项目": "Delete Project",
  "项目是否公开": "Is Project Public",
  "编辑": "Edit",
  "新建需求": "New Requirement",
  "转产品需求": "Convert to Product Requirement",
  "新建任务": "New Task",
  "删除任务": "Delete Task",
  "里程碑负责人": "Milestone Owner",
  "需求名称": "Requirement Name",
  "所属系统": "System",
  "干系人": "Stakeholders",
  "描述": "Description",
  "需求周期": "Requirement Cycle",
  "项目参与人": "Project Participants",
  "项目创建人": "Project Creator",
  "项目创建时间": "Project Create Time",
  "里程碑名称": "Milestone Name",
  "里程碑": "Milestone",
  "系统": "System",
  "开始时间": "Start Time",
  "实际完成时间": "Actual Completion Time",
  "项目": "Project",
  "主产品经理": "Main Product Manager",
  "公开状态": "Public Status",
  "删除需求": "Delete Requirement",
  "删除里程碑": "Delete Milestone",
  "规划周期": "Planning Cycle",
  "人天预算": "Person Day Budget",
  "版本号": "Version Number",
  "关联需求任务数": "Related Requirement Task Count",
  "类型": "Type",
  "参与人": "Participants",
  "预估人天": "Estimated Person Days",
  "开始结束": "Start - End",
  "commit.cnt": "Commit Count",
  "merge.cnt": "Merge Count",
  "push.cnt": "Push Count",
  "tag.cnt": "Tag Count",
  "merge.subscribe": "Subscribe Merge",
  "push.subscribe": "Subscribe Push",
  "merge.subscribers": "Merge Subscribers",
  "push.subscribers": "Push Subscribers",
  "warehouse.name": "Repository Name",
  "related.sn": "Related Serial Number",
  "commit.email": "Commit Email",
  "commit.url": "Commit URL",
  "commit.message": "Commit Message",
  "commit.date": "Commit Date",
  "commit.branch": "Commit Branch",
  "git.http.url": "Git Repository URL",
  "nick.name": "Nickname",
  "attendance.date": "Attendance Date",
  "attendance.type": "Attendance Type",
  "attendance.start.address": "Attendance Start Location",
  "attendance.end.address": "Attendance End Location",
  "attendance.start.source": "Attendance Start Source",
  "attendance.end.source": "Attendance End Source",
  "attendance.start.result": "Attendance Start Result",
  "attendance.end.result": "Attendance End Result",
  "department.name": "Department Name",
  "department.members": "Department Members",
  "location.city": "Base Location",
  "personal.attendance.days": "Personal Attendance Days",
  "personal.total.working.hours": "Personal Total Working Hours",
  "personal.average.working.hours": "Personal Average Working Hours",
  "department.attendance.person.day": "Department Attendance Person Days",
  "department.total.working.hours": "Department Total Working Hours",
  "department.average.working.hours": "Department Average Working Hours",
  "location.city.attendance.person.day": "Base Location Attendance Person Days",
  "location.city.total.working.hours": "Base Location Total Working Hours",
  "location.city.average.working.hours": "Base Location Average Working Hours",
  "review.location": "Review (Meeting) Location",
  "review.allLocation": "Location",
  "review.count": "Review Count",
  "bug.count": "Bug Count",
  "online.bug.count": "Online Bug Count",
  "is.have.template": "Weekly Report Template",
  "dept.status": "Department Status",
  "total.commit.cnt": "Total Commit Count",
  "requirment.commit.cnt": "Requirement Commit Count",
  "bug.commit.cnt": "Bug Commit Count",
  "online.bug.commit.cnt": "Online Bug Commit Count",
  "other.commit.cnt": "Other Commit Count",
  "standard.commit.rate": "Standard Commit Rate",
  "related.business": "Related Business Area",
  "related.system": "Related System",
  "position": "Position",
  "production.Defects.score": "Production Defect Score",
  "develop.defects.score": "Development Defect Score",
  "working.hours.score": "Working Hours Score",
  "average.score.of.production.and.research": "Production & Research Average Score",
  "individual.total.score": "Individual Total Score",
  "technical.debt.score": "Technical Debt Score",
  "delivery.efficiency.score": "Delivery Efficiency Score",
  "code.review.report": "CR Report",
  "status.stage.nameCn": "Stage Name (Chinese)",
  "status.stage.nameEn": "Stage Name (English)",
  "status.stage.code": "Stage Code",
  "status.stage.echoColor": "Display Color",
  "status.stage.sortNum": "Sort Number",
  "description": "Description",
  "workflow": "Workflow",
  "issue.type": "Requirement Type",
  "common.cancel": "Cancel",
  "common.ok": "OK",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.submit": "Submit",
  "common.back": "Back",
  "common.close": "Close",
  "common.reset": "Reset",
  "common.refresh": "Refresh",
  "common.search": "Search",
  "common.clear": "Clear",
  "common.copy": "Copy",
  "common.add": "Add",
  "common.viewDetails": "View Details",
  "common.moreActions": "More Actions",
  "common.noData": "No Data",
  "common.loading": "Loading...",
  "common.pleaseSelect": "Please select",
  "common.pleaseEnter": "Please enter",
  "common.yes": "Yes",
  "common.no": "No",
  "common.required": "Required",
  "common.success": "Success",
  "common.failed": "Failed",
  "common.passed": "Passed",
  "common.rejected": "Rejected",
  "common.today": "Today",
  "common.thisWeek": "This Week",
  "common.thisMonth": "This Month",
  "common.thisYear": "This Year",
  "common.all": "All",
  "common.details": "Details",
  "common.reason": "Reason",
  "common.remark": "Remarks",
  "common.label": "Label",
  "common.name": "Name",
  "common.type": "Type",
  "common.count": "Count",
  "common.time": "Time",
  "common.endTime": "End Time",
  "common.owner": "Owner",
  "common.assignee": "Assignee",
  "common.members": "Members",
  "common.people": "People",
  "common.country": "Country",
  "common.countryTeam": "Country Team",
  "common.industryTeam": "Industry Team",
  "common.serviceName": "Service Name",
  "common.serviceType": "Service Type",
  "common.branch": "Branch",
  "common.task": "Task",
  "common.defect": "Defect",
  "common.comments": "Comments",
  "common.basicInfo": "Basic Information",
  "common.fullScreen": "Full Screen",
  "common.exitFullScreen": "Exit Full Screen",
  "common.expandAll": "Expand All",
  "common.collapseAll": "Collapse All",
  "common.clickToCopy": "Click to Copy",
  "common.confirmDelete": "Confirm Deletion",
  "common.createdSuccessfully": "Created successfully",
  "common.updatedSuccessfully": "Updated successfully",
  "common.modifiedSuccessfully": "Updated successfully",
  "common.savedSuccessfully": "Saved successfully",
  "common.addedSuccessfully": "Added successfully",
  "common.deletedSuccessfully": "Deleted successfully",
  "common.deleteFailed": "Failed to delete",
  "common.copyFailed": "Failed to copy",
  "common.uploadAttachment": "Upload Attachment",
  "common.uploadFailed": "Upload failed",
  "common.imageUploadFailed": "Image upload failed",
  "common.draft": "Draft",
  "common.completed": "Completed",
  "common.released": "Released",
  "common.overdue": "Overdue",
  "common.hour": "hours",
  "common.day": "days",
  "common.item": "items",
  "common.total": "Total",
  "0 天": "0 days",
  "请选择系统": "Please select a system",
  "指标名称": "Metric Name",
  "指标说明": "Metric Description",
  "需求主要归属": "Primary Requirement Ownership",
  "关闭详情": "Close Details",
  "支持小数": "Decimals are supported",
  "缺陷类型": "Defect Type",
  "图": "Chart",
  "表": "Table",
  "请选择创建人": "Please select a creator",
  "是否删除": "Delete?",
  "请选择状态": "Please select a status",
  "实际工时（小时）": "Actual Hours",
  "图片上传错误，请重试！": "Image upload failed. Please try again.",
  "请先设置开始结束时间和预估人天": "Set the start time, end time, and estimated person-days first",
  "请输入名称": "Please enter a name",
  "计划上线日期": "Planned Release Date",
  "时间范围": "Date Range",
  "请选择负责人": "Please select an owner",
  "链接内容": "Link Content",
  "回收站不可以进行该操作，请恢复后在操作！": "This action is unavailable in the recycle bin. Restore the item first.",
  "实际工时": "Actual Hours",
  "确定要删除": "Are you sure you want to delete",
  "吗？": "?",
  "测试人员": "QA Engineer",
  "上传文件不能超过5MB": "The uploaded file cannot exceed 5 MB",
  "需求名称和链接已剪贴板": "The requirement name and link have been copied",
  "填写实际工时": "Enter Actual Hours",
  "请输入描述": "Please enter a description",
  "发现时间": "Detected At",
  "上传文件不能超过10MB": "The uploaded file cannot exceed 10 MB",
  "上传文件不能超过20MB": "The uploaded file cannot exceed 20 MB",
  "已经是第一条了": "This is already the first item",
  "已经是最后一条了": "This is already the last item",
  "条": "items",
  "查看明细": "View Details",
  "请选择需求": "Please select a requirement",
  "请选择查询类型": "Please select a query type",
  "查询": "Search",
  "表格视图": "Table View",
  "需求设计缺陷率": "Requirement Design Defect Rate",
  "产品评审驳回率": "Product Review Rejection Rate",
  "代码提交规范率": "Commit Convention Compliance Rate",
  "紧急发布率": "Emergency Release Rate",
  "未发布": "Unreleased",
  "确认要删除吗？": "Are you sure you want to delete this item?",
  "部署环境": "Deployment Environment",
  "操作成功": "Operation completed successfully",
  "写周报": "Write Weekly Report",
  "点击添加评论": "Click to add a comment",
  "取消点赞": "Remove Like",
  "添加点赞": "Like",
  "点击分享周报": "Click to share the weekly report",
  "年份": "Year",
  "至": "to",
  "回收站": "Recycle Bin",
  "审批单ID不能为空": "Approval order ID is required",
  "基础信息": "Basic Information",
  "服务分支信息": "Service Branch Information",
  "同步数据": "Sync Data",
  "关联需求名称": "Related Requirement Name",
  "总计": "Total",
  "缺陷逃逸率": "Defect Escape Rate",
  "缺陷漏检率": "Missed Defect Rate",
  "发布成功率": "Release Success Rate",
  "执行人": "Assignee",
  "复制失败:": "Copy failed:",
  "事故序列": "Incident ID",
  "严重程度": "Severity",
  "指派人": "Assigned By",
  "存量": "Existing",
  "说明": "Description",
  "数量变化（日）": "Daily Count Change",
  "这个指标的主要意义在于：": "Why this metric matters:",
  "质量控制：可以作为衡量软件质量变化的指标之一，帮助发现质量问题、进行质量改进。": "Quality control: Tracks changes in software quality and helps identify and improve quality issues.",
  "上传附件：": "Upload Attachment:",
  "复制成功": "Copied successfully",
  "提交失败:": "Submission failed:",
  "配置": "Configure",
  "编辑责任人": "Edit Owner",
  "请选择人员": "Please select users",
  "设为默认": "Set as Default",
  "发布时间": "Release Time",
  "状态变更": "Status Change",
  "只看我": "My Items Only",
  "已归档": "Archived",
  "全部记录": "All Records",
  "双击开始编辑": "Double-click to edit",
  "请切换到ALL系统下进行筛选": "Switch to the ALL system to use this filter",
  "请选择地域": "Please select a region",
  "最近更新时间": "Last Updated At",
  "同步结果": "Sync Result",
  "请选择国家": "Please select a country",
  "解决耗时": "Resolution Time",
  "关闭时长": "Time to Close",
  "重开率": "Reopen Rate",
  "降序": "Descending",
  "升序": "Ascending",
  "分支名": "Branch Name",
  "点击复制序列号": "Click to copy the ID",
  "已复制序列号": "ID copied",
  "事故等级": "Incident Severity",
  "债务类型": "Debt Type",
  "关联服务": "Related Services",
  "指派": "Assign",
  "存在未确认": "Pending confirmation",
  "全部已确认": "All confirmed",
  "评审吗？": "review?",
  "请选择标签": "Please select tags",
  "计划联调日期": "Planned Integration Date",
  "回复": "Reply",
  "完成目标": "Completion Target",
  "风险类型": "Risk Type",
  "风险原因": "Risk Reason",
  "预约发布": "Schedule Release",
  "请输入申请原因": "Please enter the request reason",
  "创建时间:": "Created At:",
  "请选择部门": "Please select a department",
  "分": "min",
  "人": "people",
  "风险": "Risk",
  "附件": "Attachments",
  "请输入内容（拖动右下角可调整高度）": "Enter content (drag the bottom-right corner to resize)",
  "无权限": "No Permission",
  "故障名称": "Name",
  "评论不能为空": "Comment is required",
  "评论成功": "Comment posted successfully",
  "请输入评论内容": "Please enter a comment",
  "活动日志": "Activity Log",
  "只能在系统ALL下进行此条件筛选": "This filter is only available under the ALL system",
  "设为默认后表格查询默认按该筛选条件查询": "After setting this as default, table queries will use this filter automatically",
  "只读权限": "Read-only Access",
  "一键创建任务": "Create Tasks",
  "请先勾选需求": "Select requirements first",
  "目标值": "Target Value",
  "pages.gray.userIdPlaceholder": "Enter one user ID per line, or separate IDs with commas\nExample:\nuser1\nuser2,user3\nuser4",
  "{count} 个团队": "{count} teams",
  "{count} 人": "{count} people",
  "{count} 人 · {names}{ellipsis}": "{count} people · {names}{ellipsis}",
  "{count} 名成员": "{count} members",
  "{count} 天": "{count} days",
  "{metric} · 需求明细": "{metric} · Requirement Details",
  "、": ", ",
  "个": "items",
  "天": "days",
  "序列号": "ID",
  "多团队研发效能对比": "Multi-team R&D Efficiency Comparison",
  "并列比较团队需求负载、未开始与进行中需求、阶段耗时和大需求风险": "Compare demand load, not-started and in-progress demands, phase duration, and large-demand risks across teams.",
  "选择 1–5 个团队": "Select 1–5 teams",
  "管理团队": "Manage Teams",
  "刷新": "Refresh",
  "所选团队总览": "Selected Teams Overview",
  "快速查看整体规模、流转效率与风险": "Quick view of overall volume, cycle efficiency, and risks",
  "需求并集去重": "Deduplicated demand union",
  "团队指标矩阵": "Team Metric Matrix",
  "所有数值均可点击查看需求明细，点击列头可排序": "Click any value to view demand details; click a column header to sort.",
  "同一需求可能由多个团队共同参与，总览按需求去重，避免重复计数": "A demand may involve multiple teams. The overview deduplicates demands to prevent double counting.",
  "跨团队总览按需求去重": "Cross-team overview deduplicated by demand",
  "请选择团队查看数据": "Select teams to view data",
  "请先配置团队": "Configure a team first",
  "需求负载对比": "Demand Load Comparison",
  "按团队查看总量与当前积压情况": "Compare total demand and current backlog by team",
  "研发与测试耗时对比": "Development and Testing Duration Comparison",
  "按对应阶段完成时间进入所选区间": "Included when the corresponding phase completion time falls within the selected range",
  "总数、构成、超10PD按需求创建时间；未完成/进行中为区间创建需求的当前状态；开发、测试、交付耗时分别按阶段完成时间进入区间。": "Total, composition, and over-10-PD metrics use demand creation time. Unfinished and in-progress metrics use the current status of demands created in the range. Development, testing, and delivery duration metrics use their respective phase completion times.",
  "指标口径说明": "Metric Definition Guide",
  "除“超 10PD 需求”外，团队范围均通过需求执行人关系判断；“超 10PD 需求”通过需求绑定任务和任务负责人判断。两种关联口径不能混用。": "Except for Over-10-PD Demands, team scope is determined by demand executor relationships. Over-10-PD Demands use bound tasks and task owners. These two association rules must not be mixed.",
  "查看完整指标说明": "View Full Metric Guide",
  "时间口径": "Time Basis",
  "团队关联": "Team Association",
  "指标定义": "Metric Definition",
  "计算方式": "Calculation",
  "需求规模": "Demand Volume",
  "当前流转": "Current Flow",
  "需求构成": "Demand Composition",
  "阶段效率": "Phase Efficiency",
  "流转效率": "Cycle Efficiency",
  "风险关注": "Risk Watch",
  "总需求数": "Total Demands",
  "未完成需求": "Unfinished Demands",
  "进行中需求": "In-progress Demands",
  "非技术需求": "Non-technical Demands",
  "开发阶段平均耗时": "Average Development Duration",
  "测试阶段平均耗时": "Average Testing Duration",
  "总交付平均耗时": "Average End-to-end Delivery Duration",
  "超 10PD 需求": "Over-10-PD Demands",
  "需求创建时间进入所选区间": "Demand creation time falls within the selected range",
  "需求创建时间进入所选区间，状态取查询时的当前状态": "Demand creation time falls within the selected range; status is evaluated at query time",
  "研发阶段完成时间进入所选区间": "Development phase completion time falls within the selected range",
  "测试阶段完成时间进入所选区间": "Testing phase completion time falls within the selected range",
  "需求完成时间进入所选区间": "Demand completion time falls within the selected range",
  "需求执行人关系中，执行人角色为研发、前端或测试，且执行人属于所选团队。": "The demand has an executor whose role is backend development, frontend development, or testing and who belongs to the selected team.",
  "与总需求相同：通过需求执行人关系关联研发、前端或测试团队成员。": "Same as Total Demands: associated through backend, frontend, or testing members in the demand executor relationship.",
  "需求执行人关系中，研发、前端或测试执行人属于所选团队。": "A backend, frontend, or testing executor in the demand executor relationship belongs to the selected team.",
  "需求通过 ISSUE 类型任务绑定关系关联任务；只要任一有效绑定任务的负责人属于所选团队，该需求即进入团队范围。": "Tasks are linked through ISSUE-type task bindings. A demand enters the team scope when the owner of any active bound task belongs to the selected team.",
  "满足团队关联条件的产品需求总量。": "Total product demands that satisfy the team association rule.",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发的需求。": "Demands currently in Pending Intervention, Solution Planning, Business Confirmation, Reviewed, Demand Queue, or To Be Developed status.",
  "当前处于开发中、前端开发中、联调中、已提测或测试中的需求。": "Demands currently in Backend Development, Frontend Development, Integration, Submitted for Testing, or Testing status.",
  "在产品需求中明确标记为技术需求的需求。": "Product demands explicitly marked as technical.",
  "未标记为技术需求的其他产品需求。": "Other product demands not marked as technical.",
  "从产品阶段结束到研发阶段结束所经历的自然天数。": "Calendar days from the end of the product phase to the end of the development phase.",
  "从研发阶段结束到测试阶段结束所经历的自然天数。": "Calendar days from the end of the development phase to the end of the testing phase.",
  "从产品阶段结束到需求完成所经历的自然天数。": "Calendar days from the end of the product phase to demand completion.",
  "需求绑定的研发相关任务预估工时合计大于 10PD。": "The total estimated effort of development-related tasks bound to the demand exceeds 10 PD.",
  "按需求 ID 去重计数；排除已删除、暂存和项目型需求。": "Deduplicate by demand ID; exclude deleted, draft, and project-type demands.",
  "从总需求中按未完成状态集合筛选，并按需求 ID 去重计数。": "Filter Total Demands by the unfinished status set and deduplicate by demand ID.",
  "从总需求中按进行中状态集合筛选，并按需求 ID 去重计数。": "Filter Total Demands by the in-progress status set and deduplicate by demand ID.",
  "从总需求中筛选技术需求，并按需求 ID 去重计数。": "Filter technical demands from Total Demands and deduplicate by demand ID.",
  "从总需求中筛选非技术需求，并按需求 ID 去重计数。": "Filter non-technical demands from Total Demands and deduplicate by demand ID.",
  "仅统计两个时间字段完整的需求，逐条计算天数后取算术平均值。": "Include only demands with both timestamps present; calculate calendar days per demand and take the arithmetic mean.",
  "仅统计两个时间字段完整的已完成需求，逐条计算天数后取算术平均值。": "Include only completed demands with both timestamps present; calculate calendar days per demand and take the arithmetic mean.",
  "对进入团队范围的需求，汇总其全部有效后端、前端、无线开发及对应技术方案、需求调研任务的预估 PD；只累加大于0的工时，按需求分组后筛选合计值 > 10。": "For demands in the team scope, sum estimated PD across all active backend, frontend, mobile development, related technical-design, and demand-research tasks. Include only effort greater than zero, group by demand, and keep totals above 10.",
  "按需求 ID 去重 · 点击查看明细": "Deduplicated by demand ID · Click to view details",
  "总需求": "Total Demands",
  "开发阶段": "Development",
  "交付耗时": "Delivery Duration",
  "开发耗时": "Development Duration",
  "测试耗时": "Testing Duration",
  "预估PD": "Estimated PD",
  "待介入": "Pending Intervention",
  "方案中": "Solution Planning",
  "业务确认": "Business Confirmation",
  "已评审": "Reviewed",
  "需求排队": "Demand Queue",
  "待开发": "To Be Developed",
  "开发中": "In Development",
  "前端开发中": "Frontend Development",
  "联调中": "Integration",
  "已提测": "Submitted for Testing",
  "测试中": "Testing",
  "团队已保存": "Team saved",
  "团队已删除": "Team deleted",
  "管理对比团队": "Manage Comparison Teams",
  "团队用于并列比较，同一成员可属于多个团队。": "Teams are used for side-by-side comparison. A member may belong to multiple teams.",
  "新增团队": "Add Team",
  "编辑团队": "Edit Team",
  "确认删除该团队？": "Delete this team?",
  "暂未配置团队": "No teams configured",
  "请输入团队名称": "Enter a team name",
  "保存": "Save",
  "删除": "Delete",
  "团队成员": "Team Members",
  "选择成员": "Select Members",
  "暂未选择成员，允许保存空团队": "No members selected. An empty team can still be saved.",
  "选择团队成员": "Select Team Members",
  "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。": "Associate teams through demand executors. Executor roles are limited to backend, frontend, or testing, and the executor must be a team member.",
  "需求创建时间进入所选区间，并且产品、研发、测试阶段结束时间至少一项不为空": "Demand creation time falls in the selected range, and at least one product, development, or testing phase end time is present",
  "需求创建时间进入所选区间，并且需求完成时间、产品阶段结束时间均不为空": "Demand creation time falls in the selected range, and both completion time and product phase end time are present",
  "通过 ISSUE 类型任务绑定关系关联任务；至少一条预估工时大于0的有效绑定任务负责人属于团队成员。": "Associate tasks through active ISSUE bindings. At least one bound task with estimated effort above zero must be owned by a team member.",
  "需求总量": "Demand Total",
  "需求创建时间进入所选区间，并且业务编号不为空": "Demand creation time falls in the selected range and the business number is present",
  "排除已删除、暂存和项目型需求后，按需求 ID 去重计数。": "Exclude deleted, draft, and project-type demands, then deduplicate by demand ID.",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发状态的{type}需求。": "{type} demands currently in Pending Intervention, Solution Planning, Business Confirmation, Reviewed, Demand Queue, or To Be Developed status.",
  "技术": "Technical",
  "非技术": "Non-technical",
  "当前处于开发中、前端开发中、联调中、已提测或测试中状态的{type}需求。": "{type} demands currently in Development, Frontend Development, Integration, Submitted for Testing, or Testing status.",
  "要求业务编号不为空，按状态集合和技术标记筛选后按需求 ID 去重计数。": "Require a business number, filter by the status set and technical flag, then deduplicate by demand ID.",
  "未完成技术需求数": "Unfinished Technical Demands",
  "进行中技术需求数": "In-progress Technical Demands",
  "未完成非技术需求数": "Unfinished Non-technical Demands",
  "进行中非技术需求数": "In-progress Non-technical Demands",
  "技术需求数": "Technical Demand Count",
  "开发测试阶段": "Development and Testing Phase",
  "进入开发测试阶段样本的技术需求数量。": "Number of technical demands in the development and testing phase sample.",
  "筛选 is_technical = 1 后按需求 ID 去重计数。": "Filter is_technical = 1 and deduplicate by demand ID.",
  "技术需求开发阶段平均耗时": "Avg. Technical Development Duration",
  "技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "Calendar days for technical demands from product phase end to development phase end.",
  "仅对两个时间字段完整的技术需求计算逐条耗时，再取算术平均值。": "Calculate duration only for technical demands with both timestamps, then take the arithmetic mean.",
  "技术需求测试阶段平均耗时": "Avg. Technical Testing Duration",
  "技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "Calendar days for technical demands from development phase end to testing phase end.",
  "非技术需求数": "Non-technical Demand Count",
  "进入开发测试阶段样本的非技术需求数量。": "Number of non-technical demands in the development and testing phase sample.",
  "筛选 is_technical 不等于 1（含空值）后按需求 ID 去重计数。": "Filter is_technical values other than 1, including null, and deduplicate by demand ID.",
  "非技术需求开发阶段平均耗时": "Avg. Non-technical Development Duration",
  "非技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "Calendar days for non-technical demands from product phase end to development phase end.",
  "仅对两个时间字段完整的非技术需求计算逐条耗时，再取算术平均值。": "Calculate duration only for non-technical demands with both timestamps, then take the arithmetic mean.",
  "非技术需求测试阶段平均耗时": "Avg. Non-technical Testing Duration",
  "非技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "Calendar days for non-technical demands from development phase end to testing phase end.",
  "产品阶段结束到需求完成": "product phase end to demand completion",
  "研发阶段结束到测试阶段结束": "development phase end to testing phase end",
  "产品阶段结束到研发阶段结束": "product phase end to development phase end",
  "已交付需求": "Delivered Demands",
  "已交付技术需求数": "Delivered Technical Demands",
  "技术需求平均交付时长": "Avg. Technical Delivery Duration",
  "技术需求研发平均交付时长": "Avg. Technical Development Delivery Duration",
  "技术需求测试平均交付时长": "Avg. Technical Testing Delivery Duration",
  "已交付非技术需求数": "Delivered Non-technical Demands",
  "非技术需求平均交付时长": "Avg. Non-technical Delivery Duration",
  "非技术需求研发平均交付时长": "Avg. Non-technical Development Delivery Duration",
  "非技术需求测试平均交付时长": "Avg. Non-technical Testing Delivery Duration",
  "总研发需求平均交付时长": "Overall Avg. Development Delivery Duration",
  "进入已交付样本的{type}需求数量。": "Number of {type} demands in the delivered sample.",
  "全部已交付需求从产品阶段结束到研发阶段结束所经历的自然天数。": "Calendar days for all delivered demands from product phase end to development phase end.",
  "{type}需求从{interval}所经历的自然天数。": "Calendar days for {type} demands from {interval}.",
  "按技术标记筛选后按需求 ID 去重计数。": "Filter by technical flag and deduplicate by demand ID.",
  "仅对计算区间两端时间完整的需求计算逐条耗时，再取算术平均值。": "Calculate duration only when both interval timestamps are present, then take the arithmetic mean.",
  "超 10PD 技术需求数": "Technical Demands Over 10 PD",
  "大需求风险": "Large-demand Risk",
  "绑定的研发相关任务预估工时合计大于 10PD 的技术需求。": "Technical demands whose bound development-related tasks total more than 10 estimated PD.",
  "汇总全部有效后端、前端、无线开发及对应技术方案、需求调研任务中大于0的预估 PD，按需求分组筛选合计值 > 10。": "Sum positive estimated PD from all active backend, frontend, mobile, related technical-design, and research tasks; group by demand and retain totals above 10.",
  "超 10PD 非技术需求数": "Non-technical Demands Over 10 PD",
  "绑定的研发相关任务预估工时合计大于 10PD 的非技术需求。": "Non-technical demands whose bound development-related tasks total more than 10 estimated PD.",
  "未完成技术": "Unfinished Technical",
  "进行中技术": "In-progress Technical",
  "未完成非技术": "Unfinished Non-technical",
  "进行中非技术": "In-progress Non-technical",
  "技术开发": "Technical Development",
  "技术测试": "Technical Testing",
  "非技术开发": "Non-technical Development",
  "非技术测试": "Non-technical Testing",
  "未开始与进行中需求对比": "Not-started and In-progress Demand Comparison",
  "未开始与进行中需求": "Not-started and In-progress Demands",
  "按技术、非技术需求拆分当前状态": "Current status split by technical and non-technical demands",
  "按需求创建时间进入区间，并按技术类型拆分": "Included by demand creation time and split by technical type",
  "全部指标均按需求创建时间进入区间；状态指标另要求业务编号，阶段指标要求至少一个阶段时间，交付指标要求完成时间和产品阶段结束时间完整。": "All metrics use demand creation time. Status metrics also require a business number, phase metrics require at least one phase timestamp, and delivery metrics require both completion and product phase end times.",
  "不限制需求创建时间，状态取查询时的当前状态": "No creation-date limit; uses each demand's current status at query time",
  "未开始技术需求数": "Not-started Technical Demands",
  "未开始业务需求数": "Not-started Business Demands",
  "进行中业务需求数": "In-progress Business Demands",
  "业务（需求类型）": "Business",
  "排除已删除、暂存和项目型需求，要求业务编号不为空；按状态集合和技术标记筛选后按需求 ID 去重计数。": "Excludes deleted, staged, and project demands and requires a business number; filters by status set and technical flag, then deduplicates by demand ID.",
  "业务需求数": "Business Demand Count",
  "进入开发测试阶段样本的业务需求（非技术产品需求）数量。": "Number of business demands (non-technical product demands) in the development and testing sample.",
  "筛选 is_technical 不等于 1（含空值），作为业务需求并按需求 ID 去重计数。": "Treats is_technical values other than 1, including null, as business demands and deduplicates by demand ID.",
  "技术需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "Elapsed time for technical demands from product phase end to development phase end, converted from seconds with 24 hours per day.",
  "技术需求从研发阶段结束到测试阶段结束的耗时，按秒折算，24小时计1天。": "Elapsed time for technical demands from development phase end to testing phase end, converted from seconds with 24 hours per day.",
  "仅对两个时间字段完整的技术需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "Calculates elapsed time for technical demands with both timestamps, counts each demand once, then takes the arithmetic mean.",
  "业务需求开发阶段平均耗时": "Average Business Demand Development Time",
  "业务需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "Elapsed time for business demands from product phase end to development phase end, converted from seconds with 24 hours per day.",
  "业务需求测试阶段平均耗时": "Average Business Demand Testing Time",
  "业务需求从研发阶段结束到测试阶段结束的耗时，按秒折算，24小时计1天。": "Elapsed time for business demands from development phase end to testing phase end, converted from seconds with 24 hours per day.",
  "仅对两个时间字段完整的业务需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "Calculates elapsed time for business demands with both timestamps, counts each demand once, then takes the arithmetic mean.",
  "需求创建时间进入所选区间，并且需求完成时间（已发布时间）、产品阶段结束时间均不为空": "Demand creation time is within the selected range, and both completion (release) time and product phase end time are present",
  "已交付业务需求数": "Delivered Business Demands",
  "业务需求平均交付时长": "Average Business Demand Delivery Time",
  "业务需求研发平均交付时长": "Average Business Demand Development Delivery Time",
  "业务需求测试平均交付时长": "Average Business Demand Testing Delivery Time",
  "全部已交付需求从产品阶段结束到研发阶段结束的耗时，按秒折算，24小时计1天。": "Elapsed time for all delivered demands from product phase end to development phase end, converted from seconds with 24 hours per day.",
  "{type}需求从{interval}的耗时，按秒折算，24小时计1天。": "Elapsed time for {type} demands from {interval}, converted from seconds with 24 hours per day.",
  "按技术标记筛选后按需求 ID 去重计数；is_technical 不等于 1 的产品需求作为业务需求。": "Filters by technical flag and deduplicates by demand ID; product demands where is_technical is not 1 are treated as business demands.",
  "仅对计算区间两端时间完整的需求逐条计算耗时，每个需求只计一次，再取算术平均值。": "Calculates elapsed time only when both interval timestamps are present, counts each demand once, then takes the arithmetic mean.",
  "超 10PD 业务需求数": "Business Demands over 10 PD",
  "绑定的研发相关任务预估工时合计大于 10PD 的业务需求（非技术产品需求）。": "Business demands (non-technical product demands) whose linked development-related tasks total more than 10 estimated PD.",
  "未开始技术": "Not-started Technical",
  "未开始业务": "Not-started Business",
  "进行中业务": "In-progress Business",
  "业务开发": "Business Development",
  "业务测试": "Business Testing",
  "按技术、业务需求拆分未开始与进行中需求，不受日期范围影响": "Not-started and in-progress demands split by technical and business type; unaffected by the date range",
  "未开始和进行中指标不受日期范围影响，统计全量需求的当前状态；总量、阶段、交付和超10PD指标按所选日期内创建的需求统计。": "Not-started and in-progress metrics use the current status of all demands and ignore the date range. Total, phase, delivery, and over-10-PD metrics use demands created in the selected range.",
  "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。同一需求有多名团队成员参与时仍只计一次。": "Associates a team through demand executors whose role is development, frontend, or testing and whose user code belongs to the team. A demand is counted once even when multiple team members participate.",
  "需求创建时间进入所选日期区间（含开始日和结束日）": "Demand creation time falls within the selected date range, including both start and end dates",
  "不限制需求创建时间，读取查询时的当前状态，并且业务编号不为空": "No creation-date limit; uses the current status at query time and requires a business number",
  "需求创建时间进入所选日期区间，并且产品、研发、测试阶段结束时间至少一项不为空": "Demand creation time falls within the selected date range and at least one of product, development, or testing phase end time is present",
  "需求创建时间进入所选日期区间，并且产品阶段结束时间、研发阶段结束时间均不为空": "Demand creation time falls within the selected date range and both product and development phase end times are present",
  "需求创建时间进入所选日期区间，并且研发阶段结束时间、测试阶段结束时间均不为空": "Demand creation time falls within the selected date range and both development and testing phase end times are present",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间均不为空": "Demand creation time falls within the selected date range and both completion (release) time and product phase end time are present",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间、研发阶段结束时间均不为空": "Demand creation time falls within the selected date range and completion (release), product phase end, and development phase end times are present",
  "需求创建时间进入所选日期区间，并且需求完成时间（已发布时间）、产品阶段结束时间、研发阶段结束时间、测试阶段结束时间均不为空": "Demand creation time falls within the selected date range and completion (release), product phase end, development phase end, and testing phase end times are present",
  "需求创建时间进入所选日期区间（含开始日和结束日），并且业务编号不为空": "Demand creation time falls within the selected date range, including both dates, and a business number is present",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1 后按需求 ID 去重计数。该数量是任一阶段时间存在的需求数，不是开发和测试平均耗时的共同样本数。": "Excludes deleted, staged, and project demands, filters is_technical = 1, and deduplicates by demand ID. This is the count with any phase timestamp, not a shared sample size for the development and testing averages.",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）作为业务需求，并按需求 ID 去重计数。该数量是任一阶段时间存在的需求数，不是开发和测试平均耗时的共同样本数。": "Excludes deleted, staged, and project demands, treats is_technical values other than 1, including null, as business demands, and deduplicates by demand ID. This is the count with any phase timestamp, not a shared sample size for the development and testing averages.",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1 并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "Excludes deleted, staged, and project demands, filters is_technical = 1, and deduplicates by demand ID. It calculates and rounds each duration to two decimals, then calculates and rounds the arithmetic mean to two decimals.",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "Excludes deleted, staged, and project demands, filters is_technical values other than 1 including null, and deduplicates by demand ID. It calculates and rounds each duration to two decimals, then calculates and rounds the arithmetic mean to two decimals.",
  "is_technical = 1": "is_technical = 1",
  "is_technical 不等于 1（含空值）": "is_technical is not 1, including null",
  "排除已删除、暂存和项目型需求，按{typeFilter}筛选后按需求 ID 去重计数。": "Excludes deleted, staged, and project demands, filters by {typeFilter}, and deduplicates by demand ID.",
  "排除已删除、暂存和项目型需求，按{typeFilter}和上述状态集合筛选后按需求 ID 去重计数。": "Excludes deleted, staged, and project demands, filters by {typeFilter} and the status set above, and deduplicates by demand ID.",
  "排除已删除、暂存和项目型需求，按{typeFilter}筛选并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数。": "Excludes deleted, staged, and project demands, filters by {typeFilter}, and deduplicates by demand ID. It calculates and rounds each duration to two decimals, then calculates and rounds the arithmetic mean to two decimals.",
  "排除已删除、暂存和项目型需求并按需求 ID 去重；逐条计算耗时并保留两位小数，再取算术平均值并保留两位小数，不区分需求类型。": "Excludes deleted, staged, and project demands and deduplicates by demand ID. It calculates and rounds each duration to two decimals, then calculates and rounds the arithmetic mean to two decimals without splitting by demand type.",
  "排除已删除、暂存和项目型需求，筛选 is_technical = 1；汇总需求绑定的全部有效后端、数据仓库、前端、移动端及对应技术方案、需求调研任务中大于 0 的预估 PD，按需求分组并筛选原始合计值 > 10，结果按需求计数。": "Excludes deleted, staged, and project demands and filters is_technical = 1. Sums positive estimated PD from all valid linked backend, data warehouse, frontend, mobile, related technical-solution, and demand-research tasks; groups by demand, filters the raw total above 10, and counts demands.",
  "排除已删除、暂存和项目型需求，筛选 is_technical 不等于 1（含空值）；汇总需求绑定的全部有效后端、数据仓库、前端、移动端及对应技术方案、需求调研任务中大于 0 的预估 PD，按需求分组并筛选原始合计值 > 10，结果按需求计数。": "Excludes deleted, staged, and project demands and filters is_technical values other than 1, including null. Sums positive estimated PD from all valid linked backend, data warehouse, frontend, mobile, related technical-solution, and demand-research tasks; groups by demand, filters the raw total above 10, and counts demands.",
  "按需求创建时间进入区间；开发、测试分别只统计对应起止时间完整的需求": "Included by demand creation time; development and testing each use only demands with their required start and end times",
  "未开始和进行中指标不受日期范围影响；其余指标按所选日期内创建的需求统计。阶段需求数只要求任一阶段时间存在，开发、测试及交付平均耗时各自只使用所需时间字段完整的需求。": "Not-started and in-progress metrics ignore the date range; other metrics use demands created in the selected dates. Phase counts require any phase timestamp, while each development, testing, and delivery average uses only demands with its required timestamps.",
  "所有指标均排除已删除、暂存和项目型需求。除“超 10PD 需求”外，团队范围通过需求执行人关系判断并按需求去重；“超 10PD 需求”通过需求绑定任务和任务负责人判断。需求数与各平均耗时可能使用不同的有效样本，请以每项时间口径为准。": "All metrics exclude deleted, staged, and project demands. Except for over-10-PD demands, team scope is determined through demand executors and deduplicated by demand; over-10-PD demands use linked tasks and task leaders. Counts and averages may use different valid samples; refer to each metric's time basis.",
};
